import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Map: { input: any; output: any; }
  Money: { input: any; output: any; }
  Time: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AdditionalSettings = {
  __typename?: 'AdditionalSettings';
  customTheme?: Maybe<CustomTheme>;
  displayInApp?: Maybe<Scalars['Boolean']['output']>;
  emailTemplateId?: Maybe<Scalars['String']['output']>;
  integrations?: Maybe<Integrations>;
  notificationEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type AddressServiceAddressGqlOutput = {
  __typename?: 'AddressServiceAddressGqlOutput';
  address: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fullAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  province: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  ward: Scalars['String']['output'];
};

export type AddressServiceCountryGqlOutput = {
  __typename?: 'AddressServiceCountryGqlOutput';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AddressServiceCreateAddressGqlInput = {
  address: Scalars['String']['input'];
  fullAddress: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  province: Scalars['String']['input'];
  ward: Scalars['String']['input'];
};

export type AddressServiceProvinceGqlOutput = {
  __typename?: 'AddressServiceProvinceGqlOutput';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AddressServiceUpdateAddressGqlInput = {
  address: Scalars['String']['input'];
  fullAddress: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  province: Scalars['String']['input'];
  ward: Scalars['String']['input'];
};

export type AddressServiceUpdateDefaultGqlInput = {
  id: Scalars['String']['input'];
};

export type AddressServiceWardGqlOutput = {
  __typename?: 'AddressServiceWardGqlOutput';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  provinceId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Status of affiliate code request */
export enum AffiliateCodeRequestStatus {
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export enum AffiliateRewardMode {
  Fixed = 'Fixed',
  Percentage = 'Percentage'
}

export enum AffiliateRewardType {
  PerClick = 'PerClick',
  PerOrder = 'PerOrder'
}

export type AffiliateServiceAffiliateCodeOutput = {
  __typename?: 'AffiliateServiceAffiliateCodeOutput';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type AffiliateServiceAffiliateTrackingOutput = {
  __typename?: 'AffiliateServiceAffiliateTrackingOutput';
  affiliateCode: Scalars['String']['output'];
  affiliateUserId?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fraudReasons: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  ipAddress: Scalars['String']['output'];
  isFraudulent: Scalars['Boolean']['output'];
  reward?: Maybe<Scalars['Float']['output']>;
  sourceEvent: AffiliateSourceEvent;
  sourceReference: Scalars['String']['output'];
  sourceType: Scalars['String']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  totalAmount?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userAgent: Scalars['String']['output'];
  utmParameters?: Maybe<UtmParametersTrackingOutput>;
  viewedAt: Scalars['DateTime']['output'];
  withdrawStatus?: Maybe<AffiliateWithdrawalStatus>;
  zaloId?: Maybe<Scalars['String']['output']>;
};

export type AffiliateServiceAnalyticsOutput = {
  __typename?: 'AffiliateServiceAnalyticsOutput';
  fraudulentViews: Scalars['Int']['output'];
  recentViews: Array<AffiliateServiceAffiliateTrackingOutput>;
  topCampaigns: Array<AffiliateServiceTopCampaignOutput>;
  totalActiveLinks: Scalars['Int']['output'];
  totalViews: Scalars['Int']['output'];
  uniqueViews: Scalars['Int']['output'];
  viewsByDay: Array<AffiliateServiceViewsByDayOutput>;
  viewsBySourceJson: Scalars['String']['output'];
};

export type AffiliateServiceBalanceOutput = {
  __typename?: 'AffiliateServiceBalanceOutput';
  availableBalance: Scalars['Float']['output'];
  totalReward: Scalars['Float']['output'];
  totalWithdrawn: Scalars['Float']['output'];
};

export type AffiliateServiceCodeRequestListOutput = {
  __typename?: 'AffiliateServiceCodeRequestListOutput';
  data: Array<AffiliateServiceCodeRequestOutput>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AffiliateServiceCodeRequestOutput = {
  __typename?: 'AffiliateServiceCodeRequestOutput';
  affiliateCodeCreated?: Maybe<Scalars['String']['output']>;
  channel: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  linkGoogleDrive: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  reviewNote?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  status: AffiliateCodeRequestStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type AffiliateServiceConfigOutput = {
  __typename?: 'AffiliateServiceConfigOutput';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  requireAffiliateCodeApproval?: Maybe<Scalars['Boolean']['output']>;
  rewardMode: AffiliateRewardMode;
  rewardType: AffiliateRewardType;
  rewardValue: Scalars['Float']['output'];
  sourceEvent: AffiliateSourceEvent;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AffiliateServiceCreateCodeRequestInput = {
  channel: Scalars['String']['input'];
  email: Scalars['String']['input'];
  linkGoogleDrive: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type AffiliateServiceCreateLinkInput = {
  customSlug?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  destinationUrl: Scalars['String']['input'];
  shortenerProvider?: InputMaybe<UrlShortenerProvider>;
  title?: InputMaybe<Scalars['String']['input']>;
  utmParameters?: InputMaybe<UtmParametersInput>;
};

export type AffiliateServiceGetCodeRequestsFilterInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<AffiliateCodeRequestStatus>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliateServiceGetLinksFilterInput = {
  affiliateCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliateServiceGetTrackingFilterInput = {
  limit?: Scalars['Float']['input'];
  skip?: Scalars['Float']['input'];
  sourceReference?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliateServiceLinkListOutput = {
  __typename?: 'AffiliateServiceLinkListOutput';
  data: Array<AffiliateServiceLinkOutput>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AffiliateServiceLinkOutput = {
  __typename?: 'AffiliateServiceLinkOutput';
  affiliateCode: Scalars['String']['output'];
  clickCount: Scalars['Int']['output'];
  conversionCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customSlug?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  destinationUrl: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  fullUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  shortUrl?: Maybe<Scalars['String']['output']>;
  shortUrlKey?: Maybe<Scalars['String']['output']>;
  shortenerProvider?: Maybe<UrlShortenerProvider>;
  tenantId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  utmParameters?: Maybe<UtmParametersOutput>;
};

export type AffiliateServiceReviewCodeRequestInput = {
  requestId: Scalars['String']['input'];
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  status: AffiliateCodeRequestStatus;
};

export type AffiliateServiceTopCampaignOutput = {
  __typename?: 'AffiliateServiceTopCampaignOutput';
  campaignId: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type AffiliateServiceTrackInput = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  sourceEvent: Scalars['String']['input'];
  sourceReference: Scalars['String']['input'];
  sourceType: Scalars['String']['input'];
  subId?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  utmParameters?: InputMaybe<UtmParametersTrackingInput>;
  zaloId?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliateServiceTrackingListOutput = {
  __typename?: 'AffiliateServiceTrackingListOutput';
  data: Array<AffiliateServiceAffiliateTrackingOutput>;
  total: Scalars['Int']['output'];
};

export type AffiliateServiceUpdateLinkInput = {
  customSlug?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  linkId: Scalars['String']['input'];
  shortenerProvider?: InputMaybe<UrlShortenerProvider>;
  title?: InputMaybe<Scalars['String']['input']>;
  utmParameters?: InputMaybe<UtmParametersInput>;
};

export type AffiliateServiceUpsertConfigInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  requireAffiliateCodeApproval?: InputMaybe<Scalars['Boolean']['input']>;
  rewardMode: Scalars['String']['input'];
  rewardType: Scalars['String']['input'];
  rewardValue: Scalars['Float']['input'];
  sourceEvent: Scalars['String']['input'];
};

export type AffiliateServiceViewsByDayOutput = {
  __typename?: 'AffiliateServiceViewsByDayOutput';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export enum AffiliateSourceEvent {
  OrderCompleted = 'OrderCompleted',
  OrderCreated = 'OrderCreated',
  View = 'View'
}

export enum AffiliateWithdrawalStatus {
  Approved = 'Approved',
  Paid = 'Paid',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type AnalyzeSentencePhonemeAnalysisGqlOutput = {
  __typename?: 'AnalyzeSentencePhonemeAnalysisGqlOutput';
  comparisonPhoneme: Scalars['String']['output'];
  isCorrect: Scalars['Boolean']['output'];
  originalPhoneme: Scalars['String']['output'];
  tip: Scalars['String']['output'];
};

export enum ApiHubServiceAcquisitionMethod {
  ApiKeyOnly = 'API_KEY_ONLY',
  Basic = 'BASIC',
  Manual = 'MANUAL',
  None = 'NONE',
  PartnerProxy = 'PARTNER_PROXY',
  Sso = 'SSO'
}

export type ApiHubServiceApiCredential = {
  __typename?: 'ApiHubServiceApiCredential';
  accountAlias?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  credentialType?: Maybe<ApiHubServiceApiCredentialType>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  externalAccountId?: Maybe<Scalars['String']['output']>;
  fields: Scalars['JSON']['output'];
  id: Scalars['UUID']['output'];
  isCurrent: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  providerCode: Scalars['String']['output'];
  refreshExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  scope?: Maybe<ApiHubServiceScope>;
  status: ApiHubServiceApiCredentialStatus;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ApiHubServiceApiCredentialFilter = {
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  providerCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  rotationGroupIdEq?: InputMaybe<Scalars['String']['input']>;
  scopeIn?: InputMaybe<Array<ApiHubServiceScope>>;
  statusIn?: InputMaybe<Array<ApiHubServiceApiCredentialStatus>>;
  tenantIdEq?: InputMaybe<Scalars['String']['input']>;
};

export type ApiHubServiceApiCredentialList = {
  __typename?: 'ApiHubServiceApiCredentialList';
  credentials: Array<ApiHubServiceApiCredential>;
  total: Scalars['Int']['output'];
};

export enum ApiHubServiceApiCredentialStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE'
}

export enum ApiHubServiceApiCredentialStrategy {
  Global = 'GLOBAL',
  Tenant = 'TENANT'
}

export type ApiHubServiceApiCredentialTemplate = {
  __typename?: 'ApiHubServiceApiCredentialTemplate';
  acquisitionMethod: ApiHubServiceAcquisitionMethod;
  createdAt: Scalars['DateTime']['output'];
  credentialType: ApiHubServiceApiCredentialType;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  providerCode: Scalars['String']['output'];
  schema: Scalars['JSON']['output'];
  templateCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ApiHubServiceApiCredentialTemplateList = {
  __typename?: 'ApiHubServiceApiCredentialTemplateList';
  templates: Array<ApiHubServiceApiCredentialTemplate>;
  total: Scalars['Int']['output'];
};

export enum ApiHubServiceApiCredentialType {
  ApiKey = 'API_KEY',
  Basic = 'BASIC',
  Custom = 'CUSTOM',
  None = 'NONE',
  Oauth2 = 'OAUTH2'
}

export type ApiHubServiceApiProvider = {
  __typename?: 'ApiHubServiceApiProvider';
  connectorKind: ApiHubServiceConnectorKind;
  connectorQueue?: Maybe<Scalars['String']['output']>;
  connectorUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credentialStrategy: ApiHubServiceApiCredentialStrategy;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  providerCode: Scalars['String']['output'];
  providerName?: Maybe<Scalars['String']['output']>;
  status: ApiHubServiceApiProviderStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type ApiHubServiceApiProviderList = {
  __typename?: 'ApiHubServiceApiProviderList';
  providers: Array<ApiHubServiceApiProvider>;
  total: Scalars['Int']['output'];
};

export type ApiHubServiceApiResponse = {
  __typename?: 'ApiHubServiceApiResponse';
  data?: Maybe<Scalars['JSON']['output']>;
  extraData?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export enum ApiHubServiceConnectorKind {
  Grpc = 'grpc',
  Http = 'http',
  Kafka = 'kafka',
  Nats = 'nats'
}

export type ApiHubServiceCreateApiCredentialInput = {
  acquisitionMethod: ApiHubServiceAcquisitionMethod;
  credentialType: ApiHubServiceApiCredentialType;
  fields: Scalars['JSON']['input'];
  providerCode: Scalars['String']['input'];
  scope: ApiHubServiceScope;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type ApiHubServiceCreateApiProviderInput = {
  connectorKind?: ApiHubServiceConnectorKind;
  connectorQueue?: InputMaybe<Scalars['String']['input']>;
  connectorUrl?: InputMaybe<Scalars['String']['input']>;
  credentialStrategy?: ApiHubServiceApiCredentialStrategy;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  providerCode: Scalars['String']['input'];
  providerName?: InputMaybe<Scalars['String']['input']>;
  status?: ApiHubServiceApiProviderStatus;
};

export type ApiHubServiceLinkFilter = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  providerCodeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  strategyIn?: InputMaybe<Array<ApiHubServiceLinkStrategy>>;
  tenantIdEq?: InputMaybe<Scalars['String']['input']>;
};

export enum ApiHubServiceLinkStrategy {
  Global = 'GLOBAL',
  Tenant = 'TENANT'
}

export type ApiHubServicePagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type ApiHubServicePromoteApiCredentialInput = {
  rotationGroupId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type ApiHubServiceRollbackApiCredentialInput = {
  rotationGroupId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

export type ApiHubServiceRotateApiCredentialInput = {
  acquisitionMethod?: InputMaybe<ApiHubServiceAcquisitionMethod>;
  compatTags?: InputMaybe<Array<Scalars['String']['input']>>;
  credentialType?: InputMaybe<ApiHubServiceApiCredentialType>;
  fields?: InputMaybe<Scalars['JSON']['input']>;
  rotationGroupId: Scalars['String']['input'];
  templateCode?: InputMaybe<Scalars['String']['input']>;
};

export enum ApiHubServiceScope {
  Global = 'GLOBAL',
  Tenant = 'TENANT'
}

export enum ApiHubServiceSelectionPolicy {
  GlobalOnly = 'GLOBAL_ONLY',
  GlobalPreferredWithTenantFallback = 'GLOBAL_PREFERRED_WITH_TENANT_FALLBACK',
  TenantOnly = 'TENANT_ONLY',
  TenantPreferredWithGlobalFallback = 'TENANT_PREFERRED_WITH_GLOBAL_FALLBACK'
}

export type ApiHubServiceTenantProviderLink = {
  __typename?: 'ApiHubServiceTenantProviderLink';
  createdAt: Scalars['DateTime']['output'];
  credentialRefId?: Maybe<Scalars['UUID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isDefault: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  priority: Scalars['Int']['output'];
  providerCode: Scalars['String']['output'];
  selectionPolicy: ApiHubServiceSelectionPolicy;
  strategy: ApiHubServiceLinkStrategy;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ApiHubServiceTenantProviderLinkList = {
  __typename?: 'ApiHubServiceTenantProviderLinkList';
  links: Array<ApiHubServiceTenantProviderLink>;
  total: Scalars['Int']['output'];
};

export type ApiHubServiceUpdateApiCredentialInput = {
  fields: Scalars['JSON']['input'];
  id: Scalars['UUID']['input'];
};

export type ApiHubServiceUpdateApiProviderInput = {
  connectorKind?: InputMaybe<ApiHubServiceConnectorKind>;
  connectorQueue?: InputMaybe<Scalars['String']['input']>;
  connectorUrl?: InputMaybe<Scalars['String']['input']>;
  credentialStrategy?: InputMaybe<ApiHubServiceApiCredentialStrategy>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ApiHubServiceApiProviderStatus>;
};

export type ApiHubServiceUpsertApiCredentialTemplateInput = {
  acquisitionMethod: ApiHubServiceAcquisitionMethod;
  credentialType: ApiHubServiceApiCredentialType;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  providerCode: Scalars['String']['input'];
  schema: Scalars['JSON']['input'];
  templateCode: Scalars['String']['input'];
};

export type ApiHubServiceUpsertTenantProviderLinkInput = {
  credentialRefId?: InputMaybe<Scalars['UUID']['input']>;
  isDefault?: Scalars['Boolean']['input'];
  isEnabled?: Scalars['Boolean']['input'];
  priority?: Scalars['Int']['input'];
  providerCode: Scalars['String']['input'];
  selectionPolicy: ApiHubServiceSelectionPolicy;
  strategy: ApiHubServiceLinkStrategy;
  tenantId: Scalars['String']['input'];
};

export enum ArticleQueryTypeEnum {
  Daily = 'Daily',
  Featured = 'Featured',
  MostViewed = 'MostViewed'
}

export type AuthServiceChangePasswordGqlInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type AuthServiceConfirmTokenGqlInput = {
  token: Scalars['String']['input'];
};

export type AuthServiceForgotPasswordGqlInput = {
  email: Scalars['String']['input'];
};

export type AuthServiceImpersonateUserGqlInput = {
  targetUserId: Scalars['String']['input'];
};

export type AuthServiceKratosLoginGqlInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type AuthServiceKratosMe = {
  __typename?: 'AuthServiceKratosMe';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  zaloId?: Maybe<Scalars['String']['output']>;
};

export type AuthServiceKratosRefreshTokenGqlInput = {
  refreshToken: Scalars['String']['input'];
};

export type AuthServiceKratosUserGqlOutput = {
  __typename?: 'AuthServiceKratosUserGqlOutput';
  accessToken: Scalars['String']['output'];
  accessTokenExpiry: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  refreshTokenExpiry: Scalars['String']['output'];
  user: AuthServiceUser;
};

export type AuthServiceKratosZaloLoginGqlInput = {
  phoneNumberToken: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AuthServiceLoginGqlInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type AuthServiceLoginWithSocialGqlInput = {
  token: Scalars['String']['input'];
};

export type AuthServiceRegisterGqlInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type AuthServiceResetPasswordGqlInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AuthServiceTokenGqlOutput = {
  __typename?: 'AuthServiceTokenGqlOutput';
  accessToken: Scalars['String']['output'];
  accessTokenExpiry: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  refreshTokenExpiry: Scalars['String']['output'];
  user: UserServiceUserGqlOutput;
};

export type AuthServiceUser = {
  __typename?: 'AuthServiceUser';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  zaloId?: Maybe<Scalars['String']['output']>;
};

export type AuthServiceZaloLoginGqlInput = {
  phoneNumberToken: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type BenefitConfig = {
  __typename?: 'BenefitConfig';
  discountType?: Maybe<Scalars['String']['output']>;
  discountValue?: Maybe<Scalars['Float']['output']>;
  pointsMultiplier?: Maybe<Scalars['Float']['output']>;
  pointsToEarn?: Maybe<Scalars['Float']['output']>;
  tierUpgrade?: Maybe<Scalars['String']['output']>;
  voucherTypeId?: Maybe<Scalars['String']['output']>;
};

export type BenefitConfigInput = {
  discountType?: InputMaybe<CampaignDiscountType>;
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  pointsMultiplier?: InputMaybe<Scalars['Float']['input']>;
  pointsToEarn?: InputMaybe<Scalars['Float']['input']>;
  tierUpgrade?: InputMaybe<Scalars['String']['input']>;
  voucherTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type BenefitDetailsInput = {
  additionalBenefits?: InputMaybe<Array<Scalars['String']['input']>>;
  discounts?: InputMaybe<Array<DiscountInput>>;
  exclusiveAccess?: InputMaybe<Scalars['Boolean']['input']>;
  freeServices?: InputMaybe<Array<Scalars['String']['input']>>;
  prioritySupport?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BinoAdminServiceAuthoritiesReportFilterGqlInput = {
  exp?: InputMaybe<Scalars['String']['input']>;
  logic?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type BinoAdminServiceAuthoritiesReportGqlOutput = {
  __typename?: 'BinoAdminServiceAuthoritiesReportGqlOutput';
  authorId: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  evidenceDescription?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incidentDescription?: Maybe<Scalars['String']['output']>;
  incidentLocation?: Maybe<Scalars['String']['output']>;
  incidentTime?: Maybe<Scalars['Time']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  postId: Scalars['ID']['output'];
  proposedAction?: Maybe<Scalars['String']['output']>;
  severityLevel?: Maybe<BinoAdminServiceSeverityLevel>;
  status: BinoAdminServiceAuthoritiesReportStatus;
  statusHistory: Array<BinoAdminServiceStatusChangeGqlOutput>;
  submitterId: Scalars['ID']['output'];
  supportingDocs?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['Time']['output'];
  urgencyLevel: BinoAdminServiceUrgencyLevel;
  violationTypeRef?: Maybe<BinoAdminServiceViolationTypeRefGqlOutput>;
  violatorAddress?: Maybe<Scalars['String']['output']>;
  violatorIdCard?: Maybe<Scalars['String']['output']>;
  violatorName?: Maybe<Scalars['String']['output']>;
};

export type BinoAdminServiceAuthoritiesReportListGqlOutput = {
  __typename?: 'BinoAdminServiceAuthoritiesReportListGqlOutput';
  authoritiesReports: Array<BinoAdminServiceAuthoritiesReportGqlOutput>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BinoAdminServiceAuthoritiesReportListParamsGqlInput = {
  authorId?: InputMaybe<Scalars['ID']['input']>;
  columns?: InputMaybe<Array<BinoAdminServiceAuthoritiesReportFilterGqlInput>>;
  createdFrom?: InputMaybe<Scalars['Time']['input']>;
  createdTo?: InputMaybe<Scalars['Time']['input']>;
  incidentFrom?: InputMaybe<Scalars['Time']['input']>;
  incidentTo?: InputMaybe<Scalars['Time']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  severityLevel?: InputMaybe<BinoAdminServiceSeverityLevel>;
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BinoAdminServiceAuthoritiesReportStatus>;
  submitterId?: InputMaybe<Scalars['ID']['input']>;
  urgencyLevel?: InputMaybe<BinoAdminServiceUrgencyLevel>;
  violationType?: InputMaybe<Scalars['String']['input']>;
};

export enum BinoAdminServiceAuthoritiesReportStatus {
  AuthorityProcessing = 'AuthorityProcessing',
  AuthorityResponded = 'AuthorityResponded',
  Closed = 'Closed',
  Rejected = 'Rejected',
  Submitted = 'Submitted'
}

export type BinoAdminServiceCreateAuthoritiesReportGqlInput = {
  authorId: Scalars['ID']['input'];
  evidenceDescription?: InputMaybe<Scalars['String']['input']>;
  incidentDescription: Scalars['String']['input'];
  incidentLocation: Scalars['String']['input'];
  incidentTime: Scalars['Time']['input'];
  postId: Scalars['ID']['input'];
  proposedAction: Scalars['String']['input'];
  severityLevel: BinoAdminServiceSeverityLevel;
  supportingDocs?: InputMaybe<Array<Scalars['String']['input']>>;
  urgencyLevel: BinoAdminServiceUrgencyLevel;
  violationType: Scalars['String']['input'];
  violatorAddress?: InputMaybe<Scalars['String']['input']>;
  violatorIdCard?: InputMaybe<Scalars['String']['input']>;
  violatorName?: InputMaybe<Scalars['String']['input']>;
};

export enum BinoAdminServicePostCategory {
  Accident = 'Accident',
  Crime = 'Crime',
  Environment = 'Environment',
  Fire = 'Fire',
  Flood = 'Flood',
  Infrastructure = 'Infrastructure',
  Other = 'Other',
  Traffic = 'Traffic'
}

export type BinoAdminServicePostGqlOutput = {
  __typename?: 'BinoAdminServicePostGqlOutput';
  address?: Maybe<Scalars['String']['output']>;
  audioUrls?: Maybe<Array<Scalars['String']['output']>>;
  category: BinoAdminServicePostCategory;
  createdAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  isAnonymous: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lat: Scalars['Float']['output'];
  long: Scalars['Float']['output'];
  status: BinoAdminServicePostStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  userId: Scalars['ID']['output'];
  videoUrls?: Maybe<Array<Scalars['String']['output']>>;
};

export type BinoAdminServicePostListGqlOutput = {
  __typename?: 'BinoAdminServicePostListGqlOutput';
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  posts: Array<BinoAdminServicePostGqlOutput>;
  total: Scalars['Int']['output'];
};

export type BinoAdminServicePostListParamsGqlInput = {
  category?: InputMaybe<BinoAdminServicePostCategory>;
  createdFrom?: InputMaybe<Scalars['Time']['input']>;
  createdTo?: InputMaybe<Scalars['Time']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BinoAdminServicePostStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum BinoAdminServicePostStatus {
  AwaitAuthorityResponse = 'AwaitAuthorityResponse',
  Canceled = 'Canceled',
  InformationIdentificationCompleted = 'InformationIdentificationCompleted',
  Processed = 'Processed',
  Rejected = 'Rejected',
  Resolved = 'Resolved',
  Resolving = 'Resolving',
  Unverified = 'Unverified',
  Verifying = 'Verifying'
}

export enum BinoAdminServiceSeverityLevel {
  Critical = 'Critical',
  Minor = 'Minor',
  Moderate = 'Moderate',
  Serious = 'Serious'
}

export type BinoAdminServiceStatusChangeGqlOutput = {
  __typename?: 'BinoAdminServiceStatusChangeGqlOutput';
  changedAt: Scalars['Time']['output'];
  changedBy: Scalars['ID']['output'];
  changedByName: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  status: BinoAdminServiceAuthoritiesReportStatus;
};

export type BinoAdminServiceUpdateAuthoritiesReportStatusGqlInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  status: BinoAdminServiceAuthoritiesReportStatus;
};

export enum BinoAdminServiceUrgencyLevel {
  Critical = 'Critical',
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export type BinoAdminServiceViolationTypeRefGqlOutput = {
  __typename?: 'BinoAdminServiceViolationTypeRefGqlOutput';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BlockTemplateOutput = {
  __typename?: 'BlockTemplateOutput';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  defaultProps?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  propsSchema?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  tenantType: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

/** The tenant type for the block template */
export enum BlockTenantType {
  Common = 'COMMON',
  TenantBased = 'TENANT_BASED'
}

/** The supported block types */
export enum BlockTypeEnum {
  CtaButton = 'CTA_BUTTON',
  ImageSlider = 'IMAGE_SLIDER',
  Markdown = 'MARKDOWN',
  SingleImage = 'SINGLE_IMAGE',
  Video = 'VIDEO',
  Wysiwyg = 'WYSIWYG'
}

export enum BookingMode {
  Custom = 'Custom',
  Slot = 'Slot'
}

export type BookingServiceAvailableDayGqlOutput = {
  __typename?: 'BookingServiceAvailableDayGqlOutput';
  date: Scalars['DateTime']['output'];
};

export type BookingServiceAvailableDaysGqlInput = {
  branchId: Scalars['String']['input'];
  month: Scalars['Int']['input'];
  slotId?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};

export type BookingServiceAvailableMonthGqlOutput = {
  __typename?: 'BookingServiceAvailableMonthGqlOutput';
  month: Scalars['Int']['output'];
  monthName: Scalars['String']['output'];
};

export type BookingServiceAvailableMonthsGqlInput = {
  branchId: Scalars['String']['input'];
  slotId?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};

export type BookingServiceAvailableTimeGqlOutput = {
  __typename?: 'BookingServiceAvailableTimeGqlOutput';
  shift: BookingServiceShiftGqlOutput;
};

export type BookingServiceAvailableTimesGqlInput = {
  branchId: Scalars['String']['input'];
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  slotId?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};

export type BookingServiceBookingGqlInput = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  employeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hasPayment?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  numOfAdults?: InputMaybe<Scalars['Int']['input']>;
  numOfChildren?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  productSuggestions?: InputMaybe<Array<Scalars['String']['input']>>;
  products?: InputMaybe<Array<BookingServiceBookingProductGqlInput>>;
  requests?: InputMaybe<Array<BookingServiceBookingRequestGqlInput>>;
  reserveDate?: InputMaybe<Scalars['DateTime']['input']>;
  reserveName?: InputMaybe<Scalars['String']['input']>;
  reserveTime?: InputMaybe<Scalars['DateTime']['input']>;
  slotId?: InputMaybe<Scalars['String']['input']>;
};

export type BookingServiceBookingGqlOutput = {
  __typename?: 'BookingServiceBookingGqlOutput';
  branchId?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  employeeIds?: Maybe<Array<Scalars['String']['output']>>;
  hasPayment?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  numOfAdults?: Maybe<Scalars['Int']['output']>;
  numOfChildren?: Maybe<Scalars['Int']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  productSuggestions?: Maybe<Array<Scalars['String']['output']>>;
  products?: Maybe<Array<BookingServiceBookingProductGqlOutput>>;
  requests?: Maybe<Array<BookingServiceBookingRequestGqlOutput>>;
  reserveDate?: Maybe<Scalars['DateTime']['output']>;
  reserveName?: Maybe<Scalars['String']['output']>;
  reserveTime?: Maybe<Scalars['DateTime']['output']>;
  slotId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BookingStatus>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type BookingServiceBookingProductGqlInput = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type BookingServiceBookingProductGqlOutput = {
  __typename?: 'BookingServiceBookingProductGqlOutput';
  productId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
};

export type BookingServiceBookingRequestGqlInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type BookingServiceBookingRequestGqlOutput = {
  __typename?: 'BookingServiceBookingRequestGqlOutput';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type BookingServiceBookingsGqlOutput = {
  __typename?: 'BookingServiceBookingsGqlOutput';
  /** Array of found items */
  data: Array<BookingServiceBookingGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type BookingServiceCreateProductSuggestionGqlInput = {
  branchId: Scalars['String']['input'];
  listProducts: Array<BookingServiceListProductGqlInput>;
};

export type BookingServiceListProductGqlInput = {
  category: Scalars['String']['input'];
  products: Array<Scalars['String']['input']>;
};

export type BookingServiceListProductGqlOutput = {
  __typename?: 'BookingServiceListProductGqlOutput';
  category: Scalars['String']['output'];
  products: Array<Scalars['String']['output']>;
};

export type BookingServiceMyBookingsFilterGqlInput = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  hasPayment?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  reserveDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  reserveDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  reserveName?: InputMaybe<Scalars['String']['input']>;
  reserveTimeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  reserveTimeTo?: InputMaybe<Scalars['DateTime']['input']>;
  slotId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BookingStatus>;
};

export type BookingServiceProductSuggestionGqlOutput = {
  __typename?: 'BookingServiceProductSuggestionGqlOutput';
  branchId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  listProducts: Array<BookingServiceListProductGqlOutput>;
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BookingServiceScheduleGqlInput = {
  customDates?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  daysOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  monthsOfYear?: InputMaybe<Array<Scalars['Int']['input']>>;
  recurrenceType: RecurrenceType;
  shifts?: InputMaybe<Array<BookingServiceShiftGqlInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingServiceScheduleGqlOutput = {
  __typename?: 'BookingServiceScheduleGqlOutput';
  customDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  daysOfMonth?: Maybe<Array<Scalars['Int']['output']>>;
  daysOfWeek?: Maybe<Array<DayOfWeek>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  monthsOfYear?: Maybe<Array<Scalars['Int']['output']>>;
  recurrenceType: Scalars['String']['output'];
  shifts?: Maybe<Array<BookingServiceShiftGqlOutput>>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type BookingServiceShiftGqlInput = {
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type BookingServiceShiftGqlOutput = {
  __typename?: 'BookingServiceShiftGqlOutput';
  endTime: Scalars['DateTime']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type BookingServiceSlotGqlInput = {
  bookingMode: BookingMode;
  description: Scalars['String']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  schedule: Array<BookingServiceScheduleGqlInput>;
};

export type BookingServiceSlotGqlOutput = {
  __typename?: 'BookingServiceSlotGqlOutput';
  bookingMode: BookingMode;
  branchId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  schedule: Array<BookingServiceScheduleGqlOutput>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BookingServiceUpdateProductSuggestionGqlInput = {
  branchId?: InputMaybe<Scalars['String']['input']>;
  listProducts?: InputMaybe<Array<BookingServiceListProductGqlInput>>;
};

export enum BookingStatus {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Pending = 'Pending'
}

export type BrandServiceBrandGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type BrandServiceBrandGqlOutput = {
  __typename?: 'BrandServiceBrandGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BrandServiceBrandsGqlOutput = {
  __typename?: 'BrandServiceBrandsGqlOutput';
  /** Array of found items */
  data: Array<BrandServiceBrandGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type Campaign = {
  __typename?: 'Campaign';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startTime: Scalars['Time']['output'];
  status: FlashSaleStatus;
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** The action type of the campaign */
export enum CampaignActionType {
  AddPoints = 'ADD_POINTS',
  ApplyDiscount = 'APPLY_DISCOUNT',
  IssueVoucher = 'ISSUE_VOUCHER',
  Mixed = 'MIXED'
}

/** The discount type of the campaign */
export enum CampaignDiscountType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

/** The recurring pattern of the campaign */
export enum CampaignRecurringPattern {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type CampaignServiceCampaignGqlOutput = {
  __typename?: 'CampaignServiceCampaignGqlOutput';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  benefitConfig?: Maybe<BenefitConfig>;
  campaignType: CampaignType;
  createdAt: Scalars['DateTime']['output'];
  currentParticipants?: Maybe<Scalars['Float']['output']>;
  description: Scalars['String']['output'];
  eligibilityRules?: Maybe<EligibilityRules>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  isStackable?: Maybe<Scalars['Boolean']['output']>;
  locations?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Float']['output']>;
  recurringPattern?: Maybe<CampaignRecurringPattern>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: CampaignStatus;
  targetAudience?: Maybe<Scalars['String']['output']>;
  targetParticipants?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  triggerType: CampaignTriggerEventType;
  updatedAt: Scalars['DateTime']['output'];
  usageLimitPerUser?: Maybe<Scalars['Float']['output']>;
  voucherLimit?: Maybe<Scalars['Float']['output']>;
  vouchersIssued?: Maybe<Scalars['Float']['output']>;
};

export type CampaignServiceCampaignTriggerGqlInput = {
  action: CampaignTriggerActionInput;
  campaignId: Scalars['String']['input'];
  conditions?: InputMaybe<CampaignTriggerConditionsInput>;
  eventType: CampaignTriggerEventType;
  sourceService: ServiceName;
  tenantId: Scalars['String']['input'];
};

export type CampaignServiceCampaignTriggerGqlOutput = {
  __typename?: 'CampaignServiceCampaignTriggerGqlOutput';
  action?: Maybe<CampaignTriggerAction>;
  campaignId: Scalars['String']['output'];
  conditions?: Maybe<CampaignTriggerConditions>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eventType: CampaignTriggerEventType;
  id: Scalars['String']['output'];
  sourceService: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CampaignServiceCampaignTriggersGqlOutput = {
  __typename?: 'CampaignServiceCampaignTriggersGqlOutput';
  data: Array<CampaignServiceCampaignTriggerGqlOutput>;
  total: Scalars['Int']['output'];
};

export type CampaignServiceCampaignsGqlOutput = {
  __typename?: 'CampaignServiceCampaignsGqlOutput';
  data: Array<CampaignServiceCampaignGqlOutput>;
  total: Scalars['Int']['output'];
};

export type CampaignServiceCreateCampaignGqlInput = {
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  benefitConfig?: InputMaybe<BenefitConfigInput>;
  campaignType: CampaignType;
  description: Scalars['String']['input'];
  eligibilityRules?: InputMaybe<EligibilityRulesInput>;
  endDate: Scalars['DateTime']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  isStackable?: InputMaybe<Scalars['Boolean']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Float']['input']>;
  recurringPattern?: InputMaybe<CampaignRecurringPattern>;
  startDate: Scalars['DateTime']['input'];
  status?: CampaignStatus;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  targetParticipants?: InputMaybe<Scalars['Float']['input']>;
  tenantId: Scalars['String']['input'];
  triggerType: CampaignTriggerEventType;
  usageLimitPerUser?: InputMaybe<Scalars['Float']['input']>;
  voucherLimit?: InputMaybe<Scalars['Float']['input']>;
  vouchersIssued?: InputMaybe<Scalars['Float']['input']>;
};

export type CampaignServiceUpdateCampaignGqlInput = {
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  benefitConfig?: InputMaybe<BenefitConfigInput>;
  campaignType: CampaignType;
  description: Scalars['String']['input'];
  eligibilityRules?: InputMaybe<EligibilityRulesInput>;
  endDate: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  isStackable?: InputMaybe<Scalars['Boolean']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Float']['input']>;
  recurringPattern?: InputMaybe<CampaignRecurringPattern>;
  startDate: Scalars['DateTime']['input'];
  status?: CampaignStatus;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  targetParticipants?: InputMaybe<Scalars['Float']['input']>;
  tenantId: Scalars['String']['input'];
  triggerType: CampaignTriggerEventType;
  usageLimitPerUser?: InputMaybe<Scalars['Float']['input']>;
  voucherLimit?: InputMaybe<Scalars['Float']['input']>;
  vouchersIssued?: InputMaybe<Scalars['Float']['input']>;
};

export type CampaignServiceUpdateCampaignTriggerGqlInput = {
  action: CampaignTriggerActionInput;
  campaignId: Scalars['String']['input'];
  conditions?: InputMaybe<CampaignTriggerConditionsInput>;
  eventType: CampaignTriggerEventType;
  id: Scalars['String']['input'];
  sourceService: ServiceName;
  tenantId: Scalars['String']['input'];
};

/** The status of the campaign */
export enum CampaignStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Ended = 'ENDED',
  Scheduled = 'SCHEDULED'
}

export enum CampaignStatusEnum {
  Active = 'Active',
  Draft = 'Draft',
  Ended = 'Ended',
  Paused = 'Paused'
}

export type CampaignTriggerAction = {
  __typename?: 'CampaignTriggerAction';
  actions?: Maybe<Array<CampaignTriggerActionItem>>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  voucherTypeId?: Maybe<Scalars['String']['output']>;
};

export type CampaignTriggerActionInput = {
  actions?: InputMaybe<Array<CampaignTriggerActionItemInput>>;
  type: CampaignActionType;
  value?: InputMaybe<Scalars['Float']['input']>;
  voucherTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignTriggerActionItem = {
  __typename?: 'CampaignTriggerActionItem';
  type: Scalars['String']['output'];
  value: Scalars['Float']['output'];
  voucherTypeId?: Maybe<Scalars['String']['output']>;
};

export type CampaignTriggerActionItemInput = {
  type: CampaignActionType;
  value: Scalars['Float']['input'];
  voucherTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignTriggerConditions = {
  __typename?: 'CampaignTriggerConditions';
  categoryIds?: Maybe<Array<Scalars['String']['output']>>;
  pointsThreshold?: Maybe<Scalars['Float']['output']>;
  productIds?: Maybe<Array<Scalars['String']['output']>>;
  purchaseAmount?: Maybe<Scalars['Float']['output']>;
};

export type CampaignTriggerConditionsInput = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pointsThreshold?: InputMaybe<Scalars['Float']['input']>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseAmount?: InputMaybe<Scalars['Float']['input']>;
};

/** The trigger event type of the campaign */
export enum CampaignTriggerEventType {
  Birthday = 'BIRTHDAY',
  PointsThreshold = 'POINTS_THRESHOLD',
  Purchase = 'PURCHASE',
  Registration = 'REGISTRATION',
  TierChange = 'TIER_CHANGE'
}

/** The type of the campaign */
export enum CampaignType {
  Discount = 'DISCOUNT',
  Mixed = 'MIXED',
  Points = 'POINTS',
  TierUpgrade = 'TIER_UPGRADE',
  Voucher = 'VOUCHER'
}

export type CartServiceCartGqlOutput = {
  __typename?: 'CartServiceCartGqlOutput';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  products: Array<CartServiceCartProductGqlOutput>;
  tenantId: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  totalAmountFormatted: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type CartServiceCartProductGqlOutput = {
  __typename?: 'CartServiceCartProductGqlOutput';
  currency: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceFormatted: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<CartServiceCartProductVariantGqlOutput>;
};

export type CartServiceCartProductVariantAttributeGqlOutput = {
  __typename?: 'CartServiceCartProductVariantAttributeGqlOutput';
  colorCode?: Maybe<Scalars['String']['output']>;
  colorName?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CartServiceCartProductVariantGqlOutput = {
  __typename?: 'CartServiceCartProductVariantGqlOutput';
  attributeKey?: Maybe<Scalars['String']['output']>;
  attributeValue?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Array<CartServiceCartProductVariantAttributeGqlOutput>>;
  basePrice: Scalars['Float']['output'];
  basePriceFormatted: Scalars['String']['output'];
  mediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceFormatted: Scalars['String']['output'];
  sku: Scalars['String']['output'];
};

export type CartServiceCreateGqlInput = {
  products: Array<CartServiceProductGqlInput>;
};

export type CartServiceDeleteGqlInput = {
  cartId: Scalars['ID']['input'];
};

export type CartServiceGetGqlInput = {
  /** Maximum number of items to return (1-100) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of items to skip (offset) */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Multiple sort fields for complex sorting */
  sort?: InputMaybe<Array<SortFieldArgs>>;
};

export type CartServiceProductGqlInput = {
  name: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  variant?: InputMaybe<CartServiceProductVariantGqlInput>;
};

export type CartServiceProductVariantGqlInput = {
  attributeKey: Scalars['String']['input'];
  attributeValue: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export type CartServiceUpdateGqlInput = {
  cartId: Scalars['ID']['input'];
  products: Array<CartServiceProductGqlInput>;
};

export enum CheckinMethodEnum {
  Gps = 'Gps',
  Image = 'Image',
  QrCode = 'QrCode',
  Wifi = 'Wifi'
}

export type CheckinMethodGqlInput = {
  gpsConfig?: InputMaybe<GpsConfigGqlInput>;
  imageConfig?: InputMaybe<ImageConfigGqlInput>;
  methodType: CheckinMethodEnum;
  wifiConfig?: InputMaybe<WiFiConfigGqlInput>;
};

export type CheckinMethodGqlOutput = {
  __typename?: 'CheckinMethodGqlOutput';
  gpsConfig?: Maybe<GpsConfigGqlOutput>;
  imageConfig?: Maybe<ImageConfigGqlOutput>;
  methodType: CheckinMethodEnum;
  wifiConfig?: Maybe<WiFiConfigGqlOutput>;
};

export type CheckinServiceCheckinGqlOutput = {
  __typename?: 'CheckinServiceCheckinGqlOutput';
  checkinMethod: Scalars['String']['output'];
  checkinTime: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  gpsVerification?: Maybe<GpsVerificationGqlOutput>;
  id: Scalars['String']['output'];
  imageVerification?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  qrCode?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  wifiVerification?: Maybe<WiFiVerificationGqlOutput>;
};

export type CheckinServiceGpsCheckinGqlInput = {
  allowedLatitude: Scalars['Float']['input'];
  allowedLongitude: Scalars['Float']['input'];
  allowedRadius: Scalars['Float']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  userId: Scalars['String']['input'];
};

export type CheckinServiceImageCheckinGqlInput = {
  imageUrl: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CheckinServiceQrCodeCheckinGqlInput = {
  allowedQrCode: Scalars['String']['input'];
  qrCode: Scalars['String']['input'];
};

export type CheckinServiceStatusGqlOutput = {
  __typename?: 'CheckinServiceStatusGqlOutput';
  checkinId: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type CheckinServiceWifiCheckinGqlInput = {
  allowedBSSIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedSSIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  bssid: Scalars['String']['input'];
  ssid: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ClockinServiceClockinGqlInput = {
  date: Scalars['DateTime']['input'];
  shiftId: Scalars['String']['input'];
};

export type ClockinServiceClockinGqlOutput = {
  __typename?: 'ClockinServiceClockinGqlOutput';
  acceptedBy: Scalars['String']['output'];
  checkinId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isAccepted: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  shiftId: Scalars['String']['output'];
  staffId: Scalars['String']['output'];
  status: ClockinStatusEnum;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ClockinServiceGpsClockinGqlInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type ClockinServiceImageClockinGqlInput = {
  imageUrl: Scalars['String']['input'];
};

export type ClockinServiceShiftGqlInput = {
  checkinMethod: CheckinMethodGqlInput;
  endTime: Scalars['DateTime']['input'];
  location: Scalars['String']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  staffIds: Array<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
};

export type ClockinServiceShiftGqlOutput = {
  __typename?: 'ClockinServiceShiftGqlOutput';
  checkinMethod: CheckinMethodGqlOutput;
  createdAt: Scalars['DateTime']['output'];
  endTime: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  staffIds: Array<Scalars['String']['output']>;
  startTime: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ClockinServiceWifiClockinGqlInput = {
  bssid: Scalars['String']['input'];
  ssid: Scalars['String']['input'];
};

export enum ClockinStatusEnum {
  Late = 'Late',
  OnTime = 'OnTime'
}

export type CommissionHistoryOutput = {
  __typename?: 'CommissionHistoryOutput';
  commissions: Array<CommissionOutput>;
  hasNextPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type CommissionOutput = {
  __typename?: 'CommissionOutput';
  amount: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  level: Scalars['Int']['output'];
  parentUserId: Scalars['String']['output'];
  percentage: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  sourceAmount: Scalars['String']['output'];
  sourceReference: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type CommissionRateInput = {
  fixedAmount?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  percentage: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CommissionRateOutput = {
  __typename?: 'CommissionRateOutput';
  fixedAmount?: Maybe<Scalars['String']['output']>;
  level: Scalars['Int']['output'];
  percentage: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Company */
export type Company = {
  __typename?: 'Company';
  address?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  locations?: Maybe<Array<Scalars['String']['output']>>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  lunchBreak?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  totalEmployees: Scalars['Float']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
  workingHour?: Maybe<Scalars['String']['output']>;
};

export type CompanyInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  lunchBreak?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  totalEmployees: Scalars['Float']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  workingHour?: InputMaybe<Scalars['String']['input']>;
};

export type ConfigureReferralSystemOutput = {
  __typename?: 'ConfigureReferralSystemOutput';
  config: ReferralConfigOutput;
  success: Scalars['Boolean']['output'];
};

export enum ContentCategoryEnum {
  Event = 'Event',
  News = 'News',
  Policy = 'Policy'
}

export type ContentServiceArticleGqlInput = {
  category: ContentCategoryEnum;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  content: Scalars['String']['input'];
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentType: ContentTypeEnum;
  description?: InputMaybe<Scalars['String']['input']>;
  displayEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  displayStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventDate?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isMostViewed?: InputMaybe<Scalars['Boolean']['input']>;
  tags: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type ContentServiceArticleGqlOutput = {
  __typename?: 'ContentServiceArticleGqlOutput';
  category?: Maybe<ContentCategoryEnum>;
  categoryIds?: Maybe<Array<Scalars['String']['output']>>;
  content?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<ContentTypeEnum>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayEndDate?: Maybe<Scalars['DateTime']['output']>;
  displayStartDate?: Maybe<Scalars['DateTime']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  isMostViewed?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ContentStatusEnum>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  viewCount?: Maybe<Scalars['Float']['output']>;
};

export type ContentServiceBlockComponentGqlInput = {
  id: Scalars['String']['input'];
  props: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ContentServiceBlockComponentGqlOutput = {
  __typename?: 'ContentServiceBlockComponentGqlOutput';
  id: Scalars['String']['output'];
  props: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ContentServiceCategoryGqlOutput = {
  __typename?: 'ContentServiceCategoryGqlOutput';
  children?: Maybe<Array<ContentServiceCategoryGqlOutput>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<ContentServiceCategoryGqlOutput>;
  parentId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ContentServiceCreateCategoryGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentServiceCreatePageGqlInput = {
  components?: InputMaybe<Array<ContentServiceBlockComponentGqlInput>>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type: PageTypeEnum;
};

export type ContentServicePageGqlInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PageTypeEnum>;
};

export type ContentServicePageGqlOutput = {
  __typename?: 'ContentServicePageGqlOutput';
  components: Array<ContentServiceBlockComponentGqlOutput>;
  contentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type: PageTypeEnum;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContentServiceSearchArticleGqlInput = {
  category?: InputMaybe<ContentCategoryEnum>;
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContentStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ArticleQueryTypeEnum>;
};

export type ContentServiceUpdateArticleGqlInput = {
  category?: InputMaybe<ContentCategoryEnum>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<ContentTypeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  displayStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventDate?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isMostViewed?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContentServiceUpdatePageGqlInput = {
  components?: InputMaybe<Array<ContentServiceBlockComponentGqlInput>>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
  type: PageTypeEnum;
};

export enum ContentStatusEnum {
  Created = 'Created',
  Published = 'Published',
  Unpublished = 'Unpublished'
}

export enum ContentTypeEnum {
  Markdown = 'Markdown',
  Text = 'Text'
}

export type CreateBlockTemplateInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  defaultProps: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  propsSchema?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantType: BlockTenantType;
  type: BlockTypeEnum;
};

export type CreateCustomerInput = {
  /** Customer address */
  address: Scalars['String']['input'];
  /** Unique customer identifier code */
  customerCode: Scalars['String']['input'];
  /** Contact email address */
  email: Scalars['String']['input'];
  /** Customer name */
  name: Scalars['String']['input'];
  /** Contact phone number */
  phone: Scalars['String']['input'];
  /** Customer priority level (defaults to MEDIUM) */
  priority?: InputMaybe<CustomerVariantPriority>;
  /** Array of ProductInstance ObjectIds */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Customer status (defaults to ACTIVE) */
  status?: InputMaybe<CustomerVariantStatus>;
  /** Customer type (defaults to INDIVIDUAL) */
  type?: InputMaybe<CustomerVariantType>;
};

export type CreatePointConfigInput = {
  currency?: Scalars['String']['input'];
  moneyAmount: Scalars['Float']['input'];
  pointsPerUnit: Scalars['Float']['input'];
};

export type CreateReferralCodeOutput = {
  __typename?: 'CreateReferralCodeOutput';
  code: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateTicketInput = {
  /** _id of User (responsible technician or staff) */
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  /** _id of User (ticket creator) */
  createdBy: Scalars['ID']['input'];
  /** _id of Customer (ticket originator) */
  customerId: Scalars['ID']['input'];
  /** Responsible department */
  department: Scalars['String']['input'];
  /** Short description of the issue or reason for creating the ticket */
  description: Scalars['String']['input'];
  /** Array of image URLs */
  imgUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Priority (defaults to MEDIUM) */
  priority?: InputMaybe<TicketVariantPriority>;
  /** _id of ProductInstance (related device) */
  productInstanceId: Scalars['ID']['input'];
  /** Scheduled maintenance date */
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Unique ticket code */
  ticketCode: Scalars['String']['input'];
  /** Ticket type */
  type: TicketVariantType;
};

export enum CurrencyEnum {
  Usd = 'USD',
  Vnd = 'VND'
}

export type CurrentRequestHeaderGqlOutput = {
  __typename?: 'CurrentRequestHeaderGqlOutput';
  headers: Scalars['String']['output'];
};

export type CustomTheme = {
  __typename?: 'CustomTheme';
  logoUrl?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
};

export type CustomThemeInput = {
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
};

/** Customer */
export type Customer = {
  __typename?: 'Customer';
  _id: Scalars['ID']['output'];
  /** Customer address */
  address: Scalars['String']['output'];
  /** Created date */
  createdAt: Scalars['DateTime']['output'];
  /** Unique customer identifier code */
  customerCode: Scalars['String']['output'];
  /** Contact email address */
  email: Scalars['String']['output'];
  /** Customer name */
  name: Scalars['String']['output'];
  /** Contact phone number */
  phone: Scalars['String']['output'];
  /** Customer priority level */
  priority: CustomerVariantPriority;
  /** Array of ProductInstance ObjectIds */
  products: Array<Scalars['ID']['output']>;
  /** Customer registration date */
  registeredAt: Scalars['DateTime']['output'];
  /** Customer status */
  status: CustomerVariantStatus;
  /** Customer type */
  type: CustomerVariantType;
  /** Updated date */
  updatedAt: Scalars['DateTime']['output'];
};

export enum CustomerVariantPriority {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  Vip = 'Vip'
}

export enum CustomerVariantStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending',
  Suspended = 'Suspended'
}

export enum CustomerVariantType {
  Company = 'Company',
  Individual = 'Individual',
  Organization = 'Organization'
}

export type DateStats = {
  __typename?: 'DateStats';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  failedCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
};

export enum DayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type DictionaryCrossReference = {
  __typename?: 'DictionaryCrossReference';
  notes?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  words: Array<DictionaryCrossReferenceWordOutput>;
};

export type DictionaryCrossReferenceInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  words: Array<DictionaryCrossReferenceWordInput>;
};

export type DictionaryCrossReferenceWordInput = {
  partOfSpeech?: InputMaybe<Scalars['String']['input']>;
  word: Scalars['String']['input'];
};

export type DictionaryCrossReferenceWordOutput = {
  __typename?: 'DictionaryCrossReferenceWordOutput';
  partOfSpeech?: Maybe<Scalars['String']['output']>;
  word: Scalars['String']['output'];
};

export type DictionaryDefinitionInput = {
  languageDefinitions: Array<LanguageDefinitionInput>;
};

export type DictionaryDefinitionOutput = {
  __typename?: 'DictionaryDefinitionOutput';
  languageDefinitions: Array<LanguageDefinitionOutput>;
};

export type DictionaryExample = {
  __typename?: 'DictionaryExample';
  text?: Maybe<Scalars['String']['output']>;
};

export type DictionaryExampleInput = {
  text: Scalars['String']['input'];
};

export type DictionaryImage = {
  __typename?: 'DictionaryImage';
  caption?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DictionaryImageInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type DictionaryInflection = {
  __typename?: 'DictionaryInflection';
  form?: Maybe<Scalars['String']['output']>;
  pronunciations?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DictionaryInflectionInput = {
  form: Scalars['String']['input'];
  pronunciations?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type DictionaryPhrase = {
  __typename?: 'DictionaryPhrase';
  definition?: Maybe<Scalars['String']['output']>;
  examples?: Maybe<Array<DictionaryExample>>;
  phrase?: Maybe<Scalars['String']['output']>;
};

export type DictionaryPhraseInput = {
  definition: Scalars['String']['input'];
  examples?: InputMaybe<Array<DictionaryExampleInput>>;
  phrase: Scalars['String']['input'];
};

export type DictionaryPronunciation = {
  __typename?: 'DictionaryPronunciation';
  audioKey?: Maybe<Scalars['String']['output']>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  dialect?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phoneticSpelling?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  simplePhonetic?: Maybe<Scalars['String']['output']>;
};

export type DictionaryPronunciationInput = {
  audioKey?: InputMaybe<Scalars['String']['input']>;
  audioUrl?: InputMaybe<Scalars['String']['input']>;
  dialect: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneticSpelling?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  simplePhonetic?: InputMaybe<Scalars['String']['input']>;
};

export type DictionaryQuotation = {
  __typename?: 'DictionaryQuotation';
  author?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  publication?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type DictionaryQuotationInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  publication?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type DictionarySense = {
  __typename?: 'DictionarySense';
  crossReferences?: Maybe<Array<DictionaryCrossReference>>;
  definitions?: Maybe<Array<DictionaryDefinitionOutput>>;
  domain?: Maybe<Array<Scalars['String']['output']>>;
  examples?: Maybe<Array<DictionaryExample>>;
  grammar?: Maybe<Array<Scalars['String']['output']>>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  notes?: Maybe<Scalars['String']['output']>;
  quotations?: Maybe<Array<DictionaryQuotation>>;
  regions?: Maybe<Array<Scalars['String']['output']>>;
  senseNumber: Scalars['Float']['output'];
};

export type DictionarySenseInput = {
  crossReferences?: InputMaybe<Array<DictionaryCrossReferenceInput>>;
  definitions: Array<DictionaryDefinitionInput>;
  domain?: InputMaybe<Array<Scalars['String']['input']>>;
  examples?: InputMaybe<Array<DictionaryExampleInput>>;
  grammar?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quotations?: InputMaybe<Array<DictionaryQuotationInput>>;
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
  senseNumber: Scalars['Float']['input'];
};

export type DictionaryServiceCrawlWordGqlInput = {
  partOfSpeech: Scalars['String']['input'];
  word: Scalars['String']['input'];
};

export type DictionaryServiceCrawlWordOutput = {
  __typename?: 'DictionaryServiceCrawlWordOutput';
  errorMessage?: Maybe<Scalars['String']['output']>;
  isDone: Scalars['Boolean']['output'];
  partOfSpeech: Scalars['String']['output'];
  word: Scalars['String']['output'];
};

export type DictionaryServiceCrawlWordsGqlInput = {
  concurrency: Scalars['Float']['input'];
  words: Array<DictionaryServiceCrawlWordGqlInput>;
};

/** Dictionary */
export type DictionaryServiceCreateDictionaryGqlInput = {
  etymology?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<DictionaryImageInput>>;
  inflections?: InputMaybe<Array<DictionaryInflectionInput>>;
  partOfSpeech: Scalars['String']['input'];
  phrases?: InputMaybe<Array<DictionaryPhraseInput>>;
  pronunciations: Array<DictionaryPronunciationInput>;
  senses?: InputMaybe<Array<DictionarySenseInput>>;
  status?: DictionaryServiceDictionaryStatus;
  word: Scalars['String']['input'];
  wordTranslations?: InputMaybe<Array<DictionaryWordTranslationInput>>;
};

/** Dictionary */
export type DictionaryServiceDictionaryGqlOutput = {
  __typename?: 'DictionaryServiceDictionaryGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  etymology?: Maybe<Scalars['String']['output']>;
  hasAudio?: Maybe<Scalars['Boolean']['output']>;
  hasImage?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  images?: Maybe<Array<DictionaryImage>>;
  inflections?: Maybe<Array<DictionaryInflection>>;
  partOfSpeech: Scalars['String']['output'];
  phrases?: Maybe<Array<DictionaryPhrase>>;
  pronunciations?: Maybe<Array<DictionaryPronunciation>>;
  senses?: Maybe<Array<DictionarySense>>;
  status: DictionaryServiceDictionaryStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videos?: Maybe<Array<DictionaryVideo>>;
  word: Scalars['String']['output'];
  wordTranslations?: Maybe<Array<DictionaryWordTranslationOutput>>;
};

/** The status of the dictionary entry */
export enum DictionaryServiceDictionaryStatus {
  Active = 'Active',
  Deleted = 'Deleted',
  Inactive = 'Inactive'
}

export type DictionaryServiceSearchByWordAndPosInput = {
  partOfSpeech: Scalars['String']['input'];
  word: Scalars['String']['input'];
};

export type DictionaryServiceSearchDictionariesInput = {
  word?: InputMaybe<Scalars['String']['input']>;
};

export type DictionaryServiceSearchManyByWordAndPosInput = {
  wordAndPosInputs: Array<DictionaryServiceSearchByWordAndPosInput>;
};

export type DictionaryServiceUpdateDictionaryGqlInput = {
  etymology?: InputMaybe<Scalars['String']['input']>;
  hasAudio?: InputMaybe<Scalars['Boolean']['input']>;
  hasImage?: InputMaybe<Scalars['Boolean']['input']>;
  images?: InputMaybe<Array<DictionaryImageInput>>;
  inflections?: InputMaybe<Array<DictionaryInflectionInput>>;
  phrases?: InputMaybe<Array<DictionaryPhraseInput>>;
  pronunciations?: InputMaybe<Array<DictionaryPronunciationInput>>;
  senses?: InputMaybe<Array<DictionarySenseInput>>;
  status?: DictionaryServiceDictionaryStatus;
  videos?: InputMaybe<Array<DictionaryVideoInput>>;
  wordTranslations?: InputMaybe<Array<DictionaryWordTranslationInput>>;
};

export type DictionaryVideo = {
  __typename?: 'DictionaryVideo';
  caption?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DictionaryVideoInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type DictionaryWordTranslationInput = {
  lang: LanguageEnum;
  translation: Scalars['String']['input'];
};

export type DictionaryWordTranslationOutput = {
  __typename?: 'DictionaryWordTranslationOutput';
  lang?: Maybe<LanguageEnum>;
  translation?: Maybe<Scalars['String']['output']>;
};

export type DiscountInput = {
  applicableCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  applicableProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  applicableServices?: InputMaybe<Array<Scalars['String']['input']>>;
  maximumDiscount?: InputMaybe<Scalars['Float']['input']>;
  minimumPurchase?: InputMaybe<Scalars['Float']['input']>;
  percentage: Scalars['Float']['input'];
  scope?: InputMaybe<DiscountScopeEnum>;
};

/** The scope where the discount applies */
export enum DiscountScopeEnum {
  Category = 'CATEGORY',
  Order = 'ORDER',
  Product = 'PRODUCT',
  Shipping = 'SHIPPING'
}

export enum DistributionTypeEnum {
  Instant = 'Instant',
  RankBased = 'RankBased'
}

export type EarnRules = {
  __typename?: 'EarnRules';
  amountSpentRatio: Scalars['Float']['output'];
  referralBonus: Scalars['Float']['output'];
  registrationBonus: Scalars['Float']['output'];
};

export type EarnRulesInput = {
  amountSpentRatio: Scalars['Float']['input'];
  referralBonus: Scalars['Int']['input'];
  registrationBonus: Scalars['Int']['input'];
};

export type EligibilityRules = {
  __typename?: 'EligibilityRules';
  excludedProducts?: Maybe<Array<Scalars['String']['output']>>;
  firstPurchaseOnly?: Maybe<Scalars['Boolean']['output']>;
  membershipTiers?: Maybe<Array<Scalars['String']['output']>>;
  minimumSpend?: Maybe<Scalars['Float']['output']>;
  productCategories?: Maybe<Array<Scalars['String']['output']>>;
};

export type EligibilityRulesInput = {
  excludedProducts?: InputMaybe<Array<Scalars['String']['input']>>;
  firstPurchaseOnly?: InputMaybe<Scalars['Boolean']['input']>;
  membershipTiers?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumSpend?: InputMaybe<Scalars['Float']['input']>;
  productCategories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EventServiceCategoryGqlOutput = {
  __typename?: 'EventServiceCategoryGqlOutput';
  children?: Maybe<Array<EventServiceCategoryGqlOutput>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<EventServiceCategoryGqlOutput>;
  parentId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EventServiceCreateCategoryGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type EventServiceEventGqlInput = {
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  location: Scalars['String']['input'];
  mediaUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  organizerEmail: Scalars['String']['input'];
  organizerName: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  timeline?: InputMaybe<Array<EventTimeLineGqlInput>>;
};

export type EventServiceEventGqlOutput = {
  __typename?: 'EventServiceEventGqlOutput';
  bannerUrl?: Maybe<Scalars['String']['output']>;
  categoryIds?: Maybe<Array<Scalars['String']['output']>>;
  content?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
  mediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  organizerEmail: Scalars['String']['output'];
  organizerName: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  timeline?: Maybe<Array<EventTimeLineGqlOutput>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EventServiceEventRegistrationGqlOutput = {
  __typename?: 'EventServiceEventRegistrationGqlOutput';
  checkinId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  eventId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isCheckedin: Scalars['Boolean']['output'];
  qrCode: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type EventServiceSearchEventGqlInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EventTimeLineGqlInput = {
  description: Scalars['String']['input'];
  time: Scalars['DateTime']['input'];
};

export type EventTimeLineGqlOutput = {
  __typename?: 'EventTimeLineGqlOutput';
  description: Scalars['String']['output'];
  time: Scalars['DateTime']['output'];
};

export enum FeatureFlagOperatorEnum {
  Includes = 'Includes',
  NotIncludes = 'NotIncludes'
}

export type FeatureFlagServiceConditionGqlInput = {
  key: Scalars['String']['input'];
  operator: FeatureFlagOperatorEnum;
  values: Array<Scalars['String']['input']>;
};

export type FeatureFlagServiceConditionGqlOutput = {
  __typename?: 'FeatureFlagServiceConditionGqlOutput';
  key: Scalars['String']['output'];
  operator: FeatureFlagOperatorEnum;
  values: Array<Scalars['String']['output']>;
};

export type FeatureFlagServiceCreateFeatureFlagGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  featureFlagData?: InputMaybe<Array<FeatureFlagServiceFeatureFlagDataGqlInput>>;
  rules: Array<FeatureFlagServiceRuleGqlInput>;
  type: FeatureFlagTypeEnum;
};

export type FeatureFlagServiceCreateTenantOverrideGqlInput = {
  featureCode: Scalars['String']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFlagServiceDeleteTenantOverrideGqlInput = {
  featureCode: Scalars['String']['input'];
};

export type FeatureFlagServiceFeatureFlagDataGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  featureCode: Scalars['String']['input'];
};

export type FeatureFlagServiceFeatureFlagGqlOutput = {
  __typename?: 'FeatureFlagServiceFeatureFlagGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featureCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  rules: Array<FeatureFlagServiceRuleGqlOutput>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<FeatureFlagTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FeatureFlagServiceGetAllFeatureFlagGqlInput = {
  types?: InputMaybe<Array<FeatureFlagTypeEnum>>;
};

export type FeatureFlagServiceGetFeatureFlagDetailGqlInput = {
  id: Scalars['String']['input'];
  type?: InputMaybe<FeatureFlagTypeEnum>;
};

export type FeatureFlagServiceGetFeatureFlagGqlInput = {
  plan?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFlagServiceRuleGqlInput = {
  conditions: Array<FeatureFlagServiceConditionGqlInput>;
  isEnabled: Scalars['Boolean']['input'];
  priority: Scalars['Float']['input'];
};

export type FeatureFlagServiceRuleGqlOutput = {
  __typename?: 'FeatureFlagServiceRuleGqlOutput';
  conditions: Array<FeatureFlagServiceConditionGqlOutput>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  priority: Scalars['Float']['output'];
};

export type FeatureFlagServiceTenantOverrideGqlOutput = {
  __typename?: 'FeatureFlagServiceTenantOverrideGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  featureCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FeatureFlagServiceUpdateFeatureFlagGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  rules: Array<FeatureFlagServiceUpdateRuleGqlInput>;
  type?: InputMaybe<FeatureFlagTypeEnum>;
};

export type FeatureFlagServiceUpdateRuleGqlInput = {
  conditions: Array<FeatureFlagServiceConditionGqlInput>;
  isEnabled: Scalars['Boolean']['input'];
  priority: Scalars['Float']['input'];
};

export type FeatureFlagServiceUpdateTenantOverrideGqlInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  overrideId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export enum FeatureFlagTypeEnum {
  Custom = 'Custom',
  PlanBased = 'PlanBased'
}

export type FeatureServiceCreateFeatureGqlInput = {
  featureCode: Scalars['String']['input'];
  featureName: Scalars['String']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeatureServiceCreateFeaturesGqlInput = {
  features: Array<FeatureServiceCreateFeatureGqlInput>;
};

export type FeatureServiceFeatureGqlOutput = {
  __typename?: 'FeatureServiceFeatureGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  featureCode?: Maybe<Scalars['String']['output']>;
  featureName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FeatureServiceGetListGqlInput = {
  featureCode?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureServiceGetListGqlOutput = {
  __typename?: 'FeatureServiceGetListGqlOutput';
  data: Array<FeatureServiceFeatureGqlOutput>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type FeatureServiceToggleFeatureGqlInput = {
  featureCode: Scalars['String']['input'];
};

export type FeatureServiceUpdateFeatureGqlInput = {
  featureName?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterInput = {
  exp?: InputMaybe<Scalars['String']['input']>;
  logic?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FlashSaleActiveCampaignFilterInput = {
  productId?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type FlashSaleCampaignFilterInput = {
  columns?: InputMaybe<Array<FilterInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FlashSaleStatus>;
};

export type FlashSaleCampaignList = {
  __typename?: 'FlashSaleCampaignList';
  data: Array<Campaign>;
  total: Scalars['Int']['output'];
};

export type FlashSaleProduct = {
  __typename?: 'FlashSaleProduct';
  campaignId: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  endTime: Scalars['Time']['output'];
  flashSalePrice: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  originalPrice: Scalars['Float']['output'];
  productId: Scalars['ID']['output'];
  sku: Scalars['String']['output'];
  startTime: Scalars['Time']['output'];
  status: FlashSaleStatus;
  stockQuantity: Scalars['Int']['output'];
  tenantId: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type FlashSaleProductFilterInput = {
  campaignId: Scalars['ID']['input'];
  columns?: InputMaybe<Array<FilterInput>>;
  status?: InputMaybe<FlashSaleStatus>;
};

export type FlashSaleProductList = {
  __typename?: 'FlashSaleProductList';
  data: Array<FlashSaleProduct>;
  total: Scalars['Int']['output'];
};

export enum FlashSaleStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Ended = 'ENDED'
}

export type FlashsaleServiceAddProductGqlInput = {
  campaignId: Scalars['ID']['input'];
  endTime: Scalars['Time']['input'];
  flashSalePrice: Scalars['Float']['input'];
  originalPrice: Scalars['Float']['input'];
  productId: Scalars['ID']['input'];
  sku: Scalars['String']['input'];
  startTime: Scalars['Time']['input'];
  status?: InputMaybe<FlashSaleStatus>;
  stockQuantity: Scalars['Int']['input'];
};

export type FlashsaleServiceCreateCampaignGqlInput = {
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['Time']['input'];
  name: Scalars['String']['input'];
  startTime: Scalars['Time']['input'];
};

export type FlashsaleServiceUpdateCampaignGqlInput = {
  bannerUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<FlashSaleStatus>;
};

export type FlashsaleServiceUpdateProductGqlInput = {
  endTime?: InputMaybe<Scalars['Time']['input']>;
  flashSalePrice?: InputMaybe<Scalars['Float']['input']>;
  originalPrice?: InputMaybe<Scalars['Float']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<FlashSaleStatus>;
  stockQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type FnsServiceAnswerGqlInput = {
  answer: Array<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
};

export type FnsServiceAnswerGqlOutput = {
  __typename?: 'FnsServiceAnswerGqlOutput';
  answer?: Maybe<Array<Scalars['String']['output']>>;
  questionId?: Maybe<Scalars['String']['output']>;
  questionName?: Maybe<Scalars['String']['output']>;
};

export type FnsServiceCreateFormGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAnonymous: Scalars['Boolean']['input'];
  questions: Array<FnsServiceQuestionGqlInput>;
  title: Scalars['String']['input'];
};

export type FnsServiceCreateSurveyGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAnonymous: Scalars['Boolean']['input'];
  questions: Array<FnsServiceQuestionGqlInput>;
  title: Scalars['String']['input'];
  type: SurveyType;
};

export type FnsServiceCreateUserResponseFormGqlInput = {
  answers: Array<FnsServiceAnswerGqlInput>;
  formId: Scalars['String']['input'];
};

export type FnsServiceCreateUserResponseSurveyGqlInput = {
  answers: Array<FnsServiceAnswerGqlInput>;
  surveyId: Scalars['String']['input'];
};

export type FnsServiceFindUserResponsesToFormGqlInput = {
  formId?: InputMaybe<Scalars['String']['input']>;
};

export type FnsServiceFindUserResponsesToSurveyGqlInput = {
  surveyId?: InputMaybe<Scalars['String']['input']>;
};

export type FnsServiceFormGqlOutput = {
  __typename?: 'FnsServiceFormGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  questions?: Maybe<Array<FnsServiceQuestionGqlOutput>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FnsServiceFormsGqlOutput = {
  __typename?: 'FnsServiceFormsGqlOutput';
  /** Array of found items */
  data: Array<FnsServiceFormGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type FnsServiceQuestionGqlInput = {
  actionLabel?: InputMaybe<Scalars['String']['input']>;
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Float']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired: Scalars['Boolean']['input'];
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  type: SurveyQuestionType;
  uiTemplate: SurveyUiTemplate;
};

export type FnsServiceQuestionGqlOutput = {
  __typename?: 'FnsServiceQuestionGqlOutput';
  actionLabel?: Maybe<Scalars['String']['output']>;
  actionUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SurveyQuestionType>;
  uiTemplate?: Maybe<SurveyUiTemplate>;
};

export type FnsServiceSurveyGqlOutput = {
  __typename?: 'FnsServiceSurveyGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  questions?: Maybe<Array<FnsServiceQuestionGqlOutput>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SurveyType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FnsServiceSurveysGqlOutput = {
  __typename?: 'FnsServiceSurveysGqlOutput';
  /** Array of found items */
  data: Array<FnsServiceSurveyGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type FnsServiceUpdateFormGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  questions?: InputMaybe<Array<FnsServiceQuestionGqlInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FnsServiceUpdateSurveyGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  questions?: InputMaybe<Array<FnsServiceQuestionGqlInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SurveyType>;
};

export type FnsServiceUserResponseGqlOutput = {
  __typename?: 'FnsServiceUserResponseGqlOutput';
  answers?: Maybe<Array<FnsServiceAnswerGqlOutput>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  formId?: Maybe<Scalars['String']['output']>;
  formTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  surveyId?: Maybe<Scalars['String']['output']>;
  surveyTitle?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type FnsServiceUserResponsesGqlOutput = {
  __typename?: 'FnsServiceUserResponsesGqlOutput';
  /** Array of found items */
  data: Array<FnsServiceUserResponseGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type GpsConfigGqlInput = {
  allowedLatitude: Scalars['Float']['input'];
  allowedLongitude: Scalars['Float']['input'];
  allowedRadius: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type GpsConfigGqlOutput = {
  __typename?: 'GPSConfigGqlOutput';
  allowedLatitude: Scalars['Float']['output'];
  allowedLongitude: Scalars['Float']['output'];
  allowedRadius: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export enum GameTypeEnum {
  FlipCard = 'FlipCard',
  LuckyWheel = 'LuckyWheel',
  Quiz = 'Quiz'
}

export type GetBlockTemplatesInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantType?: InputMaybe<BlockTenantType>;
  type?: InputMaybe<BlockTypeEnum>;
};

export type GetReferralTreeInput = {
  userId: Scalars['String']['input'];
};

export type GpsVerificationGqlOutput = {
  __typename?: 'GpsVerificationGqlOutput';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type HealthStatus = {
  __typename?: 'HealthStatus';
  error?: Maybe<Scalars['String']['output']>;
  responseTime?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
};

export type ImageConfigGqlInput = {
  note?: InputMaybe<Scalars['String']['input']>;
};

export type ImageConfigGqlOutput = {
  __typename?: 'ImageConfigGqlOutput';
  note?: Maybe<Scalars['String']['output']>;
};

export type Integrations = {
  __typename?: 'Integrations';
  apiKeys?: Maybe<Array<Scalars['String']['output']>>;
  externalSystemId?: Maybe<Scalars['String']['output']>;
};

export type IntegrationsInput = {
  apiKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  externalSystemId?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryServiceCreateStockGqlInput = {
  productId: Scalars['String']['input'];
  productName: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type InventoryServiceSearchStockForAdminGqlInput = {
  isFlashSale?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type InventoryServiceStockGqlInput = {
  productId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type InventoryServiceStockGqlOutput = {
  __typename?: 'InventoryServiceStockGqlOutput';
  availableQuantity: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  flashSaleAvailableQuantity: Scalars['Int']['output'];
  flashSaleReservedQuantity: Scalars['Int']['output'];
  flashSaleSoldQuantity: Scalars['Int']['output'];
  flashSaleTotalQuantity: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isFlashSale: Scalars['Boolean']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  reservedQuantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  soldQuantity: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  totalQuantity: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InventoryServiceStocksGqlOutput = {
  __typename?: 'InventoryServiceStocksGqlOutput';
  /** Array of found items */
  data: Array<InventoryServiceStockGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type LanguageDefinitionInput = {
  definition: Scalars['String']['input'];
  lang: LanguageEnum;
};

export type LanguageDefinitionOutput = {
  __typename?: 'LanguageDefinitionOutput';
  definition: Scalars['String']['output'];
  lang: LanguageEnum;
};

export enum LanguageEnum {
  En = 'EN',
  Vi = 'VI'
}

export type LarvaCourseSentenceVideoGqlInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type LarvaCourseSentenceVideoGqlOutput = {
  __typename?: 'LarvaCourseSentenceVideoGqlOutput';
  caption?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LarvaCourseServiceAnalyzeCompareWordOutput = {
  __typename?: 'LarvaCourseServiceAnalyzeCompareWordOutput';
  expected?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LarvaCourseServiceAnalyzeGqlOutput = {
  __typename?: 'LarvaCourseServiceAnalyzeGqlOutput';
  analyzeCompareWord?: Maybe<Array<LarvaCourseServiceAnalyzeCompareWordOutput>>;
  analyzeSentence?: Maybe<Array<LarvaCourseServiceAnalyzeSentenceDetailOutput>>;
  analyzeWordPhonetics?: Maybe<Array<LarvaCourseServiceAnalyzeWordPhoneticsOutput>>;
  comparisonText?: Maybe<Scalars['String']['output']>;
  historyLesson?: Maybe<LarvaCourseServiceHistoryLessonGqlOutput>;
  mark?: Maybe<Scalars['Float']['output']>;
  originalText?: Maybe<Scalars['String']['output']>;
};

export type LarvaCourseServiceAnalyzeSentenceDetailOutput = {
  __typename?: 'LarvaCourseServiceAnalyzeSentenceDetailOutput';
  comparisonWord?: Maybe<Scalars['String']['output']>;
  detailPhonetics?: Maybe<Array<LarvaCourseServiceAnalyzeWordPhoneticsOutput>>;
  detailWords?: Maybe<Array<LarvaCourseServiceAnalyzeCompareWordOutput>>;
  mark?: Maybe<Scalars['Float']['output']>;
  originalWord?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Analyze Speaking Input */
export type LarvaCourseServiceAnalyzeSpeakingGqlInput = {
  /** Lesson Speaking ID */
  lessonSpeakingId: Scalars['String']['input'];
  /** Record */
  record?: InputMaybe<Scalars['String']['input']>;
  /** Speech To Text */
  speechToText: Scalars['String']['input'];
};

export type LarvaCourseServiceAnalyzeWordPhoneticsOutput = {
  __typename?: 'LarvaCourseServiceAnalyzeWordPhoneticsOutput';
  expected?: Maybe<Scalars['String']['output']>;
  expectedGrapheme?: Maybe<Scalars['String']['output']>;
  grapheme?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tips?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LarvaCourseServiceCategoryStaticGqlOutput = {
  __typename?: 'LarvaCourseServiceCategoryStaticGqlOutput';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<LarvaCourseServiceCourseStatus>;
};

export type LarvaCourseServiceChangeItemsOfCollectionGqlInput = {
  sentences?: InputMaybe<Array<SentenceInput>>;
  words?: InputMaybe<Array<WordInput>>;
};

export type LarvaCourseServiceChangeNameCollectionGqlInput = {
  name: Scalars['String']['input'];
};

/** The status of the course */
export enum LarvaCourseServiceCourseStatus {
  Active = 'Active',
  Deleted = 'Deleted',
  Draft = 'Draft',
  Inactive = 'Inactive',
  Published = 'Published'
}

/** Lesson */
export type LarvaCourseServiceCreateLessonGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  level: LarvaCourseServiceLevel;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  /** Array of sentence IDs */
  sentences?: InputMaybe<Array<Scalars['String']['input']>>;
  topicId: Scalars['String']['input'];
  /** Words */
  words?: InputMaybe<Array<LessonWordInput>>;
};

/** Create Sentence */
export type LarvaCourseServiceCreateSentenceGqlInput = {
  /** Sentence Content */
  content: Scalars['String']['input'];
  /** Pronunciation Text */
  pronunciationText: Scalars['String']['input'];
  status?: LarvaCourseServiceCourseStatus;
  /** Translations */
  translations: Array<LarvaCourseServiceSentenceTranslationGqlInput>;
};

/** Topic */
export type LarvaCourseServiceCreateTopicGqlInput = {
  categoryCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
};

export type LarvaCourseServiceCreateUserCollectionGqlInput = {
  name: Scalars['String']['input'];
  sentences?: InputMaybe<Array<SentenceInput>>;
  words?: InputMaybe<Array<WordInput>>;
};

export type LarvaCourseServiceDetailUserCollectionGqlOutput = {
  __typename?: 'LarvaCourseServiceDetailUserCollectionGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sentences?: Maybe<Array<LarvaCourseServiceSentenceOfCollectionGqlOutput>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
  words?: Maybe<Array<LarvaCourseServiceWordOfCollectionGqlOutput>>;
};

export type LarvaCourseServiceFavoriteSentenceGqlOutput = {
  __typename?: 'LarvaCourseServiceFavoriteSentenceGqlOutput';
  lessonSpeakingId: Scalars['String']['output'];
  sentenceId: Scalars['String']['output'];
};

export type LarvaCourseServiceFavoriteWordGqlOutput = {
  __typename?: 'LarvaCourseServiceFavoriteWordGqlOutput';
  lessonSpeakingId: Scalars['String']['output'];
  partOfSpeech: Scalars['String']['output'];
  word: Scalars['String']['output'];
};

export type LarvaCourseServiceGeneralUserCollectionGqlOutput = {
  __typename?: 'LarvaCourseServiceGeneralUserCollectionGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sentences?: Maybe<Array<LarvaCourseServiceFavoriteSentenceGqlOutput>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
  words?: Maybe<Array<LarvaCourseServiceFavoriteWordGqlOutput>>;
};

/** Get Nearly Lessons */
export type LarvaCourseServiceGetNearlyLessonsGqlInput = {
  total: Scalars['Float']['input'];
};

export type LarvaCourseServiceHistoryLessonGqlOutput = {
  __typename?: 'LarvaCourseServiceHistoryLessonGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lessonId?: Maybe<Scalars['String']['output']>;
  lessonSpeakings?: Maybe<Array<LarvaCourseServiceHistoryLessonSpeakingGqlOutput>>;
  status?: Maybe<LarvaCourseServiceHistoryLessonStatus>;
  summaryMark?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type LarvaCourseServiceHistoryLessonSpeakingGqlOutput = {
  __typename?: 'LarvaCourseServiceHistoryLessonSpeakingGqlOutput';
  lessonSpeakingId?: Maybe<Scalars['String']['output']>;
  mark?: Maybe<Scalars['Float']['output']>;
};

/** The status of the history lesson */
export enum LarvaCourseServiceHistoryLessonStatus {
  Completed = 'Completed',
  InProgress = 'InProgress'
}

export type LarvaCourseServiceHistorySpeakingGqlOutput = {
  __typename?: 'LarvaCourseServiceHistorySpeakingGqlOutput';
  analyzeId?: Maybe<Scalars['String']['output']>;
  historyId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  mark?: Maybe<Scalars['Float']['output']>;
  record?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

/** The language of the sentence */
export enum LarvaCourseServiceLanguage {
  En = 'En',
  Vi = 'Vi'
}

export type LarvaCourseServiceLessonGqlOutput = {
  __typename?: 'LarvaCourseServiceLessonGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  historyLesson?: Maybe<LarvaCourseServiceHistoryLessonGqlOutput>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  lessonInfo?: Maybe<Array<LarvaCourseServiceLessonSpeakingGqlOutput>>;
  level?: Maybe<LarvaCourseServiceLevel>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<LarvaCourseServiceCourseStatus>;
  tenantId?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<LarvaCourseServiceTopicGqlOutput>;
  topicId?: Maybe<Scalars['String']['output']>;
  totalLessonInfos?: Maybe<Scalars['Float']['output']>;
  totalLessonInfosPass?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LarvaCourseServiceLessonOrderGqlOutput = {
  __typename?: 'LarvaCourseServiceLessonOrderGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lessonIds?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<LarvaCourseServiceCourseStatus>;
  tenantId?: Maybe<Scalars['String']['output']>;
  topicId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LarvaCourseServiceLessonSpeakingGqlOutput = {
  __typename?: 'LarvaCourseServiceLessonSpeakingGqlOutput';
  categoryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lessonId?: Maybe<Scalars['String']['output']>;
  mark?: Maybe<Scalars['Float']['output']>;
  sentence?: Maybe<LarvaCourseServiceSentenceGqlOutput>;
  sentenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<LarvaCourseServiceCourseStatus>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  word?: Maybe<LessonWordGqlOutput>;
};

export type LarvaCourseServiceLessonsGqlOutput = {
  __typename?: 'LarvaCourseServiceLessonsGqlOutput';
  /** Array of found items */
  data: Array<LarvaCourseServiceLessonGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

/** The level of difficulty */
export enum LarvaCourseServiceLevel {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2'
}

/** Search Collection of User */
export type LarvaCourseServiceSearchCollectionOfUserGqlInput = {
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Lesson */
export type LarvaCourseServiceSearchLessonGqlInput = {
  level?: InputMaybe<LarvaCourseServiceLevel>;
  name?: InputMaybe<Scalars['String']['input']>;
  topicId?: InputMaybe<Scalars['String']['input']>;
};

/** Lesson sentence */
export type LarvaCourseServiceSearchLessonSentenceGqlInput = {
  content: Scalars['String']['input'];
};

/** Lesson sentence */
export type LarvaCourseServiceSearchLessonSentenceGqlOutput = {
  __typename?: 'LarvaCourseServiceSearchLessonSentenceGqlOutput';
  lessonSpeakingId?: Maybe<Scalars['String']['output']>;
  sentence?: Maybe<LarvaCourseServiceSentenceGqlOutput>;
};

/** Lesson word */
export type LarvaCourseServiceSearchLessonWordGqlInput = {
  word: Scalars['String']['input'];
};

/** Lesson word */
export type LarvaCourseServiceSearchLessonWordGqlOutput = {
  __typename?: 'LarvaCourseServiceSearchLessonWordGqlOutput';
  lessonSpeakingId?: Maybe<Scalars['String']['output']>;
  word?: Maybe<LessonWordGqlOutput>;
};

/** Search Sentence */
export type LarvaCourseServiceSearchSentenceGqlInput = {
  /** Sentence Content */
  content?: InputMaybe<Scalars['String']['input']>;
};

/** Topic */
export type LarvaCourseServiceSearchTopicGqlInput = {
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LarvaCourseServiceSentenceGqlOutput = {
  __typename?: 'LarvaCourseServiceSentenceGqlOutput';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pronunciationText?: Maybe<Scalars['String']['output']>;
  status?: Maybe<LarvaCourseServiceCourseStatus>;
  translations?: Maybe<Array<LarvaCourseServiceSentenceTranslationGqlOutput>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videos?: Maybe<Array<LarvaCourseSentenceVideoGqlOutput>>;
  words?: Maybe<Array<LarvaCourseServiceSentenceWordOutput>>;
};

export type LarvaCourseServiceSentenceOfCollectionGqlOutput = {
  __typename?: 'LarvaCourseServiceSentenceOfCollectionGqlOutput';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lessonSpeakingId?: Maybe<Scalars['String']['output']>;
  pronunciationText?: Maybe<Scalars['String']['output']>;
  status?: Maybe<LarvaCourseServiceCourseStatus>;
  translations?: Maybe<Array<LarvaCourseServiceSentenceTranslationGqlOutput>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  videos?: Maybe<Array<LarvaCourseSentenceVideoGqlOutput>>;
  words?: Maybe<Array<LarvaCourseServiceSentenceWordOutput>>;
};

/** Create Sentence Word */
export type LarvaCourseServiceSentenceTranslationGqlInput = {
  /** Language */
  language: LarvaCourseServiceLanguage;
  /** Translation */
  translation: Scalars['String']['input'];
};

export type LarvaCourseServiceSentenceTranslationGqlOutput = {
  __typename?: 'LarvaCourseServiceSentenceTranslationGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<LarvaCourseServiceLanguage>;
  sentenceId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LarvaCourseServiceSentenceWordOutput = {
  __typename?: 'LarvaCourseServiceSentenceWordOutput';
  audioUrl?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  pronunciation?: Maybe<Scalars['String']['output']>;
  word?: Maybe<Scalars['String']['output']>;
};

export type LarvaCourseServiceSentencesGqlOutput = {
  __typename?: 'LarvaCourseServiceSentencesGqlOutput';
  /** Array of found items */
  data: Array<LarvaCourseServiceSentenceGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type LarvaCourseServiceSkillStaticGqlOutput = {
  __typename?: 'LarvaCourseServiceSkillStaticGqlOutput';
  categories?: Maybe<Array<LarvaCourseServiceCategoryStaticGqlOutput>>;
  code?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<LarvaCourseServiceCourseStatus>;
  totalTopics: Scalars['Float']['output'];
};

export type LarvaCourseServiceSubjectsGqlOutput = {
  __typename?: 'LarvaCourseServiceSubjectsGqlOutput';
  code?: Maybe<Scalars['String']['output']>;
  hasSurveyResponse?: Maybe<Scalars['Boolean']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<LarvaCourseServiceSkillStaticGqlOutput>>;
  status?: Maybe<LarvaCourseServiceCourseStatus>;
  surveyId?: Maybe<Scalars['String']['output']>;
};

export type LarvaCourseServiceTopicGqlOutput = {
  __typename?: 'LarvaCourseServiceTopicGqlOutput';
  categoryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  skillCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<LarvaCourseServiceCourseStatus>;
  subjectCode?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  totalLessons?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LarvaCourseServiceTopicOrderGqlOutput = {
  __typename?: 'LarvaCourseServiceTopicOrderGqlOutput';
  categoryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<LarvaCourseServiceCourseStatus>;
  tenantId?: Maybe<Scalars['String']['output']>;
  topicIds?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LarvaCourseServiceTopicsGqlOutput = {
  __typename?: 'LarvaCourseServiceTopicsGqlOutput';
  /** Array of found items */
  data: Array<LarvaCourseServiceTopicGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

/** Lesson */
export type LarvaCourseServiceUpdateLessonGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  level: LarvaCourseServiceLevel;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  /** Array of sentence IDs */
  sentences?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<LarvaCourseServiceCourseStatus>;
  /** Words */
  words?: InputMaybe<Array<LessonWordInput>>;
};

/** Update Sentence */
export type LarvaCourseServiceUpdateSentenceGqlInput = {
  /** Sentence Content */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Pronunciation Text */
  pronunciationText?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LarvaCourseServiceCourseStatus>;
  /** Translations */
  translations?: InputMaybe<Array<LarvaCourseServiceSentenceTranslationGqlInput>>;
  videos?: InputMaybe<Array<LarvaCourseSentenceVideoGqlInput>>;
  words?: InputMaybe<Array<LarvaCourseWordOfSentencesGqlInput>>;
};

/** Topic */
export type LarvaCourseServiceUpdateTopicGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<LarvaCourseServiceCourseStatus>;
};

export type LarvaCourseServiceWordOfCollectionGqlOutput = {
  __typename?: 'LarvaCourseServiceWordOfCollectionGqlOutput';
  hasAudio?: Maybe<Scalars['Boolean']['output']>;
  hasImage?: Maybe<Scalars['Boolean']['output']>;
  images?: Maybe<Array<LessonWordImageGqlOutput>>;
  lessonSpeakingId?: Maybe<Scalars['String']['output']>;
  partOfSpeech?: Maybe<Scalars['String']['output']>;
  pronunciations?: Maybe<Array<LessonWordPronunciationGqlOutput>>;
  senses?: Maybe<Array<LessonWordSenseGqlOutput>>;
  videos?: Maybe<Array<LessonWordVideoGqlOutput>>;
  word?: Maybe<Scalars['String']['output']>;
  wordTranslations?: Maybe<Array<LessonWordTranslationGqlOutput>>;
};

export type LarvaCourseWordOfSentencesGqlInput = {
  audioUrl?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Float']['input'];
  pronunciation: Scalars['String']['input'];
  word: Scalars['String']['input'];
};

export type LessonWordDefinitionGqlOutput = {
  __typename?: 'LessonWordDefinitionGqlOutput';
  languageDefinitions?: Maybe<Array<LessonWordLanguageDefinitionGqlOutput>>;
};

export type LessonWordGqlOutput = {
  __typename?: 'LessonWordGqlOutput';
  hasAudio?: Maybe<Scalars['Boolean']['output']>;
  hasImage?: Maybe<Scalars['Boolean']['output']>;
  images?: Maybe<Array<LessonWordImageGqlOutput>>;
  partOfSpeech?: Maybe<Scalars['String']['output']>;
  pronunciations?: Maybe<Array<LessonWordPronunciationGqlOutput>>;
  senses?: Maybe<Array<LessonWordSenseGqlOutput>>;
  videos?: Maybe<Array<LessonWordVideoGqlOutput>>;
  word?: Maybe<Scalars['String']['output']>;
  wordTranslations?: Maybe<Array<LessonWordTranslationGqlOutput>>;
};

export type LessonWordImageGqlOutput = {
  __typename?: 'LessonWordImageGqlOutput';
  caption?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Word Input */
export type LessonWordInput = {
  /** Part of Speech */
  partOfSpeech: Scalars['String']['input'];
  /** Word */
  word: Scalars['String']['input'];
};

export type LessonWordLanguageDefinitionGqlOutput = {
  __typename?: 'LessonWordLanguageDefinitionGqlOutput';
  definition?: Maybe<Scalars['String']['output']>;
  lang?: Maybe<LanguageEnum>;
};

export type LessonWordPronunciationGqlOutput = {
  __typename?: 'LessonWordPronunciationGqlOutput';
  audioKey?: Maybe<Scalars['String']['output']>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  dialect?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phoneticSpelling?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  simplePhonetic?: Maybe<Scalars['String']['output']>;
};

export type LessonWordSenseGqlOutput = {
  __typename?: 'LessonWordSenseGqlOutput';
  definitions?: Maybe<Array<LessonWordDefinitionGqlOutput>>;
  domain?: Maybe<Array<Scalars['String']['output']>>;
  grammar?: Maybe<Array<Scalars['String']['output']>>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  senseNumber?: Maybe<Scalars['Float']['output']>;
};

export type LessonWordTranslationGqlOutput = {
  __typename?: 'LessonWordTranslationGqlOutput';
  lang?: Maybe<LanguageEnum>;
  translation?: Maybe<Scalars['String']['output']>;
};

export type LessonWordVideoGqlOutput = {
  __typename?: 'LessonWordVideoGqlOutput';
  caption?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type LoyaltyProgramAdditionalSettingsInput = {
  customTheme?: InputMaybe<CustomThemeInput>;
  displayInApp?: InputMaybe<Scalars['Boolean']['input']>;
  emailTemplateId?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<IntegrationsInput>;
  notificationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoyaltyServiceCreateLoyaltyProgramGqlInput = {
  additionalSettings?: InputMaybe<LoyaltyProgramAdditionalSettingsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  pointsConfig: PointsConfigInput;
  startDate: Scalars['DateTime']['input'];
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type LoyaltyServiceCreateLoyaltyTierGqlInput = {
  benefit?: InputMaybe<BenefitDetailsInput>;
  benefitDescriptions?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  maintenanceThreshold?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  pointDiscountRate?: InputMaybe<Scalars['Float']['input']>;
  pointEarnRuleDescription?: InputMaybe<Scalars['String']['input']>;
  pointsMultiplier?: InputMaybe<Scalars['Float']['input']>;
  pointsThreshold?: InputMaybe<Scalars['Int']['input']>;
  spendingPerPoint?: InputMaybe<Scalars['Float']['input']>;
  spendingThreshold?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tierQualificationType?: InputMaybe<LoyaltyTierQualificationEnum>;
  validityPeriod?: InputMaybe<Scalars['Int']['input']>;
};

export type LoyaltyServiceLoyaltyProgramGqlOutput = {
  __typename?: 'LoyaltyServiceLoyaltyProgramGqlOutput';
  additionalSettings?: Maybe<AdditionalSettings>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pointsConfig: PointsConfig;
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LoyaltyServiceLoyaltyProgramsGqlOutput = {
  __typename?: 'LoyaltyServiceLoyaltyProgramsGqlOutput';
  /** Array of found items */
  data: Array<LoyaltyServiceLoyaltyProgramGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type LoyaltyServiceLoyaltyTierGqlOutput = {
  __typename?: 'LoyaltyServiceLoyaltyTierGqlOutput';
  benefit?: Maybe<LoyaltyTierBenefitDetails>;
  benefitDescriptions?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  level: Scalars['Int']['output'];
  maintenanceThreshold?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  pointDiscountRate?: Maybe<Scalars['Float']['output']>;
  pointEarnRuleDescription?: Maybe<Scalars['String']['output']>;
  pointsMultiplier?: Maybe<Scalars['Float']['output']>;
  pointsThreshold?: Maybe<Scalars['Int']['output']>;
  spendingPerPoint?: Maybe<Scalars['Float']['output']>;
  spendingThreshold?: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['String']['output'];
  tierQualificationType?: Maybe<LoyaltyTierQualificationEnum>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validityPeriod?: Maybe<Scalars['Int']['output']>;
};

export type LoyaltyServiceLoyaltyTiersGqlOutput = {
  __typename?: 'LoyaltyServiceLoyaltyTiersGqlOutput';
  /** Array of found items */
  data: Array<LoyaltyServiceLoyaltyTierGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type LoyaltyServiceUpdateLoyaltyTierGqlInput = {
  benefit?: InputMaybe<BenefitDetailsInput>;
  benefitDescriptions?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  level: Scalars['Int']['input'];
  maintenanceThreshold?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  pointDiscountRate?: InputMaybe<Scalars['Float']['input']>;
  pointEarnRuleDescription?: InputMaybe<Scalars['String']['input']>;
  pointsMultiplier?: InputMaybe<Scalars['Float']['input']>;
  pointsThreshold?: InputMaybe<Scalars['Int']['input']>;
  spendingPerPoint?: InputMaybe<Scalars['Float']['input']>;
  spendingThreshold?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tierQualificationType?: InputMaybe<LoyaltyTierQualificationEnum>;
  validityPeriod?: InputMaybe<Scalars['Int']['input']>;
};

export type LoyaltyTierBenefitDetails = {
  __typename?: 'LoyaltyTierBenefitDetails';
  additionalBenefits?: Maybe<Array<Scalars['String']['output']>>;
  discounts?: Maybe<Array<LoyaltyTierDiscount>>;
  exclusiveAccess?: Maybe<Scalars['Boolean']['output']>;
  freeServices?: Maybe<Array<Scalars['String']['output']>>;
  prioritySupport?: Maybe<Scalars['Boolean']['output']>;
};

export type LoyaltyTierDiscount = {
  __typename?: 'LoyaltyTierDiscount';
  applicableCategoryIds?: Maybe<Array<Scalars['String']['output']>>;
  applicableProductIds?: Maybe<Array<Scalars['String']['output']>>;
  applicableServices?: Maybe<Array<Scalars['String']['output']>>;
  maximumDiscount?: Maybe<Scalars['Float']['output']>;
  minimumPurchase?: Maybe<Scalars['Float']['output']>;
  percentage: Scalars['Float']['output'];
  scope?: Maybe<DiscountScopeEnum>;
};

/** The qualification type for loyalty tier */
export enum LoyaltyTierQualificationEnum {
  Point = 'POINT',
  Spending = 'SPENDING'
}

export type MeetingServiceCreateRoomGqlOutput = {
  __typename?: 'MeetingServiceCreateRoomGqlOutput';
  code: Scalars['String']['output'];
};

export type MembershipServiceMemberGqlOutput = {
  __typename?: 'MembershipServiceMemberGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cumulativeSpending: Scalars['Float']['output'];
  currentTierId?: Maybe<Scalars['String']['output']>;
  currentYearSpending: Scalars['Float']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  joinDate: Scalars['DateTime']['output'];
  membershipNumber: Scalars['String']['output'];
  nextTierId?: Maybe<Scalars['String']['output']>;
  pointsToNextTier?: Maybe<Scalars['Int']['output']>;
  spendingToNextTier?: Maybe<Scalars['Float']['output']>;
  tenantId: Scalars['String']['output'];
  tierExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type MembershipServiceUpdateMemberGqlInput = {
  cumulativeSpending?: InputMaybe<Scalars['Float']['input']>;
  currentTierId?: InputMaybe<Scalars['String']['input']>;
  currentYearSpending?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  nextTierId?: InputMaybe<Scalars['String']['input']>;
  pointsToNextTier?: InputMaybe<Scalars['Int']['input']>;
  spendingToNextTier?: InputMaybe<Scalars['Float']['input']>;
};

export type MessageManagementServiceCreateOaAccountGqlInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  linkedZaloID?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  oaID: Scalars['String']['input'];
  packageAutoRenewDate?: InputMaybe<Scalars['Time']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  packageValidThroughDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantID?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceCreateOaQuotaGqlInput = {
  dailyQuota: Scalars['Int']['input'];
  dailyQuotaPromotion?: InputMaybe<Scalars['Int']['input']>;
  estimatedNextMonthPromotionQuota: Scalars['Int']['input'];
  monthlyPromotionQuota: Scalars['Int']['input'];
  oaID: Scalars['String']['input'];
  quotaType?: InputMaybe<Scalars['String']['input']>;
  remainingMonthlyPromotionQuota: Scalars['Int']['input'];
  remainingQuota: Scalars['Int']['input'];
  remainingQuotaPromotion?: InputMaybe<Scalars['Int']['input']>;
  tenantID?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceCreateOttSmsGqlInput = {
  channel: Scalars['String']['input'];
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  phone: Scalars['String']['input'];
};

export type MessageManagementServiceCreateSmsConfigGqlInput = {
  apiKey: Scalars['String']['input'];
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  brandName: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  maxRetry: Scalars['Int']['input'];
  priority: Scalars['Int']['input'];
  providerName: Scalars['String']['input'];
  timeout: Scalars['Int']['input'];
};

export type MessageManagementServiceCreateViberConfigGqlInput = {
  apiToken: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  maxRetry: Scalars['Int']['input'];
  priority: Scalars['Int']['input'];
  senderName: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
  timeout: Scalars['Int']['input'];
};

export type MessageManagementServiceCreateZnsTemplateGqlInput = {
  listParams?: InputMaybe<Array<Scalars['String']['input']>>;
  previewURL?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  templateID?: InputMaybe<Scalars['String']['input']>;
  templateName: Scalars['String']['input'];
  templateType?: InputMaybe<Scalars['String']['input']>;
  tenantID?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceMessageLogParams = {
  endDate?: InputMaybe<Scalars['Time']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Time']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantID?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceOaFilter = {
  exp?: InputMaybe<Scalars['String']['input']>;
  logic?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceOaListParams = {
  columns?: InputMaybe<Array<MessageManagementServiceOaFilter>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceSendOttSmsGqlInput = {
  channel: Scalars['String']['input'];
  otpCode: Scalars['String']['input'];
  ottID: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  templateData?: InputMaybe<Scalars['Map']['input']>;
  templateID?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceSendSmsMessageGqlInput = {
  brandName?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  tenantID?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceSendViberMessageGqlInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonURL?: InputMaybe<Scalars['String']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  senderName?: InputMaybe<Scalars['String']['input']>;
  tenantID?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceSendZnsMessageGqlInput = {
  mode?: InputMaybe<Scalars['String']['input']>;
  oaID: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  templateData?: InputMaybe<Scalars['Map']['input']>;
  templateID: Scalars['String']['input'];
  tenantID?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceSmsConfigFilter = {
  exp?: InputMaybe<Scalars['String']['input']>;
  logic?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceSmsConfigListParams = {
  columns?: InputMaybe<Array<MessageManagementServiceSmsConfigFilter>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceStatisticsParams = {
  endDate: Scalars['Time']['input'];
  groupBy?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Time']['input'];
  tenantID?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceUpdateOaQuotaGqlInput = {
  dailyQuota?: InputMaybe<Scalars['Int']['input']>;
  dailyQuotaPromotion?: InputMaybe<Scalars['Int']['input']>;
  estimatedNextMonthPromotionQuota?: InputMaybe<Scalars['Int']['input']>;
  monthlyPromotionQuota?: InputMaybe<Scalars['Int']['input']>;
  quotaType?: InputMaybe<Scalars['String']['input']>;
  remainingMonthlyPromotionQuota?: InputMaybe<Scalars['Int']['input']>;
  remainingQuota?: InputMaybe<Scalars['Int']['input']>;
  remainingQuotaPromotion?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageManagementServiceUpdateSmsConfigGqlInput = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxRetry?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageManagementServiceUpdateViberConfigGqlInput = {
  apiToken?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxRetry?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  senderName?: InputMaybe<Scalars['String']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageManagementServiceViberConfigFilter = {
  exp?: InputMaybe<Scalars['String']['input']>;
  logic?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceViberConfigListParams = {
  columns?: InputMaybe<Array<MessageManagementServiceViberConfigFilter>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceZnsFilter = {
  exp?: InputMaybe<Scalars['String']['input']>;
  logic?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceZnsListParams = {
  columns?: InputMaybe<Array<MessageManagementServiceZnsFilter>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type MessageManagementServiceZnsMessageGqlInput = {
  phone: Scalars['String']['input'];
  templateData: Scalars['Map']['input'];
  templateID: Scalars['String']['input'];
  trackingID?: InputMaybe<Scalars['String']['input']>;
};

export type MessageResponse = {
  __typename?: 'MessageResponse';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<ZnsMessage>;
  messageID?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MessageStatistics = {
  __typename?: 'MessageStatistics';
  byDate: Array<DateStats>;
  byProvider: Array<ProviderStats>;
  failedCount: Scalars['Int']['output'];
  pendingCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
  successRate: Scalars['Float']['output'];
  totalMessages: Scalars['Int']['output'];
};

export type MinigamesServiceAddAnswerInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isCorrect: Scalars['Boolean']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type MinigamesServiceAddPrizeInput = {
  campaignId: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  mediaUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  pointsAmount?: InputMaybe<Scalars['Int']['input']>;
  prizeType: PrizeTypeEnum;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  voucherTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type MinigamesServiceAnswerForPlayOutput = {
  __typename?: 'MinigamesServiceAnswerForPlayOutput';
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type MinigamesServiceAnswerInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isCorrect: Scalars['Boolean']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};

export type MinigamesServiceAnswerOutput = {
  __typename?: 'MinigamesServiceAnswerOutput';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isCorrect: Scalars['Boolean']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  questionId: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MinigamesServiceCampaignFilterInput = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MinigamesServiceCampaignInfoOutput = {
  __typename?: 'MinigamesServiceCampaignInfoOutput';
  description?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  gameConfig: Scalars['JSON']['output'];
  gameType: Scalars['String']['output'];
  howToPlay?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prizes?: Maybe<Array<MinigamesServiceCampaignPrizeSummaryOutput>>;
  rules?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uiConfig: Scalars['JSON']['output'];
};

export type MinigamesServiceCampaignOutput = {
  __typename?: 'MinigamesServiceCampaignOutput';
  authenticationRequired: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  distributionType: Scalars['String']['output'];
  enablePrizeSystem: Scalars['Boolean']['output'];
  enableTierSystem: Scalars['Boolean']['output'];
  endDate: Scalars['DateTime']['output'];
  gameConfig: Scalars['JSON']['output'];
  gameType: Scalars['String']['output'];
  howToPlay?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  maxPlaysPerUser: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  playCodeRequired: Scalars['Boolean']['output'];
  prizes?: Maybe<Array<MinigamesServiceCampaignPrizeSummaryOutput>>;
  rules?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  totalPlayers?: Maybe<Scalars['Int']['output']>;
  totalPlays?: Maybe<Scalars['Int']['output']>;
  uiConfig: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MinigamesServiceCampaignPrizeSummaryOutput = {
  __typename?: 'MinigamesServiceCampaignPrizeSummaryOutput';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  probability: Scalars['Float']['output'];
};

export type MinigamesServiceCampaignsOutput = {
  __typename?: 'MinigamesServiceCampaignsOutput';
  data: Array<MinigamesServiceCampaignOutput>;
  total: Scalars['Int']['output'];
};

export type MinigamesServiceCodeOutput = {
  __typename?: 'MinigamesServiceCodeOutput';
  campaignId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  gameplayId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isUsed: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MinigamesServiceCodesOutput = {
  __typename?: 'MinigamesServiceCodesOutput';
  data: Array<MinigamesServiceCodeOutput>;
  total: Scalars['Int']['output'];
};

export type MinigamesServiceCreateCampaignInput = {
  authenticationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distributionType?: InputMaybe<DistributionTypeEnum>;
  enablePrizeSystem?: InputMaybe<Scalars['Boolean']['input']>;
  enableTierSystem?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['DateTime']['input'];
  gameConfig?: InputMaybe<Scalars['JSON']['input']>;
  howToPlay?: InputMaybe<Scalars['String']['input']>;
  maxPlaysPerUser?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  playCodeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  templateId: Scalars['String']['input'];
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  uiConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type MinigamesServiceCreateGameTemplateInput = {
  authenticationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  distributionType?: InputMaybe<DistributionTypeEnum>;
  enablePrizeSystem?: InputMaybe<Scalars['Boolean']['input']>;
  enableTierSystem?: InputMaybe<Scalars['Boolean']['input']>;
  gameConfig?: InputMaybe<Scalars['JSON']['input']>;
  gameType: GameTypeEnum;
  howToPlay: Scalars['String']['input'];
  maxPlaysPerUser?: InputMaybe<Scalars['Int']['input']>;
  playCodeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  rules: Scalars['String']['input'];
  templateName: Scalars['String']['input'];
  thumbnailUrl: Scalars['String']['input'];
  uiConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type MinigamesServiceCreateQuestionInput = {
  answers?: InputMaybe<Array<MinigamesServiceAnswerInput>>;
  audioUrl?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  explanation?: InputMaybe<Scalars['String']['input']>;
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  passage?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  presentationType: PresentationTypeEnum;
  questionType: QuestionTypeEnum;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type MinigamesServiceGameRecordFilterInput = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  guestPhone?: InputMaybe<Scalars['String']['input']>;
  prizeType?: InputMaybe<PrizeTypeEnum>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MinigamesServiceGameRecordOutput = {
  __typename?: 'MinigamesServiceGameRecordOutput';
  campaignId: Scalars['String']['output'];
  codeId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  guestName?: Maybe<Scalars['String']['output']>;
  guestPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  playerType?: Maybe<Scalars['String']['output']>;
  prize?: Maybe<MinigamesServicePrizeInfo>;
  prizeDelivered?: Maybe<Scalars['Boolean']['output']>;
  prizeDeliveredAt?: Maybe<Scalars['DateTime']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MinigamesServiceGameRecordsOutput = {
  __typename?: 'MinigamesServiceGameRecordsOutput';
  data: Array<MinigamesServiceGameRecordOutput>;
  total: Scalars['Int']['output'];
};

export type MinigamesServiceGameTemplateOutput = {
  __typename?: 'MinigamesServiceGameTemplateOutput';
  authenticationRequired: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  distributionType: DistributionTypeEnum;
  enablePrizeSystem: Scalars['Boolean']['output'];
  enableTierSystem: Scalars['Boolean']['output'];
  gameConfig?: Maybe<Scalars['JSON']['output']>;
  gameType: GameTypeEnum;
  howToPlay: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  maxPlaysPerUser: Scalars['Int']['output'];
  playCodeRequired: Scalars['Boolean']['output'];
  rules: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  uiConfig?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MinigamesServiceGenerateCodesInput = {
  campaignId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type MinigamesServiceGetQuizQuestionsForPlayInput = {
  campaignId: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  guestName?: InputMaybe<Scalars['String']['input']>;
  guestPhone?: InputMaybe<Scalars['String']['input']>;
};

export type MinigamesServicePlayGameInput = {
  campaignId: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  guestName?: InputMaybe<Scalars['String']['input']>;
  guestPhone?: InputMaybe<Scalars['String']['input']>;
};

export type MinigamesServicePlayGameResultOutput = {
  __typename?: 'MinigamesServicePlayGameResultOutput';
  gameRecordId: Scalars['String']['output'];
  prize: MinigamesServicePrizeInfo;
  prizeId: Scalars['String']['output'];
};

export type MinigamesServicePrizeDetailOutput = {
  __typename?: 'MinigamesServicePrizeDetailOutput';
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  pointsAmount?: Maybe<Scalars['Int']['output']>;
  prizeInfo: MinigamesServicePrizeInfo;
  probability: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  remainingQuantity: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MinigamesServicePrizeInfo = {
  __typename?: 'MinigamesServicePrizeInfo';
  displayName?: Maybe<Scalars['String']['output']>;
  mediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  productId?: Maybe<Scalars['String']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  type: PrizeTypeEnum;
  voucherId?: Maybe<Scalars['String']['output']>;
  voucherTypeId?: Maybe<Scalars['String']['output']>;
};

export type MinigamesServicePrizeOutput = {
  __typename?: 'MinigamesServicePrizeOutput';
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  mediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  pointsAmount?: Maybe<Scalars['Int']['output']>;
  prizeType: Scalars['String']['output'];
  probability: Scalars['Float']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  remainingQuantity: Scalars['Int']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MinigamesServicePrizeProbabilityItemInput = {
  prizeId: Scalars['String']['input'];
  probability: Scalars['Float']['input'];
};

export type MinigamesServicePrizesOutput = {
  __typename?: 'MinigamesServicePrizesOutput';
  data: Array<MinigamesServicePrizeOutput>;
  total: Scalars['Int']['output'];
};

export type MinigamesServiceQuestionForPlayOutput = {
  __typename?: 'MinigamesServiceQuestionForPlayOutput';
  answers: Array<MinigamesServiceAnswerForPlayOutput>;
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mediaUrl?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  passage?: Maybe<Scalars['String']['output']>;
  points: Scalars['Int']['output'];
  presentationType: PresentationTypeEnum;
  questionType: QuestionTypeEnum;
};

export type MinigamesServiceQuestionOutput = {
  __typename?: 'MinigamesServiceQuestionOutput';
  answers?: Maybe<Array<MinigamesServiceAnswerOutput>>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  campaignId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  correctAnswerIds?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  mediaUrl?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  passage?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  presentationType: PresentationTypeEnum;
  questionType: QuestionTypeEnum;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type MinigamesServiceQuestionResultOutput = {
  __typename?: 'MinigamesServiceQuestionResultOutput';
  correctAnswerIds: Array<Scalars['String']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  isCorrect: Scalars['Boolean']['output'];
  pointsEarned: Scalars['Int']['output'];
  questionId: Scalars['String']['output'];
};

export type MinigamesServiceQuestionsOutput = {
  __typename?: 'MinigamesServiceQuestionsOutput';
  data: Array<MinigamesServiceQuestionOutput>;
  total: Scalars['Int']['output'];
};

export type MinigamesServiceQuizAnswerInput = {
  answerIds: Array<Scalars['String']['input']>;
  questionId: Scalars['String']['input'];
};

export type MinigamesServiceQuizAnswersResultOutput = {
  __typename?: 'MinigamesServiceQuizAnswersResultOutput';
  currentTotalScore: Scalars['Int']['output'];
  gameRecordId?: Maybe<Scalars['String']['output']>;
  isLastQuestion: Scalars['Boolean']['output'];
  maxScore?: Maybe<Scalars['Int']['output']>;
  passed?: Maybe<Scalars['Boolean']['output']>;
  prize?: Maybe<MinigamesServicePrizeInfo>;
  questionResults: Array<MinigamesServiceQuestionResultOutput>;
  tier?: Maybe<TierEnum>;
};

export type MinigamesServiceQuizQuestionsForPlayOutput = {
  __typename?: 'MinigamesServiceQuizQuestionsForPlayOutput';
  allowShuffle: Scalars['Boolean']['output'];
  campaignId: Scalars['String']['output'];
  questions: Array<MinigamesServiceQuestionForPlayOutput>;
  quizMode: QuizModeEnum;
  showExplanation: Scalars['Boolean']['output'];
  timeLimit?: Maybe<Scalars['Int']['output']>;
};

export type MinigamesServiceRemainingPlaysOutput = {
  __typename?: 'MinigamesServiceRemainingPlaysOutput';
  campaignId: Scalars['String']['output'];
  maxPlays: Scalars['Int']['output'];
  playedCount: Scalars['Int']['output'];
  remainingPlays: Scalars['Int']['output'];
};

export type MinigamesServiceSetPrizeProbabilitiesInput = {
  campaignId: Scalars['String']['input'];
  probabilities: Array<MinigamesServicePrizeProbabilityItemInput>;
};

export type MinigamesServiceSubmitQuizAnswersInput = {
  answers: Array<MinigamesServiceQuizAnswerInput>;
  campaignId: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  gameRecordId?: InputMaybe<Scalars['String']['input']>;
  guestName?: InputMaybe<Scalars['String']['input']>;
  guestPhone?: InputMaybe<Scalars['String']['input']>;
};

export type MinigamesServiceUpdateAnswerInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type MinigamesServiceUpdateCampaignInput = {
  authenticationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  distributionType?: InputMaybe<DistributionTypeEnum>;
  enablePrizeSystem?: InputMaybe<Scalars['Boolean']['input']>;
  enableTierSystem?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  gameConfig?: InputMaybe<Scalars['JSON']['input']>;
  howToPlay?: InputMaybe<Scalars['String']['input']>;
  maxPlaysPerUser?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  playCodeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  uiConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type MinigamesServiceUpdateCampaignStatusInput = {
  status: CampaignStatusEnum;
};

export type MinigamesServiceUpdateGameTemplateInput = {
  authenticationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  distributionType?: InputMaybe<DistributionTypeEnum>;
  enablePrizeSystem?: InputMaybe<Scalars['Boolean']['input']>;
  enableTierSystem?: InputMaybe<Scalars['Boolean']['input']>;
  gameConfig?: InputMaybe<Scalars['JSON']['input']>;
  howToPlay?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  maxPlaysPerUser?: InputMaybe<Scalars['Int']['input']>;
  playCodeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  uiConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type MinigamesServiceUpdatePrizeInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  mediaUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  pointsAmount?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  voucherTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type MinigamesServiceUpdateQuestionInput = {
  answers?: InputMaybe<Array<UpdateAnswerItemInput>>;
  audioUrl?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  correctAnswerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  passage?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type MinigamesServiceUserGameHistoryInput = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
};

export type MinigamesServiceUserGameHistoryItemOutput = {
  __typename?: 'MinigamesServiceUserGameHistoryItemOutput';
  campaignId: Scalars['String']['output'];
  campaignName?: Maybe<Scalars['String']['output']>;
  campaignThumbnail?: Maybe<Scalars['String']['output']>;
  gameType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  playedAt: Scalars['DateTime']['output'];
  prize?: Maybe<MinigamesServicePrizeInfo>;
  prizeDelivered?: Maybe<Scalars['Boolean']['output']>;
  prizeDeliveredAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MinigamesServiceUserGameHistoryOutput = {
  __typename?: 'MinigamesServiceUserGameHistoryOutput';
  data: Array<MinigamesServiceUserGameHistoryItemOutput>;
  total: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addressServiceCreateAddress: AddressServiceAddressGqlOutput;
  addressServiceDeleteAddress: AddressServiceAddressGqlOutput;
  addressServiceUpdateAddress: AddressServiceAddressGqlOutput;
  addressServiceUpdateDefaultAddress: AddressServiceAddressGqlOutput;
  affiliateServiceCreateCodeRequest: AffiliateServiceCodeRequestOutput;
  affiliateServiceCreateLink: AffiliateServiceLinkOutput;
  affiliateServiceDeleteLink: Scalars['Boolean']['output'];
  affiliateServiceReviewCodeRequest: AffiliateServiceCodeRequestOutput;
  affiliateServiceTrack: AffiliateServiceAffiliateTrackingOutput;
  affiliateServiceUpdateLink: AffiliateServiceLinkOutput;
  affiliateServiceUpsertConfig: AffiliateServiceConfigOutput;
  apiHubServiceCreateApiCredential: ApiHubServiceApiCredential;
  apiHubServiceCreateApiProvider: Scalars['Boolean']['output'];
  apiHubServiceDisableTenantProviderLink: ApiHubServiceTenantProviderLink;
  apiHubServicePromoteApiCredential: ApiHubServiceApiCredential;
  apiHubServiceRollbackApiCredential: ApiHubServiceApiCredential;
  apiHubServiceRotateApiCredential: ApiHubServiceApiCredential;
  apiHubServiceSetApiProviderStatus: ApiHubServiceApiProvider;
  apiHubServiceUpdateApiCredential: ApiHubServiceApiCredential;
  apiHubServiceUpdateApiProvider: ApiHubServiceApiProvider;
  apiHubServiceUpsertApiCredentialTemplate: ApiHubServiceApiCredentialTemplate;
  apiHubServiceUpsertTenantProviderLink: ApiHubServiceTenantProviderLink;
  authServiceChangePassword: Scalars['Boolean']['output'];
  authServiceConfirmRegister: Scalars['Boolean']['output'];
  authServiceEmailForgotPassword: Scalars['Boolean']['output'];
  authServiceEmailLogin: AuthServiceTokenGqlOutput;
  authServiceEmailRegister: Scalars['Boolean']['output'];
  authServiceImpersonateUser: AuthServiceTokenGqlOutput;
  authServiceKratosEmailLogin: AuthServiceKratosUserGqlOutput;
  authServiceKratosImpersonateZaloUser: AuthServiceKratosUserGqlOutput;
  authServiceKratosRefreshToken: AuthServiceKratosUserGqlOutput;
  authServiceKratosZaloLogin: AuthServiceKratosUserGqlOutput;
  authServiceLoginWithGoogle: AuthServiceTokenGqlOutput;
  authServiceRefreshToken: AuthServiceTokenGqlOutput;
  authServiceResetPassword: Scalars['Boolean']['output'];
  authServiceZaloLogin: AuthServiceTokenGqlOutput;
  binoAdminServiceCreateAuthoritiesReport: BinoAdminServiceAuthoritiesReportGqlOutput;
  binoAdminServiceUpdateAuthoritiesReportStatus: BinoAdminServiceAuthoritiesReportGqlOutput;
  bookingServiceAcceptBookings: Scalars['Boolean']['output'];
  bookingServiceCancelBookings: Scalars['Boolean']['output'];
  bookingServiceCreateBooking: BookingServiceBookingGqlOutput;
  bookingServiceCreateProductSuggestion: Scalars['Boolean']['output'];
  bookingServiceCreateSlot: Scalars['Boolean']['output'];
  bookingServiceDeleteBookings: Scalars['Boolean']['output'];
  bookingServiceDeleteProductSuggestion: Scalars['Boolean']['output'];
  bookingServiceDeleteSlots: Scalars['Boolean']['output'];
  bookingServiceDisableSlots: Scalars['Boolean']['output'];
  bookingServiceEnableSlots: Scalars['Boolean']['output'];
  bookingServiceUpdateBooking: BookingServiceBookingGqlOutput;
  bookingServiceUpdateProductSuggestion: Scalars['Boolean']['output'];
  bookingServiceUpdateSlot: Scalars['Boolean']['output'];
  campaignServiceCreateCampaign: Scalars['Boolean']['output'];
  campaignServiceCreateCampaignTrigger: Scalars['Boolean']['output'];
  campaignServiceDeleteCampaign: Scalars['Boolean']['output'];
  campaignServiceDeleteCampaignTrigger: Scalars['Boolean']['output'];
  campaignServiceDisableCampaign: Scalars['Boolean']['output'];
  campaignServiceDisableCampaignTrigger: Scalars['Boolean']['output'];
  campaignServiceEnableCampaign: Scalars['Boolean']['output'];
  campaignServiceEnableCampaignTrigger: Scalars['Boolean']['output'];
  campaignServiceUpdateCampaign: Scalars['Boolean']['output'];
  campaignServiceUpdateCampaignTrigger: Scalars['Boolean']['output'];
  cartServiceCreate: CartServiceCartGqlOutput;
  cartServiceDelete: Scalars['Boolean']['output'];
  cartServiceDeleteAll: Scalars['Boolean']['output'];
  cartServiceUpdate: CartServiceCartGqlOutput;
  checkinServiceCheckinByGps: CheckinServiceStatusGqlOutput;
  checkinServiceCheckinByImage: CheckinServiceStatusGqlOutput;
  checkinServiceCheckinByQrCode: CheckinServiceStatusGqlOutput;
  checkinServiceCheckinByWifi: CheckinServiceStatusGqlOutput;
  clockinServiceAcceptClockin: Scalars['Boolean']['output'];
  clockinServiceAddStaff: Scalars['Boolean']['output'];
  clockinServiceCreateShift: Scalars['Boolean']['output'];
  clockinServiceDeleteShifts: Scalars['Boolean']['output'];
  clockinServiceDisableShifts: Scalars['Boolean']['output'];
  clockinServiceEnableShifts: Scalars['Boolean']['output'];
  clockinServiceGpsClockin: Scalars['Boolean']['output'];
  clockinServiceImageClockin: Scalars['Boolean']['output'];
  clockinServiceRemoveStaff: Scalars['Boolean']['output'];
  clockinServiceUpdateShift: Scalars['Boolean']['output'];
  clockinServiceWifiClockin: Scalars['Boolean']['output'];
  contentServiceCreateArticle: ContentServiceArticleGqlOutput;
  contentServiceCreateBlockTemplate: BlockTemplateOutput;
  contentServiceCreateCategory: Scalars['Boolean']['output'];
  contentServiceCreatePage: ContentServicePageGqlOutput;
  contentServiceDeleteArticles: Scalars['Boolean']['output'];
  contentServiceDeleteBlockTemplate: Scalars['Boolean']['output'];
  contentServiceDeleteCategory: Scalars['Boolean']['output'];
  contentServiceDisableCategories: Scalars['Boolean']['output'];
  contentServiceEnableCategories: Scalars['Boolean']['output'];
  contentServiceHideArticles: Scalars['Boolean']['output'];
  contentServiceUnhideArticles: Scalars['Boolean']['output'];
  contentServiceUpdateArticle: Scalars['Boolean']['output'];
  contentServiceUpdateArticleStatus: Scalars['Boolean']['output'];
  contentServiceUpdateBlockTemplate: BlockTemplateOutput;
  contentServiceUpdateCategory: Scalars['Boolean']['output'];
  contentServiceUpdatePage: ContentServicePageGqlOutput;
  createCompany: Scalars['Boolean']['output'];
  deleteCompanies: Scalars['Boolean']['output'];
  dictionaryServiceCrawlWord: Scalars['Boolean']['output'];
  dictionaryServiceCrawlWords: Array<DictionaryServiceCrawlWordOutput>;
  dictionaryServiceCreateDictionary: Scalars['Boolean']['output'];
  dictionaryServiceDeleteDictionaries: Scalars['Boolean']['output'];
  dictionaryServiceEnableDictionaries: Scalars['Boolean']['output'];
  dictionaryServiceUpdateDictionary: Scalars['Boolean']['output'];
  enableCompanies: Scalars['Boolean']['output'];
  eventServiceCreateCategory: Scalars['Boolean']['output'];
  eventServiceCreateEvent: Scalars['Boolean']['output'];
  eventServiceDeleteCategory: Scalars['Boolean']['output'];
  eventServiceDeleteEvents: Scalars['Boolean']['output'];
  eventServiceDisableCategories: Scalars['Boolean']['output'];
  eventServiceDisableEvents: Scalars['Boolean']['output'];
  eventServiceEnableCategories: Scalars['Boolean']['output'];
  eventServiceEnableEvents: Scalars['Boolean']['output'];
  eventServiceQrCodeCheckin: Scalars['Boolean']['output'];
  eventServiceRegisterEvent: Scalars['Boolean']['output'];
  eventServiceUpdateCategory: Scalars['Boolean']['output'];
  eventServiceUpdateEvent: Scalars['Boolean']['output'];
  featureFlagServiceCreateFeatureFlag: Scalars['Boolean']['output'];
  featureFlagServiceCreateTenantOverride: FeatureFlagServiceTenantOverrideGqlOutput;
  featureFlagServiceDeleteFeatureFlag: Scalars['Boolean']['output'];
  featureFlagServiceDeleteTenantOverride: Scalars['Boolean']['output'];
  featureFlagServiceToggleFeatureFlagById?: Maybe<FeatureFlagServiceFeatureFlagGqlOutput>;
  featureFlagServiceUpdateFeatureFlag: Scalars['Boolean']['output'];
  featureFlagServiceUpdateTenantOverride: FeatureFlagServiceTenantOverrideGqlOutput;
  featureServiceCreateFeature: Scalars['Boolean']['output'];
  featureServiceCreateFeatures: Scalars['Boolean']['output'];
  featureServiceDeleteFeature: Scalars['Boolean']['output'];
  featureServiceToggleFeature: Scalars['Boolean']['output'];
  featureServiceUpdateFeature: Scalars['Boolean']['output'];
  flashsaleServiceAddProduct: FlashSaleProduct;
  flashsaleServiceCreateCampaign: Campaign;
  flashsaleServiceDeleteCampaign: Scalars['Boolean']['output'];
  flashsaleServiceDeleteProduct: Scalars['Boolean']['output'];
  flashsaleServiceUpdateCampaign: Campaign;
  flashsaleServiceUpdateProduct: FlashSaleProduct;
  fnsServiceCreateFormForAdmin: FnsServiceFormGqlOutput;
  fnsServiceCreateSurveyForAdmin: FnsServiceSurveyGqlOutput;
  fnsServiceCreateUserResponseToForm: FnsServiceUserResponseGqlOutput;
  fnsServiceCreateUserResponseToFormForAnonymous: FnsServiceUserResponseGqlOutput;
  fnsServiceCreateUserResponseToSurvey: FnsServiceUserResponseGqlOutput;
  fnsServiceCreateUserResponseToSurveyForAnonymous: FnsServiceUserResponseGqlOutput;
  fnsServiceUpdateFormForAdmin: FnsServiceFormGqlOutput;
  fnsServiceUpdateSurveyForAdmin: FnsServiceSurveyGqlOutput;
  inventoryServiceConfirmProduct: Scalars['Boolean']['output'];
  inventoryServiceCreateStock: Scalars['Boolean']['output'];
  inventoryServiceDeleteStock: Scalars['Boolean']['output'];
  inventoryServiceReleaseProduct: Scalars['Boolean']['output'];
  inventoryServiceReserveProduct: Scalars['Boolean']['output'];
  inventoryServiceUpdateStock: Scalars['Boolean']['output'];
  larvaCourseServiceAddItemsToUserCollection: Scalars['Boolean']['output'];
  larvaCourseServiceAnalyzeSpeakingSentence: LarvaCourseServiceAnalyzeGqlOutput;
  larvaCourseServiceAnalyzeSpeakingWord: LarvaCourseServiceAnalyzeGqlOutput;
  larvaCourseServiceChangeNameUserCollection: Scalars['Boolean']['output'];
  larvaCourseServiceCreateLessonSpeaking: Scalars['Boolean']['output'];
  larvaCourseServiceCreateSentence: Scalars['Boolean']['output'];
  larvaCourseServiceCreateTopic: Scalars['Boolean']['output'];
  larvaCourseServiceCreateUserCollection: Scalars['Boolean']['output'];
  larvaCourseServiceDeleteUserCollection: Scalars['Boolean']['output'];
  larvaCourseServicePublishSentences: Scalars['Boolean']['output'];
  larvaCourseServiceRemoveItemsFromUserCollection: Scalars['Boolean']['output'];
  larvaCourseServiceUpdateLessonSpeaking: Scalars['Boolean']['output'];
  larvaCourseServiceUpdateSentence: Scalars['Boolean']['output'];
  larvaCourseServiceUpdateTopic: Scalars['Boolean']['output'];
  loyaltyServiceCreateLoyaltyProgram: Scalars['Boolean']['output'];
  loyaltyServiceCreateLoyaltyTier: Scalars['Boolean']['output'];
  loyaltyServiceDeactiveLoyaltyProgram: Scalars['Boolean']['output'];
  loyaltyServiceDeleteLoyaltyProgram: Scalars['Boolean']['output'];
  loyaltyServiceDeleteLoyaltyTiers: Scalars['Boolean']['output'];
  loyaltyServiceDisableLoyaltyTier: Scalars['Boolean']['output'];
  loyaltyServiceEnableLoyaltyTier: Scalars['Boolean']['output'];
  loyaltyServiceSetDefaultLoyaltyProgram: Scalars['Boolean']['output'];
  loyaltyServiceUpdateLoyaltyTier: Scalars['Boolean']['output'];
  meetingServiceCreateRoom: MeetingServiceCreateRoomGqlOutput;
  membershipServiceCreateMember: MembershipServiceMemberGqlOutput;
  membershipServiceUpdateMember: MembershipServiceMemberGqlOutput;
  messageManagementServiceCreateOAAccount: OaAccount;
  messageManagementServiceCreateOAQuota: OaQuota;
  messageManagementServiceCreateOttSms: OttSmsResponse;
  messageManagementServiceCreateSmsConfig: SmsConfig;
  messageManagementServiceCreateViberConfig: ViberConfig;
  messageManagementServiceCreateZnsTemplate: ZnsTemplate;
  messageManagementServiceDeleteOAQuota: Scalars['Boolean']['output'];
  messageManagementServiceDeleteSmsConfig: Scalars['Boolean']['output'];
  messageManagementServiceDeleteViberConfig: Scalars['Boolean']['output'];
  messageManagementServiceRetryMessage: MessageResponse;
  messageManagementServiceSendOttSms: MessageResponse;
  messageManagementServiceSendSmsMessage: SendSmsMessageResponse;
  messageManagementServiceSendViberMessage: SendViberMessageResponse;
  messageManagementServiceSendZnsMessage: SendZnsMessageResponse;
  messageManagementServiceSyncOAAccounts: Scalars['Boolean']['output'];
  messageManagementServiceSyncOAQuota: Scalars['Boolean']['output'];
  messageManagementServiceSyncZnsTemplates: Scalars['Boolean']['output'];
  messageManagementServiceUpdateMessageStatus: Scalars['Boolean']['output'];
  messageManagementServiceUpdateOAQuota: OaQuota;
  messageManagementServiceUpdateSmsConfig: SmsConfig;
  messageManagementServiceUpdateViberConfig: ViberConfig;
  messageManagementServiceVerifyOtp: OtpVerifyResponse;
  minigamesServiceAddAnswer: MinigamesServiceQuestionOutput;
  minigamesServiceAddPrize: MinigamesServicePrizeOutput;
  minigamesServiceConfirmPrizeDelivery: MinigamesServiceGameRecordOutput;
  minigamesServiceCreateCampaign: MinigamesServiceCampaignOutput;
  minigamesServiceCreateGameTemplate: MinigamesServiceGameTemplateOutput;
  minigamesServiceCreateQuestion: MinigamesServiceQuestionOutput;
  minigamesServiceDeleteAnswer: Scalars['Boolean']['output'];
  minigamesServiceDeleteCampaign: Scalars['Boolean']['output'];
  minigamesServiceDeleteGameTemplate: Scalars['Boolean']['output'];
  minigamesServiceDeletePrize: Scalars['Boolean']['output'];
  minigamesServiceDeleteQuestion: Scalars['Boolean']['output'];
  minigamesServiceGenerateCodes: Array<MinigamesServiceCodeOutput>;
  minigamesServicePlayGame: MinigamesServicePlayGameResultOutput;
  minigamesServicePlayGameAsGuest: MinigamesServicePlayGameResultOutput;
  minigamesServiceSetPrizeProbabilities: Array<MinigamesServicePrizeOutput>;
  minigamesServiceSubmitQuizAnswers: MinigamesServiceQuizAnswersResultOutput;
  minigamesServiceUpdateAnswer: MinigamesServiceQuestionOutput;
  minigamesServiceUpdateCampaign: MinigamesServiceCampaignOutput;
  minigamesServiceUpdateCampaignStatus: MinigamesServiceCampaignOutput;
  minigamesServiceUpdateGameTemplate: MinigamesServiceGameTemplateOutput;
  minigamesServiceUpdatePrize: MinigamesServicePrizeOutput;
  minigamesServiceUpdateQuestion: MinigamesServiceQuestionOutput;
  notificationServiceCreateTemplateForAdmin: NotificationServiceTemplateGqlOutput;
  notificationServiceMarkInAppNotificationAsRead: NotificationServiceInAppNotificationGqlOutput;
  notificationServiceUpdateTemplateForAdmin: NotificationServiceTemplateGqlOutput;
  orderServiceApplyVoucher: OrderServiceOrderGqlOutput;
  orderServiceCancelOrder: OrderServiceOrderGqlOutput;
  orderServiceConfirmOrder: Scalars['Boolean']['output'];
  orderServiceCreateBookingOrder: OrderServiceOrderGqlOutput;
  orderServiceCreateOrder: OrderServiceOrderGqlOutput;
  orderServiceCreateOrderWithProduct: OrderServiceOrderGqlOutput;
  orderServiceDeleteOrder: Scalars['Boolean']['output'];
  orderServiceUpdateOrderStatus: Scalars['Boolean']['output'];
  orderServiceUpdateShipping: OrderServiceOrderGqlOutput;
  organizationServiceAdminCreateOrganization: OrganizationServiceOrganizationGqlOutput;
  organizationServiceAdminUpdateOrganization: OrganizationServiceOrganizationGqlOutput;
  organizationServiceCreateBranch: OrganizationServiceBranchGqlOutput;
  organizationServiceDeleteBranch: OrganizationServiceBranchGqlOutput;
  organizationServiceUpdateBranch: OrganizationServiceBranchGqlOutput;
  paymentServiceCreatePaymentVendor: PaymentServiceVendorForAdminGqlOutput;
  paymentServiceUpdatePaymentVendor: PaymentServiceVendorForAdminGqlOutput;
  paymentServiceZMAConfirmTransaction: Scalars['Boolean']['output'];
  paymentServiceZMACreateTransaction: PaymentServiceZmaCreateTransactionGqlOutput;
  paymentServiceZMAUpdateTransactionStatus: Scalars['Boolean']['output'];
  pointServiceActivatePointExpiryRule: Scalars['Boolean']['output'];
  pointServiceAddPointsForProfile: PointServiceAddPointsForProfileGqlOutput;
  pointServiceCreatePointBalanceProfile: PointServicePointBalanceGqlOutput;
  pointServiceCreatePointConfig: PointConfigOutput;
  pointServiceCreatePointExpiryRule: Scalars['Boolean']['output'];
  pointServiceDeactivatePointExpiryRule: Scalars['Boolean']['output'];
  pointServiceRedeemPointsForVoucher: PointServiceRedeemPointsForVoucherGqlOutput;
  pointServiceUpdatePointBalance: PointServicePointBalanceGqlOutput;
  pointServiceUpdatePointConfig: PointConfigOutput;
  pointServiceUpdatePointExpiryRule: Scalars['Boolean']['output'];
  productServiceCreateBrand: Scalars['Boolean']['output'];
  productServiceCreateCategory: Scalars['Boolean']['output'];
  productServiceCreateColor: Scalars['Boolean']['output'];
  productServiceCreateProduct: Scalars['Boolean']['output'];
  productServiceDeleteBrands: Scalars['Boolean']['output'];
  productServiceDeleteCategory: Scalars['Boolean']['output'];
  productServiceDeleteColor: Scalars['Boolean']['output'];
  productServiceDeleteProducts: Scalars['Boolean']['output'];
  productServiceDisableBrands: Scalars['Boolean']['output'];
  productServiceDisableCategories: Scalars['Boolean']['output'];
  productServiceDisableColors: Scalars['Boolean']['output'];
  productServiceDisableProducts: Scalars['Boolean']['output'];
  productServiceEnableBrands: Scalars['Boolean']['output'];
  productServiceEnableCategories: Scalars['Boolean']['output'];
  productServiceEnableColors: Scalars['Boolean']['output'];
  productServiceEnableProducts: Scalars['Boolean']['output'];
  productServiceRateProduct: Scalars['Boolean']['output'];
  productServiceUpdateBrand: Scalars['Boolean']['output'];
  productServiceUpdateCategory: Scalars['Boolean']['output'];
  productServiceUpdateColor: Scalars['Boolean']['output'];
  productServiceUpdateProduct: Scalars['Boolean']['output'];
  ratingServiceCreateRating: RatingServiceRatingGqlOutput;
  ratingServiceDeleteRating: Scalars['Boolean']['output'];
  ratingServiceDeleteRatingForAdmin: Scalars['Boolean']['output'];
  ratingServiceToggleFavorite: RatingServiceToggleFavoriteGqlOutput;
  ratingServiceUpdateRating: RatingServiceRatingGqlOutput;
  rbacServiceAssignRoleToUser: Scalars['Boolean']['output'];
  rbacServiceCreateRole: RbacServiceRoleGqlOutput;
  rbacServiceDeleteRole: Scalars['Boolean']['output'];
  rbacServiceUnassignRoleFromUser: Scalars['Boolean']['output'];
  rbacServiceUpdateRole: RbacServiceRoleGqlOutput;
  rbacServiceValidatePermission: Scalars['Boolean']['output'];
  referralServiceConfigureReferralSystemForAgency: ConfigureReferralSystemOutput;
  referralServiceConfigureReferralSystemForOrganization: ConfigureReferralSystemOutput;
  referralServiceCreateReferralCode: CreateReferralCodeOutput;
  referralServiceProcessReferral: ReferralProcessingOutput;
  referralServiceSaveReferral: SaveReferralOutput;
  referralServiceUseReferralCode: UseReferralCodeOutput;
  sduiServiceCreateBlock: Scalars['Boolean']['output'];
  sduiServiceCreateLayout: Scalars['Boolean']['output'];
  sduiServiceCreatePage: Scalars['Boolean']['output'];
  sduiServiceDeleteBlock: Scalars['Boolean']['output'];
  sduiServiceDeletePage: Scalars['Boolean']['output'];
  sduiServiceToggleLayout: Scalars['Boolean']['output'];
  sduiServiceUpdateBlock: Scalars['Boolean']['output'];
  sduiServiceUpdateLayout: Scalars['Boolean']['output'];
  sduiServiceUpdatePage: Scalars['Boolean']['output'];
  sduiServiceUpdateTenantLayout: Scalars['Boolean']['output'];
  shippingServiceShippingMethodCreate: ShippingServiceShippingMethodGqlOutput;
  shippingServiceShippingMethodUpdateFixedPrice: ShippingServiceShippingMethodGqlOutput;
  shippingServiceShippingMethodUpdateStatus: ShippingServiceShippingMethodGqlOutput;
  subscriptionServiceArchivePlan?: Maybe<SubscriptionServicePlanGqlOutput>;
  subscriptionServiceCancelSubscription?: Maybe<SubscriptionServiceSubscriptionGqlOutput>;
  subscriptionServiceCreatePackage: SubscriptionServicePackageGqlOutput;
  subscriptionServiceCreatePlan?: Maybe<SubscriptionServicePlanGqlOutput>;
  subscriptionServiceCreateSubscription?: Maybe<SubscriptionServiceSubscriptionGqlOutput>;
  subscriptionServiceCreateUserSubscription: SubscriptionServiceCreateUserSubscriptionGqlOutput;
  subscriptionServicePauseSubscription?: Maybe<SubscriptionServiceSubscriptionGqlOutput>;
  subscriptionServiceProcessRefund?: Maybe<SubscriptionServiceBillingTransactionGqlOutput>;
  subscriptionServiceResumeSubscription?: Maybe<SubscriptionServiceSubscriptionGqlOutput>;
  subscriptionServiceRetryPayment?: Maybe<SubscriptionServiceBillingTransactionGqlOutput>;
  subscriptionServiceUpdatePackage: SubscriptionServicePackageGqlOutput;
  subscriptionServiceUpdatePlan?: Maybe<SubscriptionServicePlanGqlOutput>;
  subscriptionServiceUpdateSubscription?: Maybe<SubscriptionServiceSubscriptionGqlOutput>;
  subscriptionServiceUpgradeSubscription?: Maybe<SubscriptionServiceSubscriptionGqlOutput>;
  syncServicesyncCategory: SyncResult;
  syncServicesyncInventory: SyncResult;
  syncServicesyncOrder: SyncResult;
  syncServicesyncProduct: SyncResult;
  taskServiceAddClickAppToSpace: Scalars['Boolean']['output'];
  taskServiceAddCommentToTask: Scalars['Boolean']['output'];
  taskServiceAddListToFolder: Scalars['Boolean']['output'];
  taskServiceAddMemberToWorkspace: Scalars['Boolean']['output'];
  taskServiceAddTaskToList: Scalars['Boolean']['output'];
  taskServiceAddTimeLog: Scalars['Boolean']['output'];
  taskServiceAssignTask: Scalars['Boolean']['output'];
  taskServiceCreateDependency: Scalars['Boolean']['output'];
  taskServiceCreateFolder: Scalars['Boolean']['output'];
  taskServiceCreateList: Scalars['Boolean']['output'];
  taskServiceCreateSpace: Scalars['Boolean']['output'];
  taskServiceCreateSubtask: Scalars['Boolean']['output'];
  taskServiceCreateTask: Scalars['Boolean']['output'];
  taskServiceCreateWorkspace: Scalars['Boolean']['output'];
  taskServiceDeleteDependencies: Scalars['Boolean']['output'];
  taskServiceDeleteDependenciesByTask: Scalars['Boolean']['output'];
  taskServiceDeleteFolders: Scalars['Boolean']['output'];
  taskServiceDeleteLists: Scalars['Boolean']['output'];
  taskServiceDeleteSpaces: Scalars['Boolean']['output'];
  taskServiceDeleteTasks: Scalars['Boolean']['output'];
  taskServiceDeleteWorkspaces: Scalars['Boolean']['output'];
  taskServiceMoveListToFolder: Scalars['Boolean']['output'];
  taskServiceMoveTaskToList: Scalars['Boolean']['output'];
  taskServiceRemoveClickAppFromSpace: Scalars['Boolean']['output'];
  taskServiceRemoveListFromFolder: Scalars['Boolean']['output'];
  taskServiceRemoveMemberFromWorkspace: Scalars['Boolean']['output'];
  taskServiceRemoveTaskFromList: Scalars['Boolean']['output'];
  taskServiceUnassignTask: Scalars['Boolean']['output'];
  taskServiceUpdateDependency: Scalars['Boolean']['output'];
  taskServiceUpdateFolder: Scalars['Boolean']['output'];
  taskServiceUpdateList: Scalars['Boolean']['output'];
  taskServiceUpdateSpace: Scalars['Boolean']['output'];
  taskServiceUpdateSpaceStatuses: Scalars['Boolean']['output'];
  taskServiceUpdateTask: Scalars['Boolean']['output'];
  taskServiceUpdateTaskStatus: Scalars['Boolean']['output'];
  taskServiceUpdateWorkspace: Scalars['Boolean']['output'];
  /** Approve a pending template (creates new version if already approved) */
  templateServiceApproveTemplate?: Maybe<TemplateServiceTemplate>;
  /** Create a new template in draft status */
  templateServiceCreateTemplate?: Maybe<TemplateServiceTemplate>;
  /** Soft delete a template */
  templateServiceDeleteTemplate?: Maybe<Scalars['Boolean']['output']>;
  /** Reject a pending template */
  templateServiceRejectTemplate?: Maybe<TemplateServiceTemplate>;
  /** Rollback to a previous approved version (creates new version) */
  templateServiceRollbackTemplate?: Maybe<TemplateServiceTemplate>;
  /** Submit a draft template for approval (changes status to pending) */
  templateServiceSubmitTemplate?: Maybe<TemplateServiceTemplate>;
  /** Update a draft template (only draft can be updated) */
  templateServiceUpdateTemplate?: Maybe<TemplateServiceTemplate>;
  ticketServiceAddCommentToTicket: Scalars['Boolean']['output'];
  ticketServiceChangeCustomerStatus: Scalars['Boolean']['output'];
  ticketServiceCreateCustomer: Customer;
  ticketServiceCreateTicket: Scalars['Boolean']['output'];
  ticketServiceDeleteCustomer: Scalars['Boolean']['output'];
  ticketServiceDeleteTickets: Scalars['Boolean']['output'];
  ticketServiceDisableTickets: Scalars['Boolean']['output'];
  ticketServiceEnableTickets: Scalars['Boolean']['output'];
  ticketServiceUpdateCustomer: Customer;
  ticketServiceUpdateTicket: Scalars['Boolean']['output'];
  updateCompany: Scalars['Boolean']['output'];
  uploadServiceCompleteUpload: UploadServiceCompleteGqlOutput;
  uploadServiceRequestUpload: UploadServiceRequestGqlOutput;
  userServiceAdminCreateTenant: UserServiceTenantGqlOutput;
  userServiceAdminUpdateTenant: UserServiceTenantGqlOutput;
  userServiceCreateAgency: UserServiceUserGqlOutput;
  userServiceCreateOrganizationAdmin: UserServiceUserGqlOutput;
  userServiceCreateTenant: UserServiceTenantGqlOutput;
  userServiceCreateTenantAdmin: UserServiceUserGqlOutput;
  userServiceDeleteUser: Scalars['Boolean']['output'];
  userServiceTenantStatus: UserServiceTenantGqlOutput;
  userServiceUpdateAvatar: UserServiceUserGqlOutput;
  userServiceUpdateProfile: UserServiceUserGqlOutput;
  userServiceUpdateTenant: UserServiceTenantGqlOutput;
  userServiceUpdateTenantType: UserServiceTenantGqlOutput;
  userServiceUpdateZaloOAId: UserServiceUserGqlOutput;
  voucherServiceBulkIssueToAllUsers: Scalars['Boolean']['output'];
  voucherServiceBulkIssueToUsers: Scalars['Boolean']['output'];
  voucherServiceCreateVoucher: Scalars['Boolean']['output'];
  voucherServiceCreateVoucherType: Scalars['Boolean']['output'];
  voucherServiceDeleteVoucherTypeById: Scalars['Boolean']['output'];
  voucherServiceDeleteVouchers: Scalars['Boolean']['output'];
  voucherServiceDisableVoucherTypeById: Scalars['Boolean']['output'];
  voucherServiceEnableVoucherTypeById: Scalars['Boolean']['output'];
  voucherServiceEnableVouchers: Scalars['Boolean']['output'];
  voucherServiceUpdateVoucher: Scalars['Boolean']['output'];
  voucherServiceUpdateVoucherType: Scalars['Boolean']['output'];
};


export type MutationAddressServiceCreateAddressArgs = {
  input: AddressServiceCreateAddressGqlInput;
};


export type MutationAddressServiceDeleteAddressArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddressServiceUpdateAddressArgs = {
  input: AddressServiceUpdateAddressGqlInput;
};


export type MutationAddressServiceUpdateDefaultAddressArgs = {
  input: AddressServiceUpdateDefaultGqlInput;
};


export type MutationAffiliateServiceCreateCodeRequestArgs = {
  input: AffiliateServiceCreateCodeRequestInput;
};


export type MutationAffiliateServiceCreateLinkArgs = {
  input: AffiliateServiceCreateLinkInput;
};


export type MutationAffiliateServiceDeleteLinkArgs = {
  linkId: Scalars['String']['input'];
};


export type MutationAffiliateServiceReviewCodeRequestArgs = {
  input: AffiliateServiceReviewCodeRequestInput;
};


export type MutationAffiliateServiceTrackArgs = {
  affiliateCode: Scalars['String']['input'];
  input: AffiliateServiceTrackInput;
};


export type MutationAffiliateServiceUpdateLinkArgs = {
  input: AffiliateServiceUpdateLinkInput;
};


export type MutationAffiliateServiceUpsertConfigArgs = {
  input: AffiliateServiceUpsertConfigInput;
};


export type MutationApiHubServiceCreateApiCredentialArgs = {
  input: ApiHubServiceCreateApiCredentialInput;
};


export type MutationApiHubServiceCreateApiProviderArgs = {
  input: ApiHubServiceCreateApiProviderInput;
};


export type MutationApiHubServiceDisableTenantProviderLinkArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationApiHubServicePromoteApiCredentialArgs = {
  input: ApiHubServicePromoteApiCredentialInput;
};


export type MutationApiHubServiceRollbackApiCredentialArgs = {
  input: ApiHubServiceRollbackApiCredentialInput;
};


export type MutationApiHubServiceRotateApiCredentialArgs = {
  input: ApiHubServiceRotateApiCredentialInput;
};


export type MutationApiHubServiceSetApiProviderStatusArgs = {
  providerCode: Scalars['String']['input'];
  status: ApiHubServiceApiProviderStatus;
};


export type MutationApiHubServiceUpdateApiCredentialArgs = {
  input: ApiHubServiceUpdateApiCredentialInput;
};


export type MutationApiHubServiceUpdateApiProviderArgs = {
  input: ApiHubServiceUpdateApiProviderInput;
};


export type MutationApiHubServiceUpsertApiCredentialTemplateArgs = {
  input: ApiHubServiceUpsertApiCredentialTemplateInput;
};


export type MutationApiHubServiceUpsertTenantProviderLinkArgs = {
  input: ApiHubServiceUpsertTenantProviderLinkInput;
};


export type MutationAuthServiceChangePasswordArgs = {
  input: AuthServiceChangePasswordGqlInput;
};


export type MutationAuthServiceConfirmRegisterArgs = {
  input: AuthServiceConfirmTokenGqlInput;
};


export type MutationAuthServiceEmailForgotPasswordArgs = {
  input: AuthServiceForgotPasswordGqlInput;
};


export type MutationAuthServiceEmailLoginArgs = {
  input: AuthServiceLoginGqlInput;
};


export type MutationAuthServiceEmailRegisterArgs = {
  input: AuthServiceRegisterGqlInput;
};


export type MutationAuthServiceImpersonateUserArgs = {
  input: AuthServiceImpersonateUserGqlInput;
};


export type MutationAuthServiceKratosEmailLoginArgs = {
  input: AuthServiceKratosLoginGqlInput;
};


export type MutationAuthServiceKratosImpersonateZaloUserArgs = {
  input: AuthServiceImpersonateUserGqlInput;
};


export type MutationAuthServiceKratosRefreshTokenArgs = {
  input: AuthServiceKratosRefreshTokenGqlInput;
};


export type MutationAuthServiceKratosZaloLoginArgs = {
  input: AuthServiceKratosZaloLoginGqlInput;
};


export type MutationAuthServiceLoginWithGoogleArgs = {
  input: AuthServiceLoginWithSocialGqlInput;
};


export type MutationAuthServiceRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationAuthServiceResetPasswordArgs = {
  input: AuthServiceResetPasswordGqlInput;
};


export type MutationAuthServiceZaloLoginArgs = {
  input: AuthServiceZaloLoginGqlInput;
};


export type MutationBinoAdminServiceCreateAuthoritiesReportArgs = {
  input: BinoAdminServiceCreateAuthoritiesReportGqlInput;
};


export type MutationBinoAdminServiceUpdateAuthoritiesReportStatusArgs = {
  id: Scalars['ID']['input'];
  input: BinoAdminServiceUpdateAuthoritiesReportStatusGqlInput;
};


export type MutationBookingServiceAcceptBookingsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationBookingServiceCancelBookingsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationBookingServiceCreateBookingArgs = {
  input: BookingServiceBookingGqlInput;
};


export type MutationBookingServiceCreateProductSuggestionArgs = {
  input: BookingServiceCreateProductSuggestionGqlInput;
};


export type MutationBookingServiceCreateSlotArgs = {
  branchId: Scalars['String']['input'];
  input: BookingServiceSlotGqlInput;
};


export type MutationBookingServiceDeleteBookingsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationBookingServiceDeleteProductSuggestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationBookingServiceDeleteSlotsArgs = {
  branchId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']>;
};


export type MutationBookingServiceDisableSlotsArgs = {
  branchId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']>;
};


export type MutationBookingServiceEnableSlotsArgs = {
  branchId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']>;
};


export type MutationBookingServiceUpdateBookingArgs = {
  id: Scalars['String']['input'];
  input: BookingServiceBookingGqlInput;
};


export type MutationBookingServiceUpdateProductSuggestionArgs = {
  id: Scalars['String']['input'];
  input: BookingServiceUpdateProductSuggestionGqlInput;
};


export type MutationBookingServiceUpdateSlotArgs = {
  branchId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  input: BookingServiceSlotGqlInput;
};


export type MutationCampaignServiceCreateCampaignArgs = {
  input: CampaignServiceCreateCampaignGqlInput;
};


export type MutationCampaignServiceCreateCampaignTriggerArgs = {
  input: CampaignServiceCampaignTriggerGqlInput;
};


export type MutationCampaignServiceDeleteCampaignArgs = {
  id: Scalars['String']['input'];
};


export type MutationCampaignServiceDeleteCampaignTriggerArgs = {
  id: Scalars['String']['input'];
};


export type MutationCampaignServiceDisableCampaignArgs = {
  id: Scalars['String']['input'];
};


export type MutationCampaignServiceDisableCampaignTriggerArgs = {
  id: Scalars['String']['input'];
};


export type MutationCampaignServiceEnableCampaignArgs = {
  id: Scalars['String']['input'];
};


export type MutationCampaignServiceEnableCampaignTriggerArgs = {
  id: Scalars['String']['input'];
};


export type MutationCampaignServiceUpdateCampaignArgs = {
  id: Scalars['String']['input'];
  input: CampaignServiceUpdateCampaignGqlInput;
};


export type MutationCampaignServiceUpdateCampaignTriggerArgs = {
  input: CampaignServiceUpdateCampaignTriggerGqlInput;
};


export type MutationCartServiceCreateArgs = {
  input: CartServiceCreateGqlInput;
};


export type MutationCartServiceDeleteArgs = {
  input: CartServiceDeleteGqlInput;
};


export type MutationCartServiceUpdateArgs = {
  input: CartServiceUpdateGqlInput;
};


export type MutationCheckinServiceCheckinByGpsArgs = {
  input: CheckinServiceGpsCheckinGqlInput;
};


export type MutationCheckinServiceCheckinByImageArgs = {
  input: CheckinServiceImageCheckinGqlInput;
};


export type MutationCheckinServiceCheckinByQrCodeArgs = {
  input: CheckinServiceQrCodeCheckinGqlInput;
};


export type MutationCheckinServiceCheckinByWifiArgs = {
  input: CheckinServiceWifiCheckinGqlInput;
};


export type MutationClockinServiceAcceptClockinArgs = {
  id: Scalars['String']['input'];
};


export type MutationClockinServiceAddStaffArgs = {
  id: Scalars['String']['input'];
  staffIds: Array<Scalars['String']['input']>;
};


export type MutationClockinServiceCreateShiftArgs = {
  input: ClockinServiceShiftGqlInput;
};


export type MutationClockinServiceDeleteShiftsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationClockinServiceDisableShiftsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationClockinServiceEnableShiftsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationClockinServiceGpsClockinArgs = {
  input: ClockinServiceGpsClockinGqlInput;
  shiftId: Scalars['String']['input'];
};


export type MutationClockinServiceImageClockinArgs = {
  input: ClockinServiceImageClockinGqlInput;
  shiftId: Scalars['String']['input'];
};


export type MutationClockinServiceRemoveStaffArgs = {
  id: Scalars['String']['input'];
  staffIds: Array<Scalars['String']['input']>;
};


export type MutationClockinServiceUpdateShiftArgs = {
  id: Scalars['String']['input'];
  input: ClockinServiceShiftGqlInput;
};


export type MutationClockinServiceWifiClockinArgs = {
  input: ClockinServiceWifiClockinGqlInput;
  shiftId: Scalars['String']['input'];
};


export type MutationContentServiceCreateArticleArgs = {
  input: ContentServiceArticleGqlInput;
};


export type MutationContentServiceCreateBlockTemplateArgs = {
  input: CreateBlockTemplateInput;
};


export type MutationContentServiceCreateCategoryArgs = {
  input: ContentServiceCreateCategoryGqlInput;
};


export type MutationContentServiceCreatePageArgs = {
  input: ContentServiceCreatePageGqlInput;
};


export type MutationContentServiceDeleteArticlesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationContentServiceDeleteBlockTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationContentServiceDeleteCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationContentServiceDisableCategoriesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationContentServiceEnableCategoriesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationContentServiceHideArticlesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationContentServiceUnhideArticlesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationContentServiceUpdateArticleArgs = {
  id: Scalars['String']['input'];
  input: ContentServiceUpdateArticleGqlInput;
};


export type MutationContentServiceUpdateArticleStatusArgs = {
  id: Scalars['String']['input'];
  status: ContentStatusEnum;
};


export type MutationContentServiceUpdateBlockTemplateArgs = {
  input: UpdateBlockTemplateInput;
};


export type MutationContentServiceUpdateCategoryArgs = {
  id: Scalars['String']['input'];
  input: ContentServiceCreateCategoryGqlInput;
};


export type MutationContentServiceUpdatePageArgs = {
  id: Scalars['String']['input'];
  input: ContentServiceUpdatePageGqlInput;
};


export type MutationCreateCompanyArgs = {
  input: CompanyInput;
};


export type MutationDeleteCompaniesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDictionaryServiceCrawlWordArgs = {
  input: DictionaryServiceCrawlWordGqlInput;
};


export type MutationDictionaryServiceCrawlWordsArgs = {
  input: DictionaryServiceCrawlWordsGqlInput;
};


export type MutationDictionaryServiceCreateDictionaryArgs = {
  input: DictionaryServiceCreateDictionaryGqlInput;
};


export type MutationDictionaryServiceDeleteDictionariesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDictionaryServiceEnableDictionariesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDictionaryServiceUpdateDictionaryArgs = {
  id: Scalars['String']['input'];
  input: DictionaryServiceUpdateDictionaryGqlInput;
};


export type MutationEnableCompaniesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationEventServiceCreateCategoryArgs = {
  input: EventServiceCreateCategoryGqlInput;
};


export type MutationEventServiceCreateEventArgs = {
  input: EventServiceEventGqlInput;
};


export type MutationEventServiceDeleteCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationEventServiceDeleteEventsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationEventServiceDisableCategoriesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationEventServiceDisableEventsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationEventServiceEnableCategoriesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationEventServiceEnableEventsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationEventServiceQrCodeCheckinArgs = {
  qrCode: Scalars['String']['input'];
};


export type MutationEventServiceRegisterEventArgs = {
  eventId: Scalars['String']['input'];
};


export type MutationEventServiceUpdateCategoryArgs = {
  id: Scalars['String']['input'];
  input: EventServiceCreateCategoryGqlInput;
};


export type MutationEventServiceUpdateEventArgs = {
  id: Scalars['String']['input'];
  input: EventServiceEventGqlInput;
};


export type MutationFeatureFlagServiceCreateFeatureFlagArgs = {
  input: FeatureFlagServiceCreateFeatureFlagGqlInput;
};


export type MutationFeatureFlagServiceCreateTenantOverrideArgs = {
  input: FeatureFlagServiceCreateTenantOverrideGqlInput;
};


export type MutationFeatureFlagServiceDeleteFeatureFlagArgs = {
  featureFlagId: Scalars['String']['input'];
  type: FeatureFlagTypeEnum;
};


export type MutationFeatureFlagServiceDeleteTenantOverrideArgs = {
  input: FeatureFlagServiceDeleteTenantOverrideGqlInput;
};


export type MutationFeatureFlagServiceToggleFeatureFlagByIdArgs = {
  featureFlagId: Scalars['String']['input'];
  type: FeatureFlagTypeEnum;
};


export type MutationFeatureFlagServiceUpdateFeatureFlagArgs = {
  featureFlagId: Scalars['String']['input'];
  input: FeatureFlagServiceUpdateFeatureFlagGqlInput;
};


export type MutationFeatureFlagServiceUpdateTenantOverrideArgs = {
  input: FeatureFlagServiceUpdateTenantOverrideGqlInput;
};


export type MutationFeatureServiceCreateFeatureArgs = {
  input: FeatureServiceCreateFeatureGqlInput;
};


export type MutationFeatureServiceCreateFeaturesArgs = {
  input: FeatureServiceCreateFeaturesGqlInput;
};


export type MutationFeatureServiceDeleteFeatureArgs = {
  featureCode: Scalars['String']['input'];
};


export type MutationFeatureServiceToggleFeatureArgs = {
  input: FeatureServiceToggleFeatureGqlInput;
};


export type MutationFeatureServiceUpdateFeatureArgs = {
  featureCode: Scalars['String']['input'];
  input: FeatureServiceUpdateFeatureGqlInput;
};


export type MutationFlashsaleServiceAddProductArgs = {
  input: FlashsaleServiceAddProductGqlInput;
};


export type MutationFlashsaleServiceCreateCampaignArgs = {
  input: FlashsaleServiceCreateCampaignGqlInput;
};


export type MutationFlashsaleServiceDeleteCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFlashsaleServiceDeleteProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationFlashsaleServiceUpdateCampaignArgs = {
  id: Scalars['ID']['input'];
  input: FlashsaleServiceUpdateCampaignGqlInput;
};


export type MutationFlashsaleServiceUpdateProductArgs = {
  id: Scalars['ID']['input'];
  input: FlashsaleServiceUpdateProductGqlInput;
};


export type MutationFnsServiceCreateFormForAdminArgs = {
  input: FnsServiceCreateFormGqlInput;
};


export type MutationFnsServiceCreateSurveyForAdminArgs = {
  input: FnsServiceCreateSurveyGqlInput;
};


export type MutationFnsServiceCreateUserResponseToFormArgs = {
  input: FnsServiceCreateUserResponseFormGqlInput;
};


export type MutationFnsServiceCreateUserResponseToFormForAnonymousArgs = {
  input: FnsServiceCreateUserResponseFormGqlInput;
};


export type MutationFnsServiceCreateUserResponseToSurveyArgs = {
  input: FnsServiceCreateUserResponseSurveyGqlInput;
};


export type MutationFnsServiceCreateUserResponseToSurveyForAnonymousArgs = {
  input: FnsServiceCreateUserResponseSurveyGqlInput;
};


export type MutationFnsServiceUpdateFormForAdminArgs = {
  id: Scalars['String']['input'];
  input: FnsServiceUpdateFormGqlInput;
};


export type MutationFnsServiceUpdateSurveyForAdminArgs = {
  id: Scalars['String']['input'];
  input: FnsServiceUpdateSurveyGqlInput;
};


export type MutationInventoryServiceConfirmProductArgs = {
  input: InventoryServiceStockGqlInput;
};


export type MutationInventoryServiceCreateStockArgs = {
  input: InventoryServiceCreateStockGqlInput;
};


export type MutationInventoryServiceDeleteStockArgs = {
  stockId: Scalars['String']['input'];
};


export type MutationInventoryServiceReleaseProductArgs = {
  input: InventoryServiceStockGqlInput;
};


export type MutationInventoryServiceReserveProductArgs = {
  input: InventoryServiceStockGqlInput;
};


export type MutationInventoryServiceUpdateStockArgs = {
  input: InventoryServiceStockGqlInput;
  stockId: Scalars['String']['input'];
};


export type MutationLarvaCourseServiceAddItemsToUserCollectionArgs = {
  id: Scalars['String']['input'];
  input: LarvaCourseServiceChangeItemsOfCollectionGqlInput;
};


export type MutationLarvaCourseServiceAnalyzeSpeakingSentenceArgs = {
  input: LarvaCourseServiceAnalyzeSpeakingGqlInput;
};


export type MutationLarvaCourseServiceAnalyzeSpeakingWordArgs = {
  input: LarvaCourseServiceAnalyzeSpeakingGqlInput;
};


export type MutationLarvaCourseServiceChangeNameUserCollectionArgs = {
  id: Scalars['String']['input'];
  input: LarvaCourseServiceChangeNameCollectionGqlInput;
};


export type MutationLarvaCourseServiceCreateLessonSpeakingArgs = {
  input: LarvaCourseServiceCreateLessonGqlInput;
};


export type MutationLarvaCourseServiceCreateSentenceArgs = {
  input: LarvaCourseServiceCreateSentenceGqlInput;
};


export type MutationLarvaCourseServiceCreateTopicArgs = {
  input: LarvaCourseServiceCreateTopicGqlInput;
};


export type MutationLarvaCourseServiceCreateUserCollectionArgs = {
  input: LarvaCourseServiceCreateUserCollectionGqlInput;
};


export type MutationLarvaCourseServiceDeleteUserCollectionArgs = {
  id: Scalars['String']['input'];
};


export type MutationLarvaCourseServicePublishSentencesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationLarvaCourseServiceRemoveItemsFromUserCollectionArgs = {
  id: Scalars['String']['input'];
  input: LarvaCourseServiceChangeItemsOfCollectionGqlInput;
};


export type MutationLarvaCourseServiceUpdateLessonSpeakingArgs = {
  id: Scalars['String']['input'];
  input: LarvaCourseServiceUpdateLessonGqlInput;
};


export type MutationLarvaCourseServiceUpdateSentenceArgs = {
  id: Scalars['String']['input'];
  input: LarvaCourseServiceUpdateSentenceGqlInput;
};


export type MutationLarvaCourseServiceUpdateTopicArgs = {
  id: Scalars['String']['input'];
  input: LarvaCourseServiceUpdateTopicGqlInput;
};


export type MutationLoyaltyServiceCreateLoyaltyProgramArgs = {
  input: LoyaltyServiceCreateLoyaltyProgramGqlInput;
};


export type MutationLoyaltyServiceCreateLoyaltyTierArgs = {
  input: LoyaltyServiceCreateLoyaltyTierGqlInput;
};


export type MutationLoyaltyServiceDeactiveLoyaltyProgramArgs = {
  id: Scalars['String']['input'];
};


export type MutationLoyaltyServiceDeleteLoyaltyProgramArgs = {
  id: Scalars['String']['input'];
};


export type MutationLoyaltyServiceDeleteLoyaltyTiersArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationLoyaltyServiceDisableLoyaltyTierArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationLoyaltyServiceEnableLoyaltyTierArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationLoyaltyServiceSetDefaultLoyaltyProgramArgs = {
  id: Scalars['String']['input'];
};


export type MutationLoyaltyServiceUpdateLoyaltyTierArgs = {
  input: LoyaltyServiceUpdateLoyaltyTierGqlInput;
};


export type MutationMembershipServiceCreateMemberArgs = {
  userId: Scalars['String']['input'];
};


export type MutationMembershipServiceUpdateMemberArgs = {
  input: MembershipServiceUpdateMemberGqlInput;
};


export type MutationMessageManagementServiceCreateOaAccountArgs = {
  input: MessageManagementServiceCreateOaAccountGqlInput;
};


export type MutationMessageManagementServiceCreateOaQuotaArgs = {
  input: MessageManagementServiceCreateOaQuotaGqlInput;
};


export type MutationMessageManagementServiceCreateOttSmsArgs = {
  input: MessageManagementServiceCreateOttSmsGqlInput;
};


export type MutationMessageManagementServiceCreateSmsConfigArgs = {
  input: MessageManagementServiceCreateSmsConfigGqlInput;
};


export type MutationMessageManagementServiceCreateViberConfigArgs = {
  input: MessageManagementServiceCreateViberConfigGqlInput;
};


export type MutationMessageManagementServiceCreateZnsTemplateArgs = {
  input: MessageManagementServiceCreateZnsTemplateGqlInput;
};


export type MutationMessageManagementServiceDeleteOaQuotaArgs = {
  oaID: Scalars['String']['input'];
};


export type MutationMessageManagementServiceDeleteSmsConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMessageManagementServiceDeleteViberConfigArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMessageManagementServiceRetryMessageArgs = {
  id: Scalars['ID']['input'];
  messageType: Scalars['String']['input'];
};


export type MutationMessageManagementServiceSendOttSmsArgs = {
  input: MessageManagementServiceSendOttSmsGqlInput;
};


export type MutationMessageManagementServiceSendSmsMessageArgs = {
  input: MessageManagementServiceSendSmsMessageGqlInput;
};


export type MutationMessageManagementServiceSendViberMessageArgs = {
  input: MessageManagementServiceSendViberMessageGqlInput;
};


export type MutationMessageManagementServiceSendZnsMessageArgs = {
  input: MessageManagementServiceSendZnsMessageGqlInput;
};


export type MutationMessageManagementServiceSyncOaQuotaArgs = {
  oaID: Scalars['String']['input'];
};


export type MutationMessageManagementServiceUpdateMessageStatusArgs = {
  id: Scalars['ID']['input'];
  messageType: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationMessageManagementServiceUpdateOaQuotaArgs = {
  input: MessageManagementServiceUpdateOaQuotaGqlInput;
  oaID: Scalars['String']['input'];
};


export type MutationMessageManagementServiceUpdateSmsConfigArgs = {
  id: Scalars['ID']['input'];
  input: MessageManagementServiceUpdateSmsConfigGqlInput;
};


export type MutationMessageManagementServiceUpdateViberConfigArgs = {
  id: Scalars['ID']['input'];
  input: MessageManagementServiceUpdateViberConfigGqlInput;
};


export type MutationMessageManagementServiceVerifyOtpArgs = {
  otpCode: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationMinigamesServiceAddAnswerArgs = {
  input: MinigamesServiceAddAnswerInput;
};


export type MutationMinigamesServiceAddPrizeArgs = {
  input: MinigamesServiceAddPrizeInput;
};


export type MutationMinigamesServiceConfirmPrizeDeliveryArgs = {
  gameRecordId: Scalars['String']['input'];
};


export type MutationMinigamesServiceCreateCampaignArgs = {
  input: MinigamesServiceCreateCampaignInput;
};


export type MutationMinigamesServiceCreateGameTemplateArgs = {
  input: MinigamesServiceCreateGameTemplateInput;
};


export type MutationMinigamesServiceCreateQuestionArgs = {
  input: MinigamesServiceCreateQuestionInput;
};


export type MutationMinigamesServiceDeleteAnswerArgs = {
  id: Scalars['String']['input'];
};


export type MutationMinigamesServiceDeleteCampaignArgs = {
  id: Scalars['String']['input'];
};


export type MutationMinigamesServiceDeleteGameTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationMinigamesServiceDeletePrizeArgs = {
  id: Scalars['String']['input'];
};


export type MutationMinigamesServiceDeleteQuestionArgs = {
  id: Scalars['String']['input'];
};


export type MutationMinigamesServiceGenerateCodesArgs = {
  input: MinigamesServiceGenerateCodesInput;
};


export type MutationMinigamesServicePlayGameArgs = {
  input: MinigamesServicePlayGameInput;
};


export type MutationMinigamesServicePlayGameAsGuestArgs = {
  input: MinigamesServicePlayGameInput;
};


export type MutationMinigamesServiceSetPrizeProbabilitiesArgs = {
  input: MinigamesServiceSetPrizeProbabilitiesInput;
};


export type MutationMinigamesServiceSubmitQuizAnswersArgs = {
  input: MinigamesServiceSubmitQuizAnswersInput;
};


export type MutationMinigamesServiceUpdateAnswerArgs = {
  id: Scalars['String']['input'];
  input: MinigamesServiceUpdateAnswerInput;
};


export type MutationMinigamesServiceUpdateCampaignArgs = {
  id: Scalars['String']['input'];
  input: MinigamesServiceUpdateCampaignInput;
};


export type MutationMinigamesServiceUpdateCampaignStatusArgs = {
  id: Scalars['String']['input'];
  input: MinigamesServiceUpdateCampaignStatusInput;
};


export type MutationMinigamesServiceUpdateGameTemplateArgs = {
  id: Scalars['String']['input'];
  input: MinigamesServiceUpdateGameTemplateInput;
};


export type MutationMinigamesServiceUpdatePrizeArgs = {
  id: Scalars['String']['input'];
  input: MinigamesServiceUpdatePrizeInput;
};


export type MutationMinigamesServiceUpdateQuestionArgs = {
  id: Scalars['String']['input'];
  input: MinigamesServiceUpdateQuestionInput;
};


export type MutationNotificationServiceCreateTemplateForAdminArgs = {
  input: NotificationServiceCreateTemplateGqlInput;
};


export type MutationNotificationServiceMarkInAppNotificationAsReadArgs = {
  id: Scalars['String']['input'];
};


export type MutationNotificationServiceUpdateTemplateForAdminArgs = {
  id: Scalars['String']['input'];
  input: NotificationServiceUpdateTemplateGqlInput;
};


export type MutationOrderServiceApplyVoucherArgs = {
  input: OrderServiceCreateGqlInput;
};


export type MutationOrderServiceCancelOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationOrderServiceConfirmOrderArgs = {
  input: OrderServiceDetailGqlInput;
};


export type MutationOrderServiceCreateBookingOrderArgs = {
  input: OrderServiceCreateBookingGqlInput;
};


export type MutationOrderServiceCreateOrderArgs = {
  input: OrderServiceCreateGqlInput;
};


export type MutationOrderServiceCreateOrderWithProductArgs = {
  input: OrderServiceCreateWithProductGqlInput;
};


export type MutationOrderServiceDeleteOrderArgs = {
  input: OrderServiceDeleteGqlInput;
};


export type MutationOrderServiceUpdateOrderStatusArgs = {
  input: OrderServiceUpdateStatusGqlInput;
};


export type MutationOrderServiceUpdateShippingArgs = {
  input: OrderServiceUpdateShippingGqlInput;
};


export type MutationOrganizationServiceAdminCreateOrganizationArgs = {
  input: OrganizationServiceCreateOrganizationGqlInput;
};


export type MutationOrganizationServiceAdminUpdateOrganizationArgs = {
  id: Scalars['String']['input'];
  input: OrganizationServiceUpdateOrganizationGqlInput;
};


export type MutationOrganizationServiceCreateBranchArgs = {
  input: OrganizationServiceCreateBranchGqlInput;
};


export type MutationOrganizationServiceDeleteBranchArgs = {
  id: Scalars['String']['input'];
};


export type MutationOrganizationServiceUpdateBranchArgs = {
  id: Scalars['String']['input'];
  input: OrganizationServiceUpdateBranchGqlInput;
};


export type MutationPaymentServiceCreatePaymentVendorArgs = {
  input: PaymentServiceCreatePaymentVendorGqlInput;
};


export type MutationPaymentServiceUpdatePaymentVendorArgs = {
  input: PaymentServiceUpdatePaymentVendorGqlInput;
};


export type MutationPaymentServiceZmaConfirmTransactionArgs = {
  input: PaymentServiceZmaConfirmTransactionGqlInput;
};


export type MutationPaymentServiceZmaCreateTransactionArgs = {
  input: PaymentServiceZmaCreateTransactionGqlInput;
};


export type MutationPaymentServiceZmaUpdateTransactionStatusArgs = {
  input: PaymentServiceZmaUpdateTransactionStatusGqlInput;
};


export type MutationPointServiceActivatePointExpiryRuleArgs = {
  id: Scalars['String']['input'];
};


export type MutationPointServiceAddPointsForProfileArgs = {
  input: PointServiceAddPointsForProfileGqlInput;
};


export type MutationPointServiceCreatePointBalanceProfileArgs = {
  input: PointServiceCreatePointBalanceProfileGqlInput;
};


export type MutationPointServiceCreatePointConfigArgs = {
  input: CreatePointConfigInput;
};


export type MutationPointServiceCreatePointExpiryRuleArgs = {
  input: PointServiceCreatePointExpiryRuleProfileGqlInput;
};


export type MutationPointServiceDeactivatePointExpiryRuleArgs = {
  id: Scalars['String']['input'];
};


export type MutationPointServiceRedeemPointsForVoucherArgs = {
  input: PointServiceRedeemPointsForVoucherGqlInput;
};


export type MutationPointServiceUpdatePointBalanceArgs = {
  input: PointServiceUpdatePointBalanceGqlInput;
};


export type MutationPointServiceUpdatePointConfigArgs = {
  input: UpdatePointConfigInput;
};


export type MutationPointServiceUpdatePointExpiryRuleArgs = {
  input: PointServiceUpdatePointExpiryRuleProfileGqlInput;
};


export type MutationProductServiceCreateBrandArgs = {
  input: BrandServiceBrandGqlInput;
};


export type MutationProductServiceCreateCategoryArgs = {
  input: ProductServiceCreateCategoryGqlInput;
};


export type MutationProductServiceCreateColorArgs = {
  input: ProductServiceCreateColorGqlInput;
};


export type MutationProductServiceCreateProductArgs = {
  input: ProductServiceProductGqlInput;
};


export type MutationProductServiceDeleteBrandsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationProductServiceDeleteCategoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationProductServiceDeleteColorArgs = {
  id: Scalars['String']['input'];
};


export type MutationProductServiceDeleteProductsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationProductServiceDisableBrandsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationProductServiceDisableCategoriesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationProductServiceDisableColorsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationProductServiceDisableProductsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationProductServiceEnableBrandsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationProductServiceEnableCategoriesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationProductServiceEnableColorsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationProductServiceEnableProductsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationProductServiceRateProductArgs = {
  id: Scalars['String']['input'];
  rating: Scalars['Float']['input'];
};


export type MutationProductServiceUpdateBrandArgs = {
  id: Scalars['String']['input'];
  input: BrandServiceBrandGqlInput;
};


export type MutationProductServiceUpdateCategoryArgs = {
  id: Scalars['String']['input'];
  input: ProductServiceCreateCategoryGqlInput;
};


export type MutationProductServiceUpdateColorArgs = {
  id: Scalars['String']['input'];
  input: ProductServiceCreateColorGqlInput;
};


export type MutationProductServiceUpdateProductArgs = {
  id: Scalars['String']['input'];
  input: ProductServiceProductGqlInput;
};


export type MutationRatingServiceCreateRatingArgs = {
  input: RatingServiceCreateRatingGqlInput;
};


export type MutationRatingServiceDeleteRatingArgs = {
  id: Scalars['String']['input'];
};


export type MutationRatingServiceDeleteRatingForAdminArgs = {
  id: Scalars['String']['input'];
};


export type MutationRatingServiceToggleFavoriteArgs = {
  input: RatingServiceToggleFavoriteGqlInput;
};


export type MutationRatingServiceUpdateRatingArgs = {
  id: Scalars['String']['input'];
  input: RatingServiceUpdateRatingGqlInput;
};


export type MutationRbacServiceAssignRoleToUserArgs = {
  input: RbacServiceAssignRoleGqlInput;
};


export type MutationRbacServiceCreateRoleArgs = {
  input: RbacServiceCreateRoleGqlInput;
};


export type MutationRbacServiceDeleteRoleArgs = {
  roleId: Scalars['String']['input'];
};


export type MutationRbacServiceUnassignRoleFromUserArgs = {
  input: RbacServiceAssignRoleGqlInput;
};


export type MutationRbacServiceUpdateRoleArgs = {
  input: RbacServiceUpdateRoleGqlInput;
  roleId: Scalars['String']['input'];
};


export type MutationRbacServiceValidatePermissionArgs = {
  permission: RbacServicePermissionGqlInput;
};


export type MutationReferralServiceConfigureReferralSystemForAgencyArgs = {
  input: ReferralConfigInput;
};


export type MutationReferralServiceConfigureReferralSystemForOrganizationArgs = {
  input: ReferralConfigInput;
};


export type MutationReferralServiceProcessReferralArgs = {
  input: ReferralProcessingInput;
};


export type MutationReferralServiceSaveReferralArgs = {
  input: SaveReferralInput;
};


export type MutationReferralServiceUseReferralCodeArgs = {
  input: UseReferralCodeInput;
};


export type MutationSduiServiceCreateBlockArgs = {
  input: SduiServiceCreateBlockGqlInput;
};


export type MutationSduiServiceCreateLayoutArgs = {
  input: SduiServiceCreateLayoutGqlInput;
};


export type MutationSduiServiceCreatePageArgs = {
  input: SduiServiceCreatePageGqlInput;
};


export type MutationSduiServiceDeleteBlockArgs = {
  id: Scalars['String']['input'];
};


export type MutationSduiServiceDeletePageArgs = {
  id: Scalars['String']['input'];
};


export type MutationSduiServiceToggleLayoutArgs = {
  id: Scalars['String']['input'];
};


export type MutationSduiServiceUpdateBlockArgs = {
  id: Scalars['String']['input'];
  input: SduiServiceUpdateBlockGqlInput;
};


export type MutationSduiServiceUpdateLayoutArgs = {
  id: Scalars['String']['input'];
  input: SduiServiceUpdateLayoutGqlInput;
};


export type MutationSduiServiceUpdatePageArgs = {
  id: Scalars['String']['input'];
  input: SduiServiceUpdatePageGqlInput;
};


export type MutationSduiServiceUpdateTenantLayoutArgs = {
  input: SduiServiceUpdateTenantLayoutGqlInput;
};


export type MutationShippingServiceShippingMethodCreateArgs = {
  providerId: Scalars['String']['input'];
};


export type MutationShippingServiceShippingMethodUpdateFixedPriceArgs = {
  fixedPrice: Scalars['Float']['input'];
  shippingMethodId: Scalars['String']['input'];
};


export type MutationShippingServiceShippingMethodUpdateStatusArgs = {
  shippingMethodId: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
};


export type MutationSubscriptionServiceArchivePlanArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubscriptionServiceCancelSubscriptionArgs = {
  id: Scalars['ID']['input'];
  input: SubscriptionServiceCancelSubscriptionGqlInput;
};


export type MutationSubscriptionServiceCreatePackageArgs = {
  input: SubscriptionServiceCreatePackageGqlInput;
};


export type MutationSubscriptionServiceCreatePlanArgs = {
  input: SubscriptionServiceCreatePlanGqlInput;
};


export type MutationSubscriptionServiceCreateSubscriptionArgs = {
  input: SubscriptionServiceCreateSubscriptionGqlInput;
};


export type MutationSubscriptionServiceCreateUserSubscriptionArgs = {
  input: SubscriptionServiceCreateUserSubscriptionGqlInput;
};


export type MutationSubscriptionServicePauseSubscriptionArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationSubscriptionServiceProcessRefundArgs = {
  amount: Scalars['Money']['input'];
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationSubscriptionServiceResumeSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubscriptionServiceRetryPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubscriptionServiceUpdatePackageArgs = {
  input: SubscriptionServiceUpdatePackageGqlInput;
  packageId: Scalars['String']['input'];
};


export type MutationSubscriptionServiceUpdatePlanArgs = {
  id: Scalars['ID']['input'];
  input: SubscriptionServiceUpdatePlanGqlInput;
};


export type MutationSubscriptionServiceUpdateSubscriptionArgs = {
  id: Scalars['ID']['input'];
  input: SubscriptionServiceUpdateSubscriptionGqlInput;
};


export type MutationSubscriptionServiceUpgradeSubscriptionArgs = {
  id: Scalars['ID']['input'];
  input: SubscriptionServiceProrationCalculationGqlInput;
};


export type MutationTaskServiceAddClickAppToSpaceArgs = {
  clickApp: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};


export type MutationTaskServiceAddCommentToTaskArgs = {
  comment: TaskServiceCommentInput;
  taskId: Scalars['String']['input'];
};


export type MutationTaskServiceAddListToFolderArgs = {
  folderId: Scalars['String']['input'];
  listId: Scalars['String']['input'];
};


export type MutationTaskServiceAddMemberToWorkspaceArgs = {
  memberId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationTaskServiceAddTaskToListArgs = {
  listId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationTaskServiceAddTimeLogArgs = {
  taskId: Scalars['String']['input'];
  timeLog: TaskServiceTimeLogInput;
};


export type MutationTaskServiceAssignTaskArgs = {
  assigneeId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationTaskServiceCreateDependencyArgs = {
  input: TaskServiceCreateDependencyGqlInput;
};


export type MutationTaskServiceCreateFolderArgs = {
  input: TaskServiceCreateFolderGqlInput;
};


export type MutationTaskServiceCreateListArgs = {
  input: TaskServiceCreateListGqlInput;
};


export type MutationTaskServiceCreateSpaceArgs = {
  input: TaskServiceCreateSpaceGqlInput;
};


export type MutationTaskServiceCreateSubtaskArgs = {
  input: TaskServiceCreateTaskGqlInput;
  parentId: Scalars['String']['input'];
};


export type MutationTaskServiceCreateTaskArgs = {
  input: TaskServiceCreateTaskGqlInput;
};


export type MutationTaskServiceCreateWorkspaceArgs = {
  input: TaskServiceCreateWorkspaceGqlInput;
};


export type MutationTaskServiceDeleteDependenciesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationTaskServiceDeleteDependenciesByTaskArgs = {
  taskId: Scalars['String']['input'];
};


export type MutationTaskServiceDeleteFoldersArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationTaskServiceDeleteListsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationTaskServiceDeleteSpacesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationTaskServiceDeleteTasksArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationTaskServiceDeleteWorkspacesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationTaskServiceMoveListToFolderArgs = {
  folderId?: InputMaybe<Scalars['String']['input']>;
  listId: Scalars['String']['input'];
};


export type MutationTaskServiceMoveTaskToListArgs = {
  listId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationTaskServiceRemoveClickAppFromSpaceArgs = {
  clickApp: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};


export type MutationTaskServiceRemoveListFromFolderArgs = {
  folderId: Scalars['String']['input'];
  listId: Scalars['String']['input'];
};


export type MutationTaskServiceRemoveMemberFromWorkspaceArgs = {
  memberId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationTaskServiceRemoveTaskFromListArgs = {
  listId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationTaskServiceUnassignTaskArgs = {
  assigneeId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationTaskServiceUpdateDependencyArgs = {
  id: Scalars['String']['input'];
  input: TaskServiceUpdateDependencyGqlInput;
};


export type MutationTaskServiceUpdateFolderArgs = {
  id: Scalars['String']['input'];
  input: TaskServiceUpdateFolderGqlInput;
};


export type MutationTaskServiceUpdateListArgs = {
  id: Scalars['String']['input'];
  input: TaskServiceUpdateListGqlInput;
};


export type MutationTaskServiceUpdateSpaceArgs = {
  id: Scalars['String']['input'];
  input: TaskServiceUpdateSpaceGqlInput;
};


export type MutationTaskServiceUpdateSpaceStatusesArgs = {
  spaceId: Scalars['String']['input'];
  statuses: TaskServiceSpaceStatusesInput;
};


export type MutationTaskServiceUpdateTaskArgs = {
  id: Scalars['String']['input'];
  input: TaskServiceUpdateTaskGqlInput;
};


export type MutationTaskServiceUpdateTaskStatusArgs = {
  status: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationTaskServiceUpdateWorkspaceArgs = {
  id: Scalars['String']['input'];
  input: TaskServiceUpdateWorkspaceGqlInput;
};


export type MutationTemplateServiceApproveTemplateArgs = {
  input?: InputMaybe<TemplateServiceApproveTemplateInput>;
};


export type MutationTemplateServiceCreateTemplateArgs = {
  input?: InputMaybe<TemplateServiceCreateTemplateInput>;
};


export type MutationTemplateServiceDeleteTemplateArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTemplateServiceRejectTemplateArgs = {
  input?: InputMaybe<TemplateServiceRejectTemplateInput>;
};


export type MutationTemplateServiceRollbackTemplateArgs = {
  input?: InputMaybe<TemplateServiceRollbackTemplateInput>;
};


export type MutationTemplateServiceSubmitTemplateArgs = {
  input?: InputMaybe<TemplateServiceSubmitTemplateInput>;
};


export type MutationTemplateServiceUpdateTemplateArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<TemplateServiceUpdateTemplateInput>;
};


export type MutationTicketServiceAddCommentToTicketArgs = {
  authorId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  imgUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  performedBy?: InputMaybe<Scalars['String']['input']>;
  ticketId: Scalars['String']['input'];
};


export type MutationTicketServiceChangeCustomerStatusArgs = {
  id: Scalars['String']['input'];
  newStatus: CustomerVariantStatus;
};


export type MutationTicketServiceCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationTicketServiceCreateTicketArgs = {
  input: CreateTicketInput;
};


export type MutationTicketServiceDeleteCustomerArgs = {
  id: Scalars['String']['input'];
};


export type MutationTicketServiceDeleteTicketsArgs = {
  ids: Array<Scalars['String']['input']>;
  performedBy?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTicketServiceDisableTicketsArgs = {
  ids: Array<Scalars['String']['input']>;
  performedBy?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTicketServiceEnableTicketsArgs = {
  ids: Array<Scalars['String']['input']>;
  performedBy?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTicketServiceUpdateCustomerArgs = {
  id: Scalars['String']['input'];
  input: UpdateCustomerInput;
};


export type MutationTicketServiceUpdateTicketArgs = {
  id: Scalars['String']['input'];
  input: UpdateTicketInput;
  performedBy?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['String']['input'];
  input: CompanyInput;
};


export type MutationUploadServiceCompleteUploadArgs = {
  input: UploadServiceCompleteGqlInput;
};


export type MutationUploadServiceRequestUploadArgs = {
  input: UploadServiceRequestGqlInput;
};


export type MutationUserServiceAdminCreateTenantArgs = {
  input: UserServiceCreateTenantGqlInput;
};


export type MutationUserServiceAdminUpdateTenantArgs = {
  input: UserServiceUpdateTenantGqlInput;
};


export type MutationUserServiceCreateAgencyArgs = {
  input: UserServiceCreateBasicUserGqlInput;
};


export type MutationUserServiceCreateOrganizationAdminArgs = {
  input: UserServiceCreateUserGqlInput;
};


export type MutationUserServiceCreateTenantArgs = {
  input: UserServiceCreateTenantGqlInput;
};


export type MutationUserServiceCreateTenantAdminArgs = {
  input: UserServiceCreateUserGqlInput;
};


export type MutationUserServiceTenantStatusArgs = {
  input: UserServiceTenantStatusGqlInput;
};


export type MutationUserServiceUpdateAvatarArgs = {
  input: UserServiceUpdateAvatarGqlInput;
};


export type MutationUserServiceUpdateProfileArgs = {
  input: UserServiceUpdateProfileGqlInput;
};


export type MutationUserServiceUpdateTenantArgs = {
  input: UserServiceUpdateTenantGqlInput;
};


export type MutationUserServiceUpdateTenantTypeArgs = {
  input: UserServiceTenantTypeGqlInput;
};


export type MutationUserServiceUpdateZaloOaIdArgs = {
  input: UserServiceUpdateZaloOaIdGqlInput;
};


export type MutationVoucherServiceBulkIssueToAllUsersArgs = {
  input: VoucherServiceBulkIssueAllGqlInput;
};


export type MutationVoucherServiceBulkIssueToUsersArgs = {
  input: VoucherServiceBulkIssueGqlInput;
};


export type MutationVoucherServiceCreateVoucherArgs = {
  input: VoucherServiceCreateVoucherGqlInput;
};


export type MutationVoucherServiceCreateVoucherTypeArgs = {
  input: VoucherServiceCreateVoucherTypeGqlInput;
};


export type MutationVoucherServiceDeleteVoucherTypeByIdArgs = {
  id: Scalars['String']['input'];
};


export type MutationVoucherServiceDeleteVouchersArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationVoucherServiceDisableVoucherTypeByIdArgs = {
  id: Scalars['String']['input'];
};


export type MutationVoucherServiceEnableVoucherTypeByIdArgs = {
  id: Scalars['String']['input'];
};


export type MutationVoucherServiceEnableVouchersArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationVoucherServiceUpdateVoucherArgs = {
  id: Scalars['String']['input'];
  input: VoucherServiceUpdateVoucherGqlInput;
};


export type MutationVoucherServiceUpdateVoucherTypeArgs = {
  id: Scalars['String']['input'];
  input: VoucherServiceUpdateVoucherTypeGqlInput;
};

export enum NotificationServiceChannel {
  Email = 'Email',
  InApp = 'InApp',
  Push = 'Push',
  Sms = 'SMS'
}

export type NotificationServiceCreateTemplateGqlInput = {
  channel: NotificationServiceChannel;
  code: Scalars['String']['input'];
  content: Scalars['String']['input'];
  language: LanguageEnum;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationServiceInAppNotificationGqlOutput = {
  __typename?: 'NotificationServiceInAppNotificationGqlOutput';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type NotificationServiceTemplateGqlOutput = {
  __typename?: 'NotificationServiceTemplateGqlOutput';
  channel?: Maybe<NotificationServiceChannel>;
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  language?: Maybe<LanguageEnum>;
  subject?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NotificationServiceUpdateTemplateGqlInput = {
  channel?: InputMaybe<NotificationServiceChannel>;
  code?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<LanguageEnum>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type OaAccount = {
  __typename?: 'OAAccount';
  avatar?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isVerified: Scalars['Boolean']['output'];
  linkedZaloID?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  oaID: Scalars['String']['output'];
  packageAutoRenewDate?: Maybe<Scalars['Time']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  packageValidThroughDate?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  tenantID: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type OaAccountList = {
  __typename?: 'OAAccountList';
  accounts: Array<OaAccount>;
  total: Scalars['Int']['output'];
};

export type OaQuota = {
  __typename?: 'OAQuota';
  createdAt?: Maybe<Scalars['Time']['output']>;
  dailyQuota: Scalars['Int']['output'];
  dailyQuotaPromotion?: Maybe<Scalars['Int']['output']>;
  estimatedNextMonthPromotionQuota: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastSyncAt?: Maybe<Scalars['Time']['output']>;
  monthlyPromotionQuota: Scalars['Int']['output'];
  oaID: Scalars['String']['output'];
  quotaType: Scalars['String']['output'];
  remainingMonthlyPromotionQuota: Scalars['Int']['output'];
  remainingQuota: Scalars['Int']['output'];
  remainingQuotaPromotion?: Maybe<Scalars['Int']['output']>;
  tenantID?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  validFrom?: Maybe<Scalars['Time']['output']>;
  validThrough?: Maybe<Scalars['Time']['output']>;
};

export type OrderServiceCreateBookingGqlInput = {
  bookingId: Scalars['String']['input'];
  branchId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<OrderServiceShippingAddressGqlInput>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
  shippingNote?: InputMaybe<Scalars['String']['input']>;
  vouchers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrderServiceCreateGqlInput = {
  affiliateCode?: InputMaybe<Scalars['String']['input']>;
  bookingId?: InputMaybe<Scalars['String']['input']>;
  branchId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  cartIds: Array<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  point?: InputMaybe<Scalars['Float']['input']>;
  shippingAddress?: InputMaybe<OrderServiceShippingAddressGqlInput>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
  shippingNote?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  vouchers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrderServiceCreateWithProductGqlInput = {
  affiliateCode?: InputMaybe<Scalars['String']['input']>;
  branchId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  point?: InputMaybe<Scalars['Float']['input']>;
  products: Array<OrderServiceProductGqlInput>;
  shippingAddress?: InputMaybe<OrderServiceShippingAddressGqlInput>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
  shippingNote?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  vouchers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrderServiceDeleteGqlInput = {
  orderId: Scalars['ID']['input'];
};

export type OrderServiceDetailGqlInput = {
  id: Scalars['ID']['input'];
};

export type OrderServiceGetGqlInput = {
  booking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum number of items to return (1-100) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Number of items to skip (offset) */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Multiple sort fields for complex sorting */
  sort?: InputMaybe<Array<SortFieldArgs>>;
  sortBy?: InputMaybe<OrderServiceSortFieldArgs>;
  sortDirection?: InputMaybe<SortDirectionArgs>;
  status?: InputMaybe<OrderServiceStatus>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OrderServiceGetOrderHistoryGqlInput = {
  orderId: Scalars['String']['input'];
};

export type OrderServiceOrderGqlOutput = {
  __typename?: 'OrderServiceOrderGqlOutput';
  bookingId?: Maybe<Scalars['String']['output']>;
  branchId?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountAmountFormatted?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  payment?: Maybe<Array<OrderServicePaymentInfoGqlOutput>>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<OrderServicePaymentStatus>;
  point?: Maybe<Scalars['Float']['output']>;
  pointAmount?: Maybe<Scalars['Float']['output']>;
  pointAmountFormatted?: Maybe<Scalars['String']['output']>;
  productTotalAmount: Scalars['Float']['output'];
  productTotalAmountFormatted: Scalars['String']['output'];
  products: Array<OrderServiceProductGqlOutput>;
  promotionId?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<OrderServiceShippingAddressGqlOutput>;
  shippingFee?: Maybe<Scalars['Float']['output']>;
  shippingFeeFormatted?: Maybe<Scalars['String']['output']>;
  shippingMethod?: Maybe<Scalars['String']['output']>;
  shippingNote?: Maybe<Scalars['String']['output']>;
  shippingStatus?: Maybe<OrderServiceShippingStatus>;
  status: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  totalAmountFormatted: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  vouchers?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderServiceOrderHistoryGqlOutput = {
  __typename?: 'OrderServiceOrderHistoryGqlOutput';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  paymentStatus?: Maybe<OrderServicePaymentStatus>;
  shippingStatus?: Maybe<OrderServiceShippingStatus>;
  status: OrderServiceStatus;
  tenantId: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
};

export type OrderServicePaymentInfoGqlOutput = {
  __typename?: 'OrderServicePaymentInfoGqlOutput';
  amountPaid: Scalars['Float']['output'];
  amountPaidFormatted: Scalars['String']['output'];
  paidAt: Scalars['String']['output'];
  refundId?: Maybe<Scalars['String']['output']>;
  transactionId: Scalars['String']['output'];
};

export enum OrderServicePaymentStatus {
  Failed = 'Failed',
  Paid = 'Paid',
  PaidPartially = 'PaidPartially',
  Pending = 'Pending',
  Refunded = 'Refunded'
}

export type OrderServiceProductGqlInput = {
  name: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  quantity: Scalars['Float']['input'];
  variant?: InputMaybe<OrderServiceProductVariantGqlInput>;
};

export type OrderServiceProductGqlOutput = {
  __typename?: 'OrderServiceProductGqlOutput';
  currency: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceFormatted: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  variant?: Maybe<OrderServiceProductVariantGqlOutput>;
};

export type OrderServiceProductVariantGqlInput = {
  attributeKey?: InputMaybe<Scalars['String']['input']>;
  attributeValue?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export type OrderServiceProductVariantGqlOutput = {
  __typename?: 'OrderServiceProductVariantGqlOutput';
  attributeKey?: Maybe<Scalars['String']['output']>;
  attributeValue?: Maybe<Scalars['String']['output']>;
  basePrice: Scalars['Float']['output'];
  basePriceFormatted: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceFormatted: Scalars['String']['output'];
  sku: Scalars['String']['output'];
};

export type OrderServiceShippingAddressGqlInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  province: Scalars['String']['input'];
  ward: Scalars['String']['input'];
};

export type OrderServiceShippingAddressGqlOutput = {
  __typename?: 'OrderServiceShippingAddressGqlOutput';
  address: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  province: Scalars['String']['output'];
  ward: Scalars['String']['output'];
};

export enum OrderServiceShippingStatus {
  Delivered = 'Delivered',
  Pending = 'Pending',
  Processing = 'Processing',
  Shipped = 'Shipped'
}

export enum OrderServiceSortFieldArgs {
  CreatedAt = 'CreatedAt',
  Status = 'Status',
  TotalAmount = 'TotalAmount',
  UpdatedAt = 'UpdatedAt'
}

export enum OrderServiceStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Confirmed = 'Confirmed',
  Draft = 'Draft',
  New = 'New',
  PaymentPartiallyReceived = 'PaymentPartiallyReceived',
  PaymentReceived = 'PaymentReceived',
  Pending = 'Pending',
  PendingPayment = 'PendingPayment',
  Shipping = 'Shipping'
}

export type OrderServiceUpdateShippingGqlInput = {
  id: Scalars['String']['input'];
  shippingAddress?: InputMaybe<OrderServiceShippingAddressGqlInput>;
  shippingFee?: InputMaybe<Scalars['Float']['input']>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
  shippingNote?: InputMaybe<Scalars['String']['input']>;
  shippingStatus?: InputMaybe<OrderServiceShippingStatus>;
  shippingTrackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OrderServiceUpdateStatusGqlInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  status?: InputMaybe<OrderServiceStatus>;
};

export type OrganizationServiceBranchGqlOutput = {
  __typename?: 'OrganizationServiceBranchGqlOutput';
  address: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  status: OrganizationServiceBranchStatus;
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum OrganizationServiceBranchSortFieldArgs {
  CreatedAt = 'CreatedAt',
  Name = 'Name',
  Status = 'Status',
  UpdatedAt = 'UpdatedAt'
}

export enum OrganizationServiceBranchStatus {
  Active = 'Active',
  Disabled = 'Disabled'
}

export type OrganizationServiceCreateBranchGqlInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
  status: OrganizationServiceBranchStatus;
};

export type OrganizationServiceCreateOrganizationGqlInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  isEnterprise?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type OrganizationServiceGetBranchesGqlInput = {
  /** Maximum number of items to return (1-100) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Number of items to skip (offset) */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Multiple sort fields for complex sorting */
  sort?: InputMaybe<Array<SortFieldArgs>>;
  sortBy?: InputMaybe<OrganizationServiceBranchSortFieldArgs>;
  sortDirection?: InputMaybe<SortDirectionArgs>;
  status?: InputMaybe<OrganizationServiceBranchStatus>;
};

export type OrganizationServiceGetOrganizationsGqlInput = {
  /** Maximum number of items to return (1-100) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Number of items to skip (offset) */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Multiple sort fields for complex sorting */
  sort?: InputMaybe<Array<SortFieldArgs>>;
};

export type OrganizationServiceOrganizationGqlOutput = {
  __typename?: 'OrganizationServiceOrganizationGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isEnterprise?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: OrganizationServiceOrganizationStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum OrganizationServiceOrganizationStatus {
  Active = 'Active',
  Archived = 'Archived',
  Disabled = 'Disabled',
  Pending = 'Pending',
  Suspended = 'Suspended'
}

export type OrganizationServiceUpdateBranchGqlInput = {
  address: Scalars['String']['input'];
  name: Scalars['String']['input'];
  status: OrganizationServiceBranchStatus;
};

export type OrganizationServiceUpdateOrganizationGqlInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  isEnterprise?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type OtpVerifyResponse = {
  __typename?: 'OtpVerifyResponse';
  error?: Maybe<Scalars['String']['output']>;
  remainingAttempts?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type OttSms = {
  __typename?: 'OttSms';
  channel: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Time']['output']>;
  expiredAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  otpCode: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tenantID?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  verifiedAt?: Maybe<Scalars['Time']['output']>;
};

export type OttSmsResponse = {
  __typename?: 'OttSmsResponse';
  error?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Int']['output']>;
  ottID?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum PackageBillingCycleType {
  OneTime = 'OneTime',
  Recurring = 'Recurring'
}

export enum PackageDurationUnitType {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

/** The type of page content */
export enum PageTypeEnum {
  About = 'About',
  Article = 'Article',
  Contact = 'Contact',
  Event = 'Event',
  Faq = 'FAQ',
  Landing = 'Landing',
  Post = 'Post',
  Privacy = 'Privacy',
  Product = 'Product',
  Terms = 'Terms'
}

export type PaginationArgs = {
  /** Maximum number of items to return (1-100) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Number of items to skip (offset) */
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentServiceCreatePaymentVendorGqlInput = {
  code: PaymentServiceVendor;
  momoConfig?: InputMaybe<PaymentServiceMomoConfigGqlInput>;
  name: Scalars['String']['input'];
  vnpayConfig?: InputMaybe<PaymentServiceVnpayConfigGqlInput>;
};

export enum PaymentServiceCurrencyEnum {
  Usd = 'Usd',
  Vnd = 'Vnd'
}

export type PaymentServiceMomoConfigGqlInput = {
  accessKey: Scalars['String']['input'];
  apiUrl: Scalars['String']['input'];
  ipnUrl: Scalars['String']['input'];
  partnerCode: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  secretKey: Scalars['String']['input'];
};

export type PaymentServiceMomoConfigGqlOutput = {
  __typename?: 'PaymentServiceMomoConfigGqlOutput';
  accessKey?: Maybe<Scalars['String']['output']>;
  apiUrl?: Maybe<Scalars['String']['output']>;
  ipnUrl?: Maybe<Scalars['String']['output']>;
  partnerCode?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  secretKey?: Maybe<Scalars['String']['output']>;
};

export enum PaymentServicePaymentStatus {
  Checking = 'Checking',
  Failed = 'Failed',
  Paid = 'Paid',
  Pending = 'Pending',
  Refunded = 'Refunded'
}

export enum PaymentServicePlatformType {
  Android = 'Android',
  Ios = 'IOS',
  Web = 'Web',
  Zma = 'ZMA'
}

export type PaymentServiceSubscriptionTransactionGqlOutput = {
  __typename?: 'PaymentServiceSubscriptionTransactionGqlOutput';
  amount: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency: PaymentServiceCurrencyEnum;
  duration: Scalars['Float']['output'];
  durationUnit: PackageDurationUnitType;
  id: Scalars['String']['output'];
  packageName: Scalars['String']['output'];
  paymentMethod: PaymentServiceVendor;
  pricingName: Scalars['String']['output'];
  status: PaymentServicePaymentStatus;
  subscriptionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type PaymentServiceTransactionGqlOutput = {
  __typename?: 'PaymentServiceTransactionGqlOutput';
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<PaymentServiceCurrencyEnum>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<PaymentServicePlatformType>;
  status?: Maybe<PaymentServicePaymentStatus>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vendor?: Maybe<PaymentServiceVendor>;
  vendorMessage?: Maybe<Scalars['String']['output']>;
  vendorOriginalTransactionId?: Maybe<Scalars['String']['output']>;
  vendorStatus?: Maybe<Scalars['String']['output']>;
  vendorTransactionId?: Maybe<Scalars['String']['output']>;
};

export type PaymentServiceTransactionsGqlOutput = {
  __typename?: 'PaymentServiceTransactionsGqlOutput';
  /** Array of found items */
  data: Array<PaymentServiceTransactionGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type PaymentServiceUpdatePaymentVendorGqlInput = {
  code: PaymentServiceVendor;
  momoConfig?: InputMaybe<PaymentServiceMomoConfigGqlInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  vnpayConfig?: InputMaybe<PaymentServiceVnpayConfigGqlInput>;
};

export enum PaymentServiceVendor {
  ApplePay = 'ApplePay',
  CreditCard = 'CreditCard',
  GooglePay = 'GooglePay',
  MoMo = 'MoMo',
  Paypal = 'Paypal',
  VnPay = 'VNPay',
  Zma = 'ZMA'
}

export type PaymentServiceVendorForAdminGqlOutput = {
  __typename?: 'PaymentServiceVendorForAdminGqlOutput';
  code?: Maybe<PaymentServiceVendor>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  momoConfig?: Maybe<PaymentServiceMomoConfigGqlOutput>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vnpayConfig?: Maybe<PaymentServiceVnpayConfigGqlOutput>;
};

export type PaymentServiceVendorGqlOutput = {
  __typename?: 'PaymentServiceVendorGqlOutput';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentServiceVnpayConfigGqlInput = {
  vnpApi: Scalars['String']['input'];
  vnpHashSecret: Scalars['String']['input'];
  vnpReturnUrl: Scalars['String']['input'];
  vnpTmnCode: Scalars['String']['input'];
  vnpUrl: Scalars['String']['input'];
  vnpVersion: Scalars['String']['input'];
};

export type PaymentServiceVnpayConfigGqlOutput = {
  __typename?: 'PaymentServiceVnpayConfigGqlOutput';
  vnpApi?: Maybe<Scalars['String']['output']>;
  vnpHashSecret?: Maybe<Scalars['String']['output']>;
  vnpReturnUrl?: Maybe<Scalars['String']['output']>;
  vnpTmnCode?: Maybe<Scalars['String']['output']>;
  vnpUrl?: Maybe<Scalars['String']['output']>;
  vnpVersion?: Maybe<Scalars['String']['output']>;
};

export type PaymentServiceZmaConfirmTransactionGqlInput = {
  checkoutSdkOrderId: Scalars['String']['input'];
  transactionId: Scalars['String']['input'];
};

export type PaymentServiceZmaCreateTransactionGqlInput = {
  amount: Scalars['Float']['input'];
  method: PaymentServiceZmaMethodGqlInput;
  orderId: Scalars['String']['input'];
};

export type PaymentServiceZmaCreateTransactionGqlOutput = {
  __typename?: 'PaymentServiceZMACreateTransactionGqlOutput';
  amount?: Maybe<Scalars['Float']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  extradata?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Array<Scalars['JSON']['output']>>;
  mac?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type PaymentServiceZmaMethodGqlInput = {
  id: Scalars['String']['input'];
  isCustom: Scalars['Boolean']['input'];
};

export type PaymentServiceZmaUpdateTransactionStatusGqlInput = {
  status: PaymentServicePaymentStatus;
  transactionId: Scalars['String']['input'];
};

export type PermissionGqlOutput = {
  __typename?: 'PermissionGqlOutput';
  action: Scalars['String']['output'];
  possession: Scalars['String']['output'];
  resource: Scalars['String']['output'];
};

export type PointConfigOutput = {
  __typename?: 'PointConfigOutput';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  moneyAmount: Scalars['Float']['output'];
  pointsPerUnit: Scalars['Float']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** The type of point expiry rule */
export enum PointExpiryRuleType {
  DaysAfterEarn = 'DAYS_AFTER_EARN',
  EndOfQuarter = 'END_OF_QUARTER',
  EndOfYear = 'END_OF_YEAR',
  FixedDate = 'FIXED_DATE',
  Never = 'NEVER'
}

export type PointServiceAddPointsForProfileGqlInput = {
  loyaltyProgramId?: InputMaybe<Scalars['String']['input']>;
  pointAmount: Scalars['Int']['input'];
  source: PointTransactionSource;
  sourceReference?: InputMaybe<Scalars['String']['input']>;
  transactionDate: Scalars['DateTime']['input'];
  transactionType: PointTransactionType;
  userId: Scalars['String']['input'];
};

export type PointServiceAddPointsForProfileGqlOutput = {
  __typename?: 'PointServiceAddPointsForProfileGqlOutput';
  success: Scalars['Boolean']['output'];
};

export type PointServiceCountPointTransactionsByUserIdGqlInput = {
  sourceReference: Scalars['String']['input'];
  transactionType: PointTransactionType;
  userId: Scalars['String']['input'];
};

export type PointServiceCountPointTransactionsByUserIdGqlOutput = {
  __typename?: 'PointServiceCountPointTransactionsByUserIdGqlOutput';
  count: Scalars['Int']['output'];
};

export type PointServiceCreatePointBalanceProfileGqlInput = {
  userId: Scalars['String']['input'];
};

export type PointServiceCreatePointExpiryRuleProfileGqlInput = {
  applicableTiersId?: InputMaybe<Array<Scalars['String']['input']>>;
  daysValid?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiryType: PointExpiryRuleType;
  fixedDate?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyProgramId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pointSourceType: PointSourceType;
};

export type PointServiceGetPointBalanceByUserIdGqlInput = {
  userId: Scalars['String']['input'];
};

export type PointServiceMyPointTransactionsFilterGqlInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<PointTransactionSource>;
  sourceReference?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  transactionType?: InputMaybe<PointTransactionType>;
};

export type PointServicePointBalanceGqlOutput = {
  __typename?: 'PointServicePointBalanceGqlOutput';
  availablePoints: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expiredPoints: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  pendingPoints: Scalars['Int']['output'];
  pointExpiryBreakdown?: Maybe<Scalars['JSON']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  redeemedPoints: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  totalPoints: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type PointServicePointExpiryRuleGqlOutput = {
  __typename?: 'PointServicePointExpiryRuleGqlOutput';
  applicableTiersId: Array<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  daysValid: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  expiryType: Scalars['String']['output'];
  fixedDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  loyaltyProgramId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PointServicePointExpiryRulesGqlOutput = {
  __typename?: 'PointServicePointExpiryRulesGqlOutput';
  /** Array of found items */
  data: Array<PointServicePointExpiryRuleGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type PointServicePointTransactionGqlOutput = {
  __typename?: 'PointServicePointTransactionGqlOutput';
  amount: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  performedBy?: Maybe<Scalars['String']['output']>;
  source: PointTransactionSource;
  sourceReference?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  transactionDate: Scalars['DateTime']['output'];
  transactionType: PointTransactionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type PointServiceRedeemPointsForVoucherGqlInput = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
  voucherTypeId: Scalars['String']['input'];
};

export type PointServiceRedeemPointsForVoucherGqlOutput = {
  __typename?: 'PointServiceRedeemPointsForVoucherGqlOutput';
  message?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  vouchers?: Maybe<Array<VoucherServiceVoucherGqlOutput>>;
};

export type PointServiceUpdatePointBalanceGqlInput = {
  availablePoints?: InputMaybe<Scalars['Int']['input']>;
  expiredPoints?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  pendingPoints?: InputMaybe<Scalars['Int']['input']>;
  redeemedPoints?: InputMaybe<Scalars['Int']['input']>;
  totalPoints?: InputMaybe<Scalars['Int']['input']>;
};

export type PointServiceUpdatePointExpiryRuleProfileGqlInput = {
  applicableTiersId?: InputMaybe<Array<Scalars['String']['input']>>;
  daysValid?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiryType: PointExpiryRuleType;
  fixedDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loyaltyProgramId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pointSourceType: PointSourceType;
};

/** The type of point source */
export enum PointSourceType {
  Birthday = 'BIRTHDAY',
  Campaign = 'CAMPAIGN',
  Manual = 'MANUAL',
  Other = 'OTHER',
  Purchase = 'PURCHASE',
  Referral = 'REFERRAL',
  Registration = 'REGISTRATION'
}

/** Sources of point transactions */
export enum PointTransactionSource {
  Achievement = 'ACHIEVEMENT',
  AdminAdjustment = 'ADMIN_ADJUSTMENT',
  Birthday = 'BIRTHDAY',
  Campaign = 'CAMPAIGN',
  Correction = 'CORRECTION',
  Engagement = 'ENGAGEMENT',
  Event = 'EVENT',
  Expiration = 'EXPIRATION',
  Login = 'LOGIN',
  Order = 'ORDER',
  Other = 'OTHER',
  Promotion = 'PROMOTION',
  Purchase = 'PURCHASE',
  Redemption = 'REDEMPTION',
  Referral = 'REFERRAL',
  Refund = 'REFUND',
  Registration = 'REGISTRATION',
  Review = 'REVIEW',
  System = 'SYSTEM',
  TierUpgrade = 'TIER_UPGRADE'
}

/** Types of point transactions */
export enum PointTransactionType {
  Adjust = 'ADJUST',
  Earn = 'EARN',
  Expire = 'EXPIRE',
  Redeem = 'REDEEM',
  Revert = 'REVERT',
  Transfer = 'TRANSFER'
}

export type PointsConfig = {
  __typename?: 'PointsConfig';
  earnRules: EarnRules;
  redemptionRules: RedemptionRules;
};

export type PointsConfigInput = {
  earnRules: EarnRulesInput;
  redemptionRules: RedemptionRulesInput;
};

export enum PresentationTypeEnum {
  AudioScriptToText = 'AudioScriptToText',
  FillInBlank = 'FillInBlank',
  ImageAndAudioToText = 'ImageAndAudioToText',
  ImageAndTextToText = 'ImageAndTextToText',
  PassageReading = 'PassageReading',
  TextToImageAndText = 'TextToImageAndText',
  TextToText = 'TextToText',
  VideoAndTextToText = 'VideoAndTextToText',
  WordArrangement = 'WordArrangement'
}

export enum PrizeTypeEnum {
  Nothing = 'Nothing',
  Points = 'Points',
  Product = 'Product',
  Voucher = 'Voucher'
}

export enum ProductAttributeEnum {
  Color = 'Color',
  Gender = 'Gender',
  Height = 'Height',
  Ingredients = 'Ingredients',
  Innovation = 'Innovation',
  Length = 'Length',
  Material = 'Material',
  Origin = 'Origin',
  Shape = 'Shape',
  Size = 'Size',
  Smell = 'Smell',
  Style = 'Style',
  Taste = 'Taste',
  Warranty = 'Warranty',
  Weight = 'Weight',
  Width = 'Width'
}

export type ProductAttributeInput = {
  key: ProductAttributeEnum;
  value: Scalars['String']['input'];
};

export type ProductAttributeOutput = {
  __typename?: 'ProductAttributeOutput';
  key: ProductAttributeEnum;
  value: Scalars['String']['output'];
};

export type ProductDiscountDetail = {
  __typename?: 'ProductDiscountDetail';
  discountAmount: Scalars['Float']['output'];
  discountedPrice: Scalars['Float']['output'];
  originalPrice: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
};

export type ProductSaleInput = {
  saleEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  salePrice: Scalars['Float']['input'];
  saleStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductSaleOutput = {
  __typename?: 'ProductSaleOutput';
  saleEndDate?: Maybe<Scalars['DateTime']['output']>;
  salePrice?: Maybe<Scalars['Float']['output']>;
  saleStartDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductServiceCategoryGqlOutput = {
  __typename?: 'ProductServiceCategoryGqlOutput';
  children?: Maybe<Array<ProductServiceCategoryGqlOutput>>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<ProductServiceCategoryGqlOutput>;
  parentId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductServiceColorGqlOutput = {
  __typename?: 'ProductServiceColorGqlOutput';
  colorCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductServiceCreateCategoryGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductServiceCreateColorGqlInput = {
  colorCode: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ProductServiceProductGqlInput = {
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryIds: Array<Scalars['String']['input']>;
  commonAttributes?: InputMaybe<Array<ProductAttributeInput>>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyEnum;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Float']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  mediaUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantNames?: InputMaybe<Array<Scalars['String']['input']>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  thumbnailUrl: Scalars['String']['input'];
  title: Scalars['String']['input'];
  variants: Array<ProductVariantInput>;
};

export type ProductServiceProductGqlOutput = {
  __typename?: 'ProductServiceProductGqlOutput';
  brandIds?: Maybe<Array<Scalars['String']['output']>>;
  categoryIds: Array<Scalars['String']['output']>;
  commonAttributes: Array<ProductAttributeOutput>;
  contentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency: CurrencyEnum;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isFeatured: Scalars['Boolean']['output'];
  isLatest: Scalars['Boolean']['output'];
  mediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  merchantNames?: Maybe<Array<Scalars['String']['output']>>;
  rating: ProductServiceProductRating;
  shortDescription?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  summarizedAttributes?: Maybe<Array<ProductServiceSummarizedAttributeGqlOutput>>;
  tags: Array<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variants?: Maybe<Array<ProductVariantOutput>>;
};

export type ProductServiceProductRating = {
  __typename?: 'ProductServiceProductRating';
  average: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type ProductServiceProductsGqlOutput = {
  __typename?: 'ProductServiceProductsGqlOutput';
  /** Array of found items */
  data: Array<ProductServiceProductGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type ProductServiceSearchProductGqlInput = {
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isFlashSale?: InputMaybe<Scalars['Boolean']['input']>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  isSale?: InputMaybe<Scalars['Boolean']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  merchantNames?: InputMaybe<Array<Scalars['String']['input']>>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProductServiceSearchProductsForAdminGqlInput = {
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isFlashSale?: InputMaybe<Scalars['Boolean']['input']>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
  isSale?: InputMaybe<Scalars['Boolean']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  merchantNames?: InputMaybe<Array<Scalars['String']['input']>>;
  minPrice?: InputMaybe<Scalars['Float']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProductServiceSummarizedAttributeGqlOutput = {
  __typename?: 'ProductServiceSummarizedAttributeGqlOutput';
  displayName: Scalars['String']['output'];
  key: ProductAttributeEnum;
  values: Array<Scalars['String']['output']>;
};

export type ProductVariantInput = {
  attributes?: InputMaybe<Array<ProductAttributeInput>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSale?: InputMaybe<Scalars['Boolean']['input']>;
  mediaUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  sale?: InputMaybe<ProductSaleInput>;
  sku: Scalars['String']['input'];
};

export type ProductVariantOutput = {
  __typename?: 'ProductVariantOutput';
  attributes?: Maybe<Array<ProductAttributeOutput>>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  basePriceFormatted?: Maybe<Scalars['String']['output']>;
  flashSale?: Maybe<ProductSaleOutput>;
  isEnabled: Scalars['Boolean']['output'];
  isFlashSale: Scalars['Boolean']['output'];
  isSale: Scalars['Boolean']['output'];
  mediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  priceFormatted: Scalars['String']['output'];
  sale?: Maybe<ProductSaleOutput>;
  sku: Scalars['String']['output'];
};

export type ProviderStats = {
  __typename?: 'ProviderStats';
  count: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  successCount: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  addressServiceAllAddress: Array<AddressServiceAddressGqlOutput>;
  addressServiceCountries: Array<AddressServiceCountryGqlOutput>;
  addressServiceDefaultAddress: AddressServiceAddressGqlOutput;
  addressServiceProvinces: Array<AddressServiceProvinceGqlOutput>;
  addressServiceWardsByProvinceId: Array<AddressServiceWardGqlOutput>;
  affiliateServiceGetAnalyticsForAgency: AffiliateServiceAnalyticsOutput;
  affiliateServiceGetAnalyticsForOrganization: AffiliateServiceAnalyticsOutput;
  affiliateServiceGetCodeRequests: AffiliateServiceCodeRequestListOutput;
  affiliateServiceGetCurrentConfig?: Maybe<AffiliateServiceConfigOutput>;
  affiliateServiceGetLinksForOrganization: AffiliateServiceLinkListOutput;
  affiliateServiceGetMyAffiliateCode: AffiliateServiceAffiliateCodeOutput;
  affiliateServiceGetMyAnalytics: AffiliateServiceAnalyticsOutput;
  affiliateServiceGetMyBalance: AffiliateServiceBalanceOutput;
  affiliateServiceGetMyCodeRequest?: Maybe<AffiliateServiceCodeRequestOutput>;
  affiliateServiceGetMyLink: AffiliateServiceLinkOutput;
  affiliateServiceGetMyLinks: AffiliateServiceLinkListOutput;
  affiliateServiceGetMyTracking: AffiliateServiceTrackingListOutput;
  affiliateServiceGetTrackingForAgency: AffiliateServiceTrackingListOutput;
  affiliateServiceGetTrackingForOrganization: AffiliateServiceTrackingListOutput;
  affiliateServiceGetUrlShortenerProviders: UrlShortenerProvidersOutput;
  allCompanies: Array<Company>;
  apiHubServiceApiCredentialTemplates: ApiHubServiceApiCredentialTemplateList;
  apiHubServiceApiCredentials: ApiHubServiceApiCredentialList;
  apiHubServiceApiCredentialsByTenant?: Maybe<Array<Maybe<ApiHubServiceApiCredential>>>;
  apiHubServiceApiProviderByCode?: Maybe<ApiHubServiceApiProvider>;
  apiHubServiceApiProviders: ApiHubServiceApiProviderList;
  apiHubServiceLinks: ApiHubServiceTenantProviderLinkList;
  authServiceKratosMe?: Maybe<AuthServiceKratosMe>;
  authServiceMe: UserServiceUserGqlOutput;
  binoAdminServiceAuthoritiesReport?: Maybe<BinoAdminServiceAuthoritiesReportGqlOutput>;
  binoAdminServiceAuthoritiesReports: BinoAdminServiceAuthoritiesReportListGqlOutput;
  binoAdminServicePost?: Maybe<BinoAdminServicePostGqlOutput>;
  bookingServiceAllBookings: BookingServiceBookingsGqlOutput;
  bookingServiceAllSlots: Array<BookingServiceSlotGqlOutput>;
  bookingServiceAvailableDays: Array<BookingServiceAvailableDayGqlOutput>;
  bookingServiceAvailableMonths: Array<BookingServiceAvailableMonthGqlOutput>;
  bookingServiceAvailableTimes: Array<BookingServiceAvailableTimeGqlOutput>;
  bookingServiceBookingsById: BookingServiceBookingGqlOutput;
  bookingServiceDisabledSlots: Array<BookingServiceSlotGqlOutput>;
  bookingServiceEnabledSlots: Array<BookingServiceSlotGqlOutput>;
  bookingServiceEndedBookings: Array<BookingServiceBookingGqlOutput>;
  bookingServiceGetAllProductSuggestionsByTenant: Array<BookingServiceProductSuggestionGqlOutput>;
  bookingServiceGetProductSuggestionById?: Maybe<BookingServiceProductSuggestionGqlOutput>;
  bookingServiceGetProductSuggestionsByBranch: Array<BookingServiceProductSuggestionGqlOutput>;
  bookingServiceIncomingBookings: Array<BookingServiceBookingGqlOutput>;
  bookingServiceMyBookings: Array<BookingServiceBookingGqlOutput>;
  bookingServiceOngoingBookings: Array<BookingServiceBookingGqlOutput>;
  bookingServicePendingBookings: Array<BookingServiceBookingGqlOutput>;
  bookingServicePublicSlots: Array<BookingServiceSlotGqlOutput>;
  bookingServiceSlotById: BookingServiceSlotGqlOutput;
  campaignServiceAllCampaignTriggers: CampaignServiceCampaignTriggersGqlOutput;
  campaignServiceAllCampaigns: CampaignServiceCampaignsGqlOutput;
  campaignServiceCampaignById: CampaignServiceCampaignGqlOutput;
  campaignServiceCampaignTriggerById: CampaignServiceCampaignTriggerGqlOutput;
  campaignServiceCampaignsByIds: Array<CampaignServiceCampaignGqlOutput>;
  campaignServiceDisabledCampaigns: Array<CampaignServiceCampaignGqlOutput>;
  campaignServiceEnabledCampaignTriggers: Array<CampaignServiceCampaignTriggerGqlOutput>;
  campaignServiceEnabledCampaigns: Array<CampaignServiceCampaignGqlOutput>;
  campaignServiceSearchCampaigns: Array<CampaignServiceCampaignGqlOutput>;
  cartService: Array<CartServiceCartGqlOutput>;
  checkinServiceCheckinById: CheckinServiceCheckinGqlOutput;
  checkoutServiceGet: Scalars['String']['output'];
  clockinServiceAllClockin: Array<ClockinServiceClockinGqlOutput>;
  clockinServiceAllShifts: Array<ClockinServiceShiftGqlOutput>;
  clockinServiceClockinById: ClockinServiceClockinGqlOutput;
  clockinServiceMyClockin: Array<ClockinServiceClockinGqlOutput>;
  clockinServiceMyShifts: Array<ClockinServiceShiftGqlOutput>;
  clockinServiceShiftById: ClockinServiceShiftGqlOutput;
  companies: Array<Company>;
  company: Company;
  contentServiceAllCategories: Array<ContentServiceCategoryGqlOutput>;
  contentServiceArticle: ContentServiceArticleGqlOutput;
  contentServiceBlockTemplate?: Maybe<BlockTemplateOutput>;
  contentServiceBlockTemplates: Array<BlockTemplateOutput>;
  contentServiceCategoryById: ContentServiceCategoryGqlOutput;
  contentServiceGetAllArticles: Array<ContentServiceArticleGqlOutput>;
  contentServiceGetPage?: Maybe<ContentServicePageGqlOutput>;
  contentServicePublicCategories: Array<ContentServiceCategoryGqlOutput>;
  contentServicePublicSubCategories: Array<ContentServiceCategoryGqlOutput>;
  contentServiceSearchArticles: Array<ContentServiceArticleGqlOutput>;
  contentServiceSubCategories: Array<ContentServiceCategoryGqlOutput>;
  dictionaryServiceAllDictionaries: Array<DictionaryServiceDictionaryGqlOutput>;
  dictionaryServiceDictionaries: Array<DictionaryServiceDictionaryGqlOutput>;
  dictionaryServiceDictionary: DictionaryServiceDictionaryGqlOutput;
  dictionaryServiceSearchDictionaries: Array<DictionaryServiceDictionaryGqlOutput>;
  dictionaryServiceSearchDictionariesByWordAndPos: Array<DictionaryServiceDictionaryGqlOutput>;
  disabledCompanies: Array<Company>;
  enabledCompanies: Array<Company>;
  eventServiceAllCategories: Array<EventServiceCategoryGqlOutput>;
  eventServiceAllEvents: Array<EventServiceEventGqlOutput>;
  eventServiceAllRegistrations: Array<EventServiceEventRegistrationGqlOutput>;
  eventServiceCategoryById: EventServiceCategoryGqlOutput;
  eventServiceDisabledEvents: Array<EventServiceEventGqlOutput>;
  eventServiceEnabledEvents: Array<EventServiceEventGqlOutput>;
  eventServiceEndedEvents: Array<EventServiceEventGqlOutput>;
  eventServiceEventById: EventServiceEventGqlOutput;
  eventServiceIncomingEvents: Array<EventServiceEventGqlOutput>;
  eventServiceMyRegistration: EventServiceEventRegistrationGqlOutput;
  eventServiceOngoingEvents: Array<EventServiceEventGqlOutput>;
  eventServicePublicCategories: Array<EventServiceCategoryGqlOutput>;
  eventServicePublicEvents: Array<EventServiceEventGqlOutput>;
  eventServicePublicSubCategories: Array<EventServiceCategoryGqlOutput>;
  eventServiceSearchEvents: Array<EventServiceEventGqlOutput>;
  eventServiceSubCategories: Array<EventServiceCategoryGqlOutput>;
  featureFlagServiceGetAllFeatureFlags: Array<FeatureFlagServiceFeatureFlagGqlOutput>;
  featureFlagServiceGetEnabledFeatureFlags: Array<FeatureFlagServiceFeatureFlagGqlOutput>;
  featureFlagServiceGetFeatureFlagDetail: FeatureFlagServiceFeatureFlagGqlOutput;
  featureFlagServiceGetTenantOverrides: Array<FeatureFlagServiceTenantOverrideGqlOutput>;
  featureServiceGetFeatureByCode?: Maybe<FeatureServiceFeatureGqlOutput>;
  featureServiceGetFeatureList: FeatureServiceGetListGqlOutput;
  flashsaleServiceGetActiveCampaigns: FlashSaleCampaignList;
  flashsaleServiceGetCampaign?: Maybe<Campaign>;
  flashsaleServiceGetCampaignProducts: FlashSaleProductList;
  flashsaleServiceGetCampaigns: FlashSaleCampaignList;
  flashsaleServiceHasActiveFlashSale: Scalars['Boolean']['output'];
  fnsServiceGetFormById: FnsServiceFormGqlOutput;
  fnsServiceGetFormByIdForAdmin: FnsServiceFormGqlOutput;
  fnsServiceGetFormsForAdmin: FnsServiceFormsGqlOutput;
  fnsServiceGetSurveyById: FnsServiceSurveyGqlOutput;
  fnsServiceGetSurveyByIdForAdmin: FnsServiceSurveyGqlOutput;
  fnsServiceGetSurveyByType: FnsServiceSurveyGqlOutput;
  fnsServiceGetSurveysForAdmin: FnsServiceSurveysGqlOutput;
  fnsServiceGetUserResponseByIdForAdmin: FnsServiceUserResponseGqlOutput;
  fnsServiceGetUserResponsesToFormForAdmin: FnsServiceUserResponsesGqlOutput;
  fnsServiceGetUserResponsesToSurveyForAdmin: FnsServiceUserResponsesGqlOutput;
  formServiceCompany: Company;
  health?: Maybe<Scalars['String']['output']>;
  inventoryServiceAllStock: InventoryServiceStocksGqlOutput;
  inventoryServiceSearchStockForAdmin: Array<InventoryServiceStockGqlOutput>;
  inventoryServiceStockById: InventoryServiceStockGqlOutput;
  inventoryServiceStockByProductAndSku: InventoryServiceStockGqlOutput;
  larvaCourseServiceAllSentences: Array<LarvaCourseServiceSentenceGqlOutput>;
  larvaCourseServiceCollection: LarvaCourseServiceDetailUserCollectionGqlOutput;
  larvaCourseServiceCollections: Array<LarvaCourseServiceGeneralUserCollectionGqlOutput>;
  larvaCourseServiceCollectionsOfUser: Array<LarvaCourseServiceGeneralUserCollectionGqlOutput>;
  larvaCourseServiceGetLessonSentences: Array<LarvaCourseServiceSearchLessonSentenceGqlOutput>;
  larvaCourseServiceGetLessonSpeakingSummary: LarvaCourseServiceHistoryLessonGqlOutput;
  larvaCourseServiceGetLessonWords: Array<LarvaCourseServiceSearchLessonWordGqlOutput>;
  larvaCourseServiceGetNearlyLessons: Array<LarvaCourseServiceLessonGqlOutput>;
  larvaCourseServiceLessonById: LarvaCourseServiceLessonGqlOutput;
  larvaCourseServiceLessonSpeakingById: LarvaCourseServiceLessonGqlOutput;
  larvaCourseServiceLessonsByIds: Array<LarvaCourseServiceLessonGqlOutput>;
  larvaCourseServiceSearchCollectionsOfUser: Array<LarvaCourseServiceGeneralUserCollectionGqlOutput>;
  larvaCourseServiceSearchLessonsSpeaking: LarvaCourseServiceLessonsGqlOutput;
  larvaCourseServiceSearchSentences: LarvaCourseServiceSentencesGqlOutput;
  larvaCourseServiceSearchTopics: LarvaCourseServiceTopicsGqlOutput;
  larvaCourseServiceSentence: LarvaCourseServiceSentenceGqlOutput;
  larvaCourseServiceSentences: Array<LarvaCourseServiceSentenceGqlOutput>;
  larvaCourseServiceSubjects: Array<LarvaCourseServiceSubjectsGqlOutput>;
  larvaCourseServiceTopicById: LarvaCourseServiceTopicGqlOutput;
  larvaCourseServiceTopicsByIds: Array<LarvaCourseServiceTopicGqlOutput>;
  loyaltyServiceActiveLoyaltyPrograms: Array<LoyaltyServiceLoyaltyProgramGqlOutput>;
  loyaltyServiceAllLoyaltyPrograms: LoyaltyServiceLoyaltyProgramsGqlOutput;
  loyaltyServiceAllLoyaltyTiers: LoyaltyServiceLoyaltyTiersGqlOutput;
  loyaltyServiceDefaultLoyaltyProgram: LoyaltyServiceLoyaltyProgramGqlOutput;
  loyaltyServiceEnabledLoyaltyTiers: Array<LoyaltyServiceLoyaltyTierGqlOutput>;
  loyaltyServiceLoyaltyProgramById: LoyaltyServiceLoyaltyProgramGqlOutput;
  loyaltyServiceLoyaltyTierById: LoyaltyServiceLoyaltyTierGqlOutput;
  loyaltyServiceLoyaltyTierByIdForAdmin: LoyaltyServiceLoyaltyTierGqlOutput;
  loyaltyServiceLoyaltyTierByUserId: LoyaltyServiceLoyaltyTierGqlOutput;
  meetingServiceTest: Scalars['Boolean']['output'];
  membershipServiceMemberInfoByUserId: MembershipServiceMemberGqlOutput;
  membershipServiceMyMemberInfo: MembershipServiceMemberGqlOutput;
  messageManagementServiceMessageStatistics: MessageStatistics;
  messageManagementServiceOaAccounts: OaAccountList;
  messageManagementServiceOaAccountsAll: OaAccountList;
  messageManagementServiceOaDetail?: Maybe<OaAccount>;
  messageManagementServiceOaQuota?: Maybe<OaQuota>;
  messageManagementServiceOttSmsList: Array<OttSms>;
  messageManagementServiceSmsConfigs: SmsConfigList;
  messageManagementServiceSmsMessageLogs: SmsMessageLogList;
  messageManagementServiceSystemHealth: SystemHealth;
  messageManagementServiceSystemSettings: Array<SystemSettings>;
  messageManagementServiceViberConfigs: ViberConfigList;
  messageManagementServiceViberMessageLogs: ViberMessageLogList;
  messageManagementServiceZnsMessageLogs: ZnsMessageLogList;
  messageManagementServiceZnsTemplate?: Maybe<ZnsTemplate>;
  messageManagementServiceZnsTemplateByTemplateID?: Maybe<ZnsTemplate>;
  messageManagementServiceZnsTemplates?: Maybe<ZnsTemplateList>;
  minigamesServiceGetActiveCampaigns: Array<MinigamesServiceCampaignOutput>;
  minigamesServiceGetAllCampaigns: MinigamesServiceCampaignsOutput;
  minigamesServiceGetCampaign: MinigamesServiceCampaignOutput;
  minigamesServiceGetCampaignCodes: MinigamesServiceCodesOutput;
  minigamesServiceGetCampaignInfo: MinigamesServiceCampaignInfoOutput;
  minigamesServiceGetCampaignPrizes: MinigamesServicePrizesOutput;
  minigamesServiceGetGameRecords: MinigamesServiceGameRecordsOutput;
  minigamesServiceGetGameTemplates: Array<MinigamesServiceGameTemplateOutput>;
  minigamesServiceGetMyGameHistory: MinigamesServiceUserGameHistoryOutput;
  minigamesServiceGetPrize: MinigamesServicePrizeDetailOutput;
  minigamesServiceGetQuestion: MinigamesServiceQuestionOutput;
  minigamesServiceGetQuestionsByCampaign: MinigamesServiceQuestionsOutput;
  minigamesServiceGetQuizQuestionsForPlay: MinigamesServiceQuizQuestionsForPlayOutput;
  minigamesServiceGetRemainingPlays: MinigamesServiceRemainingPlaysOutput;
  notificationServiceInAppNotifications: Array<NotificationServiceInAppNotificationGqlOutput>;
  notificationServiceTemplate: NotificationServiceTemplateGqlOutput;
  notificationServiceTemplates: Array<NotificationServiceTemplateGqlOutput>;
  orderServiceGetOrder: OrderServiceOrderGqlOutput;
  orderServiceGetOrderHistories: Array<OrderServiceOrderHistoryGqlOutput>;
  orderServiceGetOrders: Array<OrderServiceOrderGqlOutput>;
  orderServiceOrganizationGetOrders: Array<OrderServiceOrderGqlOutput>;
  organizationServiceAdminAllOrganizations: Array<OrganizationServiceOrganizationGqlOutput>;
  organizationServiceAdminOrganizationById: OrganizationServiceOrganizationGqlOutput;
  organizationServiceAllBranches: Array<OrganizationServiceBranchGqlOutput>;
  organizationServiceBranchById: OrganizationServiceBranchGqlOutput;
  organizationServiceBranchByIds: Array<OrganizationServiceBranchGqlOutput>;
  organizationServiceBranches: Array<OrganizationServiceBranchGqlOutput>;
  organizationServiceGetByDomain: OrganizationServiceOrganizationGqlOutput;
  organizationServiceMyOrg: OrganizationServiceOrganizationGqlOutput;
  paymentServiceTransactionByIdForAdmin: PaymentServiceTransactionGqlOutput;
  paymentServiceTransactionsForAdmin: PaymentServiceTransactionsGqlOutput;
  paymentServiceUserSubscriptionTransaction: PaymentServiceSubscriptionTransactionGqlOutput;
  paymentServiceUserSubscriptionTransactions: Array<PaymentServiceSubscriptionTransactionGqlOutput>;
  paymentServiceVendor: PaymentServiceVendorGqlOutput;
  paymentServiceVendorForAdmin: PaymentServiceVendorForAdminGqlOutput;
  paymentServiceVendors: Array<PaymentServiceVendorGqlOutput>;
  paymentServiceVendorsForAdmin: Array<PaymentServiceVendorForAdminGqlOutput>;
  pointServiceAllPointExpiryRules: PointServicePointExpiryRulesGqlOutput;
  pointServiceCountPointTransactionsByUserId: PointServiceCountPointTransactionsByUserIdGqlOutput;
  pointServiceGetPointBalanceById: PointServicePointBalanceGqlOutput;
  pointServiceGetPointBalanceByUserId: PointServicePointBalanceGqlOutput;
  pointServiceMyPointBalance: PointServicePointBalanceGqlOutput;
  pointServiceMyPointTransactions: Array<PointServicePointTransactionGqlOutput>;
  pointServicePointConfig?: Maybe<PointConfigOutput>;
  pointServicePointExpiryRuleById: PointServicePointExpiryRuleGqlOutput;
  pointServicePointExpiryRulesByLoyaltyProgramId: Array<PointServicePointExpiryRuleGqlOutput>;
  pointServicePointTransactionsByUserId: Array<PointServicePointTransactionGqlOutput>;
  privacyPolicy: Scalars['String']['output'];
  productServiceAllBrands: BrandServiceBrandsGqlOutput;
  productServiceAllCategories: Array<ProductServiceCategoryGqlOutput>;
  productServiceAllColors: Array<ProductServiceColorGqlOutput>;
  productServiceAllProducts: ProductServiceProductsGqlOutput;
  productServiceBrandById: BrandServiceBrandGqlOutput;
  productServiceCategoryById: ProductServiceCategoryGqlOutput;
  productServiceColorByCode: ProductServiceColorGqlOutput;
  productServiceColorById: ProductServiceColorGqlOutput;
  productServiceDisabledProducts: ProductServiceProductsGqlOutput;
  productServiceEnabledBrands: BrandServiceBrandsGqlOutput;
  productServiceEnabledProducts: ProductServiceProductsGqlOutput;
  productServiceFeaturedProducts: Array<ProductServiceProductGqlOutput>;
  productServiceLatestProducts: Array<ProductServiceProductGqlOutput>;
  productServiceProductById: ProductServiceProductGqlOutput;
  productServiceProductByIdForAdmin: ProductServiceProductGqlOutput;
  productServicePublicCategories: Array<ProductServiceCategoryGqlOutput>;
  productServicePublicProducts: Array<ProductServiceProductGqlOutput>;
  productServicePublicSubCategories: Array<ProductServiceCategoryGqlOutput>;
  productServiceSearchProducts: Array<ProductServiceProductGqlOutput>;
  productServiceSearchProductsForAdmin: Array<ProductServiceProductGqlOutput>;
  productServiceSubCategories: Array<ProductServiceCategoryGqlOutput>;
  ratingServiceCheckFavoriteStatus: RatingServiceCheckGqlOutput;
  ratingServiceCheckRatingStatus: RatingServiceCheckRatingStatusGqlOutput;
  ratingServiceGetMyFavorites: RatingServiceFavoritesGqlOutput;
  ratingServiceGetRatingDetails: RatingServiceRatingGqlOutput;
  ratingServiceGetRatingsByFilter: RatingServiceRatingsGqlOutput;
  ratingServiceMyRatings: RatingServiceMyRatingsGqlOutput;
  ratingServiceRatingSummary: RatingServiceRatingSummaryGqlOutput;
  rbacServiceAvailablePermissions: Array<PermissionGqlOutput>;
  rbacServiceCurrentUserRole: Array<RbacServiceRoleGqlOutput>;
  rbacServiceRoleById: RbacServiceRoleGqlOutput;
  rbacServiceRoles: Array<RbacServiceRoleGqlOutput>;
  rbacServiceRolesByOrganization: Array<RbacServiceRoleGqlOutput>;
  rbacServiceRolesByOwn: Array<RbacServiceRoleGqlOutput>;
  rbacServiceRolesByTenant: Array<RbacServiceRoleGqlOutput>;
  rbacServiceUserRoles: Array<RbacServiceRoleGqlOutput>;
  referralServiceCommissionHistory: CommissionHistoryOutput;
  referralServiceMyReferralCode: ReferralCodeOutput;
  referralServiceMyReferralTree: ReferralTreeOutput;
  referralServiceReferralConfig: ConfigureReferralSystemOutput;
  referralServiceReferralConfigForAgency: ConfigureReferralSystemOutput;
  referralServiceReferralStatistics: ReferralStatisticsOutput;
  referralServiceReferralTreeForAgency: ReferralTreeOutput;
  referralServiceReferralTreeForOrganization: ReferralTreeOutput;
  sduiServiceBlock: SduiServiceBlockGqlOutput;
  sduiServiceBlockByCode: SduiServiceBlockGqlOutput;
  sduiServiceBlocks: Array<SduiServiceBlockGqlOutput>;
  sduiServiceGetAllLayouts: Array<SduiServiceLayoutGqlOutput>;
  sduiServiceGetLayout: SduiServiceLayoutGqlOutput;
  sduiServiceGetLayoutDetail: SduiServiceLayoutGqlOutput;
  sduiServiceGetLayouts: Array<SduiServiceLayoutGqlOutput>;
  sduiServiceGetTenantLayout: SduiServiceLayoutGqlOutput;
  sduiServicePage: SduiServicePageGqlOutput;
  sduiServicePageByKey: SduiServicePageGqlOutput;
  sduiServicePages: Array<SduiServicePageGqlOutput>;
  searchCompanies: Array<Company>;
  shippingServiceProviders: Array<ShippingServiceProviderGqlOutput>;
  shippingServiceShippingMethods: Array<ShippingServiceShippingMethodGqlOutput>;
  shippingServiceShippingMethodsAvailable: Array<ShippingServiceShippingMethodGqlOutput>;
  storageServiceGetFileMetadata: StorageServiceFileMetadataGqlOutput;
  subscriptionServiceAllPackages: Array<SubscriptionServicePackageGqlOutput>;
  subscriptionServiceAllPackagesForAdmin: Array<SubscriptionServicePackageGqlOutput>;
  subscriptionServiceAuditEvents?: Maybe<SubscriptionServiceAuditEventListGqlOutput>;
  subscriptionServiceBillingTransactions?: Maybe<SubscriptionServiceBillingTransactionListGqlOutput>;
  subscriptionServiceCurrentUserSubscription: SubscriptionServiceGetUserSubscriptionGqlOutput;
  subscriptionServicePackage: SubscriptionServicePackageGqlOutput;
  subscriptionServicePackageForAdmin: SubscriptionServicePackageGqlOutput;
  subscriptionServicePlan?: Maybe<SubscriptionServicePlanGqlOutput>;
  subscriptionServicePlans?: Maybe<SubscriptionServicePlanListGqlOutput>;
  subscriptionServiceSubscription?: Maybe<SubscriptionServiceSubscriptionGqlOutput>;
  subscriptionServiceSubscriptionByTenant?: Maybe<SubscriptionServiceSubscriptionGqlOutput>;
  subscriptionServiceSubscriptions?: Maybe<SubscriptionServiceSubscriptionListGqlOutput>;
  subscriptionServiceUsageMetrics?: Maybe<SubscriptionServiceUsageMetricListGqlOutput>;
  taskServiceAllDependencies: Array<TaskServiceDependencyGqlOutput>;
  taskServiceAllFolders: Array<TaskServiceFolderGqlOutput>;
  taskServiceAllLists: Array<TaskServiceListGqlOutput>;
  taskServiceAllSpaces: Array<TaskServiceSpaceGqlOutput>;
  taskServiceAllTasks: Array<TaskServiceTaskGqlOutput>;
  taskServiceAllWorkspaces: Array<TaskServiceWorkspaceGqlOutput>;
  taskServiceBlockedTasks: Array<Scalars['String']['output']>;
  taskServiceBlockingTasks: Array<Scalars['String']['output']>;
  taskServiceDependencies: Array<TaskServiceDependencyGqlOutput>;
  taskServiceDependenciesByTask: Array<TaskServiceDependencyGqlOutput>;
  taskServiceDependenciesByType: Array<TaskServiceDependencyGqlOutput>;
  taskServiceDependenciesFromTask: Array<TaskServiceDependencyGqlOutput>;
  taskServiceDependenciesToTask: Array<TaskServiceDependencyGqlOutput>;
  taskServiceDependency: TaskServiceDependencyGqlOutput;
  taskServiceFolder: TaskServiceFolderGqlOutput;
  taskServiceFolders: Array<TaskServiceFolderGqlOutput>;
  taskServiceFoldersBySpace: Array<TaskServiceFolderGqlOutput>;
  taskServiceList: TaskServiceListGqlOutput;
  taskServiceLists: Array<TaskServiceListGqlOutput>;
  taskServiceListsByFolder: Array<TaskServiceListGqlOutput>;
  taskServiceListsBySpace: Array<TaskServiceListGqlOutput>;
  taskServiceOverdueTasks: Array<TaskServiceTaskGqlOutput>;
  taskServiceSearchFolders: Array<TaskServiceFolderGqlOutput>;
  taskServiceSearchLists: Array<TaskServiceListGqlOutput>;
  taskServiceSearchSpaces: Array<TaskServiceSpaceGqlOutput>;
  taskServiceSearchTasks: Array<TaskServiceTaskGqlOutput>;
  taskServiceSearchWorkspaces: Array<TaskServiceWorkspaceGqlOutput>;
  taskServiceSpace: TaskServiceSpaceGqlOutput;
  taskServiceSpaces: Array<TaskServiceSpaceGqlOutput>;
  taskServiceSpacesByWorkspace: Array<TaskServiceSpaceGqlOutput>;
  taskServiceSubtasks: Array<TaskServiceTaskGqlOutput>;
  taskServiceTask: TaskServiceTaskGqlOutput;
  taskServiceTasks: Array<TaskServiceTaskGqlOutput>;
  taskServiceTasksByAssignee: Array<TaskServiceTaskGqlOutput>;
  taskServiceTasksByList: Array<TaskServiceTaskGqlOutput>;
  taskServiceTasksByPriority: Array<TaskServiceTaskGqlOutput>;
  taskServiceTasksByStatus: Array<TaskServiceTaskGqlOutput>;
  taskServiceWorkspace: TaskServiceWorkspaceGqlOutput;
  taskServiceWorkspaces: Array<TaskServiceWorkspaceGqlOutput>;
  taskServiceWorkspacesByMember: Array<TaskServiceWorkspaceGqlOutput>;
  taskServiceWorkspacesByOwner: Array<TaskServiceWorkspaceGqlOutput>;
  /** Get the latest approved template (live template) for use in sending messages */
  templateServiceGetApprovedTemplate?: Maybe<TemplateServiceTemplate>;
  /** Get the template currently being edited (draft status) for a given templateId */
  templateServiceGetEditingTemplate?: Maybe<TemplateServiceTemplate>;
  /** Get a specific template version by its MongoDB document ID (hex format) */
  templateServiceGetTemplate?: Maybe<TemplateServiceTemplate>;
  /** Get all versions of a template (history) */
  templateServiceGetTemplateHistory?: Maybe<Array<Maybe<TemplateServiceTemplate>>>;
  /** Get all templates with the same templateId (all versions and statuses) */
  templateServiceGetTemplatesByTemplateId?: Maybe<Array<Maybe<TemplateServiceTemplate>>>;
  /** List approved templates by tenant and optional type */
  templateServiceListApprovedTemplates?: Maybe<TemplateServiceTemplateList>;
  /** List template IDs with templateCode and earliest creation date */
  templateServiceListTemplateIds?: Maybe<TemplateServiceTemplateIdList>;
  /** List templates with filters */
  templateServiceListTemplates?: Maybe<TemplateServiceTemplateList>;
  /** Validate if variables in content match provided variables list */
  templateServiceValidateVariables?: Maybe<TemplateServiceVariableValidation>;
  termAndCondition: Scalars['String']['output'];
  ticketServiceAllCustomers: Array<Customer>;
  ticketServiceAllTicketLogs: Array<TicketLog>;
  ticketServiceAllTickets: Array<Ticket>;
  ticketServiceCustomer: Customer;
  ticketServiceCustomerByCode: Customer;
  ticketServiceSearchCustomers: Array<Customer>;
  ticketServiceSearchTicketLogs: Array<TicketLog>;
  ticketServiceSearchTickets: Array<Ticket>;
  ticketServiceTicket: Ticket;
  ticketServiceTicketLog: TicketLog;
  ticketServiceTicketLogs: Array<TicketLog>;
  ticketServiceTicketLogsByActionType: Array<TicketLog>;
  ticketServiceTicketLogsByIds: Array<TicketLog>;
  ticketServiceTicketLogsByPerformer: Array<TicketLog>;
  ticketServiceTickets: Array<Ticket>;
  uploadTest: Scalars['String']['output'];
  userServiceAdminAllTenant: Array<UserServiceTenantGqlOutput>;
  userServiceAllTenant: Array<UserServiceTenantGqlOutput>;
  userServiceAllUserOfTenant: Array<UserServiceUserGqlOutput>;
  userServiceAllZaloUserOfTenant: Array<UserServiceUserGqlOutput>;
  userServiceGetUserById: UserServiceUserGqlOutput;
  userServiceGetUserByIdForAdmin: UserServiceUserGqlOutput;
  userServiceGetUserByIds: Array<UserServiceUserGqlOutput>;
  userServiceTenantByDomain?: Maybe<UserServiceTenantGqlOutput>;
  userServiceTenantById: UserServiceTenantGqlOutput;
  userServiceTenantIdFromDomain?: Maybe<Scalars['String']['output']>;
  userServiceTenantOfUser: UserServiceTenantGqlOutput;
  userServiceTest: CurrentRequestHeaderGqlOutput;
  userServiceUsersByType: UserServiceUsersGqlOutput;
  userServiceUsersOfTenantForAdmin: UserServiceUsersGqlOutput;
  voucherServiceAllVoucherTypes: VoucherServiceVoucherTypesGqlOutput;
  voucherServiceAllVouchers: VoucherServiceVouchersGqlOutput;
  voucherServiceDeletedVoucherTypes: Array<VoucherServiceVoucherTypeGqlOutput>;
  voucherServiceDisabledVoucherTypes: Array<VoucherServiceVoucherTypeGqlOutput>;
  voucherServiceDisabledVouchers: Array<VoucherServiceVoucherGqlOutput>;
  voucherServiceEnabledVoucherTypes: Array<VoucherServiceVoucherTypeGqlOutput>;
  voucherServiceEnabledVouchers: Array<VoucherServiceVoucherGqlOutput>;
  voucherServiceLoyaltyVoucherType: VoucherServiceVoucherTypesGqlOutput;
  voucherServiceMyVouchers: Array<VoucherServiceVoucherGqlOutput>;
  voucherServiceRedeemableVoucherTypes: Array<VoucherServiceRedeemableVoucherTypeGqlOutput>;
  voucherServiceSearchVouchers: Array<VoucherServiceVoucherGqlOutput>;
  voucherServiceVoucherById: VoucherServiceVoucherGqlOutput;
  voucherServiceVoucherTypeById: VoucherServiceVoucherTypeGqlOutput;
  voucherServiceVouchersByIds: Array<VoucherServiceVoucherGqlOutput>;
};


export type QueryAddressServiceAllAddressArgs = {
  input: PaginationArgs;
};


export type QueryAddressServiceWardsByProvinceIdArgs = {
  provinceId: Scalars['String']['input'];
};


export type QueryAffiliateServiceGetAnalyticsForAgencyArgs = {
  affiliateCode?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAffiliateServiceGetAnalyticsForOrganizationArgs = {
  affiliateCode?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAffiliateServiceGetCodeRequestsArgs = {
  filter: AffiliateServiceGetCodeRequestsFilterInput;
};


export type QueryAffiliateServiceGetLinksForOrganizationArgs = {
  filter: AffiliateServiceGetLinksFilterInput;
};


export type QueryAffiliateServiceGetMyAnalyticsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  month?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAffiliateServiceGetMyBalanceArgs = {
  month?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAffiliateServiceGetMyLinkArgs = {
  linkId: Scalars['String']['input'];
};


export type QueryAffiliateServiceGetMyLinksArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  skip?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAffiliateServiceGetMyTrackingArgs = {
  input: PaginationArgs;
  month?: InputMaybe<Scalars['Float']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAffiliateServiceGetTrackingForAgencyArgs = {
  filter: AffiliateServiceGetTrackingFilterInput;
};


export type QueryAffiliateServiceGetTrackingForOrganizationArgs = {
  filter: AffiliateServiceGetTrackingFilterInput;
};


export type QueryAllCompaniesArgs = {
  pagination: PaginationArgs;
};


export type QueryApiHubServiceApiCredentialTemplatesArgs = {
  params?: InputMaybe<ApiHubServicePagination>;
  providerCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryApiHubServiceApiCredentialsArgs = {
  filter?: InputMaybe<ApiHubServiceApiCredentialFilter>;
  params?: InputMaybe<ApiHubServicePagination>;
};


export type QueryApiHubServiceApiCredentialsByTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryApiHubServiceApiProviderByCodeArgs = {
  providerCode: Scalars['String']['input'];
};


export type QueryApiHubServiceApiProvidersArgs = {
  filter?: InputMaybe<ApiHubServiceApiProviderFilter>;
  params?: InputMaybe<ApiHubServicePagination>;
};


export type QueryApiHubServiceLinksArgs = {
  filter?: InputMaybe<ApiHubServiceLinkFilter>;
  params?: InputMaybe<ApiHubServicePagination>;
};


export type QueryBinoAdminServiceAuthoritiesReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBinoAdminServiceAuthoritiesReportsArgs = {
  params?: InputMaybe<BinoAdminServiceAuthoritiesReportListParamsGqlInput>;
};


export type QueryBinoAdminServicePostArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingServiceAllBookingsArgs = {
  pagination: PaginationArgs;
};


export type QueryBookingServiceAllSlotsArgs = {
  branchId: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryBookingServiceAvailableDaysArgs = {
  input: BookingServiceAvailableDaysGqlInput;
};


export type QueryBookingServiceAvailableMonthsArgs = {
  input: BookingServiceAvailableMonthsGqlInput;
};


export type QueryBookingServiceAvailableTimesArgs = {
  input: BookingServiceAvailableTimesGqlInput;
};


export type QueryBookingServiceBookingsByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryBookingServiceDisabledSlotsArgs = {
  branchId: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryBookingServiceEnabledSlotsArgs = {
  branchId: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryBookingServiceEndedBookingsArgs = {
  pagination: PaginationArgs;
};


export type QueryBookingServiceGetProductSuggestionByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryBookingServiceGetProductSuggestionsByBranchArgs = {
  branchId: Scalars['String']['input'];
};


export type QueryBookingServiceIncomingBookingsArgs = {
  pagination: PaginationArgs;
};


export type QueryBookingServiceMyBookingsArgs = {
  filter?: InputMaybe<BookingServiceMyBookingsFilterGqlInput>;
  pagination: PaginationArgs;
};


export type QueryBookingServiceOngoingBookingsArgs = {
  pagination: PaginationArgs;
};


export type QueryBookingServicePendingBookingsArgs = {
  pagination: PaginationArgs;
};


export type QueryBookingServicePublicSlotsArgs = {
  branchId: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryBookingServiceSlotByIdArgs = {
  branchId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryCampaignServiceAllCampaignTriggersArgs = {
  pagination: PaginationArgs;
};


export type QueryCampaignServiceAllCampaignsArgs = {
  pagination: PaginationArgs;
};


export type QueryCampaignServiceCampaignByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryCampaignServiceCampaignTriggerByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryCampaignServiceCampaignsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryCampaignServiceDisabledCampaignsArgs = {
  pagination: PaginationArgs;
};


export type QueryCampaignServiceEnabledCampaignTriggersArgs = {
  pagination: PaginationArgs;
};


export type QueryCampaignServiceEnabledCampaignsArgs = {
  pagination: PaginationArgs;
};


export type QueryCampaignServiceSearchCampaignsArgs = {
  input: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryCartServiceArgs = {
  input: CartServiceGetGqlInput;
};


export type QueryCheckinServiceCheckinByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryClockinServiceAllClockinArgs = {
  input: ClockinServiceClockinGqlInput;
  pagination: PaginationArgs;
};


export type QueryClockinServiceAllShiftsArgs = {
  pagination: PaginationArgs;
};


export type QueryClockinServiceClockinByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryClockinServiceMyClockinArgs = {
  input: ClockinServiceClockinGqlInput;
  pagination: PaginationArgs;
};


export type QueryClockinServiceShiftByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryCompaniesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryCompanyArgs = {
  id: Scalars['String']['input'];
};


export type QueryContentServiceArticleArgs = {
  id: Scalars['String']['input'];
};


export type QueryContentServiceBlockTemplateArgs = {
  id: Scalars['String']['input'];
};


export type QueryContentServiceBlockTemplatesArgs = {
  input?: InputMaybe<GetBlockTemplatesInput>;
};


export type QueryContentServiceCategoryByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryContentServiceGetAllArticlesArgs = {
  input: ContentServiceSearchArticleGqlInput;
  pagination: PaginationArgs;
};


export type QueryContentServiceGetPageArgs = {
  input: ContentServicePageGqlInput;
};


export type QueryContentServicePublicSubCategoriesArgs = {
  parentId: Scalars['String']['input'];
};


export type QueryContentServiceSearchArticlesArgs = {
  input: ContentServiceSearchArticleGqlInput;
  pagination: PaginationArgs;
};


export type QueryContentServiceSubCategoriesArgs = {
  parentId: Scalars['String']['input'];
};


export type QueryDictionaryServiceAllDictionariesArgs = {
  input: PaginationArgs;
};


export type QueryDictionaryServiceDictionariesArgs = {
  ids: Array<Scalars['String']['input']>;
  pagination: PaginationArgs;
};


export type QueryDictionaryServiceDictionaryArgs = {
  id: Scalars['String']['input'];
};


export type QueryDictionaryServiceSearchDictionariesArgs = {
  input: DictionaryServiceSearchDictionariesInput;
  pagination: PaginationArgs;
};


export type QueryDictionaryServiceSearchDictionariesByWordAndPosArgs = {
  input: DictionaryServiceSearchManyByWordAndPosInput;
  pagination: PaginationArgs;
};


export type QueryDisabledCompaniesArgs = {
  pagination: PaginationArgs;
};


export type QueryEnabledCompaniesArgs = {
  pagination: PaginationArgs;
};


export type QueryEventServiceAllEventsArgs = {
  input?: InputMaybe<EventServiceSearchEventGqlInput>;
  pagination: PaginationArgs;
};


export type QueryEventServiceAllRegistrationsArgs = {
  id: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryEventServiceCategoryByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryEventServiceDisabledEventsArgs = {
  pagination: PaginationArgs;
};


export type QueryEventServiceEnabledEventsArgs = {
  pagination: PaginationArgs;
};


export type QueryEventServiceEndedEventsArgs = {
  pagination: PaginationArgs;
};


export type QueryEventServiceEventByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryEventServiceIncomingEventsArgs = {
  pagination: PaginationArgs;
};


export type QueryEventServiceMyRegistrationArgs = {
  id: Scalars['String']['input'];
};


export type QueryEventServiceOngoingEventsArgs = {
  pagination: PaginationArgs;
};


export type QueryEventServicePublicEventsArgs = {
  pagination: PaginationArgs;
};


export type QueryEventServicePublicSubCategoriesArgs = {
  parentId: Scalars['String']['input'];
};


export type QueryEventServiceSearchEventsArgs = {
  input: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryEventServiceSubCategoriesArgs = {
  parentId: Scalars['String']['input'];
};


export type QueryFeatureFlagServiceGetAllFeatureFlagsArgs = {
  input: FeatureFlagServiceGetAllFeatureFlagGqlInput;
};


export type QueryFeatureFlagServiceGetEnabledFeatureFlagsArgs = {
  input: FeatureFlagServiceGetFeatureFlagGqlInput;
};


export type QueryFeatureFlagServiceGetFeatureFlagDetailArgs = {
  input: FeatureFlagServiceGetFeatureFlagDetailGqlInput;
};


export type QueryFeatureServiceGetFeatureByCodeArgs = {
  featureCode: Scalars['String']['input'];
};


export type QueryFeatureServiceGetFeatureListArgs = {
  input?: InputMaybe<FeatureServiceGetListGqlInput>;
};


export type QueryFlashsaleServiceGetActiveCampaignsArgs = {
  input?: InputMaybe<FlashSaleActiveCampaignFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFlashsaleServiceGetCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFlashsaleServiceGetCampaignProductsArgs = {
  input: FlashSaleProductFilterInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFlashsaleServiceGetCampaignsArgs = {
  input?: InputMaybe<FlashSaleCampaignFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFnsServiceGetFormByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFnsServiceGetFormByIdForAdminArgs = {
  id: Scalars['String']['input'];
};


export type QueryFnsServiceGetFormsForAdminArgs = {
  pagination: PaginationArgs;
};


export type QueryFnsServiceGetSurveyByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryFnsServiceGetSurveyByIdForAdminArgs = {
  id: Scalars['String']['input'];
};


export type QueryFnsServiceGetSurveyByTypeArgs = {
  type: SurveyType;
};


export type QueryFnsServiceGetSurveysForAdminArgs = {
  pagination: PaginationArgs;
};


export type QueryFnsServiceGetUserResponseByIdForAdminArgs = {
  id: Scalars['String']['input'];
};


export type QueryFnsServiceGetUserResponsesToFormForAdminArgs = {
  input: FnsServiceFindUserResponsesToFormGqlInput;
  pagination: PaginationArgs;
};


export type QueryFnsServiceGetUserResponsesToSurveyForAdminArgs = {
  input: FnsServiceFindUserResponsesToSurveyGqlInput;
  pagination: PaginationArgs;
};


export type QueryFormServiceCompanyArgs = {
  id: Scalars['String']['input'];
};


export type QueryInventoryServiceAllStockArgs = {
  pagination: PaginationArgs;
};


export type QueryInventoryServiceSearchStockForAdminArgs = {
  input: InventoryServiceSearchStockForAdminGqlInput;
  pagination: PaginationArgs;
};


export type QueryInventoryServiceStockByIdArgs = {
  stockId: Scalars['String']['input'];
};


export type QueryInventoryServiceStockByProductAndSkuArgs = {
  productId: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};


export type QueryLarvaCourseServiceAllSentencesArgs = {
  pagination: PaginationArgs;
};


export type QueryLarvaCourseServiceCollectionArgs = {
  id: Scalars['String']['input'];
};


export type QueryLarvaCourseServiceCollectionsArgs = {
  ids: Array<Scalars['String']['input']>;
  pagination: PaginationArgs;
};


export type QueryLarvaCourseServiceCollectionsOfUserArgs = {
  pagination: PaginationArgs;
};


export type QueryLarvaCourseServiceGetLessonSentencesArgs = {
  input: LarvaCourseServiceSearchLessonSentenceGqlInput;
  pagination: PaginationArgs;
};


export type QueryLarvaCourseServiceGetLessonSpeakingSummaryArgs = {
  id: Scalars['String']['input'];
};


export type QueryLarvaCourseServiceGetLessonWordsArgs = {
  input: LarvaCourseServiceSearchLessonWordGqlInput;
  pagination: PaginationArgs;
};


export type QueryLarvaCourseServiceGetNearlyLessonsArgs = {
  input: LarvaCourseServiceGetNearlyLessonsGqlInput;
};


export type QueryLarvaCourseServiceLessonByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryLarvaCourseServiceLessonSpeakingByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryLarvaCourseServiceLessonsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
  pagination: PaginationArgs;
};


export type QueryLarvaCourseServiceSearchCollectionsOfUserArgs = {
  input: LarvaCourseServiceSearchCollectionOfUserGqlInput;
  pagination: PaginationArgs;
};


export type QueryLarvaCourseServiceSearchLessonsSpeakingArgs = {
  input: LarvaCourseServiceSearchLessonGqlInput;
  pagination: PaginationArgs;
};


export type QueryLarvaCourseServiceSearchSentencesArgs = {
  input: LarvaCourseServiceSearchSentenceGqlInput;
  pagination: PaginationArgs;
};


export type QueryLarvaCourseServiceSearchTopicsArgs = {
  input: LarvaCourseServiceSearchTopicGqlInput;
  pagination: PaginationArgs;
};


export type QueryLarvaCourseServiceSentenceArgs = {
  id: Scalars['String']['input'];
};


export type QueryLarvaCourseServiceSentencesArgs = {
  ids: Array<Scalars['String']['input']>;
  pagination: PaginationArgs;
};


export type QueryLarvaCourseServiceTopicByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryLarvaCourseServiceTopicsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
  pagination: PaginationArgs;
};


export type QueryLoyaltyServiceAllLoyaltyProgramsArgs = {
  pagination: PaginationArgs;
};


export type QueryLoyaltyServiceAllLoyaltyTiersArgs = {
  pagination: PaginationArgs;
};


export type QueryLoyaltyServiceEnabledLoyaltyTiersArgs = {
  pagination: PaginationArgs;
};


export type QueryLoyaltyServiceLoyaltyProgramByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryLoyaltyServiceLoyaltyTierByIdArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLoyaltyServiceLoyaltyTierByIdForAdminArgs = {
  id: Scalars['String']['input'];
};


export type QueryLoyaltyServiceLoyaltyTierByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryMembershipServiceMemberInfoByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryMessageManagementServiceMessageStatisticsArgs = {
  params?: InputMaybe<MessageManagementServiceStatisticsParams>;
};


export type QueryMessageManagementServiceOaAccountsArgs = {
  params?: InputMaybe<MessageManagementServiceOaListParams>;
};


export type QueryMessageManagementServiceOaAccountsAllArgs = {
  params?: InputMaybe<MessageManagementServiceOaListParams>;
};


export type QueryMessageManagementServiceOaDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessageManagementServiceOaQuotaArgs = {
  oaID: Scalars['String']['input'];
};


export type QueryMessageManagementServiceOttSmsListArgs = {
  params?: InputMaybe<MessageManagementServiceMessageLogParams>;
};


export type QueryMessageManagementServiceSmsConfigsArgs = {
  params?: InputMaybe<MessageManagementServiceSmsConfigListParams>;
};


export type QueryMessageManagementServiceSmsMessageLogsArgs = {
  params?: InputMaybe<MessageManagementServiceMessageLogParams>;
};


export type QueryMessageManagementServiceViberConfigsArgs = {
  params?: InputMaybe<MessageManagementServiceViberConfigListParams>;
};


export type QueryMessageManagementServiceViberMessageLogsArgs = {
  params?: InputMaybe<MessageManagementServiceMessageLogParams>;
};


export type QueryMessageManagementServiceZnsMessageLogsArgs = {
  params?: InputMaybe<MessageManagementServiceMessageLogParams>;
};


export type QueryMessageManagementServiceZnsTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessageManagementServiceZnsTemplateByTemplateIdArgs = {
  templateID: Scalars['String']['input'];
};


export type QueryMessageManagementServiceZnsTemplatesArgs = {
  params?: InputMaybe<MessageManagementServiceZnsListParams>;
};


export type QueryMinigamesServiceGetAllCampaignsArgs = {
  filter?: InputMaybe<MinigamesServiceCampaignFilterInput>;
  pagination: PaginationArgs;
};


export type QueryMinigamesServiceGetCampaignArgs = {
  id: Scalars['String']['input'];
};


export type QueryMinigamesServiceGetCampaignCodesArgs = {
  id: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryMinigamesServiceGetCampaignInfoArgs = {
  id: Scalars['String']['input'];
};


export type QueryMinigamesServiceGetCampaignPrizesArgs = {
  id: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryMinigamesServiceGetGameRecordsArgs = {
  input: MinigamesServiceGameRecordFilterInput;
  pagination: PaginationArgs;
};


export type QueryMinigamesServiceGetMyGameHistoryArgs = {
  input: MinigamesServiceUserGameHistoryInput;
  pagination: PaginationArgs;
};


export type QueryMinigamesServiceGetPrizeArgs = {
  id: Scalars['String']['input'];
};


export type QueryMinigamesServiceGetQuestionArgs = {
  id: Scalars['String']['input'];
};


export type QueryMinigamesServiceGetQuestionsByCampaignArgs = {
  id: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryMinigamesServiceGetQuizQuestionsForPlayArgs = {
  input: MinigamesServiceGetQuizQuestionsForPlayInput;
};


export type QueryMinigamesServiceGetRemainingPlaysArgs = {
  campaignId: Scalars['String']['input'];
};


export type QueryNotificationServiceInAppNotificationsArgs = {
  pagination: PaginationArgs;
};


export type QueryNotificationServiceTemplateArgs = {
  id: Scalars['String']['input'];
};


export type QueryNotificationServiceTemplatesArgs = {
  pagination: PaginationArgs;
};


export type QueryOrderServiceGetOrderArgs = {
  input: OrderServiceDetailGqlInput;
};


export type QueryOrderServiceGetOrderHistoriesArgs = {
  input: OrderServiceGetOrderHistoryGqlInput;
};


export type QueryOrderServiceGetOrdersArgs = {
  input: OrderServiceGetGqlInput;
};


export type QueryOrderServiceOrganizationGetOrdersArgs = {
  input: OrderServiceGetGqlInput;
};


export type QueryOrganizationServiceAdminAllOrganizationsArgs = {
  input: OrganizationServiceGetOrganizationsGqlInput;
};


export type QueryOrganizationServiceAdminOrganizationByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationServiceAllBranchesArgs = {
  input: OrganizationServiceGetBranchesGqlInput;
};


export type QueryOrganizationServiceBranchByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationServiceBranchByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryOrganizationServiceBranchesArgs = {
  input: OrganizationServiceGetBranchesGqlInput;
};


export type QueryOrganizationServiceGetByDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryPaymentServiceTransactionByIdForAdminArgs = {
  id: Scalars['String']['input'];
};


export type QueryPaymentServiceTransactionsForAdminArgs = {
  pagination: PaginationArgs;
};


export type QueryPaymentServiceUserSubscriptionTransactionArgs = {
  transactionId: Scalars['String']['input'];
};


export type QueryPaymentServiceUserSubscriptionTransactionsArgs = {
  pagination: PaginationArgs;
};


export type QueryPaymentServiceVendorArgs = {
  code: PaymentServiceVendor;
};


export type QueryPaymentServiceVendorForAdminArgs = {
  code: PaymentServiceVendor;
};


export type QueryPaymentServiceVendorsArgs = {
  pagination: PaginationArgs;
};


export type QueryPaymentServiceVendorsForAdminArgs = {
  pagination: PaginationArgs;
};


export type QueryPointServiceAllPointExpiryRulesArgs = {
  pagination: PaginationArgs;
};


export type QueryPointServiceCountPointTransactionsByUserIdArgs = {
  input: PointServiceCountPointTransactionsByUserIdGqlInput;
};


export type QueryPointServiceGetPointBalanceByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryPointServiceGetPointBalanceByUserIdArgs = {
  input: PointServiceGetPointBalanceByUserIdGqlInput;
};


export type QueryPointServiceMyPointTransactionsArgs = {
  filter?: InputMaybe<PointServiceMyPointTransactionsFilterGqlInput>;
  pagination: PaginationArgs;
};


export type QueryPointServicePointExpiryRuleByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryPointServicePointExpiryRulesByLoyaltyProgramIdArgs = {
  loyaltyProgramId: Scalars['String']['input'];
};


export type QueryPointServicePointTransactionsByUserIdArgs = {
  filter?: InputMaybe<PointServiceMyPointTransactionsFilterGqlInput>;
  pagination: PaginationArgs;
  userId: Scalars['String']['input'];
};


export type QueryProductServiceAllBrandsArgs = {
  pagination: PaginationArgs;
};


export type QueryProductServiceAllProductsArgs = {
  pagination: PaginationArgs;
};


export type QueryProductServiceBrandByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductServiceCategoryByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductServiceColorByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryProductServiceColorByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductServiceDisabledProductsArgs = {
  pagination: PaginationArgs;
};


export type QueryProductServiceEnabledBrandsArgs = {
  pagination: PaginationArgs;
};


export type QueryProductServiceEnabledProductsArgs = {
  pagination: PaginationArgs;
};


export type QueryProductServiceFeaturedProductsArgs = {
  pagination: PaginationArgs;
};


export type QueryProductServiceLatestProductsArgs = {
  pagination: PaginationArgs;
};


export type QueryProductServiceProductByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductServiceProductByIdForAdminArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductServicePublicProductsArgs = {
  pagination: PaginationArgs;
};


export type QueryProductServicePublicSubCategoriesArgs = {
  parentId: Scalars['String']['input'];
};


export type QueryProductServiceSearchProductsArgs = {
  input: ProductServiceSearchProductGqlInput;
  pagination: PaginationArgs;
};


export type QueryProductServiceSearchProductsForAdminArgs = {
  input: ProductServiceSearchProductsForAdminGqlInput;
  pagination: PaginationArgs;
};


export type QueryProductServiceSubCategoriesArgs = {
  parentId: Scalars['String']['input'];
};


export type QueryRatingServiceCheckFavoriteStatusArgs = {
  input: RatingServiceCheckGqlInput;
};


export type QueryRatingServiceCheckRatingStatusArgs = {
  input: RatingServiceCheckRatingStatusGqlInput;
};


export type QueryRatingServiceGetMyFavoritesArgs = {
  input?: InputMaybe<RatingServiceGetFavoritesGqlInput>;
  pagination: PaginationArgs;
};


export type QueryRatingServiceGetRatingDetailsArgs = {
  id: Scalars['String']['input'];
};


export type QueryRatingServiceGetRatingsByFilterArgs = {
  input?: InputMaybe<RatingServiceGetRatingsGqlInput>;
  pagination: PaginationArgs;
};


export type QueryRatingServiceMyRatingsArgs = {
  pagination: PaginationArgs;
};


export type QueryRatingServiceRatingSummaryArgs = {
  referenceId: Scalars['String']['input'];
  referenceType: RatingReferenceTypeEnum;
};


export type QueryRbacServiceRoleByIdArgs = {
  roleId: Scalars['String']['input'];
};


export type QueryRbacServiceUserRolesArgs = {
  userIds: Array<Scalars['String']['input']>;
};


export type QueryReferralServiceCommissionHistoryArgs = {
  input?: InputMaybe<PaginationArgs>;
};


export type QueryReferralServiceReferralTreeForAgencyArgs = {
  input: GetReferralTreeInput;
};


export type QueryReferralServiceReferralTreeForOrganizationArgs = {
  input: GetReferralTreeInput;
};


export type QuerySduiServiceBlockArgs = {
  id: Scalars['String']['input'];
};


export type QuerySduiServiceBlockByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QuerySduiServiceGetLayoutDetailArgs = {
  id: Scalars['String']['input'];
};


export type QuerySduiServicePageArgs = {
  id: Scalars['String']['input'];
};


export type QuerySduiServicePageByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QuerySearchCompaniesArgs = {
  input: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryShippingServiceShippingMethodsAvailableArgs = {
  address: Scalars['String']['input'];
  cartIds: Array<Scalars['String']['input']>;
  provinceId: Scalars['String']['input'];
  wardId: Scalars['String']['input'];
};


export type QueryStorageServiceGetFileMetadataArgs = {
  id: Scalars['String']['input'];
};


export type QuerySubscriptionServiceAllPackagesArgs = {
  currency: PaymentServiceCurrencyEnum;
  pagination: PaginationArgs;
};


export type QuerySubscriptionServiceAllPackagesForAdminArgs = {
  pagination: PaginationArgs;
};


export type QuerySubscriptionServiceAuditEventsArgs = {
  params?: InputMaybe<SubscriptionServiceAuditEventListParamsGqlInput>;
};


export type QuerySubscriptionServiceBillingTransactionsArgs = {
  params?: InputMaybe<SubscriptionServiceBillingTransactionListParamsGqlInput>;
};


export type QuerySubscriptionServicePackageArgs = {
  currency: PaymentServiceCurrencyEnum;
  packageId: Scalars['String']['input'];
};


export type QuerySubscriptionServicePackageForAdminArgs = {
  packageId: Scalars['String']['input'];
};


export type QuerySubscriptionServicePlanArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubscriptionServicePlansArgs = {
  params?: InputMaybe<SubscriptionServicePlanListParamsGqlInput>;
};


export type QuerySubscriptionServiceSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySubscriptionServiceSubscriptionByTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type QuerySubscriptionServiceSubscriptionsArgs = {
  params?: InputMaybe<SubscriptionServiceSubscriptionListParamsGqlInput>;
};


export type QuerySubscriptionServiceUsageMetricsArgs = {
  params?: InputMaybe<SubscriptionServiceUsageMetricListParamsGqlInput>;
};


export type QueryTaskServiceAllDependenciesArgs = {
  pagination: PaginationArgs;
};


export type QueryTaskServiceAllFoldersArgs = {
  pagination: PaginationArgs;
};


export type QueryTaskServiceAllListsArgs = {
  pagination: PaginationArgs;
};


export type QueryTaskServiceAllSpacesArgs = {
  pagination: PaginationArgs;
};


export type QueryTaskServiceAllTasksArgs = {
  pagination: PaginationArgs;
};


export type QueryTaskServiceAllWorkspacesArgs = {
  pagination: PaginationArgs;
};


export type QueryTaskServiceBlockedTasksArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryTaskServiceBlockingTasksArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryTaskServiceDependenciesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryTaskServiceDependenciesByTaskArgs = {
  pagination: PaginationArgs;
  taskId: Scalars['String']['input'];
};


export type QueryTaskServiceDependenciesByTypeArgs = {
  pagination: PaginationArgs;
  type: Scalars['String']['input'];
};


export type QueryTaskServiceDependenciesFromTaskArgs = {
  fromTaskId: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryTaskServiceDependenciesToTaskArgs = {
  pagination: PaginationArgs;
  toTaskId: Scalars['String']['input'];
};


export type QueryTaskServiceDependencyArgs = {
  id: Scalars['String']['input'];
};


export type QueryTaskServiceFolderArgs = {
  id: Scalars['String']['input'];
};


export type QueryTaskServiceFoldersArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryTaskServiceFoldersBySpaceArgs = {
  pagination: PaginationArgs;
  spaceId: Scalars['String']['input'];
};


export type QueryTaskServiceListArgs = {
  id: Scalars['String']['input'];
};


export type QueryTaskServiceListsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryTaskServiceListsByFolderArgs = {
  folderId: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryTaskServiceListsBySpaceArgs = {
  pagination: PaginationArgs;
  spaceId: Scalars['String']['input'];
};


export type QueryTaskServiceOverdueTasksArgs = {
  pagination: PaginationArgs;
};


export type QueryTaskServiceSearchFoldersArgs = {
  input: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryTaskServiceSearchListsArgs = {
  input: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryTaskServiceSearchSpacesArgs = {
  input: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryTaskServiceSearchTasksArgs = {
  input: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryTaskServiceSearchWorkspacesArgs = {
  input: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryTaskServiceSpaceArgs = {
  id: Scalars['String']['input'];
};


export type QueryTaskServiceSpacesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryTaskServiceSpacesByWorkspaceArgs = {
  pagination: PaginationArgs;
  workspaceId: Scalars['String']['input'];
};


export type QueryTaskServiceSubtasksArgs = {
  pagination: PaginationArgs;
  parentId: Scalars['String']['input'];
};


export type QueryTaskServiceTaskArgs = {
  id: Scalars['String']['input'];
};


export type QueryTaskServiceTasksArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryTaskServiceTasksByAssigneeArgs = {
  assigneeId: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryTaskServiceTasksByListArgs = {
  listId: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryTaskServiceTasksByPriorityArgs = {
  pagination: PaginationArgs;
  priority: Scalars['String']['input'];
};


export type QueryTaskServiceTasksByStatusArgs = {
  pagination: PaginationArgs;
  status: Scalars['String']['input'];
};


export type QueryTaskServiceWorkspaceArgs = {
  id: Scalars['String']['input'];
};


export type QueryTaskServiceWorkspacesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryTaskServiceWorkspacesByMemberArgs = {
  memberId: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryTaskServiceWorkspacesByOwnerArgs = {
  ownerId: Scalars['String']['input'];
  pagination: PaginationArgs;
};


export type QueryTemplateServiceGetApprovedTemplateArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplateServiceGetEditingTemplateArgs = {
  templateId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplateServiceGetTemplateArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplateServiceGetTemplateHistoryArgs = {
  templateId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplateServiceGetTemplatesByTemplateIdArgs = {
  templateId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplateServiceListApprovedTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplateServiceListTemplateIdsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplateServiceListTemplatesArgs = {
  filter?: InputMaybe<TemplateServiceTemplateFilterInput>;
};


export type QueryTemplateServiceValidateVariablesArgs = {
  input?: InputMaybe<TemplateServiceValidateVariablesInput>;
};


export type QueryTicketServiceAllTicketLogsArgs = {
  pagination: PaginationArgs;
};


export type QueryTicketServiceAllTicketsArgs = {
  pagination: PaginationArgs;
};


export type QueryTicketServiceCustomerArgs = {
  id: Scalars['String']['input'];
};


export type QueryTicketServiceCustomerByCodeArgs = {
  customerCode: Scalars['String']['input'];
};


export type QueryTicketServiceSearchCustomersArgs = {
  searchInput: SearchCustomerInput;
};


export type QueryTicketServiceSearchTicketLogsArgs = {
  pagination: PaginationArgs;
  searchTerm: Scalars['String']['input'];
};


export type QueryTicketServiceSearchTicketsArgs = {
  pagination: PaginationArgs;
  searchTerm: Scalars['String']['input'];
};


export type QueryTicketServiceTicketArgs = {
  id: Scalars['String']['input'];
};


export type QueryTicketServiceTicketLogArgs = {
  id: Scalars['String']['input'];
};


export type QueryTicketServiceTicketLogsArgs = {
  ticketId: Scalars['String']['input'];
};


export type QueryTicketServiceTicketLogsByActionTypeArgs = {
  actionType: TicketLogActionType;
  ticketId: Scalars['String']['input'];
};


export type QueryTicketServiceTicketLogsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryTicketServiceTicketLogsByPerformerArgs = {
  performedBy: Scalars['String']['input'];
  ticketId: Scalars['String']['input'];
};


export type QueryTicketServiceTicketsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryUserServiceAdminAllTenantArgs = {
  input: PaginationArgs;
  organizationId: Scalars['String']['input'];
};


export type QueryUserServiceAllTenantArgs = {
  input: UserServiceGetTenantsGqlInput;
};


export type QueryUserServiceAllUserOfTenantArgs = {
  input: PaginationArgs;
};


export type QueryUserServiceAllZaloUserOfTenantArgs = {
  input: UserServiceGetZaloUsersGqlInput;
};


export type QueryUserServiceGetUserByIdForAdminArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserServiceGetUserByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryUserServiceTenantByDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryUserServiceTenantIdFromDomainArgs = {
  domain: Scalars['String']['input'];
};


export type QueryUserServiceUsersByTypeArgs = {
  input?: InputMaybe<UserServiceFindUsersByTypeInput>;
  pagination: PaginationArgs;
};


export type QueryUserServiceUsersOfTenantForAdminArgs = {
  input?: InputMaybe<UserServiceFindUsersForAdminInput>;
  pagination: PaginationArgs;
};


export type QueryVoucherServiceAllVoucherTypesArgs = {
  pagination: PaginationArgs;
};


export type QueryVoucherServiceAllVouchersArgs = {
  pagination: PaginationArgs;
};


export type QueryVoucherServiceDeletedVoucherTypesArgs = {
  pagination: PaginationArgs;
};


export type QueryVoucherServiceDisabledVoucherTypesArgs = {
  pagination: PaginationArgs;
};


export type QueryVoucherServiceDisabledVouchersArgs = {
  pagination: PaginationArgs;
};


export type QueryVoucherServiceEnabledVoucherTypesArgs = {
  pagination: PaginationArgs;
};


export type QueryVoucherServiceEnabledVouchersArgs = {
  pagination: PaginationArgs;
};


export type QueryVoucherServiceLoyaltyVoucherTypeArgs = {
  pagination: PaginationArgs;
};


export type QueryVoucherServiceMyVouchersArgs = {
  filter?: InputMaybe<VoucherServiceMyVouchersFilterGqlInput>;
  pagination: PaginationArgs;
};


export type QueryVoucherServiceRedeemableVoucherTypesArgs = {
  pagination: PaginationArgs;
};


export type QueryVoucherServiceSearchVouchersArgs = {
  pagination: PaginationArgs;
  search: Scalars['String']['input'];
};


export type QueryVoucherServiceVoucherByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryVoucherServiceVoucherTypeByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryVoucherServiceVouchersByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};

export enum QuestionTypeEnum {
  MultipleChoice = 'MultipleChoice',
  WordOrder = 'WordOrder'
}

export enum QuizModeEnum {
  Instant = 'Instant',
  SubmitAll = 'SubmitAll'
}

export type RatingAdvancedFiltersGqlInput = {
  hasComment?: InputMaybe<Scalars['Boolean']['input']>;
  ratingRange?: InputMaybe<RatingRangeGqlInput>;
};

export type RatingRangeGqlInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export enum RatingReferenceTypeEnum {
  Driver = 'Driver',
  Employee = 'Employee',
  Product = 'Product',
  Trip = 'Trip',
  User = 'User'
}

export type RatingServiceCheckGqlInput = {
  referenceId: Scalars['String']['input'];
  referenceType: RatingReferenceTypeEnum;
};

export type RatingServiceCheckGqlOutput = {
  __typename?: 'RatingServiceCheckGqlOutput';
  /** Favorite record ID if favorited */
  favoriteId?: Maybe<Scalars['String']['output']>;
  /** Whether user has favorited this item */
  isFavorited: Scalars['Boolean']['output'];
};

export type RatingServiceCheckRatingStatusGqlInput = {
  referenceId: Scalars['String']['input'];
  referenceType: RatingReferenceTypeEnum;
};

export type RatingServiceCheckRatingStatusGqlOutput = {
  __typename?: 'RatingServiceCheckRatingStatusGqlOutput';
  hasRated: Scalars['Boolean']['output'];
  rating?: Maybe<RatingServiceRatingGqlOutput>;
};

export type RatingServiceCreateRatingGqlInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  mediaUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  rating: Scalars['Int']['input'];
  referenceId: Scalars['String']['input'];
  referenceType: RatingReferenceTypeEnum;
};

export type RatingServiceFavoriteGqlOutput = {
  __typename?: 'RatingServiceFavoriteGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  isFavorited: Scalars['Boolean']['output'];
  referenceId: Scalars['String']['output'];
  referenceType: RatingReferenceTypeEnum;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type RatingServiceFavoritesGqlOutput = {
  __typename?: 'RatingServiceFavoritesGqlOutput';
  /** Array of user's favorites */
  data: Array<RatingServiceFavoriteGqlOutput>;
  /** Total number of favorites */
  total: Scalars['Int']['output'];
};

export type RatingServiceGetFavoritesGqlInput = {
  referenceType?: InputMaybe<RatingReferenceTypeEnum>;
};

export type RatingServiceGetRatingsGqlInput = {
  filters?: InputMaybe<RatingAdvancedFiltersGqlInput>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  referenceType?: InputMaybe<RatingReferenceTypeEnum>;
  sort?: InputMaybe<RatingSortGqlInput>;
};

export type RatingServiceMyRatingsGqlOutput = {
  __typename?: 'RatingServiceMyRatingsGqlOutput';
  data: Array<RatingServiceMyRatingsItemGqlOutput>;
  total: Scalars['Int']['output'];
};

export type RatingServiceMyRatingsItemGqlOutput = {
  __typename?: 'RatingServiceMyRatingsItemGqlOutput';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  mediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  rating: Scalars['Int']['output'];
  referenceId: Scalars['String']['output'];
  referenceType: RatingReferenceTypeEnum;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type RatingServiceRatingGqlOutput = {
  __typename?: 'RatingServiceRatingGqlOutput';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  mediaUrls?: Maybe<Array<Scalars['String']['output']>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  rating: Scalars['Int']['output'];
  referenceId: Scalars['String']['output'];
  referenceType: RatingReferenceTypeEnum;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type RatingServiceRatingSummaryGqlOutput = {
  __typename?: 'RatingServiceRatingSummaryGqlOutput';
  averageRating: Scalars['Float']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  ratingDistribution: Scalars['JSON']['output'];
  referenceId: Scalars['String']['output'];
  referenceType: RatingReferenceTypeEnum;
  tenantId?: Maybe<Scalars['String']['output']>;
  totalComments: Scalars['Int']['output'];
  totalRatings: Scalars['Int']['output'];
  totalScores: Scalars['Int']['output'];
};

export type RatingServiceRatingsGqlOutput = {
  __typename?: 'RatingServiceRatingsGqlOutput';
  /** Array of found items */
  data: Array<RatingServiceRatingGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type RatingServiceToggleFavoriteGqlInput = {
  referenceId: Scalars['String']['input'];
  referenceType: RatingReferenceTypeEnum;
};

export type RatingServiceToggleFavoriteGqlOutput = {
  __typename?: 'RatingServiceToggleFavoriteGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Current favorite status after toggle */
  isFavorited: Scalars['Boolean']['output'];
  referenceId: Scalars['String']['output'];
  referenceType: RatingReferenceTypeEnum;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
};

export type RatingServiceUpdateRatingGqlInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  mediaUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
};

/** Available fields to sort ratings by */
export enum RatingSortFieldEnum {
  Rating = 'Rating',
  UpdatedAt = 'UpdatedAt'
}

export type RatingSortGqlInput = {
  sortBy?: InputMaybe<RatingSortFieldEnum>;
  sortDirection?: InputMaybe<SortDirectionArgs>;
};

export type RbacServiceAssignRoleGqlInput = {
  roleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RbacServiceCreateRoleGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  permissions: Array<RbacServicePermissionGqlInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type RbacServicePermissionGqlInput = {
  action: Scalars['String']['input'];
  possession: Scalars['String']['input'];
  resource: Scalars['String']['input'];
};

export type RbacServiceRoleGqlOutput = {
  __typename?: 'RbacServiceRoleGqlOutput';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  permissions: Array<PermissionGqlOutput>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RbacServiceUpdateRoleGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<RbacServicePermissionGqlInput>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export enum RecurrenceType {
  Annually = 'Annually',
  Custom = 'Custom',
  Daily = 'Daily',
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

export type RedeemedVoucher = {
  __typename?: 'RedeemedVoucher';
  code: Scalars['String']['output'];
  discountAmount: Scalars['Float']['output'];
  message?: Maybe<Scalars['String']['output']>;
  redemptionCount: Scalars['Int']['output'];
  voucherId: Scalars['String']['output'];
};

export type RedemptionRules = {
  __typename?: 'RedemptionRules';
  minimumPoints: Scalars['Float']['output'];
  pointValue: Scalars['Float']['output'];
};

export type RedemptionRulesInput = {
  minimumPoints: Scalars['Int']['input'];
  pointValue: Scalars['Int']['input'];
};

export type ReferralCodeOutput = {
  __typename?: 'ReferralCodeOutput';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  usageCount: Scalars['Int']['output'];
};

export type ReferralConfigInput = {
  allowCustomCodes: Scalars['Boolean']['input'];
  codePrefix: Scalars['String']['input'];
  commissionRates: Array<CommissionRateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  maxLevels: Scalars['Int']['input'];
  minPayoutAmount: Scalars['String']['input'];
  rewardVoucherTypeIds?: InputMaybe<Array<RewardVoucherTypeInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  voucherTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type ReferralConfigOutput = {
  __typename?: 'ReferralConfigOutput';
  allowCustomCodes: Scalars['Boolean']['output'];
  codePrefix: Scalars['String']['output'];
  commissionRates: Array<CommissionRateOutput>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  maxLevels: Scalars['Int']['output'];
  minPayoutAmount: Scalars['String']['output'];
  rewardVoucherTypeIds?: Maybe<Array<RewardVoucherTypeOutput>>;
  title?: Maybe<Scalars['String']['output']>;
  voucherTypeId?: Maybe<Scalars['String']['output']>;
};

export type ReferralProcessingInput = {
  amount: Scalars['String']['input'];
  sourceReference: Scalars['String']['input'];
  sourceType: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ReferralProcessingOutput = {
  __typename?: 'ReferralProcessingOutput';
  commissionsProcessed: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  totalCommissionDistributed: Scalars['String']['output'];
};

export type ReferralStatisticsOutput = {
  __typename?: 'ReferralStatisticsOutput';
  pendingCommissions: Scalars['String']['output'];
  thisMonthCommission: Scalars['String']['output'];
  thisMonthReferrals: Scalars['Int']['output'];
  totalCommissionEarned: Scalars['String']['output'];
  totalReferrals: Scalars['Int']['output'];
};

export type ReferralTreeNodeOutput = {
  __typename?: 'ReferralTreeNodeOutput';
  children: Array<ReferralTreeNodeOutput>;
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  level?: Maybe<Scalars['Int']['output']>;
  totalCommissionEarned: Scalars['String']['output'];
  totalReferrals: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type ReferralTreeOutput = {
  __typename?: 'ReferralTreeOutput';
  children: Array<ReferralTreeNodeOutput>;
  totalCommissionEarned: Scalars['String']['output'];
  totalReferrals: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type RewardVoucherTypeInput = {
  qty: Scalars['Int']['input'];
  voucherTypeId: Scalars['String']['input'];
};

export type RewardVoucherTypeOutput = {
  __typename?: 'RewardVoucherTypeOutput';
  qty: Scalars['Int']['output'];
  voucherTypeId: Scalars['String']['output'];
};

export enum Role {
  Readonly = 'READONLY',
  Support = 'SUPPORT',
  SysAdmin = 'SYS_ADMIN',
  TenantAdmin = 'TENANT_ADMIN'
}

export type SaveReferralInput = {
  referralCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SaveReferralOutput = {
  __typename?: 'SaveReferralOutput';
  level: Scalars['Int']['output'];
  parentUserId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SduiServiceActionInput = {
  route?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SduiServiceActionOutput = {
  __typename?: 'SduiServiceActionOutput';
  route?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SduiServiceBannerComponentInput = {
  action?: InputMaybe<SduiServiceActionInput>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SduiServiceBannerComponentOutput = {
  __typename?: 'SduiServiceBannerComponentOutput';
  action?: Maybe<SduiServiceActionOutput>;
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type SduiServiceBlockConfigGqlInput = {
  key: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SduiServiceBlockConfigGqlOutput = {
  __typename?: 'SduiServiceBlockConfigGqlOutput';
  key: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SduiServiceBlockGqlOutput = {
  __typename?: 'SduiServiceBlockGqlOutput';
  code?: Maybe<Scalars['String']['output']>;
  configs?: Maybe<Array<SduiServiceBlockConfigGqlOutput>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SduiServiceBottomNavBarComponentInput = {
  items: Array<SduiServiceBottomNavBarItemInput>;
  selectedIndex?: InputMaybe<Scalars['Float']['input']>;
};

export type SduiServiceBottomNavBarComponentOutput = {
  __typename?: 'SduiServiceBottomNavBarComponentOutput';
  items?: Maybe<Array<SduiServiceBottomNavBarItemOutput>>;
  selectedIndex?: Maybe<Scalars['Float']['output']>;
};

export type SduiServiceBottomNavBarItemInput = {
  action?: InputMaybe<SduiServiceActionInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type SduiServiceBottomNavBarItemOutput = {
  __typename?: 'SduiServiceBottomNavBarItemOutput';
  action?: Maybe<SduiServiceActionOutput>;
  icon?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type SduiServiceComponentInput = {
  banner: SduiServiceBannerComponentInput;
  bottomNavBar: SduiServiceBottomNavBarComponentInput;
};

export type SduiServiceComponentOutput = {
  __typename?: 'SduiServiceComponentOutput';
  banner?: Maybe<SduiServiceBannerComponentOutput>;
  bottomNavBar?: Maybe<SduiServiceBottomNavBarComponentOutput>;
};

export type SduiServiceCreateBlockGqlInput = {
  code: Scalars['String']['input'];
  configs?: InputMaybe<Array<SduiServiceBlockConfigGqlInput>>;
};

export type SduiServiceCreateLayoutGqlInput = {
  components: SduiServiceComponentInput;
  layoutId: Scalars['String']['input'];
  modules: Array<SduiServiceModuleInput>;
  tenantId: Scalars['String']['input'];
  theme: SduiServiceThemeInput;
};

export type SduiServiceCreatePageGqlInput = {
  blocks?: InputMaybe<Array<SduiServicePageBlockGqlInput>>;
  key: Scalars['String']['input'];
};

export type SduiServiceCustomFieldInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  fieldValue?: InputMaybe<Scalars['String']['input']>;
};

export type SduiServiceCustomFieldOutput = {
  __typename?: 'SduiServiceCustomFieldOutput';
  fieldName?: Maybe<Scalars['String']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  fieldValue?: Maybe<Scalars['String']['output']>;
};

export type SduiServiceLayoutGqlOutput = {
  __typename?: 'SduiServiceLayoutGqlOutput';
  components?: Maybe<SduiServiceComponentOutput>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customFields?: Maybe<Array<SduiServiceCustomFieldOutput>>;
  id?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  layoutId?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<SduiServiceModuleOutput>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<SduiServiceThemeOutput>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SduiServiceModuleInput = {
  action: SduiServiceActionInput;
  featureCode?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  isShow?: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SduiServiceModuleOutput = {
  __typename?: 'SduiServiceModuleOutput';
  action?: Maybe<SduiServiceActionOutput>;
  featureCode?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  isShow?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SduiServicePageBlockConfigGqlInput = {
  key: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SduiServicePageBlockConfigGqlOutput = {
  __typename?: 'SduiServicePageBlockConfigGqlOutput';
  key: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SduiServicePageBlockGqlInput = {
  block?: InputMaybe<Scalars['String']['input']>;
  configs?: InputMaybe<Array<SduiServicePageBlockConfigGqlInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SduiServicePageBlockGqlOutput = {
  __typename?: 'SduiServicePageBlockGqlOutput';
  block?: Maybe<Scalars['String']['output']>;
  configs?: Maybe<Array<SduiServicePageBlockConfigGqlOutput>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SduiServicePageGqlOutput = {
  __typename?: 'SduiServicePageGqlOutput';
  blocks?: Maybe<Array<SduiServicePageBlockGqlOutput>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SduiServiceThemeInput = {
  backgroundColor: Scalars['String']['input'];
  buttonStyle: Scalars['String']['input'];
  color: Scalars['String']['input'];
  fontFamily: Scalars['String']['input'];
  fontSize: Scalars['String']['input'];
  primaryColor: Scalars['String']['input'];
  secondaryColor: Scalars['String']['input'];
  themeName: Scalars['String']['input'];
};

export type SduiServiceThemeOutput = {
  __typename?: 'SduiServiceThemeOutput';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  buttonStyle?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  themeName?: Maybe<Scalars['String']['output']>;
};

export type SduiServiceUpdateBlockGqlInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  configs?: InputMaybe<Array<SduiServiceBlockConfigGqlInput>>;
};

export type SduiServiceUpdateComponentInput = {
  banner: SduiServiceBannerComponentInput;
};

export type SduiServiceUpdateLayoutGqlInput = {
  components: SduiServiceComponentInput;
  customFields?: InputMaybe<Array<SduiServiceCustomFieldInput>>;
  modules: Array<SduiServiceModuleInput>;
  theme: SduiServiceThemeInput;
};

export type SduiServiceUpdatePageGqlInput = {
  blocks?: InputMaybe<Array<SduiServicePageBlockGqlInput>>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type SduiServiceUpdateTenantLayoutGqlInput = {
  components: SduiServiceUpdateComponentInput;
  customFields?: InputMaybe<Array<SduiServiceCustomFieldInput>>;
};

export type SearchCustomerInput = {
  /** Filter customers registered from this date */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter customers registered until this date */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by customer priority */
  priority?: InputMaybe<CustomerVariantPriority>;
  /** Search by customer code, name, phone, or email */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** Filter by customer status */
  status?: InputMaybe<CustomerVariantStatus>;
  /** Filter by customer type */
  type?: InputMaybe<CustomerVariantType>;
};

export type SendSmsMessageResponse = {
  __typename?: 'SendSmsMessageResponse';
  data?: Maybe<Scalars['Map']['output']>;
  messageID?: Maybe<Scalars['String']['output']>;
  resultCode: Scalars['Int']['output'];
  resultMessage: Scalars['String']['output'];
  trackingID?: Maybe<Scalars['String']['output']>;
};

export type SendViberMessageResponse = {
  __typename?: 'SendViberMessageResponse';
  data?: Maybe<Scalars['Map']['output']>;
  messageID?: Maybe<Scalars['String']['output']>;
  resultCode: Scalars['Int']['output'];
  resultMessage: Scalars['String']['output'];
  trackingID?: Maybe<Scalars['String']['output']>;
};

export type SendZnsMessageResponse = {
  __typename?: 'SendZnsMessageResponse';
  data?: Maybe<Scalars['Map']['output']>;
  resultCode: Scalars['Int']['output'];
  resultMessage: Scalars['String']['output'];
  trackingID?: Maybe<Scalars['String']['output']>;
};

export type SentenceInput = {
  lessonSpeakingId: Scalars['String']['input'];
  sentenceId: Scalars['String']['input'];
};

/** Available ZMA microservices for inter-service communication */
export enum ServiceName {
  Affiliate = 'AFFILIATE',
  ApiHub = 'API_HUB',
  Auth = 'AUTH',
  Booking = 'BOOKING',
  Campaign = 'CAMPAIGN',
  Cart = 'CART',
  Checkin = 'CHECKIN',
  Clockin = 'CLOCKIN',
  Content = 'CONTENT',
  Dictionary = 'DICTIONARY',
  Event = 'EVENT',
  FeatureFlag = 'FEATURE_FLAG',
  Fns = 'FNS',
  Inventory = 'INVENTORY',
  LarvaCourse = 'LARVA_COURSE',
  Loyalty = 'LOYALTY',
  Membership = 'MEMBERSHIP',
  Order = 'ORDER',
  Organization = 'ORGANIZATION',
  Payment = 'PAYMENT',
  Point = 'POINT',
  Product = 'PRODUCT',
  Referral = 'REFERRAL',
  Shipping = 'SHIPPING',
  Storage = 'STORAGE',
  Subscription = 'SUBSCRIPTION',
  Ticket = 'TICKET',
  User = 'USER',
  Voucher = 'VOUCHER'
}

export type ShippingServiceProviderGqlOutput = {
  __typename?: 'ShippingServiceProviderGqlOutput';
  description: Scalars['String']['output'];
  fixedPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type ShippingServiceShippingMethodGqlOutput = {
  __typename?: 'ShippingServiceShippingMethodGqlOutput';
  amount: Scalars['Float']['output'];
  amountFormatted: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerLogoUrl: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SmsConfig = {
  __typename?: 'SmsConfig';
  apiKey: Scalars['String']['output'];
  apiSecret?: Maybe<Scalars['String']['output']>;
  brandName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  maxRetry: Scalars['Int']['output'];
  priority: Scalars['Int']['output'];
  providerName: Scalars['String']['output'];
  tenantID?: Maybe<Scalars['String']['output']>;
  timeout: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type SmsConfigList = {
  __typename?: 'SmsConfigList';
  configs: Array<SmsConfig>;
  total: Scalars['Int']['output'];
};

export type SmsMessageLog = {
  __typename?: 'SmsMessageLog';
  brandName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  messageID?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  resultCode: Scalars['Int']['output'];
  resultMessage?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  tenantID?: Maybe<Scalars['String']['output']>;
  trackingID: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type SmsMessageLogList = {
  __typename?: 'SmsMessageLogList';
  messages: Array<SmsMessageLog>;
  total: Scalars['Int']['output'];
};

/** Sort direction for ordering query results */
export enum SortDirectionArgs {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortFieldArgs = {
  /** Sort direction for this field */
  direction?: SortDirectionArgs;
  /** Field name to sort by */
  field: Scalars['String']['input'];
};

export enum StorageProviderType {
  R2 = 'R2',
  S3 = 'S3'
}

export type StorageServiceFileMetadataGqlOutput = {
  __typename?: 'StorageServiceFileMetadataGqlOutput';
  bucketKey?: Maybe<Scalars['String']['output']>;
  bucketName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  ownerEntityId?: Maybe<Scalars['String']['output']>;
  ownerService?: Maybe<ServiceName>;
  provider?: Maybe<StorageProviderType>;
  sizeInBytes?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<StorageStatusType>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum StorageStatusType {
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending',
  Processing = 'Processing',
  Quarantined = 'Quarantined'
}

export type SubscriptionServiceAuditEventGqlOutput = {
  __typename?: 'SubscriptionServiceAuditEventGqlOutput';
  changes: Scalars['JSON']['output'];
  correlationId: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  eventType: SubscriptionServiceEventType;
  id: Scalars['ID']['output'];
  initiatedBy: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  reason: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type SubscriptionServiceAuditEventListGqlOutput = {
  __typename?: 'SubscriptionServiceAuditEventListGqlOutput';
  events: Array<SubscriptionServiceAuditEventGqlOutput>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SubscriptionServiceAuditEventListParamsGqlInput = {
  eventType?: InputMaybe<SubscriptionServiceEventType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export enum SubscriptionServiceBillingCycle {
  Custom = 'CUSTOM',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type SubscriptionServiceBillingGqlOutput = {
  __typename?: 'SubscriptionServiceBillingGqlOutput';
  billingDate: Scalars['Int']['output'];
  currentPeriod: SubscriptionServiceBillingPeriodGqlOutput;
  cycle: SubscriptionServiceBillingCycle;
  nextBillingDate: Scalars['Time']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionServiceBillingPeriodGqlOutput = {
  __typename?: 'SubscriptionServiceBillingPeriodGqlOutput';
  end: Scalars['Time']['output'];
  start: Scalars['Time']['output'];
};

export type SubscriptionServiceBillingTransactionGqlOutput = {
  __typename?: 'SubscriptionServiceBillingTransactionGqlOutput';
  amount: Scalars['Money']['output'];
  billingPeriod: SubscriptionServiceBillingPeriodGqlOutput;
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoice: SubscriptionServiceInvoiceGqlOutput;
  payment: SubscriptionServicePaymentInfoGqlOutput;
  processedAt: Scalars['Time']['output'];
  processedBy: Scalars['String']['output'];
  retryCount: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SubscriptionServiceBillingTransactionListGqlOutput = {
  __typename?: 'SubscriptionServiceBillingTransactionListGqlOutput';
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  transactions: Array<SubscriptionServiceBillingTransactionGqlOutput>;
};

export type SubscriptionServiceBillingTransactionListParamsGqlInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionServiceCancelSubscriptionGqlInput = {
  effectiveDate?: InputMaybe<Scalars['Time']['input']>;
  reason: Scalars['String']['input'];
  refundAmount?: InputMaybe<Scalars['Money']['input']>;
  sendCancellationEmail: Scalars['Boolean']['input'];
};

export type SubscriptionServiceChangeEventGqlOutput = {
  __typename?: 'SubscriptionServiceChangeEventGqlOutput';
  action: Scalars['String']['output'];
  actor: Scalars['String']['output'];
  details: Scalars['JSON']['output'];
  timestamp: Scalars['Time']['output'];
};

export type SubscriptionServiceCreatePackageGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  isTrial?: Scalars['Boolean']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  paymentMethods?: InputMaybe<Array<PaymentServiceVendor>>;
  pricings: Array<SubscriptionServicePricingGqlInput>;
  upgradeablePackages?: Array<Scalars['String']['input']>;
};

export type SubscriptionServiceCreatePlanBillingGqlInput = {
  cycles: Array<SubscriptionServiceBillingCycle>;
  downgradeProration?: InputMaybe<SubscriptionServiceProrationLogic>;
  proration: Scalars['Boolean']['input'];
  upgradeProration?: InputMaybe<SubscriptionServiceProrationLogic>;
};

export type SubscriptionServiceCreatePlanGqlInput = {
  billing: SubscriptionServiceCreatePlanBillingGqlInput;
  category: Scalars['String']['input'];
  code: Scalars['String']['input'];
  customMetadata?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  features: Scalars['JSON']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
  pricing: SubscriptionServiceCreatePlanPricingGqlInput;
  roles: Array<Scalars['String']['input']>;
  usageMetrics: Array<Scalars['String']['input']>;
};

export type SubscriptionServiceCreatePlanPricingGqlInput = {
  monthly?: InputMaybe<Scalars['Money']['input']>;
  setupFee?: InputMaybe<Scalars['Money']['input']>;
  trial?: InputMaybe<SubscriptionServiceCreateTrialPricingGqlInput>;
  yearly?: InputMaybe<Scalars['Money']['input']>;
};

export type SubscriptionServiceCreateSubscriptionGqlInput = {
  billingCycle: SubscriptionServiceBillingCycle;
  customMetadata?: InputMaybe<Scalars['JSON']['input']>;
  customerId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  trialDays?: InputMaybe<Scalars['Int']['input']>;
};

export type SubscriptionServiceCreateTrialPricingGqlInput = {
  autoConvert: Scalars['Boolean']['input'];
  days: Scalars['Int']['input'];
};

export type SubscriptionServiceCreateUserSubscriptionGqlInput = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  packageId: Scalars['String']['input'];
  pricingId: Scalars['String']['input'];
  vendor: PaymentServiceVendor;
};

export type SubscriptionServiceCreateUserSubscriptionGqlOutput = {
  __typename?: 'SubscriptionServiceCreateUserSubscriptionGqlOutput';
  isPaymentRequired?: Maybe<Scalars['Boolean']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  userSubscriptionId: Scalars['String']['output'];
};

export enum SubscriptionServiceEventType {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Downgraded = 'DOWNGRADED',
  Paused = 'PAUSED',
  PaymentFailed = 'PAYMENT_FAILED',
  PaymentRecovered = 'PAYMENT_RECOVERED',
  Renewed = 'RENEWED',
  Resumed = 'RESUMED',
  TrialExpired = 'TRIAL_EXPIRED',
  TrialStarted = 'TRIAL_STARTED',
  Upgraded = 'UPGRADED'
}

export enum SubscriptionServiceFeatureType {
  Boolean = 'BOOLEAN',
  Granted = 'GRANTED',
  Limit = 'LIMIT'
}

export type SubscriptionServiceFinancialGqlOutput = {
  __typename?: 'SubscriptionServiceFinancialGqlOutput';
  creditsApplied: Scalars['Money']['output'];
  currency: Scalars['String']['output'];
  discounts: Scalars['JSON']['output'];
  proratedAmount: Scalars['Money']['output'];
  taxes: Scalars['JSON']['output'];
  totalAmount: Scalars['Money']['output'];
};

export type SubscriptionServiceGetUserSubscriptionGqlOutput = {
  __typename?: 'SubscriptionServiceGetUserSubscriptionGqlOutput';
  autoRenew?: Maybe<Scalars['Boolean']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currencyPaid?: Maybe<PaymentServiceCurrencyEnum>;
  duration?: Maybe<Scalars['Float']['output']>;
  durationUnit?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  nextBillingDate?: Maybe<Scalars['DateTime']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  pricePaid?: Maybe<Scalars['Float']['output']>;
  pricing?: Maybe<SubscriptionServicePackagePriceGqlOutput>;
  pricingName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionServiceInvoiceGqlOutput = {
  __typename?: 'SubscriptionServiceInvoiceGqlOutput';
  dueDate: Scalars['Time']['output'];
  items: Array<SubscriptionServiceInvoiceItemGqlOutput>;
  number: Scalars['String']['output'];
  subtotal: Scalars['Money']['output'];
  taxes: Scalars['JSON']['output'];
  total: Scalars['Money']['output'];
};

export type SubscriptionServiceInvoiceItemGqlOutput = {
  __typename?: 'SubscriptionServiceInvoiceItemGqlOutput';
  description: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  total: Scalars['Money']['output'];
  unitPrice: Scalars['Money']['output'];
};

export type SubscriptionServicePackageGqlOutput = {
  __typename?: 'SubscriptionServicePackageGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isTrial?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentMethods?: Maybe<Array<PaymentServiceVendor>>;
  pricings?: Maybe<Array<SubscriptionServicePackagePriceGqlOutput>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upgradeablePackages?: Maybe<Array<Scalars['String']['output']>>;
};

export type SubscriptionServicePackagePriceGqlOutput = {
  __typename?: 'SubscriptionServicePackagePriceGqlOutput';
  amount?: Maybe<Scalars['Float']['output']>;
  appleProductId?: Maybe<Scalars['String']['output']>;
  billingCycle?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<PaymentServiceCurrencyEnum>;
  duration?: Maybe<Scalars['Float']['output']>;
  durationUnit?: Maybe<Scalars['String']['output']>;
  googleProductId?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pricingId?: Maybe<Scalars['String']['output']>;
  trialPeriodDays?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionServicePaymentInfoGqlOutput = {
  __typename?: 'SubscriptionServicePaymentInfoGqlOutput';
  gateway: Scalars['String']['output'];
  invoiceId: Scalars['String']['output'];
  method: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type SubscriptionServicePlanBillingGqlOutput = {
  __typename?: 'SubscriptionServicePlanBillingGqlOutput';
  cycles: Array<SubscriptionServiceBillingCycle>;
  downgradeProration?: Maybe<SubscriptionServiceProrationLogic>;
  proration: Scalars['Boolean']['output'];
  upgradeProration?: Maybe<SubscriptionServiceProrationLogic>;
};

export type SubscriptionServicePlanGqlOutput = {
  __typename?: 'SubscriptionServicePlanGqlOutput';
  billing: SubscriptionServicePlanBillingGqlOutput;
  category: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  features: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  pricing: SubscriptionServicePlanPricingGqlOutput;
  roles: Array<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  usageMetrics: Array<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type SubscriptionServicePlanListGqlOutput = {
  __typename?: 'SubscriptionServicePlanListGqlOutput';
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  plans: Array<SubscriptionServicePlanGqlOutput>;
  total: Scalars['Int']['output'];
};

export type SubscriptionServicePlanListParamsGqlInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionServicePlanPricingGqlOutput = {
  __typename?: 'SubscriptionServicePlanPricingGqlOutput';
  monthly?: Maybe<Scalars['Money']['output']>;
  setupFee?: Maybe<Scalars['Money']['output']>;
  trial?: Maybe<SubscriptionServiceTrialPricingGqlOutput>;
  yearly?: Maybe<Scalars['Money']['output']>;
};

export enum SubscriptionServicePlanType {
  Basic = 'BASIC',
  Custom = 'CUSTOM',
  Enterprise = 'ENTERPRISE',
  Pro = 'PRO'
}

export type SubscriptionServicePricingGqlInput = {
  amount: Scalars['Float']['input'];
  appleProductId?: InputMaybe<Scalars['String']['input']>;
  billingCycle: PackageBillingCycleType;
  currency: PaymentServiceCurrencyEnum;
  duration: Scalars['Float']['input'];
  durationUnit: PackageDurationUnitType;
  googleProductId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionServiceProrationCalculationGqlInput = {
  billingCycle?: InputMaybe<SubscriptionServiceBillingCycle>;
  prorationLogic?: InputMaybe<SubscriptionServiceProrationLogic>;
  targetPlanId: Scalars['String']['input'];
};

export enum SubscriptionServiceProrationLogic {
  Credit = 'CREDIT',
  Full = 'FULL',
  Prorata = 'PRORATA'
}

export enum SubscriptionServiceState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Suspended = 'SUSPENDED',
  Trial = 'TRIAL'
}

export type SubscriptionServiceSubscriptionGqlOutput = {
  __typename?: 'SubscriptionServiceSubscriptionGqlOutput';
  billing: SubscriptionServiceBillingGqlOutput;
  changeHistory: Array<SubscriptionServiceChangeEventGqlOutput>;
  createdAt: Scalars['Time']['output'];
  customerId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['Time']['output']>;
  financial: SubscriptionServiceFinancialGqlOutput;
  id: Scalars['ID']['output'];
  planId: Scalars['String']['output'];
  planName: Scalars['String']['output'];
  planVersion: Scalars['Int']['output'];
  state: SubscriptionServiceState;
  tenantId: Scalars['String']['output'];
  trialInfo?: Maybe<SubscriptionServiceTrialInfoGqlOutput>;
  updatedAt: Scalars['Time']['output'];
  usage: SubscriptionServiceUsageGqlOutput;
};

export type SubscriptionServiceSubscriptionListGqlOutput = {
  __typename?: 'SubscriptionServiceSubscriptionListGqlOutput';
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  subscriptions: Array<SubscriptionServiceSubscriptionGqlOutput>;
  total: Scalars['Int']['output'];
};

export type SubscriptionServiceSubscriptionListParamsGqlInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<SubscriptionServiceState>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionServiceTrialInfoGqlOutput = {
  __typename?: 'SubscriptionServiceTrialInfoGqlOutput';
  autoConvert: Scalars['Boolean']['output'];
  endsAt?: Maybe<Scalars['Time']['output']>;
  isActive: Scalars['Boolean']['output'];
  startedAt?: Maybe<Scalars['Time']['output']>;
};

export type SubscriptionServiceTrialPricingGqlOutput = {
  __typename?: 'SubscriptionServiceTrialPricingGqlOutput';
  autoConvert: Scalars['Boolean']['output'];
  days: Scalars['Int']['output'];
};

export type SubscriptionServiceUpdatePackageGqlInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isTrial?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<Array<PaymentServiceVendor>>;
  pricings?: InputMaybe<Array<SubscriptionServicePricingGqlInput>>;
  upgradeablePackages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubscriptionServiceUpdatePlanGqlInput = {
  billing?: InputMaybe<SubscriptionServiceCreatePlanBillingGqlInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  customMetadata?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Scalars['JSON']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  pricing?: InputMaybe<SubscriptionServiceCreatePlanPricingGqlInput>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  usageMetrics?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubscriptionServiceUpdateSubscriptionGqlInput = {
  customMetadata?: InputMaybe<Scalars['JSON']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionServiceUsageAlertGqlOutput = {
  __typename?: 'SubscriptionServiceUsageAlertGqlOutput';
  current: Scalars['Int']['output'];
  metric: Scalars['String']['output'];
  threshold: Scalars['Int']['output'];
  triggeredAt: Scalars['Time']['output'];
};

export type SubscriptionServiceUsageGqlOutput = {
  __typename?: 'SubscriptionServiceUsageGqlOutput';
  alerts: Array<SubscriptionServiceUsageAlertGqlOutput>;
  metrics: Scalars['JSON']['output'];
  period: SubscriptionServiceBillingPeriodGqlOutput;
};

export type SubscriptionServiceUsageMetricGqlOutput = {
  __typename?: 'SubscriptionServiceUsageMetricGqlOutput';
  alertTriggered: Scalars['Boolean']['output'];
  cost: Scalars['Money']['output'];
  id: Scalars['ID']['output'];
  isOverage: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  metric: Scalars['String']['output'];
  period: SubscriptionServiceBillingPeriodGqlOutput;
  source: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  timestamp: Scalars['Time']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type SubscriptionServiceUsageMetricListGqlOutput = {
  __typename?: 'SubscriptionServiceUsageMetricListGqlOutput';
  limit: Scalars['Int']['output'];
  metrics: Array<SubscriptionServiceUsageMetricGqlOutput>;
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SubscriptionServiceUsageMetricListParamsGqlInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  metric?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  periodEnd?: InputMaybe<Scalars['Time']['input']>;
  periodStart?: InputMaybe<Scalars['Time']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};

/** Available question types for surveys */
export enum SurveyQuestionType {
  Cta = 'CTA',
  MultipleChoice = 'MultipleChoice',
  Rating = 'Rating',
  SingleChoice = 'SingleChoice',
  Text = 'Text',
  YesNo = 'YesNo'
}

/** Types of surveys */
export enum SurveyType {
  CustomerEffortScore = 'CustomerEffortScore',
  CustomerSatisfactionScore = 'CustomerSatisfactionScore',
  NetPromoterScore = 'NetPromoterScore',
  Onboarding = 'Onboarding',
  OpenFeedback = 'OpenFeedback',
  ProductMarketFit = 'ProductMarketFit',
  UserInterview = 'UserInterview'
}

/** Available UI templates for surveys */
export enum SurveyUiTemplate {
  Cta = 'CTA',
  Default = 'Default',
  Emoji = 'Emoji',
  Faces = 'Faces',
  Scale = 'Scale',
  Stars = 'Stars'
}

export type SyncResult = {
  __typename?: 'SyncResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SystemHealth = {
  __typename?: 'SystemHealth';
  mongodb: HealthStatus;
  redis: HealthStatus;
  status: Scalars['String']['output'];
  timestamp: Scalars['Time']['output'];
  uptime: Scalars['Int']['output'];
  version: Scalars['String']['output'];
  zaloAPI: HealthStatus;
};

export type SystemSettings = {
  __typename?: 'SystemSettings';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
  value: Scalars['String']['output'];
};

export type TaskServiceActivityGqlOutput = {
  __typename?: 'TaskServiceActivityGqlOutput';
  event?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type TaskServiceActivityInput = {
  event: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
  userId: Scalars['String']['input'];
};

export type TaskServiceCommentGqlOutput = {
  __typename?: 'TaskServiceCommentGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export type TaskServiceCommentInput = {
  createdAt: Scalars['DateTime']['input'];
  text: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type TaskServiceCreateDependencyGqlInput = {
  fromTaskId: Scalars['String']['input'];
  toTaskId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type TaskServiceCreateFolderGqlInput = {
  lists?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};

export type TaskServiceCreateListGqlInput = {
  folderId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
  tasks?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TaskServiceCreateSpaceGqlInput = {
  clickApps?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultViews?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  requiredViews?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<TaskServiceSpaceStatusesInput>;
  workspaceId: Scalars['String']['input'];
};

export type TaskServiceCreateTaskGqlInput = {
  activity?: InputMaybe<Array<TaskServiceActivityInput>>;
  assignees?: InputMaybe<Array<Scalars['String']['input']>>;
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  comments?: InputMaybe<Array<TaskServiceCommentInput>>;
  createdBy: Scalars['String']['input'];
  customFields?: InputMaybe<Array<TaskServiceCustomFieldInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  listId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  timeEstimate?: InputMaybe<Scalars['Int']['input']>;
  timeTracked?: InputMaybe<TaskServiceTimeTrackedInput>;
  updatedBy: Scalars['String']['input'];
};

export type TaskServiceCreateWorkspaceGqlInput = {
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  spaces?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TaskServiceCustomFieldGqlOutput = {
  __typename?: 'TaskServiceCustomFieldGqlOutput';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TaskServiceCustomFieldInput = {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TaskServiceDependencyGqlOutput = {
  __typename?: 'TaskServiceDependencyGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fromTaskId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  toTaskId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TaskServiceFolderGqlOutput = {
  __typename?: 'TaskServiceFolderGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lists?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  spaceId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TaskServiceListGqlOutput = {
  __typename?: 'TaskServiceListGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  folderId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  spaceId?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<Scalars['String']['output']>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TaskServiceSpaceGqlOutput = {
  __typename?: 'TaskServiceSpaceGqlOutput';
  clickApps?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  defaultViews?: Maybe<Array<Scalars['String']['output']>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requiredViews?: Maybe<Array<Scalars['String']['output']>>;
  statuses?: Maybe<TaskServiceSpaceStatusesGqlOutput>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type TaskServiceSpaceStatusesGqlOutput = {
  __typename?: 'TaskServiceSpaceStatusesGqlOutput';
  active?: Maybe<Array<Scalars['String']['output']>>;
  closed?: Maybe<Array<Scalars['String']['output']>>;
  done?: Maybe<Array<Scalars['String']['output']>>;
};

export type TaskServiceSpaceStatusesInput = {
  active: Array<Scalars['String']['input']>;
  closed: Array<Scalars['String']['input']>;
  done: Array<Scalars['String']['input']>;
};

export type TaskServiceTaskGqlOutput = {
  __typename?: 'TaskServiceTaskGqlOutput';
  activity?: Maybe<Array<TaskServiceActivityGqlOutput>>;
  assignees?: Maybe<Array<Scalars['String']['output']>>;
  attachments?: Maybe<Array<Scalars['String']['output']>>;
  comments?: Maybe<Array<TaskServiceCommentGqlOutput>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Array<TaskServiceCustomFieldGqlOutput>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  listId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  timeEstimate?: Maybe<Scalars['Int']['output']>;
  timeTracked?: Maybe<TaskServiceTimeTrackedGqlOutput>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TaskServiceTimeLogGqlOutput = {
  __typename?: 'TaskServiceTimeLogGqlOutput';
  duration?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type TaskServiceTimeLogInput = {
  duration: Scalars['Int']['input'];
  timestamp: Scalars['DateTime']['input'];
  userId: Scalars['String']['input'];
};

export type TaskServiceTimeTrackedGqlOutput = {
  __typename?: 'TaskServiceTimeTrackedGqlOutput';
  logs?: Maybe<Array<TaskServiceTimeLogGqlOutput>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TaskServiceTimeTrackedInput = {
  logs: Array<TaskServiceTimeLogInput>;
  total: Scalars['Int']['input'];
};

export type TaskServiceUpdateDependencyGqlInput = {
  fromTaskId?: InputMaybe<Scalars['String']['input']>;
  toTaskId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TaskServiceUpdateFolderGqlInput = {
  lists?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
};

export type TaskServiceUpdateListGqlInput = {
  folderId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TaskServiceUpdateSpaceGqlInput = {
  clickApps?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultViews?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredViews?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<TaskServiceSpaceStatusesInput>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type TaskServiceUpdateTaskGqlInput = {
  activity?: InputMaybe<Array<TaskServiceActivityInput>>;
  assignees?: InputMaybe<Array<Scalars['String']['input']>>;
  attachments?: InputMaybe<Array<Scalars['String']['input']>>;
  comments?: InputMaybe<Array<TaskServiceCommentInput>>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Array<TaskServiceCustomFieldInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  listId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  timeEstimate?: InputMaybe<Scalars['Int']['input']>;
  timeTracked?: InputMaybe<TaskServiceTimeTrackedInput>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type TaskServiceUpdateWorkspaceGqlInput = {
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  spaces?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TaskServiceWorkspaceGqlOutput = {
  __typename?: 'TaskServiceWorkspaceGqlOutput';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  members?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  spaces?: Maybe<Array<Scalars['String']['output']>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TemplateServiceApproveTemplateInput = {
  approvedBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateServiceCreateTemplateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  templateCode?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TemplateServiceRejectTemplateInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  rejectedBy?: InputMaybe<Scalars['String']['input']>;
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateServiceRollbackTemplateInput = {
  rolledBackBy?: InputMaybe<Scalars['String']['input']>;
  targetVersion?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateServiceSubmitTemplateInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  submittedBy?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateServiceTemplate = {
  __typename?: 'TemplateServiceTemplate';
  approvedAt?: Maybe<Scalars['Time']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rejectedReason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TemplateServiceTemplateStatus>;
  templateCode?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  variables?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type TemplateServiceTemplateFilterInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TemplateServiceTemplateStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateServiceTemplateIdItem = {
  __typename?: 'TemplateServiceTemplateIdItem';
  createdAt?: Maybe<Scalars['Time']['output']>;
  templateCode?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
};

export type TemplateServiceTemplateIdList = {
  __typename?: 'TemplateServiceTemplateIdList';
  templateIds?: Maybe<Array<Maybe<TemplateServiceTemplateIdItem>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TemplateServiceTemplateList = {
  __typename?: 'TemplateServiceTemplateList';
  templates?: Maybe<Array<Maybe<TemplateServiceTemplate>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum TemplateServiceTemplateStatus {
  Approved = 'approved',
  Archived = 'archived',
  Draft = 'draft',
  Pending = 'pending',
  Rejected = 'rejected'
}

export type TemplateServiceUpdateTemplateInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TemplateServiceValidateVariablesInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TemplateServiceVariableValidation = {
  __typename?: 'TemplateServiceVariableValidation';
  isValid?: Maybe<Scalars['Boolean']['output']>;
  missingVariables?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unusedVariables?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Ticket */
export type Ticket = {
  __typename?: 'Ticket';
  _id: Scalars['ID']['output'];
  /** _id of User (responsible technician or staff) */
  assignedTo?: Maybe<Scalars['ID']['output']>;
  /** Array of sub-document containing comments */
  comments: Array<TicketComment>;
  /** Ticket creation time */
  createdAt: Scalars['DateTime']['output'];
  /** _id of User (ticket creator) */
  createdBy: Scalars['ID']['output'];
  /** _id of Customer (ticket originator) */
  customerId: Scalars['ID']['output'];
  /** Responsible department */
  department: Scalars['String']['output'];
  /** Short description of the issue or reason for creating the ticket */
  description: Scalars['String']['output'];
  /** Array of string URL or path */
  imgUrls: Array<Scalars['String']['output']>;
  /** Array of ObjectId referencing TicketLog */
  logs: Array<Scalars['ID']['output']>;
  /** Priority */
  priority: TicketVariantPriority;
  /** _id of ProductInstance (related device) */
  productInstanceId: Scalars['ID']['output'];
  /** Scheduled maintenance date */
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
  /** Ticket status */
  status: TicketVariantStatus;
  /** Unique ticket code */
  ticketCode: Scalars['String']['output'];
  /** Ticket type */
  type: TicketVariantType;
  /** Last update time */
  updatedAt: Scalars['DateTime']['output'];
};

export type TicketComment = {
  __typename?: 'TicketComment';
  _id: Scalars['ID']['output'];
  /** _id of User (comment author) */
  authorId: Scalars['ID']['output'];
  /** Comment content */
  content: Scalars['String']['output'];
  /** Comment time */
  createdAt: Scalars['DateTime']['output'];
  /** Array of image URL or path */
  imgUrls: Array<Scalars['String']['output']>;
};

/** Ticket Log */
export type TicketLog = {
  __typename?: 'TicketLog';
  _id: Scalars['ID']['output'];
  /** Action type */
  actionType: TicketLogActionType;
  /** Action record time */
  createdAt: Scalars['DateTime']['output'];
  /** Detailed action description */
  description: Scalars['String']['output'];
  /** Value before change */
  fromValue?: Maybe<Scalars['String']['output']>;
  /** _id of User who performed the action */
  performedBy: Scalars['ID']['output'];
  /** Reference to _id of Ticket */
  ticketId: Scalars['ID']['output'];
  /** Value after change */
  toValue?: Maybe<Scalars['String']['output']>;
};

export enum TicketLogActionType {
  Assign = 'Assign',
  CommentAdded = 'CommentAdded',
  Create = 'Create',
  Deleted = 'Deleted',
  DepartmentChange = 'DepartmentChange',
  DescriptionChange = 'DescriptionChange',
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  ImgAdded = 'ImgAdded',
  PriorityChange = 'PriorityChange',
  StatusChange = 'StatusChange',
  Updated = 'Updated'
}

export enum TicketVariantPriority {
  Critical = 'Critical',
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export enum TicketVariantStatus {
  Closed = 'Closed',
  InProgress = 'InProgress',
  Open = 'Open',
  PendingCustomer = 'PendingCustomer',
  Resolved = 'Resolved'
}

export enum TicketVariantType {
  Corrective = 'Corrective',
  Predictive = 'Predictive',
  Preventive = 'Preventive',
  Unplanned = 'Unplanned'
}

export enum TierEnum {
  Bronze = 'Bronze',
  Gold = 'Gold',
  Silver = 'Silver',
  Unranked = 'Unranked'
}

export type UpdateAnswerItemInput = {
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlockTemplateInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  defaultProps?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  propsSchema?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantType?: InputMaybe<BlockTenantType>;
  type?: InputMaybe<BlockTypeEnum>;
};

export type UpdateCustomerInput = {
  /** Customer address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Contact email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Customer name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Contact phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Customer priority level */
  priority?: InputMaybe<CustomerVariantPriority>;
  /** Array of ProductInstance ObjectIds */
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Customer status */
  status?: InputMaybe<CustomerVariantStatus>;
  /** Customer type */
  type?: InputMaybe<CustomerVariantType>;
};

export type UpdatePointConfigInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  moneyAmount?: InputMaybe<Scalars['Float']['input']>;
  pointsPerUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateTicketInput = {
  /** _id of User (responsible technician or staff) */
  assignedTo?: InputMaybe<Scalars['ID']['input']>;
  /** Responsible department */
  department?: InputMaybe<Scalars['String']['input']>;
  /** Short description of the issue */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Array of image URLs */
  imgUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Priority */
  priority?: InputMaybe<TicketVariantPriority>;
  /** Scheduled maintenance date */
  scheduledDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Ticket status */
  status?: InputMaybe<TicketVariantStatus>;
  /** Ticket type */
  type?: InputMaybe<TicketVariantType>;
};

export type UploadServiceCompleteGqlInput = {
  fileId: Scalars['String']['input'];
};

export type UploadServiceCompleteGqlOutput = {
  __typename?: 'UploadServiceCompleteGqlOutput';
  fileUrl: Scalars['String']['output'];
  status: StorageStatusType;
};

export type UploadServiceRequestGqlInput = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  ownerEntityId: Scalars['String']['input'];
  ownerService: ServiceName;
};

export type UploadServiceRequestGqlOutput = {
  __typename?: 'UploadServiceRequestGqlOutput';
  fileId: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

/** URL shortening provider options */
export enum UrlShortenerProvider {
  Bitly = 'Bitly',
  Custom = 'Custom',
  None = 'None',
  Rebrandly = 'Rebrandly',
  TinyUrl = 'TinyUrl'
}

export type UrlShortenerProviderInfo = {
  __typename?: 'UrlShortenerProviderInfo';
  description: Scalars['String']['output'];
  isConfigured: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  provider: UrlShortenerProvider;
  requiresApiKey: Scalars['Boolean']['output'];
  supportsCustomSlug: Scalars['Boolean']['output'];
};

export type UrlShortenerProvidersOutput = {
  __typename?: 'UrlShortenerProvidersOutput';
  defaultProvider: UrlShortenerProvider;
  providers: Array<UrlShortenerProviderInfo>;
};

export type UseReferralCodeInput = {
  referralCode: Scalars['String']['input'];
};

export type UseReferralCodeOutput = {
  __typename?: 'UseReferralCodeOutput';
  level?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  parentUserId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  voucher?: Maybe<Scalars['String']['output']>;
};

export type UserServiceCreateBasicUserGqlInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
};

export type UserServiceCreateTenantGqlInput = {
  banner?: InputMaybe<Scalars['String']['input']>;
  checkoutPrivateKey?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  favicon?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  miniAppUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  oaId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  registerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  zaloAppId: Scalars['String']['input'];
  zaloAppSecret: Scalars['String']['input'];
};

export type UserServiceCreateUserGqlInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
};

export type UserServiceFindUsersByTypeInput = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<UserServiceUserStatus>>;
  type: UserServiceUserType;
};

export type UserServiceFindUsersForAdminInput = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<UserServiceUserStatus>>;
};

/** Available gender options for user profiles */
export enum UserServiceGender {
  Female = 'Female',
  Male = 'Male'
}

export type UserServiceGetTenantsGqlInput = {
  /** Maximum number of items to return (1-100) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Number of items to skip (offset) */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Multiple sort fields for complex sorting */
  sort?: InputMaybe<Array<SortFieldArgs>>;
  sortBy?: InputMaybe<UserServiceTenantSortFieldArgs>;
  sortDirection?: InputMaybe<SortDirectionArgs>;
  status?: InputMaybe<UserServiceTenantStatus>;
};

export type UserServiceGetZaloUsersGqlInput = {
  /** Maximum number of items to return (1-100) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Number of items to skip (offset) */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Multiple sort fields for complex sorting */
  sort?: InputMaybe<Array<SortFieldArgs>>;
  sortBy?: InputMaybe<UserServiceUserSortFieldArgs>;
  sortDirection?: InputMaybe<SortDirectionArgs>;
  status?: InputMaybe<UserServiceUserStatus>;
};

export type UserServiceSocialProviderGqlOutput = {
  __typename?: 'UserServiceSocialProviderGqlOutput';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type UserServiceSocialProvidersGqlOutput = {
  __typename?: 'UserServiceSocialProvidersGqlOutput';
  facebook?: Maybe<UserServiceSocialProviderGqlOutput>;
  google?: Maybe<UserServiceSocialProviderGqlOutput>;
};

export enum UserServiceTenantBillingStatus {
  Cancelled = 'Cancelled',
  Overdue = 'Overdue',
  Paid = 'Paid',
  Trial = 'Trial'
}

export type UserServiceTenantGqlOutput = {
  __typename?: 'UserServiceTenantGqlOutput';
  banner?: Maybe<Scalars['String']['output']>;
  billingStatus: UserServiceTenantBillingStatus;
  checkoutPrivateKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  miniAppUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  oaId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  registerEnabled?: Maybe<Scalars['Boolean']['output']>;
  status: UserServiceTenantStatus;
  title?: Maybe<Scalars['String']['output']>;
  type: UserServiceTenantType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  zaloAppId: Scalars['String']['output'];
  zaloAppSecret: Scalars['String']['output'];
};

/** Available fields for sorting tenants in queries */
export enum UserServiceTenantSortFieldArgs {
  CreatedAt = 'CreatedAt',
  Name = 'Name',
  Status = 'Status',
  UpdatedAt = 'UpdatedAt'
}

/** Tenant account status values (active, inactive, suspended, etc.) */
export enum UserServiceTenantStatus {
  Active = 'Active',
  Archived = 'Archived',
  Disabled = 'Disabled',
  Pending = 'Pending',
  Suspended = 'Suspended'
}

export type UserServiceTenantStatusGqlInput = {
  id: Scalars['String']['input'];
  status: UserServiceTenantStatus;
};

/** Tenant type classifications (enterprise, standard, etc.) */
export enum UserServiceTenantType {
  Base = 'Base',
  Enterprise = 'Enterprise',
  Pro = 'Pro'
}

export type UserServiceTenantTypeGqlInput = {
  id: Scalars['String']['input'];
  type: UserServiceTenantType;
};

export type UserServiceUpdateAvatarGqlInput = {
  avatarUrl: Scalars['String']['input'];
};

export type UserServiceUpdateProfileGqlInput = {
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<UserServiceGender>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UserServiceUpdateTenantGqlInput = {
  banner?: InputMaybe<Scalars['String']['input']>;
  checkoutPrivateKey?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  favicon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  miniAppUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  oaId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  registerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  zaloAppId: Scalars['String']['input'];
  zaloAppSecret: Scalars['String']['input'];
};

export type UserServiceUpdateZaloOaIdGqlInput = {
  zaloOAId: Scalars['String']['input'];
};

export type UserServiceUserGqlOutput = {
  __typename?: 'UserServiceUserGqlOutput';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  failedLoginAttempts?: Maybe<Scalars['Float']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<UserServiceGender>;
  id: Scalars['String']['output'];
  lastActive?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  resetToken?: Maybe<Scalars['String']['output']>;
  resetTokenExpiry?: Maybe<Scalars['String']['output']>;
  socialProviders?: Maybe<UserServiceSocialProvidersGqlOutput>;
  status: UserServiceUserStatus;
  tenantId?: Maybe<Scalars['String']['output']>;
  type: UserServiceUserType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  verificationCode?: Maybe<Scalars['String']['output']>;
  zaloId?: Maybe<Scalars['String']['output']>;
  zaloOAId?: Maybe<Scalars['String']['output']>;
};

/** Available fields for sorting users in queries */
export enum UserServiceUserSortFieldArgs {
  CreatedAt = 'CreatedAt',
  Email = 'Email',
  FirstName = 'FirstName',
  LastName = 'LastName',
  Status = 'Status',
  UpdatedAt = 'UpdatedAt'
}

/** User account status values (active, inactive, suspended, etc.) */
export enum UserServiceUserStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending',
  Suspended = 'Suspended'
}

/** User type classifications (admin, regular user, etc.) */
export enum UserServiceUserType {
  Admin = 'Admin',
  Agency = 'Agency',
  OrganizationAdmin = 'OrganizationAdmin',
  TenantAdmin = 'TenantAdmin',
  User = 'User',
  Zalo = 'Zalo'
}

export type UserServiceUsersGqlOutput = {
  __typename?: 'UserServiceUsersGqlOutput';
  /** Array of found items */
  data: Array<UserServiceUserGqlOutput>;
  /** Total number of items */
  total: Scalars['Int']['output'];
};

export type UtmParametersInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type UtmParametersOutput = {
  __typename?: 'UtmParametersOutput';
  campaign?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

export type UtmParametersTrackingInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type UtmParametersTrackingOutput = {
  __typename?: 'UtmParametersTrackingOutput';
  campaign?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

export type ViberConfig = {
  __typename?: 'ViberConfig';
  apiToken: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  maxRetry: Scalars['Int']['output'];
  priority: Scalars['Int']['output'];
  senderName: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  tenantID?: Maybe<Scalars['String']['output']>;
  timeout: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type ViberConfigList = {
  __typename?: 'ViberConfigList';
  configs: Array<ViberConfig>;
  total: Scalars['Int']['output'];
};

export type ViberMessageLog = {
  __typename?: 'ViberMessageLog';
  createdAt: Scalars['Time']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  messageID?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  resultCode: Scalars['Int']['output'];
  resultMessage?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  tenantID?: Maybe<Scalars['String']['output']>;
  trackingID: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type ViberMessageLogList = {
  __typename?: 'ViberMessageLogList';
  messages: Array<ViberMessageLog>;
  total: Scalars['Int']['output'];
};

export type VoucherApplicationResult = {
  __typename?: 'VoucherApplicationResult';
  applicableProductIds?: Maybe<Array<Scalars['String']['output']>>;
  discountAmount: Scalars['Float']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  isApplicable: Scalars['Boolean']['output'];
  productDiscounts?: Maybe<Array<ProductDiscountDetail>>;
  reservation?: Maybe<VoucherReservation>;
};

export type VoucherDetail = {
  __typename?: 'VoucherDetail';
  applicationResult: VoucherApplicationResult;
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountType: VoucherDiscountType;
  discountValue: Scalars['Float']['output'];
  maximumDiscount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  voucherId: Scalars['String']['output'];
};

/** The type of discount offered by the voucher */
export enum VoucherDiscountType {
  Bogo = 'Bogo',
  FixedAmount = 'FixedAmount',
  FreeItem = 'FreeItem',
  FreeShipping = 'FreeShipping',
  Percentage = 'Percentage'
}

export type VoucherReservation = {
  __typename?: 'VoucherReservation';
  expiryDate: Scalars['DateTime']['output'];
  reservationId: Scalars['String']['output'];
};

export type VoucherServiceBulkIssueAllGqlInput = {
  voucherTypeId: Scalars['String']['input'];
};

export type VoucherServiceBulkIssueGqlInput = {
  userIds: Array<Scalars['String']['input']>;
  voucherTypeId: Scalars['String']['input'];
};

export type VoucherServiceCreateVoucherGqlInput = {
  applicableCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  applicableLoyaltyTierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  applicableProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discountType: Scalars['String']['input'];
  discountValue: Scalars['Float']['input'];
  endDate: Scalars['DateTime']['input'];
  excludedProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  isStackable?: Scalars['Boolean']['input'];
  issueDate: Scalars['DateTime']['input'];
  maximumDiscount?: InputMaybe<Scalars['Float']['input']>;
  minimumPurchase?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  redeemedDate?: InputMaybe<Scalars['DateTime']['input']>;
  redeemedOrderId?: InputMaybe<Scalars['String']['input']>;
  redemptionCount?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
  userId: Scalars['String']['input'];
  voucherTypeId: Scalars['String']['input'];
};

export type VoucherServiceCreateVoucherTypeGqlInput = {
  applicableCategoryIds?: Array<Scalars['String']['input']>;
  applicableLoyaltyTierIds?: Array<Scalars['String']['input']>;
  applicableProductIds?: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountType: VoucherDiscountType;
  discountValue: Scalars['Float']['input'];
  excludedProductIds?: Array<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: Scalars['Boolean']['input'];
  isSharedCode?: Scalars['Boolean']['input'];
  isStackable?: Scalars['Boolean']['input'];
  issuedLimitPerUser?: InputMaybe<Scalars['Float']['input']>;
  maximumDiscount?: InputMaybe<Scalars['Float']['input']>;
  minimumPurchase?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  redemptionLimitPerUser?: InputMaybe<Scalars['Float']['input']>;
  termsAndConditions?: Scalars['String']['input'];
  totalIssuedLimit?: InputMaybe<Scalars['Float']['input']>;
  totalRedemptionLimit?: InputMaybe<Scalars['Float']['input']>;
  validityDays?: Scalars['Float']['input'];
};

export type VoucherServiceMyVouchersFilterGqlInput = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<VoucherDiscountType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  redemptionCount?: InputMaybe<Scalars['Int']['input']>;
  voucherTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherServiceRedeemableVoucherTypeGqlOutput = {
  __typename?: 'VoucherServiceRedeemableVoucherTypeGqlOutput';
  applicableCategoryIds: Array<Scalars['String']['output']>;
  applicableLoyaltyTierIds: Array<Scalars['String']['output']>;
  applicableProductIds: Array<Scalars['String']['output']>;
  canRedeem?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountType: VoucherDiscountType;
  discountValue: Scalars['Float']['output'];
  excludedProductIds: Array<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isRedeemableWithPoints: Scalars['Boolean']['output'];
  isSharedCode: Scalars['Boolean']['output'];
  isStackable: Scalars['Boolean']['output'];
  issuedLimitPerUser?: Maybe<Scalars['Int']['output']>;
  maximumDiscount?: Maybe<Scalars['Float']['output']>;
  minimumPurchase: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  pointsRequired?: Maybe<Scalars['Int']['output']>;
  redemptionLimitPerUser?: Maybe<Scalars['Int']['output']>;
  sharedCode?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  termsAndConditions: Scalars['String']['output'];
  totalIssuedCount: Scalars['Int']['output'];
  totalIssuedLimit?: Maybe<Scalars['Int']['output']>;
  totalRedemptionCount: Scalars['Int']['output'];
  totalRedemptionLimit?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userRedemptionCount?: Maybe<Scalars['Int']['output']>;
  validityDays: Scalars['Int']['output'];
};

export type VoucherServiceUpdateVoucherGqlInput = {
  applicableCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  applicableLoyaltyTierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  applicableProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  campaignId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discountType: Scalars['String']['input'];
  discountValue: Scalars['Float']['input'];
  endDate: Scalars['DateTime']['input'];
  excludedProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  isStackable?: Scalars['Boolean']['input'];
  issueDate: Scalars['DateTime']['input'];
  maximumDiscount?: InputMaybe<Scalars['Float']['input']>;
  minimumPurchase?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  redeemedDate?: InputMaybe<Scalars['DateTime']['input']>;
  redeemedOrderId?: InputMaybe<Scalars['String']['input']>;
  redemptionCount?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
  userId: Scalars['String']['input'];
  voucherTypeId: Scalars['String']['input'];
};

export type VoucherServiceUpdateVoucherTypeGqlInput = {
  applicableCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  applicableLoyaltyTierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  applicableProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<VoucherDiscountType>;
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  excludedProductIds?: InputMaybe<Array<Scalars['String']['input']>>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSharedCode?: InputMaybe<Scalars['Boolean']['input']>;
  isStackable?: InputMaybe<Scalars['Boolean']['input']>;
  issuedLimitPerUser?: InputMaybe<Scalars['Float']['input']>;
  maximumDiscount?: InputMaybe<Scalars['Float']['input']>;
  minimumPurchase?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  redemptionLimitPerUser?: InputMaybe<Scalars['Float']['input']>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  totalIssuedLimit?: InputMaybe<Scalars['Float']['input']>;
  totalRedemptionLimit?: InputMaybe<Scalars['Float']['input']>;
  validityDays?: InputMaybe<Scalars['Float']['input']>;
};

export type VoucherServiceVoucherGqlOutput = {
  __typename?: 'VoucherServiceVoucherGqlOutput';
  applicableCategoryIds: Array<Scalars['String']['output']>;
  applicableLoyaltyTierIds: Array<Scalars['String']['output']>;
  applicableProductIds: Array<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  discountType: VoucherDiscountType;
  discountValue: Scalars['Float']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  excludedProductIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  isStackable: Scalars['Boolean']['output'];
  issueDate: Scalars['DateTime']['output'];
  maximumDiscount?: Maybe<Scalars['Float']['output']>;
  minimumPurchase: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  redeemedDate?: Maybe<Scalars['DateTime']['output']>;
  redeemedOrderId?: Maybe<Scalars['String']['output']>;
  redemptionCount: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  tenantId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['String']['output'];
  voucherTypeId: Scalars['String']['output'];
};

export type VoucherServiceVoucherTypeGqlOutput = {
  __typename?: 'VoucherServiceVoucherTypeGqlOutput';
  applicableCategoryIds: Array<Scalars['String']['output']>;
  applicableLoyaltyTierIds: Array<Scalars['String']['output']>;
  applicableProductIds: Array<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountType: VoucherDiscountType;
  discountValue: Scalars['Float']['output'];
  excludedProductIds: Array<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isRedeemableWithPoints: Scalars['Boolean']['output'];
  isSharedCode: Scalars['Boolean']['output'];
  isStackable: Scalars['Boolean']['output'];
  issuedLimitPerUser?: Maybe<Scalars['Int']['output']>;
  maximumDiscount?: Maybe<Scalars['Float']['output']>;
  minimumPurchase: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  pointsRequired?: Maybe<Scalars['Int']['output']>;
  redemptionLimitPerUser?: Maybe<Scalars['Int']['output']>;
  sharedCode?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
  termsAndConditions: Scalars['String']['output'];
  totalIssuedCount: Scalars['Int']['output'];
  totalIssuedLimit?: Maybe<Scalars['Int']['output']>;
  totalRedemptionCount: Scalars['Int']['output'];
  totalRedemptionLimit?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validityDays: Scalars['Int']['output'];
};

export type VoucherServiceVoucherTypesGqlOutput = {
  __typename?: 'VoucherServiceVoucherTypesGqlOutput';
  data: Array<VoucherServiceVoucherTypeGqlOutput>;
  total: Scalars['Int']['output'];
};

export type VoucherServiceVouchersGqlOutput = {
  __typename?: 'VoucherServiceVouchersGqlOutput';
  data: Array<VoucherServiceVoucherGqlOutput>;
  total: Scalars['Int']['output'];
};

export type WiFiConfigGqlInput = {
  allowedBSSIDs: Array<Scalars['String']['input']>;
  allowedSSIDs: Array<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type WiFiConfigGqlOutput = {
  __typename?: 'WiFiConfigGqlOutput';
  allowedBSSIDs: Array<Scalars['String']['output']>;
  allowedSSIDs: Array<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export type WiFiVerificationGqlOutput = {
  __typename?: 'WiFiVerificationGqlOutput';
  bssid: Scalars['String']['output'];
  ssid: Scalars['String']['output'];
};

export type WordInput = {
  lessonSpeakingId: Scalars['String']['input'];
  partOfSpeech: Scalars['String']['input'];
  word: Scalars['String']['input'];
};

export type ZnsMessage = {
  __typename?: 'ZnsMessage';
  createdAt?: Maybe<Scalars['Time']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phone: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  templateContent?: Maybe<Scalars['String']['output']>;
  templateData: Scalars['Map']['output'];
  templateID: Scalars['String']['output'];
  templateName?: Maybe<Scalars['String']['output']>;
  templateType?: Maybe<Scalars['String']['output']>;
  tenantID?: Maybe<Scalars['String']['output']>;
  trackingID?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  zaloMsgID?: Maybe<Scalars['String']['output']>;
};

export type ZnsMessageList = {
  __typename?: 'ZnsMessageList';
  messages: Array<ZnsMessage>;
  total: Scalars['Int']['output'];
};

export type ZnsMessageLog = {
  __typename?: 'ZnsMessageLog';
  createdAt: Scalars['Time']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phone: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  resultCode: Scalars['Int']['output'];
  resultMessage?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['Time']['output']>;
  status: Scalars['String']['output'];
  templateContent?: Maybe<Scalars['String']['output']>;
  templateData: Scalars['Map']['output'];
  templateID: Scalars['String']['output'];
  templateName?: Maybe<Scalars['String']['output']>;
  templateType?: Maybe<Scalars['String']['output']>;
  tenantID?: Maybe<Scalars['String']['output']>;
  trackingID: Scalars['String']['output'];
  unitPrice?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  zaloMsgID?: Maybe<Scalars['String']['output']>;
};

export type ZnsMessageLogList = {
  __typename?: 'ZnsMessageLogList';
  messages: Array<ZnsMessageLog>;
  total: Scalars['Int']['output'];
};

export type ZnsTemplate = {
  __typename?: 'ZnsTemplate';
  createdAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  listParams: Array<Scalars['String']['output']>;
  previewURL?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  templateID?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  templateType?: Maybe<Scalars['String']['output']>;
  tenantID?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type ZnsTemplateList = {
  __typename?: 'ZnsTemplateList';
  templates: Array<ZnsTemplate>;
  total: Scalars['Int']['output'];
};

export type ApiHubServiceApiProviderFilter = {
  credentialStrategyIn?: InputMaybe<Array<ApiHubServiceApiCredentialStrategy>>;
  providerCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  statusIn?: InputMaybe<Array<ApiHubServiceApiProviderStatus>>;
};

export enum ApiHubServiceApiProviderStatus {
  Active = 'ACTIVE',
  Deprecated = 'DEPRECATED',
  Disabled = 'DISABLED',
  Maintenance = 'MAINTENANCE',
  Removed = 'REMOVED'
}

export type CreateLoyaltyProgramMutationVariables = Exact<{
  input: LoyaltyServiceCreateLoyaltyProgramGqlInput;
}>;


export type CreateLoyaltyProgramMutation = { __typename?: 'Mutation', loyaltyServiceCreateLoyaltyProgram: boolean };

export type UpdateLoyaltyProgramMutationVariables = Exact<{
  input: LoyaltyServiceCreateLoyaltyProgramGqlInput;
}>;


export type UpdateLoyaltyProgramMutation = { __typename?: 'Mutation', loyaltyServiceCreateLoyaltyProgram: boolean };

export type DeleteLoyaltyProgramMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteLoyaltyProgramMutation = { __typename?: 'Mutation', loyaltyServiceDeleteLoyaltyProgram: boolean };

export type SetDefaultLoyaltyProgramMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SetDefaultLoyaltyProgramMutation = { __typename?: 'Mutation', loyaltyServiceSetDefaultLoyaltyProgram: boolean };

export type CreateLoyaltyTierMutationVariables = Exact<{
  input: LoyaltyServiceCreateLoyaltyTierGqlInput;
}>;


export type CreateLoyaltyTierMutation = { __typename?: 'Mutation', loyaltyServiceCreateLoyaltyTier: boolean };

export type UpdateLoyaltyTierMutationVariables = Exact<{
  input: LoyaltyServiceUpdateLoyaltyTierGqlInput;
}>;


export type UpdateLoyaltyTierMutation = { __typename?: 'Mutation', loyaltyServiceUpdateLoyaltyTier: boolean };

export type DeleteLoyaltyTiersMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteLoyaltyTiersMutation = { __typename?: 'Mutation', loyaltyServiceDeleteLoyaltyTiers: boolean };

export type EnableLoyaltyTierMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type EnableLoyaltyTierMutation = { __typename?: 'Mutation', loyaltyServiceEnableLoyaltyTier: boolean };

export type DisableLoyaltyTierMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DisableLoyaltyTierMutation = { __typename?: 'Mutation', loyaltyServiceDisableLoyaltyTier: boolean };

export type SduiServiceCreateLayoutMutationVariables = Exact<{
  input: SduiServiceCreateLayoutGqlInput;
}>;


export type SduiServiceCreateLayoutMutation = { __typename?: 'Mutation', sduiServiceCreateLayout: boolean };

export type SduiServiceUpdateLayoutMutationVariables = Exact<{
  sduiServiceUpdateLayoutId: Scalars['String']['input'];
  input: SduiServiceUpdateLayoutGqlInput;
}>;


export type SduiServiceUpdateLayoutMutation = { __typename?: 'Mutation', sduiServiceUpdateLayout: boolean };

export type SduiServiceToggleLayoutMutationVariables = Exact<{
  sduiServiceToggleLayoutId: Scalars['String']['input'];
}>;


export type SduiServiceToggleLayoutMutation = { __typename?: 'Mutation', sduiServiceToggleLayout: boolean };

export type SduiServiceUpdateTenantLayoutMutationVariables = Exact<{
  input: SduiServiceUpdateTenantLayoutGqlInput;
}>;


export type SduiServiceUpdateTenantLayoutMutation = { __typename?: 'Mutation', sduiServiceUpdateTenantLayout: boolean };

export type UserServiceCreateOrganizationAdminMutationVariables = Exact<{
  input: UserServiceCreateUserGqlInput;
}>;


export type UserServiceCreateOrganizationAdminMutation = { __typename?: 'Mutation', userServiceCreateOrganizationAdmin: { __typename?: 'UserServiceUserGqlOutput', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, avatarUrl?: string | null, fullName?: string | null, status: UserServiceUserStatus, type: UserServiceUserType, organizationId?: string | null, tenantId?: string | null, createdAt?: string | null, updatedAt?: string | null } };

export type UserServiceCreateTenantAdminMutationVariables = Exact<{
  input: UserServiceCreateUserGqlInput;
}>;


export type UserServiceCreateTenantAdminMutation = { __typename?: 'Mutation', userServiceCreateTenantAdmin: { __typename?: 'UserServiceUserGqlOutput', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, avatarUrl?: string | null, fullName?: string | null, status: UserServiceUserStatus, type: UserServiceUserType, organizationId?: string | null, tenantId?: string | null, createdAt?: string | null, updatedAt?: string | null } };

export type GetUsersOfTenantForAdminQueryVariables = Exact<{
  pagination: PaginationArgs;
  input?: InputMaybe<UserServiceFindUsersByTypeInput>;
}>;


export type GetUsersOfTenantForAdminQuery = { __typename?: 'Query', userServiceUsersByType: { __typename?: 'UserServiceUsersGqlOutput', total: number, data: Array<{ __typename?: 'UserServiceUserGqlOutput', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, phoneNumber?: string | null, birthDate?: string | null, gender?: UserServiceGender | null, avatarUrl?: string | null, type: UserServiceUserType, status: UserServiceUserStatus, tenantId?: string | null, organizationId?: string | null, createdAt?: string | null, updatedAt?: string | null }> } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', authServiceMe: { __typename?: 'UserServiceUserGqlOutput', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, avatarUrl?: string | null, fullName?: string | null, status: UserServiceUserStatus, type: UserServiceUserType, createdAt?: string | null, updatedAt?: string | null } };

export type AuthServiceEmailLoginMutationVariables = Exact<{
  input: AuthServiceLoginGqlInput;
}>;


export type AuthServiceEmailLoginMutation = { __typename?: 'Mutation', authServiceEmailLogin: { __typename?: 'AuthServiceTokenGqlOutput', accessToken: string, refreshToken: string, user: { __typename?: 'UserServiceUserGqlOutput', id: string, avatarUrl?: string | null, createdAt?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, status: UserServiceUserStatus, tenantId?: string | null, organizationId?: string | null, type: UserServiceUserType, updatedAt?: string | null, zaloId?: string | null } } };

export type AuthServiceRefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type AuthServiceRefreshTokenMutation = { __typename?: 'Mutation', authServiceRefreshToken: { __typename?: 'AuthServiceTokenGqlOutput', accessToken: string, refreshToken: string } };

export type AuthServiceLoginImpersonateMutationVariables = Exact<{
  input: AuthServiceImpersonateUserGqlInput;
}>;


export type AuthServiceLoginImpersonateMutation = { __typename?: 'Mutation', authServiceImpersonateUser: { __typename?: 'AuthServiceTokenGqlOutput', accessToken: string, accessTokenExpiry: string, refreshToken: string, refreshTokenExpiry: string, user: { __typename?: 'UserServiceUserGqlOutput', id: string, avatarUrl?: string | null, createdAt?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, status: UserServiceUserStatus, tenantId?: string | null, organizationId?: string | null, type: UserServiceUserType, updatedAt?: string | null, zaloId?: string | null } } };

export type GetActiveBlockTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveBlockTemplatesQuery = { __typename?: 'Query', contentServiceBlockTemplates: Array<{ __typename?: 'BlockTemplateOutput', id: string, name: string, description?: string | null, type: string, tenantType: string, tenantId?: string | null, category?: string | null, tags?: Array<string> | null, defaultProps?: string | null, propsSchema?: string | null, isActive: boolean, createdAt?: any | null, updatedAt?: any | null }> };

export type GetAllBranchesQueryVariables = Exact<{
  input: OrganizationServiceGetBranchesGqlInput;
}>;


export type GetAllBranchesQuery = { __typename?: 'Query', organizationServiceAllBranches: Array<{ __typename?: 'OrganizationServiceBranchGqlOutput', id: string, name: string, address: string, status: OrganizationServiceBranchStatus, organizationId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> };

export type GetBranchByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBranchByIdQuery = { __typename?: 'Query', organizationServiceBranchById: { __typename?: 'OrganizationServiceBranchGqlOutput', id: string, name: string, address: string, status: OrganizationServiceBranchStatus, organizationId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type GetBranchesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetBranchesByIdsQuery = { __typename?: 'Query', organizationServiceBranchByIds: Array<{ __typename?: 'OrganizationServiceBranchGqlOutput', id: string, name: string, address: string, status: OrganizationServiceBranchStatus, organizationId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> };

export type CreateBranchMutationVariables = Exact<{
  input: OrganizationServiceCreateBranchGqlInput;
}>;


export type CreateBranchMutation = { __typename?: 'Mutation', organizationServiceCreateBranch: { __typename?: 'OrganizationServiceBranchGqlOutput', id: string, name: string, address: string, status: OrganizationServiceBranchStatus, organizationId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdateBranchMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: OrganizationServiceUpdateBranchGqlInput;
}>;


export type UpdateBranchMutation = { __typename?: 'Mutation', organizationServiceUpdateBranch: { __typename?: 'OrganizationServiceBranchGqlOutput', id: string, name: string, address: string, status: OrganizationServiceBranchStatus, organizationId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeleteBranchMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteBranchMutation = { __typename?: 'Mutation', organizationServiceDeleteBranch: { __typename?: 'OrganizationServiceBranchGqlOutput', id: string, name: string, address: string, status: OrganizationServiceBranchStatus, organizationId: string, tenantId: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type CreateArticleMutationVariables = Exact<{
  input: ContentServiceArticleGqlInput;
}>;


export type CreateArticleMutation = { __typename?: 'Mutation', contentServiceCreateArticle: { __typename?: 'ContentServiceArticleGqlOutput', id?: string | null } };

export type GetAllArticlesQueryVariables = Exact<{
  pagination: PaginationArgs;
  input: ContentServiceSearchArticleGqlInput;
}>;


export type GetAllArticlesQuery = { __typename?: 'Query', contentServiceGetAllArticles: Array<{ __typename?: 'ContentServiceArticleGqlOutput', id?: string | null, title?: string | null, tags?: Array<string> | null, status?: ContentStatusEnum | null, publishedAt?: any | null, tenantId?: string | null, viewCount?: number | null, category?: ContentCategoryEnum | null, categoryIds?: Array<string> | null, content?: string | null, contentType?: ContentTypeEnum | null, updatedAt?: any | null, description?: string | null, isFeatured?: boolean | null, displayEndDate?: any | null, displayStartDate?: any | null, isMostViewed?: boolean | null, eventDate?: string | null, imageUrl?: string | null, createdAt?: any | null }> };

export type GetArticleByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetArticleByIdQuery = { __typename?: 'Query', contentServiceArticle: { __typename?: 'ContentServiceArticleGqlOutput', id?: string | null, title?: string | null, tags?: Array<string> | null, status?: ContentStatusEnum | null, publishedAt?: any | null, tenantId?: string | null, viewCount?: number | null, category?: ContentCategoryEnum | null, categoryIds?: Array<string> | null, content?: string | null, contentType?: ContentTypeEnum | null, createdAt?: any | null, imageUrl?: string | null, description?: string | null, updatedAt?: any | null, contentId?: string | null, isFeatured?: boolean | null, displayEndDate?: any | null, displayStartDate?: any | null, isMostViewed?: boolean | null } };

export type UpdateArticleMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ContentServiceUpdateArticleGqlInput;
}>;


export type UpdateArticleMutation = { __typename?: 'Mutation', contentServiceUpdateArticle: boolean };

export type DeleteArticlesMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteArticlesMutation = { __typename?: 'Mutation', contentServiceDeleteArticles: boolean };

export type UpdateArticleStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: ContentStatusEnum;
}>;


export type UpdateArticleStatusMutation = { __typename?: 'Mutation', contentServiceUpdateArticleStatus: boolean };

export type ContentCreateCategoryMutationVariables = Exact<{
  input: ContentServiceCreateCategoryGqlInput;
}>;


export type ContentCreateCategoryMutation = { __typename?: 'Mutation', contentServiceCreateCategory: boolean };

export type ContentUpdateCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ContentServiceCreateCategoryGqlInput;
}>;


export type ContentUpdateCategoryMutation = { __typename?: 'Mutation', contentServiceUpdateCategory: boolean };

export type ContentDeleteCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ContentDeleteCategoryMutation = { __typename?: 'Mutation', contentServiceDeleteCategory: boolean };

export type ContentGetAllCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ContentGetAllCategoriesQuery = { __typename?: 'Query', contentServiceAllCategories: Array<{ __typename?: 'ContentServiceCategoryGqlOutput', id: string, tenantId?: string | null, name: string, description?: string | null, iconUrl?: string | null, parentId?: string | null, isEnabled: boolean, isDeleted: boolean, createdAt: any, updatedAt: any, parent?: { __typename?: 'ContentServiceCategoryGqlOutput', id: string, name: string, description?: string | null } | null, children?: Array<{ __typename?: 'ContentServiceCategoryGqlOutput', id: string, name: string, description?: string | null, iconUrl?: string | null, isEnabled: boolean }> | null }> };

export type CreateEventsMutationVariables = Exact<{
  input: EventServiceEventGqlInput;
}>;


export type CreateEventsMutation = { __typename?: 'Mutation', eventServiceCreateEvent: boolean };

export type GetAllEventsQueryVariables = Exact<{
  pagination: PaginationArgs;
  input: EventServiceSearchEventGqlInput;
}>;


export type GetAllEventsQuery = { __typename?: 'Query', eventServiceAllEvents: Array<{ __typename?: 'EventServiceEventGqlOutput', id: string, name: string, status: string, content?: string | null, startDate: any, description: string, thumbnailUrl?: string | null, endDate: any, contentId?: string | null, categoryIds?: Array<string> | null, createdAt?: any | null, updatedAt?: any | null, tenantId?: string | null }> };

export type GetEventDetailQueryVariables = Exact<{
  eventServiceEventByIdId: Scalars['String']['input'];
}>;


export type GetEventDetailQuery = { __typename?: 'Query', eventServiceEventById: { __typename?: 'EventServiceEventGqlOutput', id: string, name: string, status: string, content?: string | null, startDate: any, description: string, thumbnailUrl?: string | null, endDate: any, location: string, organizerName: string, organizerEmail: string, bannerUrl?: string | null, contentId?: string | null, categoryIds?: Array<string> | null, createdAt?: any | null, updatedAt?: any | null } };

export type UpdateEventsMutationVariables = Exact<{
  eventServiceUpdateEventId: Scalars['String']['input'];
  eventServiceUpdateEventInput: EventServiceEventGqlInput;
}>;


export type UpdateEventsMutation = { __typename?: 'Mutation', eventServiceUpdateEvent: boolean };

export type EventServiceDeleteEventsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type EventServiceDeleteEventsMutation = { __typename?: 'Mutation', eventServiceDeleteEvents: boolean };

export type EventCreateCategoryMutationVariables = Exact<{
  input: EventServiceCreateCategoryGqlInput;
}>;


export type EventCreateCategoryMutation = { __typename?: 'Mutation', eventServiceCreateCategory: boolean };

export type EventUpdateCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: EventServiceCreateCategoryGqlInput;
}>;


export type EventUpdateCategoryMutation = { __typename?: 'Mutation', eventServiceUpdateCategory: boolean };

export type EventDeleteCategoryMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EventDeleteCategoryMutation = { __typename?: 'Mutation', eventServiceDeleteCategory: boolean };

export type EventGetAllCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type EventGetAllCategoriesQuery = { __typename?: 'Query', eventServiceAllCategories: Array<{ __typename?: 'EventServiceCategoryGqlOutput', id: string, tenantId?: string | null, name: string, description?: string | null, iconUrl?: string | null, parentId?: string | null, isEnabled: boolean, isDeleted: boolean, createdAt: any, updatedAt: any, parent?: { __typename?: 'EventServiceCategoryGqlOutput', id: string, name: string, description?: string | null } | null, children?: Array<{ __typename?: 'EventServiceCategoryGqlOutput', id: string, name: string, description?: string | null, iconUrl?: string | null, isEnabled: boolean }> | null }> };

export type FeatureFlagServiceGetAllFeatureFlagsQueryVariables = Exact<{
  input: FeatureFlagServiceGetAllFeatureFlagGqlInput;
}>;


export type FeatureFlagServiceGetAllFeatureFlagsQuery = { __typename?: 'Query', featureFlagServiceGetAllFeatureFlags: Array<{ __typename?: 'FeatureFlagServiceFeatureFlagGqlOutput', id: string, description?: string | null, featureCode?: string | null, isEnabled?: boolean | null, createdAt?: any | null, updatedAt?: any | null, tenantId?: string | null, type?: FeatureFlagTypeEnum | null, rules: Array<{ __typename?: 'FeatureFlagServiceRuleGqlOutput', priority: number, conditions: Array<{ __typename?: 'FeatureFlagServiceConditionGqlOutput', key: string, operator: FeatureFlagOperatorEnum, values: Array<string> }> }> }> };

export type FeatureFlagServiceCreateFeatureFlagMutationVariables = Exact<{
  input: FeatureFlagServiceCreateFeatureFlagGqlInput;
}>;


export type FeatureFlagServiceCreateFeatureFlagMutation = { __typename?: 'Mutation', featureFlagServiceCreateFeatureFlag: boolean };

export type FeatureFlagServiceDeleteFeatureFlagMutationVariables = Exact<{
  featureFlagId: Scalars['String']['input'];
  type: FeatureFlagTypeEnum;
}>;


export type FeatureFlagServiceDeleteFeatureFlagMutation = { __typename?: 'Mutation', featureFlagServiceDeleteFeatureFlag: boolean };

export type FeatureFlagServiceGetFeatureFlagDetailQueryVariables = Exact<{
  input: FeatureFlagServiceGetFeatureFlagDetailGqlInput;
}>;


export type FeatureFlagServiceGetFeatureFlagDetailQuery = { __typename?: 'Query', featureFlagServiceGetFeatureFlagDetail: { __typename?: 'FeatureFlagServiceFeatureFlagGqlOutput', id: string, featureCode?: string | null, description?: string | null, isEnabled?: boolean | null, createdAt?: any | null, updatedAt?: any | null, tenantId?: string | null, type?: FeatureFlagTypeEnum | null, rules: Array<{ __typename?: 'FeatureFlagServiceRuleGqlOutput', isEnabled?: boolean | null, priority: number, conditions: Array<{ __typename?: 'FeatureFlagServiceConditionGqlOutput', key: string, operator: FeatureFlagOperatorEnum, values: Array<string> }> }> } };

export type FeatureFlagServiceUpdateFeatureFlagMutationVariables = Exact<{
  input: FeatureFlagServiceUpdateFeatureFlagGqlInput;
  id: Scalars['String']['input'];
}>;


export type FeatureFlagServiceUpdateFeatureFlagMutation = { __typename?: 'Mutation', featureFlagServiceUpdateFeatureFlag: boolean };

export type FeatureFlagServiceToggleFeatureFlagMutationVariables = Exact<{
  id: Scalars['String']['input'];
  type: FeatureFlagTypeEnum;
}>;


export type FeatureFlagServiceToggleFeatureFlagMutation = { __typename?: 'Mutation', featureFlagServiceToggleFeatureFlagById?: { __typename?: 'FeatureFlagServiceFeatureFlagGqlOutput', id: string } | null };

export type GetEnabledFeatureFlagsQueryVariables = Exact<{
  input: FeatureFlagServiceGetFeatureFlagGqlInput;
}>;


export type GetEnabledFeatureFlagsQuery = { __typename?: 'Query', featureFlagServiceGetEnabledFeatureFlags: Array<{ __typename?: 'FeatureFlagServiceFeatureFlagGqlOutput', featureCode?: string | null }> };

export type FeatureServiceGetFeatureListQueryVariables = Exact<{
  input?: InputMaybe<FeatureServiceGetListGqlInput>;
}>;


export type FeatureServiceGetFeatureListQuery = { __typename?: 'Query', featureServiceGetFeatureList: { __typename?: 'FeatureServiceGetListGqlOutput', total: number, page: number, limit: number, totalPages: number, data: Array<{ __typename?: 'FeatureServiceFeatureGqlOutput', id?: string | null, featureCode?: string | null, featureName?: string | null, isEnabled?: boolean | null, isDeleted?: boolean | null, createdAt?: any | null, updatedAt?: any | null }> } };

export type FeatureServiceCreateFeatureMutationVariables = Exact<{
  input: FeatureServiceCreateFeatureGqlInput;
}>;


export type FeatureServiceCreateFeatureMutation = { __typename?: 'Mutation', featureServiceCreateFeature: boolean };

export type FeatureServiceCreateFeaturesMutationVariables = Exact<{
  input: FeatureServiceCreateFeaturesGqlInput;
}>;


export type FeatureServiceCreateFeaturesMutation = { __typename?: 'Mutation', featureServiceCreateFeatures: boolean };

export type FeatureServiceDeleteFeatureMutationVariables = Exact<{
  featureCode: Scalars['String']['input'];
}>;


export type FeatureServiceDeleteFeatureMutation = { __typename?: 'Mutation', featureServiceDeleteFeature: boolean };

export type FeatureServiceToggleFeatureMutationVariables = Exact<{
  input: FeatureServiceToggleFeatureGqlInput;
}>;


export type FeatureServiceToggleFeatureMutation = { __typename?: 'Mutation', featureServiceToggleFeature: boolean };

export type FeatureServiceUpdateFeatureMutationVariables = Exact<{
  featureCode: Scalars['String']['input'];
  input: FeatureServiceUpdateFeatureGqlInput;
}>;


export type FeatureServiceUpdateFeatureMutation = { __typename?: 'Mutation', featureServiceUpdateFeature: boolean };

export type FeatureFlagServiceGetTenantOverridesQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagServiceGetTenantOverridesQuery = { __typename?: 'Query', featureFlagServiceGetTenantOverrides: Array<{ __typename?: 'FeatureFlagServiceTenantOverrideGqlOutput', id?: string | null, featureCode?: string | null, isEnabled?: boolean | null, reason?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type FeatureFlagServiceCreateTenantOverrideMutationVariables = Exact<{
  input: FeatureFlagServiceCreateTenantOverrideGqlInput;
}>;


export type FeatureFlagServiceCreateTenantOverrideMutation = { __typename?: 'Mutation', featureFlagServiceCreateTenantOverride: { __typename?: 'FeatureFlagServiceTenantOverrideGqlOutput', id?: string | null, featureCode?: string | null, isEnabled?: boolean | null, reason?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null } };

export type FeatureFlagServiceDeleteTenantOverrideMutationVariables = Exact<{
  input: FeatureFlagServiceDeleteTenantOverrideGqlInput;
}>;


export type FeatureFlagServiceDeleteTenantOverrideMutation = { __typename?: 'Mutation', featureFlagServiceDeleteTenantOverride: boolean };

export type GetAllLoyaltyProgramsQueryVariables = Exact<{
  pagination: PaginationArgs;
}>;


export type GetAllLoyaltyProgramsQuery = { __typename?: 'Query', loyaltyServiceAllLoyaltyPrograms: { __typename?: 'LoyaltyServiceLoyaltyProgramsGqlOutput', total: number, data: Array<{ __typename?: 'LoyaltyServiceLoyaltyProgramGqlOutput', id: string, tenantId: string, name: string, description: string, startDate: any, endDate?: any | null, isActive: boolean, isDefault: boolean, isEnabled: boolean, isDeleted: boolean, createdAt?: any | null, updatedAt?: any | null, pointsConfig: { __typename?: 'PointsConfig', earnRules: { __typename?: 'EarnRules', amountSpentRatio: number, registrationBonus: number, referralBonus: number }, redemptionRules: { __typename?: 'RedemptionRules', minimumPoints: number, pointValue: number } }, additionalSettings?: { __typename?: 'AdditionalSettings', notificationEnabled?: boolean | null, emailTemplateId?: string | null, displayInApp?: boolean | null, customTheme?: { __typename?: 'CustomTheme', primaryColor?: string | null, secondaryColor?: string | null, logoUrl?: string | null } | null, integrations?: { __typename?: 'Integrations', externalSystemId?: string | null, apiKeys?: Array<string> | null } | null } | null }> } };

export type GetActiveLoyaltyProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveLoyaltyProgramsQuery = { __typename?: 'Query', loyaltyServiceActiveLoyaltyPrograms: Array<{ __typename?: 'LoyaltyServiceLoyaltyProgramGqlOutput', id: string, tenantId: string, name: string, description: string, startDate: any, endDate?: any | null, isActive: boolean, isDefault: boolean, isEnabled: boolean, isDeleted: boolean, createdAt?: any | null, updatedAt?: any | null, pointsConfig: { __typename?: 'PointsConfig', earnRules: { __typename?: 'EarnRules', amountSpentRatio: number, registrationBonus: number, referralBonus: number }, redemptionRules: { __typename?: 'RedemptionRules', minimumPoints: number, pointValue: number } }, additionalSettings?: { __typename?: 'AdditionalSettings', notificationEnabled?: boolean | null, emailTemplateId?: string | null, displayInApp?: boolean | null, customTheme?: { __typename?: 'CustomTheme', primaryColor?: string | null, secondaryColor?: string | null, logoUrl?: string | null } | null, integrations?: { __typename?: 'Integrations', externalSystemId?: string | null, apiKeys?: Array<string> | null } | null } | null }> };

export type GetDefaultLoyaltyProgramQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultLoyaltyProgramQuery = { __typename?: 'Query', loyaltyServiceDefaultLoyaltyProgram: { __typename?: 'LoyaltyServiceLoyaltyProgramGqlOutput', id: string, tenantId: string, name: string, description: string, startDate: any, endDate?: any | null, isActive: boolean, isDefault: boolean, isEnabled: boolean, isDeleted: boolean, createdAt?: any | null, updatedAt?: any | null, pointsConfig: { __typename?: 'PointsConfig', earnRules: { __typename?: 'EarnRules', amountSpentRatio: number, registrationBonus: number, referralBonus: number }, redemptionRules: { __typename?: 'RedemptionRules', minimumPoints: number, pointValue: number } }, additionalSettings?: { __typename?: 'AdditionalSettings', notificationEnabled?: boolean | null, emailTemplateId?: string | null, displayInApp?: boolean | null, customTheme?: { __typename?: 'CustomTheme', primaryColor?: string | null, secondaryColor?: string | null, logoUrl?: string | null } | null, integrations?: { __typename?: 'Integrations', externalSystemId?: string | null, apiKeys?: Array<string> | null } | null } | null } };

export type GetLoyaltyProgramByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetLoyaltyProgramByIdQuery = { __typename?: 'Query', loyaltyServiceLoyaltyProgramById: { __typename?: 'LoyaltyServiceLoyaltyProgramGqlOutput', id: string, tenantId: string, name: string, description: string, startDate: any, endDate?: any | null, isActive: boolean, isDefault: boolean, isEnabled: boolean, isDeleted: boolean, createdAt?: any | null, updatedAt?: any | null, pointsConfig: { __typename?: 'PointsConfig', earnRules: { __typename?: 'EarnRules', amountSpentRatio: number, registrationBonus: number, referralBonus: number }, redemptionRules: { __typename?: 'RedemptionRules', minimumPoints: number, pointValue: number } }, additionalSettings?: { __typename?: 'AdditionalSettings', notificationEnabled?: boolean | null, emailTemplateId?: string | null, displayInApp?: boolean | null, customTheme?: { __typename?: 'CustomTheme', primaryColor?: string | null, secondaryColor?: string | null, logoUrl?: string | null } | null, integrations?: { __typename?: 'Integrations', externalSystemId?: string | null, apiKeys?: Array<string> | null } | null } | null } };

export type GetAllLoyaltyTiersQueryVariables = Exact<{
  pagination: PaginationArgs;
}>;


export type GetAllLoyaltyTiersQuery = { __typename?: 'Query', loyaltyServiceAllLoyaltyTiers: { __typename?: 'LoyaltyServiceLoyaltyTiersGqlOutput', total: number, data: Array<{ __typename?: 'LoyaltyServiceLoyaltyTierGqlOutput', id: string, tenantId: string, name: string, description: string, level: number, pointsThreshold?: number | null, spendingThreshold?: number | null, pointsMultiplier?: number | null, spendingPerPoint?: number | null, maintenanceThreshold?: number | null, validityPeriod?: number | null, pointEarnRuleDescription?: string | null, benefitDescriptions?: Array<string> | null, iconUrl?: string | null, isEnabled?: boolean | null, isDeleted?: boolean | null, createdAt?: any | null, updatedAt?: any | null, benefit?: { __typename?: 'LoyaltyTierBenefitDetails', prioritySupport?: boolean | null, exclusiveAccess?: boolean | null, additionalBenefits?: Array<string> | null, freeServices?: Array<string> | null, discounts?: Array<{ __typename?: 'LoyaltyTierDiscount', percentage: number, minimumPurchase?: number | null, maximumDiscount?: number | null, scope?: DiscountScopeEnum | null, applicableProductIds?: Array<string> | null, applicableCategoryIds?: Array<string> | null, applicableServices?: Array<string> | null }> | null } | null }> } };

export type GetEnabledLoyaltyTiersQueryVariables = Exact<{
  pagination: PaginationArgs;
}>;


export type GetEnabledLoyaltyTiersQuery = { __typename?: 'Query', loyaltyServiceEnabledLoyaltyTiers: Array<{ __typename?: 'LoyaltyServiceLoyaltyTierGqlOutput', id: string, tenantId: string, name: string, description: string, level: number, pointsThreshold?: number | null, spendingThreshold?: number | null, pointsMultiplier?: number | null, spendingPerPoint?: number | null, maintenanceThreshold?: number | null, validityPeriod?: number | null, pointEarnRuleDescription?: string | null, benefitDescriptions?: Array<string> | null, iconUrl?: string | null, isEnabled?: boolean | null, isDeleted?: boolean | null, createdAt?: any | null, updatedAt?: any | null, benefit?: { __typename?: 'LoyaltyTierBenefitDetails', prioritySupport?: boolean | null, exclusiveAccess?: boolean | null, additionalBenefits?: Array<string> | null, freeServices?: Array<string> | null, discounts?: Array<{ __typename?: 'LoyaltyTierDiscount', percentage: number, minimumPurchase?: number | null, maximumDiscount?: number | null, scope?: DiscountScopeEnum | null, applicableProductIds?: Array<string> | null, applicableCategoryIds?: Array<string> | null, applicableServices?: Array<string> | null }> | null } | null }> };

export type GetLoyaltyTierByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetLoyaltyTierByIdQuery = { __typename?: 'Query', loyaltyServiceLoyaltyTierById: { __typename?: 'LoyaltyServiceLoyaltyTierGqlOutput', id: string, tenantId: string, name: string, level: number, description: string, iconUrl?: string | null, spendingThreshold?: number | null, pointsThreshold?: number | null, pointsMultiplier?: number | null, spendingPerPoint?: number | null, benefitDescriptions?: Array<string> | null, pointEarnRuleDescription?: string | null, validityPeriod?: number | null, maintenanceThreshold?: number | null, isEnabled?: boolean | null, isDeleted?: boolean | null, createdAt?: any | null, updatedAt?: any | null, benefit?: { __typename?: 'LoyaltyTierBenefitDetails', prioritySupport?: boolean | null, exclusiveAccess?: boolean | null, additionalBenefits?: Array<string> | null, freeServices?: Array<string> | null, discounts?: Array<{ __typename?: 'LoyaltyTierDiscount', percentage: number, minimumPurchase?: number | null, maximumDiscount?: number | null, scope?: DiscountScopeEnum | null, applicableProductIds?: Array<string> | null, applicableCategoryIds?: Array<string> | null, applicableServices?: Array<string> | null }> | null } | null } };

export type GetOrdersQueryVariables = Exact<{
  input: OrderServiceGetGqlInput;
}>;


export type GetOrdersQuery = { __typename?: 'Query', orderServiceOrganizationGetOrders: Array<{ __typename?: 'OrderServiceOrderGqlOutput', id: string, status: string, type: string, currency: string, productTotalAmount: number, productTotalAmountFormatted: string, shippingFee?: number | null, shippingFeeFormatted?: string | null, discountAmount?: number | null, discountAmountFormatted?: string | null, totalAmount: number, totalAmountFormatted: string, pointAmount?: number | null, pointAmountFormatted?: string | null, paymentMethod?: string | null, paymentStatus?: OrderServicePaymentStatus | null, shippingMethod?: string | null, shippingStatus?: OrderServiceShippingStatus | null, shippingNote?: string | null, branchId?: string | null, tenantId: string, userId: string, promotionId?: string | null, vouchers?: Array<string> | null, createdAt: string, updatedAt: string, shippingAddress?: { __typename?: 'OrderServiceShippingAddressGqlOutput', name: string, phone: string, address: string, province: string, ward: string } | null, payment?: Array<{ __typename?: 'OrderServicePaymentInfoGqlOutput', transactionId: string, amountPaid: number, amountPaidFormatted: string, paidAt: string, refundId?: string | null }> | null, products: Array<{ __typename?: 'OrderServiceProductGqlOutput', name: string, price: number, priceFormatted: string, quantity: number, productId: string, currency: string, thumbnailUrl?: string | null, variant?: { __typename?: 'OrderServiceProductVariantGqlOutput', name: string, price: number, priceFormatted: string, sku: string, attributeKey?: string | null, attributeValue?: string | null } | null }> }> };

export type GetOrderQueryVariables = Exact<{
  input: OrderServiceDetailGqlInput;
}>;


export type GetOrderQuery = { __typename?: 'Query', orderServiceGetOrder: { __typename?: 'OrderServiceOrderGqlOutput', id: string, status: string, type: string, currency: string, productTotalAmount: number, productTotalAmountFormatted: string, shippingFee?: number | null, shippingFeeFormatted?: string | null, discountAmount?: number | null, discountAmountFormatted?: string | null, totalAmount: number, totalAmountFormatted: string, pointAmount?: number | null, pointAmountFormatted?: string | null, paymentMethod?: string | null, paymentStatus?: OrderServicePaymentStatus | null, shippingMethod?: string | null, shippingStatus?: OrderServiceShippingStatus | null, shippingNote?: string | null, branchId?: string | null, tenantId: string, userId: string, promotionId?: string | null, vouchers?: Array<string> | null, createdAt: string, updatedAt: string, shippingAddress?: { __typename?: 'OrderServiceShippingAddressGqlOutput', name: string, phone: string, address: string, province: string, ward: string } | null, payment?: Array<{ __typename?: 'OrderServicePaymentInfoGqlOutput', transactionId: string, amountPaid: number, amountPaidFormatted: string, paidAt: string, refundId?: string | null }> | null, products: Array<{ __typename?: 'OrderServiceProductGqlOutput', name: string, price: number, priceFormatted: string, quantity: number, productId: string, currency: string, thumbnailUrl?: string | null, variant?: { __typename?: 'OrderServiceProductVariantGqlOutput', name: string, price: number, priceFormatted: string, sku: string, attributeKey?: string | null, attributeValue?: string | null } | null }> } };

export type GetOrderHistoriesQueryVariables = Exact<{
  input: OrderServiceGetOrderHistoryGqlInput;
}>;


export type GetOrderHistoriesQuery = { __typename?: 'Query', orderServiceGetOrderHistories: Array<{ __typename?: 'OrderServiceOrderHistoryGqlOutput', id: string, status: OrderServiceStatus, description: string, comment?: string | null, updatedBy: string, createdAt: string }> };

export type UpdateOrderStatusMutationVariables = Exact<{
  input: OrderServiceUpdateStatusGqlInput;
}>;


export type UpdateOrderStatusMutation = { __typename?: 'Mutation', orderServiceUpdateOrderStatus: boolean };

export type GetAllOrganizationsQueryVariables = Exact<{
  input: OrganizationServiceGetOrganizationsGqlInput;
}>;


export type GetAllOrganizationsQuery = { __typename?: 'Query', organizationServiceAdminAllOrganizations: Array<{ __typename?: 'OrganizationServiceOrganizationGqlOutput', id: string, name: string, status: OrganizationServiceOrganizationStatus, createdBy: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> };

export type GetOrganizationByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOrganizationByIdQuery = { __typename?: 'Query', organizationServiceAdminOrganizationById: { __typename?: 'OrganizationServiceOrganizationGqlOutput', id: string, name: string, status: OrganizationServiceOrganizationStatus, createdBy: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type CreateOrganizationMutationVariables = Exact<{
  input: OrganizationServiceCreateOrganizationGqlInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', organizationServiceAdminCreateOrganization: { __typename?: 'OrganizationServiceOrganizationGqlOutput', id: string, name: string, status: OrganizationServiceOrganizationStatus, createdBy: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: OrganizationServiceUpdateOrganizationGqlInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', organizationServiceAdminUpdateOrganization: { __typename?: 'OrganizationServiceOrganizationGqlOutput', id: string, name: string, status: OrganizationServiceOrganizationStatus, createdBy: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type ContentServiceGetPageQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PageTypeEnum>;
}>;


export type ContentServiceGetPageQuery = { __typename?: 'Query', contentServiceGetPage?: { __typename?: 'ContentServicePageGqlOutput', id: string, name: string, type: PageTypeEnum, description?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, components: Array<{ __typename?: 'ContentServiceBlockComponentGqlOutput', id: string, type: string, props: string }> } | null };

export type ContentServiceCreatePageMutationVariables = Exact<{
  input: ContentServiceCreatePageGqlInput;
}>;


export type ContentServiceCreatePageMutation = { __typename?: 'Mutation', contentServiceCreatePage: { __typename?: 'ContentServicePageGqlOutput', id: string, name: string, type: PageTypeEnum, description?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, components: Array<{ __typename?: 'ContentServiceBlockComponentGqlOutput', id: string, type: string, props: string }> } };

export type ContentServiceUpdatePageMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: ContentServiceUpdatePageGqlInput;
}>;


export type ContentServiceUpdatePageMutation = { __typename?: 'Mutation', contentServiceUpdatePage: { __typename?: 'ContentServicePageGqlOutput', id: string, name: string, type: PageTypeEnum, description?: string | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, components: Array<{ __typename?: 'ContentServiceBlockComponentGqlOutput', id: string, type: string, props: string }> } };

export type RatingServiceGetRatingsByFilterQueryVariables = Exact<{
  input?: InputMaybe<RatingServiceGetRatingsGqlInput>;
  pagination: PaginationArgs;
}>;


export type RatingServiceGetRatingsByFilterQuery = { __typename?: 'Query', ratingServiceGetRatingsByFilter: { __typename?: 'RatingServiceRatingsGqlOutput', total: number, data: Array<{ __typename?: 'RatingServiceRatingGqlOutput', id: string, rating: number, comment?: string | null, userId: string, referenceType: RatingReferenceTypeEnum, referenceId: string, createdAt?: any | null, updatedAt?: any | null, metadata?: any | null }> } };

export type RatingServiceDeleteRatingForAdminMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RatingServiceDeleteRatingForAdminMutation = { __typename?: 'Mutation', ratingServiceDeleteRatingForAdmin: boolean };

export type RatingServiceGetRatingDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RatingServiceGetRatingDetailsQuery = { __typename?: 'Query', ratingServiceGetRatingDetails: { __typename?: 'RatingServiceRatingGqlOutput', id: string, rating: number, comment?: string | null, userId: string, referenceType: RatingReferenceTypeEnum, referenceId: string, createdAt?: any | null, updatedAt?: any | null, metadata?: any | null, tenantId?: string | null, deletedAt?: any | null } };

export type SduiServiceGetLayoutsQueryVariables = Exact<{ [key: string]: never; }>;


export type SduiServiceGetLayoutsQuery = { __typename?: 'Query', sduiServiceGetLayouts: Array<{ __typename?: 'SduiServiceLayoutGqlOutput', id?: string | null, layoutId?: string | null, tenantId?: string | null, isEnabled?: boolean | null, components?: { __typename?: 'SduiServiceComponentOutput', banner?: { __typename?: 'SduiServiceBannerComponentOutput', imageUrl?: string | null } | null, bottomNavBar?: { __typename?: 'SduiServiceBottomNavBarComponentOutput', selectedIndex?: number | null, items?: Array<{ __typename?: 'SduiServiceBottomNavBarItemOutput', icon?: string | null, label?: string | null }> | null } | null } | null, modules?: Array<{ __typename?: 'SduiServiceModuleOutput', featureCode?: string | null, icon?: string | null, isShow?: boolean | null, title?: string | null, action?: { __typename?: 'SduiServiceActionOutput', route?: string | null, target?: string | null, type?: string | null, value?: string | null } | null }> | null, theme?: { __typename?: 'SduiServiceThemeOutput', backgroundColor?: string | null, buttonStyle?: string | null, color?: string | null, fontFamily?: string | null, fontSize?: string | null, primaryColor?: string | null, secondaryColor?: string | null, themeName?: string | null } | null }> };

export type SduiServiceGetLayoutDetailQueryVariables = Exact<{
  sduiServiceGetLayoutDetailId: Scalars['String']['input'];
}>;


export type SduiServiceGetLayoutDetailQuery = { __typename?: 'Query', sduiServiceGetLayoutDetail: { __typename?: 'SduiServiceLayoutGqlOutput', id?: string | null, layoutId?: string | null, tenantId?: string | null, isEnabled?: boolean | null, components?: { __typename?: 'SduiServiceComponentOutput', banner?: { __typename?: 'SduiServiceBannerComponentOutput', imageUrl?: string | null } | null, bottomNavBar?: { __typename?: 'SduiServiceBottomNavBarComponentOutput', selectedIndex?: number | null, items?: Array<{ __typename?: 'SduiServiceBottomNavBarItemOutput', icon?: string | null, label?: string | null }> | null } | null } | null, modules?: Array<{ __typename?: 'SduiServiceModuleOutput', featureCode?: string | null, icon?: string | null, isShow?: boolean | null, title?: string | null, action?: { __typename?: 'SduiServiceActionOutput', route?: string | null, target?: string | null, type?: string | null, value?: string | null } | null }> | null, theme?: { __typename?: 'SduiServiceThemeOutput', backgroundColor?: string | null, buttonStyle?: string | null, color?: string | null, fontFamily?: string | null, fontSize?: string | null, primaryColor?: string | null, secondaryColor?: string | null, themeName?: string | null } | null, customFields?: Array<{ __typename?: 'SduiServiceCustomFieldOutput', fieldName?: string | null, fieldValue?: string | null }> | null } };

export type SduiServiceGetTenantLayoutQueryVariables = Exact<{ [key: string]: never; }>;


export type SduiServiceGetTenantLayoutQuery = { __typename?: 'Query', sduiServiceGetLayout: { __typename?: 'SduiServiceLayoutGqlOutput', id?: string | null, isEnabled?: boolean | null, components?: { __typename?: 'SduiServiceComponentOutput', banner?: { __typename?: 'SduiServiceBannerComponentOutput', imageUrl?: string | null } | null } | null, customFields?: Array<{ __typename?: 'SduiServiceCustomFieldOutput', fieldName?: string | null, fieldType?: string | null, fieldValue?: string | null }> | null } };

export type UploadServiceRequestUploadMutationVariables = Exact<{
  input: UploadServiceRequestGqlInput;
}>;


export type UploadServiceRequestUploadMutation = { __typename?: 'Mutation', uploadServiceRequestUpload: { __typename?: 'UploadServiceRequestGqlOutput', fileId: string, uploadUrl: string } };

export type CompleteUploadMutationVariables = Exact<{
  input: UploadServiceCompleteGqlInput;
}>;


export type CompleteUploadMutation = { __typename?: 'Mutation', uploadServiceCompleteUpload: { __typename?: 'UploadServiceCompleteGqlOutput', status: StorageStatusType, fileUrl: string } };

export type GetSurveysForAdminQueryVariables = Exact<{
  pagination: PaginationArgs;
}>;


export type GetSurveysForAdminQuery = { __typename?: 'Query', fnsServiceGetSurveysForAdmin: { __typename?: 'FnsServiceSurveysGqlOutput', total: number, data: Array<{ __typename?: 'FnsServiceSurveyGqlOutput', id: string, title?: string | null, description?: string | null, type?: SurveyType | null, isActive?: boolean | null, isAnonymous?: boolean | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'FnsServiceQuestionGqlOutput', id: string, text?: string | null, type?: SurveyQuestionType | null, uiTemplate?: SurveyUiTemplate | null, index?: number | null, isRequired?: boolean | null, isActive?: boolean | null, minValue?: number | null, maxValue?: number | null, options?: Array<string> | null, actionLabel?: string | null, actionUrl?: string | null }> | null }> } };

export type GetSurveyByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSurveyByIdQuery = { __typename?: 'Query', fnsServiceGetSurveyById: { __typename?: 'FnsServiceSurveyGqlOutput', id: string, title?: string | null, description?: string | null, type?: SurveyType | null, isActive?: boolean | null, isAnonymous?: boolean | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'FnsServiceQuestionGqlOutput', id: string, text?: string | null, type?: SurveyQuestionType | null, uiTemplate?: SurveyUiTemplate | null, index?: number | null, isRequired?: boolean | null, isActive?: boolean | null, minValue?: number | null, maxValue?: number | null, options?: Array<string> | null, actionLabel?: string | null, actionUrl?: string | null }> | null } };

export type GetSurveyByTypeQueryVariables = Exact<{
  type: SurveyType;
}>;


export type GetSurveyByTypeQuery = { __typename?: 'Query', fnsServiceGetSurveyByType: { __typename?: 'FnsServiceSurveyGqlOutput', id: string, title?: string | null, description?: string | null, type?: SurveyType | null, isActive?: boolean | null, isAnonymous?: boolean | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'FnsServiceQuestionGqlOutput', id: string, text?: string | null, type?: SurveyQuestionType | null, uiTemplate?: SurveyUiTemplate | null, index?: number | null, isRequired?: boolean | null, isActive?: boolean | null, minValue?: number | null, maxValue?: number | null, options?: Array<string> | null, actionLabel?: string | null, actionUrl?: string | null }> | null } };

export type CreateSurveyForAdminMutationVariables = Exact<{
  input: FnsServiceCreateSurveyGqlInput;
}>;


export type CreateSurveyForAdminMutation = { __typename?: 'Mutation', fnsServiceCreateSurveyForAdmin: { __typename?: 'FnsServiceSurveyGqlOutput', id: string, title?: string | null, description?: string | null, type?: SurveyType | null, isActive?: boolean | null, isAnonymous?: boolean | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null } };

export type UpdateSurveyForAdminMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: FnsServiceUpdateSurveyGqlInput;
}>;


export type UpdateSurveyForAdminMutation = { __typename?: 'Mutation', fnsServiceUpdateSurveyForAdmin: { __typename?: 'FnsServiceSurveyGqlOutput', id: string, title?: string | null, description?: string | null, type?: SurveyType | null, isActive?: boolean | null, isAnonymous?: boolean | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null } };

export type GetUserResponsesForAdminQueryVariables = Exact<{
  pagination: PaginationArgs;
  input: FnsServiceFindUserResponsesToSurveyGqlInput;
}>;


export type GetUserResponsesForAdminQuery = { __typename?: 'Query', fnsServiceGetUserResponsesToSurveyForAdmin: { __typename?: 'FnsServiceUserResponsesGqlOutput', total: number, data: Array<{ __typename?: 'FnsServiceUserResponseGqlOutput', id: string, surveyId?: string | null, formId?: string | null, userId?: string | null, tenantId?: string | null, ipAddress?: string | null, userAgent?: string | null, createdAt?: any | null, updatedAt?: any | null, answers?: Array<{ __typename?: 'FnsServiceAnswerGqlOutput', questionId?: string | null, answer?: Array<string> | null }> | null }> } };

export type GetUserResponseByIdForAdminQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetUserResponseByIdForAdminQuery = { __typename?: 'Query', fnsServiceGetUserResponseByIdForAdmin: { __typename?: 'FnsServiceUserResponseGqlOutput', id: string, surveyId?: string | null, formId?: string | null, userId?: string | null, tenantId?: string | null, ipAddress?: string | null, userAgent?: string | null, createdAt?: any | null, updatedAt?: any | null, answers?: Array<{ __typename?: 'FnsServiceAnswerGqlOutput', questionId?: string | null, answer?: Array<string> | null }> | null } };

export type CreateUserResponseMutationVariables = Exact<{
  input: FnsServiceCreateUserResponseSurveyGqlInput;
}>;


export type CreateUserResponseMutation = { __typename?: 'Mutation', fnsServiceCreateUserResponseToSurvey: { __typename?: 'FnsServiceUserResponseGqlOutput', id: string, surveyId?: string | null, userId?: string | null, tenantId?: string | null, createdAt?: any | null } };

export type CreateResponseForAnonymousMutationVariables = Exact<{
  input: FnsServiceCreateUserResponseSurveyGqlInput;
}>;


export type CreateResponseForAnonymousMutation = { __typename?: 'Mutation', fnsServiceCreateUserResponseToSurveyForAnonymous: { __typename?: 'FnsServiceUserResponseGqlOutput', id: string, surveyId?: string | null, ipAddress?: string | null, userAgent?: string | null, createdAt?: any | null } };

export type GetFormsForAdminQueryVariables = Exact<{
  pagination: PaginationArgs;
}>;


export type GetFormsForAdminQuery = { __typename?: 'Query', fnsServiceGetFormsForAdmin: { __typename?: 'FnsServiceFormsGqlOutput', total: number, data: Array<{ __typename?: 'FnsServiceFormGqlOutput', id: string, title?: string | null, description?: string | null, isActive?: boolean | null, isAnonymous?: boolean | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'FnsServiceQuestionGqlOutput', id: string, text?: string | null, type?: SurveyQuestionType | null, uiTemplate?: SurveyUiTemplate | null, index?: number | null, isRequired?: boolean | null, isActive?: boolean | null, minValue?: number | null, maxValue?: number | null, options?: Array<string> | null, actionLabel?: string | null, actionUrl?: string | null }> | null }> } };

export type GetFormByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetFormByIdQuery = { __typename?: 'Query', fnsServiceGetFormById: { __typename?: 'FnsServiceFormGqlOutput', id: string, title?: string | null, description?: string | null, isActive?: boolean | null, isAnonymous?: boolean | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, questions?: Array<{ __typename?: 'FnsServiceQuestionGqlOutput', id: string, text?: string | null, type?: SurveyQuestionType | null, uiTemplate?: SurveyUiTemplate | null, index?: number | null, isRequired?: boolean | null, isActive?: boolean | null, minValue?: number | null, maxValue?: number | null, options?: Array<string> | null, actionLabel?: string | null, actionUrl?: string | null }> | null } };

export type CreateFormForAdminMutationVariables = Exact<{
  input: FnsServiceCreateFormGqlInput;
}>;


export type CreateFormForAdminMutation = { __typename?: 'Mutation', fnsServiceCreateFormForAdmin: { __typename?: 'FnsServiceFormGqlOutput', id: string, title?: string | null, description?: string | null, isActive?: boolean | null, isAnonymous?: boolean | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null } };

export type UpdateFormForAdminMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: FnsServiceUpdateFormGqlInput;
}>;


export type UpdateFormForAdminMutation = { __typename?: 'Mutation', fnsServiceUpdateFormForAdmin: { __typename?: 'FnsServiceFormGqlOutput', id: string, title?: string | null, description?: string | null, isActive?: boolean | null, isAnonymous?: boolean | null, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null } };

export type CreateUserResponseFormMutationVariables = Exact<{
  input: FnsServiceCreateUserResponseFormGqlInput;
}>;


export type CreateUserResponseFormMutation = { __typename?: 'Mutation', fnsServiceCreateUserResponseToForm: { __typename?: 'FnsServiceUserResponseGqlOutput', id: string, formId?: string | null, userId?: string | null, tenantId?: string | null, createdAt?: any | null } };

export type CreateResponseFormForAnonymousMutationVariables = Exact<{
  input: FnsServiceCreateUserResponseFormGqlInput;
}>;


export type CreateResponseFormForAnonymousMutation = { __typename?: 'Mutation', fnsServiceCreateUserResponseToFormForAnonymous: { __typename?: 'FnsServiceUserResponseGqlOutput', id: string, formId?: string | null, ipAddress?: string | null, userAgent?: string | null, createdAt?: any | null } };

export type UserServiceAllTenantQueryVariables = Exact<{
  input: UserServiceGetTenantsGqlInput;
}>;


export type UserServiceAllTenantQuery = { __typename?: 'Query', userServiceAllTenant: Array<{ __typename?: 'UserServiceTenantGqlOutput', id: string, name: string, status: UserServiceTenantStatus, organizationId: string, zaloAppId: string, zaloAppSecret: string, miniAppUrl?: string | null, title?: string | null, description?: string | null, banner?: string | null, favicon?: string | null, createdAt?: string | null, updatedAt?: string | null, type: UserServiceTenantType }> };

export type UserServiceAllZaloUserOfTenantQueryVariables = Exact<{
  input: UserServiceGetZaloUsersGqlInput;
}>;


export type UserServiceAllZaloUserOfTenantQuery = { __typename?: 'Query', userServiceAllZaloUserOfTenant: Array<{ __typename?: 'UserServiceUserGqlOutput', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, avatarUrl?: string | null, fullName?: string | null, status: UserServiceUserStatus, type: UserServiceUserType, tenantId?: string | null, organizationId?: string | null, zaloId?: string | null, createdAt?: string | null, updatedAt?: string | null }> };

export type UserServiceCreateTenantMutationVariables = Exact<{
  input: UserServiceCreateTenantGqlInput;
}>;


export type UserServiceCreateTenantMutation = { __typename?: 'Mutation', userServiceCreateTenant: { __typename?: 'UserServiceTenantGqlOutput', id: string, name: string, status: UserServiceTenantStatus, organizationId: string, zaloAppId: string, zaloAppSecret: string, miniAppUrl?: string | null, title?: string | null, description?: string | null, banner?: string | null, favicon?: string | null, createdAt?: string | null, updatedAt?: string | null } };

export type UserServiceUpdateTenantMutationVariables = Exact<{
  input: UserServiceUpdateTenantGqlInput;
}>;


export type UserServiceUpdateTenantMutation = { __typename?: 'Mutation', userServiceUpdateTenant: { __typename?: 'UserServiceTenantGqlOutput', id: string, name: string, status: UserServiceTenantStatus, organizationId: string, zaloAppId: string, zaloAppSecret: string, miniAppUrl?: string | null, title?: string | null, description?: string | null, banner?: string | null, favicon?: string | null, createdAt?: string | null, updatedAt?: string | null } };

export type UserServiceTenantStatusMutationVariables = Exact<{
  input: UserServiceTenantStatusGqlInput;
}>;


export type UserServiceTenantStatusMutation = { __typename?: 'Mutation', userServiceTenantStatus: { __typename?: 'UserServiceTenantGqlOutput', id: string } };

export type UserServiceAdminAllTenantQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  pagination: PaginationArgs;
}>;


export type UserServiceAdminAllTenantQuery = { __typename?: 'Query', userServiceAdminAllTenant: Array<{ __typename?: 'UserServiceTenantGqlOutput', id: string, organizationId: string, name: string, status: UserServiceTenantStatus, zaloAppId: string, zaloAppSecret: string, miniAppUrl?: string | null, title?: string | null, description?: string | null, oaId?: string | null, domain?: string | null, logo?: string | null, banner?: string | null, favicon?: string | null, registerEnabled?: boolean | null, createdAt?: string | null, updatedAt?: string | null, type: UserServiceTenantType }> };

export type UserServiceGetTenantQueryVariables = Exact<{ [key: string]: never; }>;


export type UserServiceGetTenantQuery = { __typename?: 'Query', userServiceTenantById: { __typename?: 'UserServiceTenantGqlOutput', type: UserServiceTenantType } };

export type UserServiceTenantByDomainQueryVariables = Exact<{
  domain: Scalars['String']['input'];
}>;


export type UserServiceTenantByDomainQuery = { __typename?: 'Query', userServiceTenantByDomain?: { __typename?: 'UserServiceTenantGqlOutput', banner?: string | null, billingStatus: UserServiceTenantBillingStatus, createdAt?: string | null, description?: string | null, domain?: string | null, favicon?: string | null, id: string, logo?: string | null, miniAppUrl?: string | null, name: string, oaId?: string | null, organizationId: string, registerEnabled?: boolean | null, status: UserServiceTenantStatus, title?: string | null, type: UserServiceTenantType, updatedAt?: string | null, zaloAppId: string, zaloAppSecret: string } | null };



export const CreateLoyaltyProgramDocument = `
    mutation CreateLoyaltyProgram($input: LoyaltyServiceCreateLoyaltyProgramGqlInput!) {
  loyaltyServiceCreateLoyaltyProgram(input: $input)
}
    `;

export const useCreateLoyaltyProgramMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateLoyaltyProgramMutation, TError, CreateLoyaltyProgramMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateLoyaltyProgramMutation, TError, CreateLoyaltyProgramMutationVariables, TContext>(
      {
    mutationKey: ['CreateLoyaltyProgram'],
    mutationFn: (variables?: CreateLoyaltyProgramMutationVariables) => fetcher<CreateLoyaltyProgramMutation, CreateLoyaltyProgramMutationVariables>(client, CreateLoyaltyProgramDocument, variables, headers)(),
    ...options
  }
    )};

useCreateLoyaltyProgramMutation.getKey = () => ['CreateLoyaltyProgram'];


useCreateLoyaltyProgramMutation.fetcher = (client: GraphQLClient, variables: CreateLoyaltyProgramMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateLoyaltyProgramMutation, CreateLoyaltyProgramMutationVariables>(client, CreateLoyaltyProgramDocument, variables, headers);

export const UpdateLoyaltyProgramDocument = `
    mutation UpdateLoyaltyProgram($input: LoyaltyServiceCreateLoyaltyProgramGqlInput!) {
  loyaltyServiceCreateLoyaltyProgram(input: $input)
}
    `;

export const useUpdateLoyaltyProgramMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateLoyaltyProgramMutation, TError, UpdateLoyaltyProgramMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateLoyaltyProgramMutation, TError, UpdateLoyaltyProgramMutationVariables, TContext>(
      {
    mutationKey: ['UpdateLoyaltyProgram'],
    mutationFn: (variables?: UpdateLoyaltyProgramMutationVariables) => fetcher<UpdateLoyaltyProgramMutation, UpdateLoyaltyProgramMutationVariables>(client, UpdateLoyaltyProgramDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateLoyaltyProgramMutation.getKey = () => ['UpdateLoyaltyProgram'];


useUpdateLoyaltyProgramMutation.fetcher = (client: GraphQLClient, variables: UpdateLoyaltyProgramMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateLoyaltyProgramMutation, UpdateLoyaltyProgramMutationVariables>(client, UpdateLoyaltyProgramDocument, variables, headers);

export const DeleteLoyaltyProgramDocument = `
    mutation DeleteLoyaltyProgram($id: String!) {
  loyaltyServiceDeleteLoyaltyProgram(id: $id)
}
    `;

export const useDeleteLoyaltyProgramMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteLoyaltyProgramMutation, TError, DeleteLoyaltyProgramMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteLoyaltyProgramMutation, TError, DeleteLoyaltyProgramMutationVariables, TContext>(
      {
    mutationKey: ['DeleteLoyaltyProgram'],
    mutationFn: (variables?: DeleteLoyaltyProgramMutationVariables) => fetcher<DeleteLoyaltyProgramMutation, DeleteLoyaltyProgramMutationVariables>(client, DeleteLoyaltyProgramDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteLoyaltyProgramMutation.getKey = () => ['DeleteLoyaltyProgram'];


useDeleteLoyaltyProgramMutation.fetcher = (client: GraphQLClient, variables: DeleteLoyaltyProgramMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteLoyaltyProgramMutation, DeleteLoyaltyProgramMutationVariables>(client, DeleteLoyaltyProgramDocument, variables, headers);

export const SetDefaultLoyaltyProgramDocument = `
    mutation SetDefaultLoyaltyProgram($id: String!) {
  loyaltyServiceSetDefaultLoyaltyProgram(id: $id)
}
    `;

export const useSetDefaultLoyaltyProgramMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetDefaultLoyaltyProgramMutation, TError, SetDefaultLoyaltyProgramMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SetDefaultLoyaltyProgramMutation, TError, SetDefaultLoyaltyProgramMutationVariables, TContext>(
      {
    mutationKey: ['SetDefaultLoyaltyProgram'],
    mutationFn: (variables?: SetDefaultLoyaltyProgramMutationVariables) => fetcher<SetDefaultLoyaltyProgramMutation, SetDefaultLoyaltyProgramMutationVariables>(client, SetDefaultLoyaltyProgramDocument, variables, headers)(),
    ...options
  }
    )};

useSetDefaultLoyaltyProgramMutation.getKey = () => ['SetDefaultLoyaltyProgram'];


useSetDefaultLoyaltyProgramMutation.fetcher = (client: GraphQLClient, variables: SetDefaultLoyaltyProgramMutationVariables, headers?: RequestInit['headers']) => fetcher<SetDefaultLoyaltyProgramMutation, SetDefaultLoyaltyProgramMutationVariables>(client, SetDefaultLoyaltyProgramDocument, variables, headers);

export const CreateLoyaltyTierDocument = `
    mutation CreateLoyaltyTier($input: LoyaltyServiceCreateLoyaltyTierGqlInput!) {
  loyaltyServiceCreateLoyaltyTier(input: $input)
}
    `;

export const useCreateLoyaltyTierMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateLoyaltyTierMutation, TError, CreateLoyaltyTierMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateLoyaltyTierMutation, TError, CreateLoyaltyTierMutationVariables, TContext>(
      {
    mutationKey: ['CreateLoyaltyTier'],
    mutationFn: (variables?: CreateLoyaltyTierMutationVariables) => fetcher<CreateLoyaltyTierMutation, CreateLoyaltyTierMutationVariables>(client, CreateLoyaltyTierDocument, variables, headers)(),
    ...options
  }
    )};

useCreateLoyaltyTierMutation.getKey = () => ['CreateLoyaltyTier'];


useCreateLoyaltyTierMutation.fetcher = (client: GraphQLClient, variables: CreateLoyaltyTierMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateLoyaltyTierMutation, CreateLoyaltyTierMutationVariables>(client, CreateLoyaltyTierDocument, variables, headers);

export const UpdateLoyaltyTierDocument = `
    mutation UpdateLoyaltyTier($input: LoyaltyServiceUpdateLoyaltyTierGqlInput!) {
  loyaltyServiceUpdateLoyaltyTier(input: $input)
}
    `;

export const useUpdateLoyaltyTierMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateLoyaltyTierMutation, TError, UpdateLoyaltyTierMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateLoyaltyTierMutation, TError, UpdateLoyaltyTierMutationVariables, TContext>(
      {
    mutationKey: ['UpdateLoyaltyTier'],
    mutationFn: (variables?: UpdateLoyaltyTierMutationVariables) => fetcher<UpdateLoyaltyTierMutation, UpdateLoyaltyTierMutationVariables>(client, UpdateLoyaltyTierDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateLoyaltyTierMutation.getKey = () => ['UpdateLoyaltyTier'];


useUpdateLoyaltyTierMutation.fetcher = (client: GraphQLClient, variables: UpdateLoyaltyTierMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateLoyaltyTierMutation, UpdateLoyaltyTierMutationVariables>(client, UpdateLoyaltyTierDocument, variables, headers);

export const DeleteLoyaltyTiersDocument = `
    mutation DeleteLoyaltyTiers($ids: [String!]!) {
  loyaltyServiceDeleteLoyaltyTiers(ids: $ids)
}
    `;

export const useDeleteLoyaltyTiersMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteLoyaltyTiersMutation, TError, DeleteLoyaltyTiersMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteLoyaltyTiersMutation, TError, DeleteLoyaltyTiersMutationVariables, TContext>(
      {
    mutationKey: ['DeleteLoyaltyTiers'],
    mutationFn: (variables?: DeleteLoyaltyTiersMutationVariables) => fetcher<DeleteLoyaltyTiersMutation, DeleteLoyaltyTiersMutationVariables>(client, DeleteLoyaltyTiersDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteLoyaltyTiersMutation.getKey = () => ['DeleteLoyaltyTiers'];


useDeleteLoyaltyTiersMutation.fetcher = (client: GraphQLClient, variables: DeleteLoyaltyTiersMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteLoyaltyTiersMutation, DeleteLoyaltyTiersMutationVariables>(client, DeleteLoyaltyTiersDocument, variables, headers);

export const EnableLoyaltyTierDocument = `
    mutation EnableLoyaltyTier($ids: [String!]!) {
  loyaltyServiceEnableLoyaltyTier(ids: $ids)
}
    `;

export const useEnableLoyaltyTierMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EnableLoyaltyTierMutation, TError, EnableLoyaltyTierMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<EnableLoyaltyTierMutation, TError, EnableLoyaltyTierMutationVariables, TContext>(
      {
    mutationKey: ['EnableLoyaltyTier'],
    mutationFn: (variables?: EnableLoyaltyTierMutationVariables) => fetcher<EnableLoyaltyTierMutation, EnableLoyaltyTierMutationVariables>(client, EnableLoyaltyTierDocument, variables, headers)(),
    ...options
  }
    )};

useEnableLoyaltyTierMutation.getKey = () => ['EnableLoyaltyTier'];


useEnableLoyaltyTierMutation.fetcher = (client: GraphQLClient, variables: EnableLoyaltyTierMutationVariables, headers?: RequestInit['headers']) => fetcher<EnableLoyaltyTierMutation, EnableLoyaltyTierMutationVariables>(client, EnableLoyaltyTierDocument, variables, headers);

export const DisableLoyaltyTierDocument = `
    mutation DisableLoyaltyTier($ids: [String!]!) {
  loyaltyServiceDisableLoyaltyTier(ids: $ids)
}
    `;

export const useDisableLoyaltyTierMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DisableLoyaltyTierMutation, TError, DisableLoyaltyTierMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DisableLoyaltyTierMutation, TError, DisableLoyaltyTierMutationVariables, TContext>(
      {
    mutationKey: ['DisableLoyaltyTier'],
    mutationFn: (variables?: DisableLoyaltyTierMutationVariables) => fetcher<DisableLoyaltyTierMutation, DisableLoyaltyTierMutationVariables>(client, DisableLoyaltyTierDocument, variables, headers)(),
    ...options
  }
    )};

useDisableLoyaltyTierMutation.getKey = () => ['DisableLoyaltyTier'];


useDisableLoyaltyTierMutation.fetcher = (client: GraphQLClient, variables: DisableLoyaltyTierMutationVariables, headers?: RequestInit['headers']) => fetcher<DisableLoyaltyTierMutation, DisableLoyaltyTierMutationVariables>(client, DisableLoyaltyTierDocument, variables, headers);

export const SduiServiceCreateLayoutDocument = `
    mutation SduiServiceCreateLayout($input: SduiServiceCreateLayoutGqlInput!) {
  sduiServiceCreateLayout(input: $input)
}
    `;

export const useSduiServiceCreateLayoutMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SduiServiceCreateLayoutMutation, TError, SduiServiceCreateLayoutMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SduiServiceCreateLayoutMutation, TError, SduiServiceCreateLayoutMutationVariables, TContext>(
      {
    mutationKey: ['SduiServiceCreateLayout'],
    mutationFn: (variables?: SduiServiceCreateLayoutMutationVariables) => fetcher<SduiServiceCreateLayoutMutation, SduiServiceCreateLayoutMutationVariables>(client, SduiServiceCreateLayoutDocument, variables, headers)(),
    ...options
  }
    )};

useSduiServiceCreateLayoutMutation.getKey = () => ['SduiServiceCreateLayout'];


useSduiServiceCreateLayoutMutation.fetcher = (client: GraphQLClient, variables: SduiServiceCreateLayoutMutationVariables, headers?: RequestInit['headers']) => fetcher<SduiServiceCreateLayoutMutation, SduiServiceCreateLayoutMutationVariables>(client, SduiServiceCreateLayoutDocument, variables, headers);

export const SduiServiceUpdateLayoutDocument = `
    mutation SduiServiceUpdateLayout($sduiServiceUpdateLayoutId: String!, $input: SduiServiceUpdateLayoutGqlInput!) {
  sduiServiceUpdateLayout(id: $sduiServiceUpdateLayoutId, input: $input)
}
    `;

export const useSduiServiceUpdateLayoutMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SduiServiceUpdateLayoutMutation, TError, SduiServiceUpdateLayoutMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SduiServiceUpdateLayoutMutation, TError, SduiServiceUpdateLayoutMutationVariables, TContext>(
      {
    mutationKey: ['SduiServiceUpdateLayout'],
    mutationFn: (variables?: SduiServiceUpdateLayoutMutationVariables) => fetcher<SduiServiceUpdateLayoutMutation, SduiServiceUpdateLayoutMutationVariables>(client, SduiServiceUpdateLayoutDocument, variables, headers)(),
    ...options
  }
    )};

useSduiServiceUpdateLayoutMutation.getKey = () => ['SduiServiceUpdateLayout'];


useSduiServiceUpdateLayoutMutation.fetcher = (client: GraphQLClient, variables: SduiServiceUpdateLayoutMutationVariables, headers?: RequestInit['headers']) => fetcher<SduiServiceUpdateLayoutMutation, SduiServiceUpdateLayoutMutationVariables>(client, SduiServiceUpdateLayoutDocument, variables, headers);

export const SduiServiceToggleLayoutDocument = `
    mutation SduiServiceToggleLayout($sduiServiceToggleLayoutId: String!) {
  sduiServiceToggleLayout(id: $sduiServiceToggleLayoutId)
}
    `;

export const useSduiServiceToggleLayoutMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SduiServiceToggleLayoutMutation, TError, SduiServiceToggleLayoutMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SduiServiceToggleLayoutMutation, TError, SduiServiceToggleLayoutMutationVariables, TContext>(
      {
    mutationKey: ['SduiServiceToggleLayout'],
    mutationFn: (variables?: SduiServiceToggleLayoutMutationVariables) => fetcher<SduiServiceToggleLayoutMutation, SduiServiceToggleLayoutMutationVariables>(client, SduiServiceToggleLayoutDocument, variables, headers)(),
    ...options
  }
    )};

useSduiServiceToggleLayoutMutation.getKey = () => ['SduiServiceToggleLayout'];


useSduiServiceToggleLayoutMutation.fetcher = (client: GraphQLClient, variables: SduiServiceToggleLayoutMutationVariables, headers?: RequestInit['headers']) => fetcher<SduiServiceToggleLayoutMutation, SduiServiceToggleLayoutMutationVariables>(client, SduiServiceToggleLayoutDocument, variables, headers);

export const SduiServiceUpdateTenantLayoutDocument = `
    mutation sduiServiceUpdateTenantLayout($input: SduiServiceUpdateTenantLayoutGqlInput!) {
  sduiServiceUpdateTenantLayout(input: $input)
}
    `;

export const useSduiServiceUpdateTenantLayoutMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SduiServiceUpdateTenantLayoutMutation, TError, SduiServiceUpdateTenantLayoutMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<SduiServiceUpdateTenantLayoutMutation, TError, SduiServiceUpdateTenantLayoutMutationVariables, TContext>(
      {
    mutationKey: ['sduiServiceUpdateTenantLayout'],
    mutationFn: (variables?: SduiServiceUpdateTenantLayoutMutationVariables) => fetcher<SduiServiceUpdateTenantLayoutMutation, SduiServiceUpdateTenantLayoutMutationVariables>(client, SduiServiceUpdateTenantLayoutDocument, variables, headers)(),
    ...options
  }
    )};

useSduiServiceUpdateTenantLayoutMutation.getKey = () => ['sduiServiceUpdateTenantLayout'];


useSduiServiceUpdateTenantLayoutMutation.fetcher = (client: GraphQLClient, variables: SduiServiceUpdateTenantLayoutMutationVariables, headers?: RequestInit['headers']) => fetcher<SduiServiceUpdateTenantLayoutMutation, SduiServiceUpdateTenantLayoutMutationVariables>(client, SduiServiceUpdateTenantLayoutDocument, variables, headers);

export const UserServiceCreateOrganizationAdminDocument = `
    mutation userServiceCreateOrganizationAdmin($input: UserServiceCreateUserGqlInput!) {
  userServiceCreateOrganizationAdmin(input: $input) {
    id
    email
    firstName
    lastName
    phoneNumber
    avatarUrl
    fullName
    status
    type
    organizationId
    tenantId
    createdAt
    updatedAt
  }
}
    `;

export const useUserServiceCreateOrganizationAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UserServiceCreateOrganizationAdminMutation, TError, UserServiceCreateOrganizationAdminMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UserServiceCreateOrganizationAdminMutation, TError, UserServiceCreateOrganizationAdminMutationVariables, TContext>(
      {
    mutationKey: ['userServiceCreateOrganizationAdmin'],
    mutationFn: (variables?: UserServiceCreateOrganizationAdminMutationVariables) => fetcher<UserServiceCreateOrganizationAdminMutation, UserServiceCreateOrganizationAdminMutationVariables>(client, UserServiceCreateOrganizationAdminDocument, variables, headers)(),
    ...options
  }
    )};

useUserServiceCreateOrganizationAdminMutation.getKey = () => ['userServiceCreateOrganizationAdmin'];


useUserServiceCreateOrganizationAdminMutation.fetcher = (client: GraphQLClient, variables: UserServiceCreateOrganizationAdminMutationVariables, headers?: RequestInit['headers']) => fetcher<UserServiceCreateOrganizationAdminMutation, UserServiceCreateOrganizationAdminMutationVariables>(client, UserServiceCreateOrganizationAdminDocument, variables, headers);

export const UserServiceCreateTenantAdminDocument = `
    mutation userServiceCreateTenantAdmin($input: UserServiceCreateUserGqlInput!) {
  userServiceCreateTenantAdmin(input: $input) {
    id
    email
    firstName
    lastName
    phoneNumber
    avatarUrl
    fullName
    status
    type
    organizationId
    tenantId
    createdAt
    updatedAt
  }
}
    `;

export const useUserServiceCreateTenantAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UserServiceCreateTenantAdminMutation, TError, UserServiceCreateTenantAdminMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UserServiceCreateTenantAdminMutation, TError, UserServiceCreateTenantAdminMutationVariables, TContext>(
      {
    mutationKey: ['userServiceCreateTenantAdmin'],
    mutationFn: (variables?: UserServiceCreateTenantAdminMutationVariables) => fetcher<UserServiceCreateTenantAdminMutation, UserServiceCreateTenantAdminMutationVariables>(client, UserServiceCreateTenantAdminDocument, variables, headers)(),
    ...options
  }
    )};

useUserServiceCreateTenantAdminMutation.getKey = () => ['userServiceCreateTenantAdmin'];


useUserServiceCreateTenantAdminMutation.fetcher = (client: GraphQLClient, variables: UserServiceCreateTenantAdminMutationVariables, headers?: RequestInit['headers']) => fetcher<UserServiceCreateTenantAdminMutation, UserServiceCreateTenantAdminMutationVariables>(client, UserServiceCreateTenantAdminDocument, variables, headers);

export const GetUsersOfTenantForAdminDocument = `
    query GetUsersOfTenantForAdmin($pagination: PaginationArgs!, $input: UserServiceFindUsersByTypeInput) {
  userServiceUsersByType(pagination: $pagination, input: $input) {
    data {
      id
      email
      firstName
      lastName
      fullName
      phoneNumber
      birthDate
      gender
      avatarUrl
      type
      status
      tenantId
      organizationId
      createdAt
      updatedAt
    }
    total
  }
}
    `;

export const useGetUsersOfTenantForAdminQuery = <
      TData = GetUsersOfTenantForAdminQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUsersOfTenantForAdminQueryVariables,
      options?: Omit<UseQueryOptions<GetUsersOfTenantForAdminQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUsersOfTenantForAdminQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetUsersOfTenantForAdminQuery, TError, TData>(
      {
    queryKey: ['GetUsersOfTenantForAdmin', variables],
    queryFn: fetcher<GetUsersOfTenantForAdminQuery, GetUsersOfTenantForAdminQueryVariables>(client, GetUsersOfTenantForAdminDocument, variables, headers),
    ...options
  }
    )};

useGetUsersOfTenantForAdminQuery.getKey = (variables: GetUsersOfTenantForAdminQueryVariables) => ['GetUsersOfTenantForAdmin', variables];

export const useInfiniteGetUsersOfTenantForAdminQuery = <
      TData = InfiniteData<GetUsersOfTenantForAdminQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUsersOfTenantForAdminQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUsersOfTenantForAdminQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUsersOfTenantForAdminQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetUsersOfTenantForAdminQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetUsersOfTenantForAdmin.infinite', variables],
      queryFn: (metaData) => fetcher<GetUsersOfTenantForAdminQuery, GetUsersOfTenantForAdminQueryVariables>(client, GetUsersOfTenantForAdminDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUsersOfTenantForAdminQuery.getKey = (variables: GetUsersOfTenantForAdminQueryVariables) => ['GetUsersOfTenantForAdmin.infinite', variables];


useGetUsersOfTenantForAdminQuery.fetcher = (client: GraphQLClient, variables: GetUsersOfTenantForAdminQueryVariables, headers?: RequestInit['headers']) => fetcher<GetUsersOfTenantForAdminQuery, GetUsersOfTenantForAdminQueryVariables>(client, GetUsersOfTenantForAdminDocument, variables, headers);

export const GetMeDocument = `
    query GetMe {
  authServiceMe {
    id
    email
    firstName
    lastName
    phoneNumber
    avatarUrl
    fullName
    status
    type
    createdAt
    updatedAt
  }
}
    `;

export const useGetMeQuery = <
      TData = GetMeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetMeQueryVariables,
      options?: Omit<UseQueryOptions<GetMeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetMeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetMe'] : ['GetMe', variables],
    queryFn: fetcher<GetMeQuery, GetMeQueryVariables>(client, GetMeDocument, variables, headers),
    ...options
  }
    )};

useGetMeQuery.getKey = (variables?: GetMeQueryVariables) => variables === undefined ? ['GetMe'] : ['GetMe', variables];

export const useInfiniteGetMeQuery = <
      TData = InfiniteData<GetMeQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetMeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetMeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetMeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetMeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetMe.infinite'] : ['GetMe.infinite', variables],
      queryFn: (metaData) => fetcher<GetMeQuery, GetMeQueryVariables>(client, GetMeDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetMeQuery.getKey = (variables?: GetMeQueryVariables) => variables === undefined ? ['GetMe.infinite'] : ['GetMe.infinite', variables];


useGetMeQuery.fetcher = (client: GraphQLClient, variables?: GetMeQueryVariables, headers?: RequestInit['headers']) => fetcher<GetMeQuery, GetMeQueryVariables>(client, GetMeDocument, variables, headers);

export const AuthServiceEmailLoginDocument = `
    mutation AuthServiceEmailLogin($input: AuthServiceLoginGqlInput!) {
  authServiceEmailLogin(input: $input) {
    accessToken
    refreshToken
    user {
      id
      avatarUrl
      createdAt
      email
      firstName
      lastName
      phoneNumber
      status
      tenantId
      organizationId
      type
      updatedAt
      zaloId
    }
  }
}
    `;

export const useAuthServiceEmailLoginMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AuthServiceEmailLoginMutation, TError, AuthServiceEmailLoginMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<AuthServiceEmailLoginMutation, TError, AuthServiceEmailLoginMutationVariables, TContext>(
      {
    mutationKey: ['AuthServiceEmailLogin'],
    mutationFn: (variables?: AuthServiceEmailLoginMutationVariables) => fetcher<AuthServiceEmailLoginMutation, AuthServiceEmailLoginMutationVariables>(client, AuthServiceEmailLoginDocument, variables, headers)(),
    ...options
  }
    )};

useAuthServiceEmailLoginMutation.getKey = () => ['AuthServiceEmailLogin'];


useAuthServiceEmailLoginMutation.fetcher = (client: GraphQLClient, variables: AuthServiceEmailLoginMutationVariables, headers?: RequestInit['headers']) => fetcher<AuthServiceEmailLoginMutation, AuthServiceEmailLoginMutationVariables>(client, AuthServiceEmailLoginDocument, variables, headers);

export const AuthServiceRefreshTokenDocument = `
    mutation AuthServiceRefreshToken($refreshToken: String!) {
  authServiceRefreshToken(refreshToken: $refreshToken) {
    accessToken
    refreshToken
  }
}
    `;

export const useAuthServiceRefreshTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AuthServiceRefreshTokenMutation, TError, AuthServiceRefreshTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<AuthServiceRefreshTokenMutation, TError, AuthServiceRefreshTokenMutationVariables, TContext>(
      {
    mutationKey: ['AuthServiceRefreshToken'],
    mutationFn: (variables?: AuthServiceRefreshTokenMutationVariables) => fetcher<AuthServiceRefreshTokenMutation, AuthServiceRefreshTokenMutationVariables>(client, AuthServiceRefreshTokenDocument, variables, headers)(),
    ...options
  }
    )};

useAuthServiceRefreshTokenMutation.getKey = () => ['AuthServiceRefreshToken'];


useAuthServiceRefreshTokenMutation.fetcher = (client: GraphQLClient, variables: AuthServiceRefreshTokenMutationVariables, headers?: RequestInit['headers']) => fetcher<AuthServiceRefreshTokenMutation, AuthServiceRefreshTokenMutationVariables>(client, AuthServiceRefreshTokenDocument, variables, headers);

export const AuthServiceLoginImpersonateDocument = `
    mutation AuthServiceLoginImpersonate($input: AuthServiceImpersonateUserGqlInput!) {
  authServiceImpersonateUser(input: $input) {
    accessToken
    accessTokenExpiry
    refreshToken
    refreshTokenExpiry
    user {
      id
      avatarUrl
      createdAt
      email
      firstName
      lastName
      phoneNumber
      status
      tenantId
      organizationId
      type
      updatedAt
      zaloId
    }
  }
}
    `;

export const useAuthServiceLoginImpersonateMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AuthServiceLoginImpersonateMutation, TError, AuthServiceLoginImpersonateMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<AuthServiceLoginImpersonateMutation, TError, AuthServiceLoginImpersonateMutationVariables, TContext>(
      {
    mutationKey: ['AuthServiceLoginImpersonate'],
    mutationFn: (variables?: AuthServiceLoginImpersonateMutationVariables) => fetcher<AuthServiceLoginImpersonateMutation, AuthServiceLoginImpersonateMutationVariables>(client, AuthServiceLoginImpersonateDocument, variables, headers)(),
    ...options
  }
    )};

useAuthServiceLoginImpersonateMutation.getKey = () => ['AuthServiceLoginImpersonate'];


useAuthServiceLoginImpersonateMutation.fetcher = (client: GraphQLClient, variables: AuthServiceLoginImpersonateMutationVariables, headers?: RequestInit['headers']) => fetcher<AuthServiceLoginImpersonateMutation, AuthServiceLoginImpersonateMutationVariables>(client, AuthServiceLoginImpersonateDocument, variables, headers);

export const GetActiveBlockTemplatesDocument = `
    query GetActiveBlockTemplates {
  contentServiceBlockTemplates(input: {isActive: true}) {
    id
    name
    description
    type
    tenantType
    tenantId
    category
    tags
    defaultProps
    propsSchema
    isActive
    createdAt
    updatedAt
  }
}
    `;

export const useGetActiveBlockTemplatesQuery = <
      TData = GetActiveBlockTemplatesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetActiveBlockTemplatesQueryVariables,
      options?: Omit<UseQueryOptions<GetActiveBlockTemplatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetActiveBlockTemplatesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetActiveBlockTemplatesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetActiveBlockTemplates'] : ['GetActiveBlockTemplates', variables],
    queryFn: fetcher<GetActiveBlockTemplatesQuery, GetActiveBlockTemplatesQueryVariables>(client, GetActiveBlockTemplatesDocument, variables, headers),
    ...options
  }
    )};

useGetActiveBlockTemplatesQuery.getKey = (variables?: GetActiveBlockTemplatesQueryVariables) => variables === undefined ? ['GetActiveBlockTemplates'] : ['GetActiveBlockTemplates', variables];

export const useInfiniteGetActiveBlockTemplatesQuery = <
      TData = InfiniteData<GetActiveBlockTemplatesQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetActiveBlockTemplatesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetActiveBlockTemplatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetActiveBlockTemplatesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetActiveBlockTemplatesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetActiveBlockTemplates.infinite'] : ['GetActiveBlockTemplates.infinite', variables],
      queryFn: (metaData) => fetcher<GetActiveBlockTemplatesQuery, GetActiveBlockTemplatesQueryVariables>(client, GetActiveBlockTemplatesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetActiveBlockTemplatesQuery.getKey = (variables?: GetActiveBlockTemplatesQueryVariables) => variables === undefined ? ['GetActiveBlockTemplates.infinite'] : ['GetActiveBlockTemplates.infinite', variables];


useGetActiveBlockTemplatesQuery.fetcher = (client: GraphQLClient, variables?: GetActiveBlockTemplatesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetActiveBlockTemplatesQuery, GetActiveBlockTemplatesQueryVariables>(client, GetActiveBlockTemplatesDocument, variables, headers);

export const GetAllBranchesDocument = `
    query GetAllBranches($input: OrganizationServiceGetBranchesGqlInput!) {
  organizationServiceAllBranches(input: $input) {
    id
    name
    address
    status
    organizationId
    tenantId
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

export const useGetAllBranchesQuery = <
      TData = GetAllBranchesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllBranchesQueryVariables,
      options?: Omit<UseQueryOptions<GetAllBranchesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllBranchesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllBranchesQuery, TError, TData>(
      {
    queryKey: ['GetAllBranches', variables],
    queryFn: fetcher<GetAllBranchesQuery, GetAllBranchesQueryVariables>(client, GetAllBranchesDocument, variables, headers),
    ...options
  }
    )};

useGetAllBranchesQuery.getKey = (variables: GetAllBranchesQueryVariables) => ['GetAllBranches', variables];

export const useInfiniteGetAllBranchesQuery = <
      TData = InfiniteData<GetAllBranchesQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllBranchesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAllBranchesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAllBranchesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetAllBranchesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAllBranches.infinite', variables],
      queryFn: (metaData) => fetcher<GetAllBranchesQuery, GetAllBranchesQueryVariables>(client, GetAllBranchesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAllBranchesQuery.getKey = (variables: GetAllBranchesQueryVariables) => ['GetAllBranches.infinite', variables];


useGetAllBranchesQuery.fetcher = (client: GraphQLClient, variables: GetAllBranchesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllBranchesQuery, GetAllBranchesQueryVariables>(client, GetAllBranchesDocument, variables, headers);

export const GetBranchByIdDocument = `
    query GetBranchById($id: String!) {
  organizationServiceBranchById(id: $id) {
    id
    name
    address
    status
    organizationId
    tenantId
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

export const useGetBranchByIdQuery = <
      TData = GetBranchByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetBranchByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetBranchByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBranchByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetBranchByIdQuery, TError, TData>(
      {
    queryKey: ['GetBranchById', variables],
    queryFn: fetcher<GetBranchByIdQuery, GetBranchByIdQueryVariables>(client, GetBranchByIdDocument, variables, headers),
    ...options
  }
    )};

useGetBranchByIdQuery.getKey = (variables: GetBranchByIdQueryVariables) => ['GetBranchById', variables];

export const useInfiniteGetBranchByIdQuery = <
      TData = InfiniteData<GetBranchByIdQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetBranchByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBranchByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBranchByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetBranchByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBranchById.infinite', variables],
      queryFn: (metaData) => fetcher<GetBranchByIdQuery, GetBranchByIdQueryVariables>(client, GetBranchByIdDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBranchByIdQuery.getKey = (variables: GetBranchByIdQueryVariables) => ['GetBranchById.infinite', variables];


useGetBranchByIdQuery.fetcher = (client: GraphQLClient, variables: GetBranchByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetBranchByIdQuery, GetBranchByIdQueryVariables>(client, GetBranchByIdDocument, variables, headers);

export const GetBranchesByIdsDocument = `
    query GetBranchesByIds($ids: [String!]!) {
  organizationServiceBranchByIds(ids: $ids) {
    id
    name
    address
    status
    organizationId
    tenantId
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

export const useGetBranchesByIdsQuery = <
      TData = GetBranchesByIdsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetBranchesByIdsQueryVariables,
      options?: Omit<UseQueryOptions<GetBranchesByIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBranchesByIdsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetBranchesByIdsQuery, TError, TData>(
      {
    queryKey: ['GetBranchesByIds', variables],
    queryFn: fetcher<GetBranchesByIdsQuery, GetBranchesByIdsQueryVariables>(client, GetBranchesByIdsDocument, variables, headers),
    ...options
  }
    )};

useGetBranchesByIdsQuery.getKey = (variables: GetBranchesByIdsQueryVariables) => ['GetBranchesByIds', variables];

export const useInfiniteGetBranchesByIdsQuery = <
      TData = InfiniteData<GetBranchesByIdsQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetBranchesByIdsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBranchesByIdsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBranchesByIdsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetBranchesByIdsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBranchesByIds.infinite', variables],
      queryFn: (metaData) => fetcher<GetBranchesByIdsQuery, GetBranchesByIdsQueryVariables>(client, GetBranchesByIdsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBranchesByIdsQuery.getKey = (variables: GetBranchesByIdsQueryVariables) => ['GetBranchesByIds.infinite', variables];


useGetBranchesByIdsQuery.fetcher = (client: GraphQLClient, variables: GetBranchesByIdsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetBranchesByIdsQuery, GetBranchesByIdsQueryVariables>(client, GetBranchesByIdsDocument, variables, headers);

export const CreateBranchDocument = `
    mutation CreateBranch($input: OrganizationServiceCreateBranchGqlInput!) {
  organizationServiceCreateBranch(input: $input) {
    id
    name
    address
    status
    organizationId
    tenantId
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

export const useCreateBranchMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateBranchMutation, TError, CreateBranchMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateBranchMutation, TError, CreateBranchMutationVariables, TContext>(
      {
    mutationKey: ['CreateBranch'],
    mutationFn: (variables?: CreateBranchMutationVariables) => fetcher<CreateBranchMutation, CreateBranchMutationVariables>(client, CreateBranchDocument, variables, headers)(),
    ...options
  }
    )};

useCreateBranchMutation.getKey = () => ['CreateBranch'];


useCreateBranchMutation.fetcher = (client: GraphQLClient, variables: CreateBranchMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateBranchMutation, CreateBranchMutationVariables>(client, CreateBranchDocument, variables, headers);

export const UpdateBranchDocument = `
    mutation UpdateBranch($id: String!, $input: OrganizationServiceUpdateBranchGqlInput!) {
  organizationServiceUpdateBranch(id: $id, input: $input) {
    id
    name
    address
    status
    organizationId
    tenantId
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

export const useUpdateBranchMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateBranchMutation, TError, UpdateBranchMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateBranchMutation, TError, UpdateBranchMutationVariables, TContext>(
      {
    mutationKey: ['UpdateBranch'],
    mutationFn: (variables?: UpdateBranchMutationVariables) => fetcher<UpdateBranchMutation, UpdateBranchMutationVariables>(client, UpdateBranchDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateBranchMutation.getKey = () => ['UpdateBranch'];


useUpdateBranchMutation.fetcher = (client: GraphQLClient, variables: UpdateBranchMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateBranchMutation, UpdateBranchMutationVariables>(client, UpdateBranchDocument, variables, headers);

export const DeleteBranchDocument = `
    mutation DeleteBranch($id: String!) {
  organizationServiceDeleteBranch(id: $id) {
    id
    name
    address
    status
    organizationId
    tenantId
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

export const useDeleteBranchMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteBranchMutation, TError, DeleteBranchMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteBranchMutation, TError, DeleteBranchMutationVariables, TContext>(
      {
    mutationKey: ['DeleteBranch'],
    mutationFn: (variables?: DeleteBranchMutationVariables) => fetcher<DeleteBranchMutation, DeleteBranchMutationVariables>(client, DeleteBranchDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteBranchMutation.getKey = () => ['DeleteBranch'];


useDeleteBranchMutation.fetcher = (client: GraphQLClient, variables: DeleteBranchMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteBranchMutation, DeleteBranchMutationVariables>(client, DeleteBranchDocument, variables, headers);

export const CreateArticleDocument = `
    mutation createArticle($input: ContentServiceArticleGqlInput!) {
  contentServiceCreateArticle(input: $input) {
    id
  }
}
    `;

export const useCreateArticleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateArticleMutation, TError, CreateArticleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateArticleMutation, TError, CreateArticleMutationVariables, TContext>(
      {
    mutationKey: ['createArticle'],
    mutationFn: (variables?: CreateArticleMutationVariables) => fetcher<CreateArticleMutation, CreateArticleMutationVariables>(client, CreateArticleDocument, variables, headers)(),
    ...options
  }
    )};

useCreateArticleMutation.getKey = () => ['createArticle'];


useCreateArticleMutation.fetcher = (client: GraphQLClient, variables: CreateArticleMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateArticleMutation, CreateArticleMutationVariables>(client, CreateArticleDocument, variables, headers);

export const GetAllArticlesDocument = `
    query getAllArticles($pagination: PaginationArgs!, $input: ContentServiceSearchArticleGqlInput!) {
  contentServiceGetAllArticles(pagination: $pagination, input: $input) {
    id
    title
    tags
    status
    publishedAt
    tenantId
    viewCount
    category
    categoryIds
    content
    contentType
    updatedAt
    description
    isFeatured
    displayEndDate
    displayStartDate
    isMostViewed
    eventDate
    imageUrl
    createdAt
  }
}
    `;

export const useGetAllArticlesQuery = <
      TData = GetAllArticlesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllArticlesQueryVariables,
      options?: Omit<UseQueryOptions<GetAllArticlesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllArticlesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllArticlesQuery, TError, TData>(
      {
    queryKey: ['getAllArticles', variables],
    queryFn: fetcher<GetAllArticlesQuery, GetAllArticlesQueryVariables>(client, GetAllArticlesDocument, variables, headers),
    ...options
  }
    )};

useGetAllArticlesQuery.getKey = (variables: GetAllArticlesQueryVariables) => ['getAllArticles', variables];

export const useInfiniteGetAllArticlesQuery = <
      TData = InfiniteData<GetAllArticlesQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllArticlesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAllArticlesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAllArticlesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetAllArticlesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAllArticles.infinite', variables],
      queryFn: (metaData) => fetcher<GetAllArticlesQuery, GetAllArticlesQueryVariables>(client, GetAllArticlesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAllArticlesQuery.getKey = (variables: GetAllArticlesQueryVariables) => ['getAllArticles.infinite', variables];


useGetAllArticlesQuery.fetcher = (client: GraphQLClient, variables: GetAllArticlesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllArticlesQuery, GetAllArticlesQueryVariables>(client, GetAllArticlesDocument, variables, headers);

export const GetArticleByIdDocument = `
    query getArticleById($id: String!) {
  contentServiceArticle(id: $id) {
    id
    title
    tags
    status
    publishedAt
    tenantId
    viewCount
    category
    categoryIds
    content
    contentType
    createdAt
    imageUrl
    description
    updatedAt
    createdAt
    contentId
    isFeatured
    displayEndDate
    displayStartDate
    isMostViewed
  }
}
    `;

export const useGetArticleByIdQuery = <
      TData = GetArticleByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetArticleByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetArticleByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetArticleByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetArticleByIdQuery, TError, TData>(
      {
    queryKey: ['getArticleById', variables],
    queryFn: fetcher<GetArticleByIdQuery, GetArticleByIdQueryVariables>(client, GetArticleByIdDocument, variables, headers),
    ...options
  }
    )};

useGetArticleByIdQuery.getKey = (variables: GetArticleByIdQueryVariables) => ['getArticleById', variables];

export const useInfiniteGetArticleByIdQuery = <
      TData = InfiniteData<GetArticleByIdQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetArticleByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetArticleByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetArticleByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetArticleByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getArticleById.infinite', variables],
      queryFn: (metaData) => fetcher<GetArticleByIdQuery, GetArticleByIdQueryVariables>(client, GetArticleByIdDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetArticleByIdQuery.getKey = (variables: GetArticleByIdQueryVariables) => ['getArticleById.infinite', variables];


useGetArticleByIdQuery.fetcher = (client: GraphQLClient, variables: GetArticleByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetArticleByIdQuery, GetArticleByIdQueryVariables>(client, GetArticleByIdDocument, variables, headers);

export const UpdateArticleDocument = `
    mutation updateArticle($id: String!, $input: ContentServiceUpdateArticleGqlInput!) {
  contentServiceUpdateArticle(id: $id, input: $input)
}
    `;

export const useUpdateArticleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateArticleMutation, TError, UpdateArticleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateArticleMutation, TError, UpdateArticleMutationVariables, TContext>(
      {
    mutationKey: ['updateArticle'],
    mutationFn: (variables?: UpdateArticleMutationVariables) => fetcher<UpdateArticleMutation, UpdateArticleMutationVariables>(client, UpdateArticleDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateArticleMutation.getKey = () => ['updateArticle'];


useUpdateArticleMutation.fetcher = (client: GraphQLClient, variables: UpdateArticleMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateArticleMutation, UpdateArticleMutationVariables>(client, UpdateArticleDocument, variables, headers);

export const DeleteArticlesDocument = `
    mutation deleteArticles($ids: [String!]!) {
  contentServiceDeleteArticles(ids: $ids)
}
    `;

export const useDeleteArticlesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteArticlesMutation, TError, DeleteArticlesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<DeleteArticlesMutation, TError, DeleteArticlesMutationVariables, TContext>(
      {
    mutationKey: ['deleteArticles'],
    mutationFn: (variables?: DeleteArticlesMutationVariables) => fetcher<DeleteArticlesMutation, DeleteArticlesMutationVariables>(client, DeleteArticlesDocument, variables, headers)(),
    ...options
  }
    )};

useDeleteArticlesMutation.getKey = () => ['deleteArticles'];


useDeleteArticlesMutation.fetcher = (client: GraphQLClient, variables: DeleteArticlesMutationVariables, headers?: RequestInit['headers']) => fetcher<DeleteArticlesMutation, DeleteArticlesMutationVariables>(client, DeleteArticlesDocument, variables, headers);

export const UpdateArticleStatusDocument = `
    mutation updateArticleStatus($id: String!, $status: ContentStatusEnum!) {
  contentServiceUpdateArticleStatus(id: $id, status: $status)
}
    `;

export const useUpdateArticleStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateArticleStatusMutation, TError, UpdateArticleStatusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateArticleStatusMutation, TError, UpdateArticleStatusMutationVariables, TContext>(
      {
    mutationKey: ['updateArticleStatus'],
    mutationFn: (variables?: UpdateArticleStatusMutationVariables) => fetcher<UpdateArticleStatusMutation, UpdateArticleStatusMutationVariables>(client, UpdateArticleStatusDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateArticleStatusMutation.getKey = () => ['updateArticleStatus'];


useUpdateArticleStatusMutation.fetcher = (client: GraphQLClient, variables: UpdateArticleStatusMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateArticleStatusMutation, UpdateArticleStatusMutationVariables>(client, UpdateArticleStatusDocument, variables, headers);

export const ContentCreateCategoryDocument = `
    mutation ContentCreateCategory($input: ContentServiceCreateCategoryGqlInput!) {
  contentServiceCreateCategory(input: $input)
}
    `;

export const useContentCreateCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ContentCreateCategoryMutation, TError, ContentCreateCategoryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ContentCreateCategoryMutation, TError, ContentCreateCategoryMutationVariables, TContext>(
      {
    mutationKey: ['ContentCreateCategory'],
    mutationFn: (variables?: ContentCreateCategoryMutationVariables) => fetcher<ContentCreateCategoryMutation, ContentCreateCategoryMutationVariables>(client, ContentCreateCategoryDocument, variables, headers)(),
    ...options
  }
    )};

useContentCreateCategoryMutation.getKey = () => ['ContentCreateCategory'];


useContentCreateCategoryMutation.fetcher = (client: GraphQLClient, variables: ContentCreateCategoryMutationVariables, headers?: RequestInit['headers']) => fetcher<ContentCreateCategoryMutation, ContentCreateCategoryMutationVariables>(client, ContentCreateCategoryDocument, variables, headers);

export const ContentUpdateCategoryDocument = `
    mutation ContentUpdateCategory($id: String!, $input: ContentServiceCreateCategoryGqlInput!) {
  contentServiceUpdateCategory(id: $id, input: $input)
}
    `;

export const useContentUpdateCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ContentUpdateCategoryMutation, TError, ContentUpdateCategoryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ContentUpdateCategoryMutation, TError, ContentUpdateCategoryMutationVariables, TContext>(
      {
    mutationKey: ['ContentUpdateCategory'],
    mutationFn: (variables?: ContentUpdateCategoryMutationVariables) => fetcher<ContentUpdateCategoryMutation, ContentUpdateCategoryMutationVariables>(client, ContentUpdateCategoryDocument, variables, headers)(),
    ...options
  }
    )};

useContentUpdateCategoryMutation.getKey = () => ['ContentUpdateCategory'];


useContentUpdateCategoryMutation.fetcher = (client: GraphQLClient, variables: ContentUpdateCategoryMutationVariables, headers?: RequestInit['headers']) => fetcher<ContentUpdateCategoryMutation, ContentUpdateCategoryMutationVariables>(client, ContentUpdateCategoryDocument, variables, headers);

export const ContentDeleteCategoryDocument = `
    mutation ContentDeleteCategory($id: String!) {
  contentServiceDeleteCategory(id: $id)
}
    `;

export const useContentDeleteCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ContentDeleteCategoryMutation, TError, ContentDeleteCategoryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ContentDeleteCategoryMutation, TError, ContentDeleteCategoryMutationVariables, TContext>(
      {
    mutationKey: ['ContentDeleteCategory'],
    mutationFn: (variables?: ContentDeleteCategoryMutationVariables) => fetcher<ContentDeleteCategoryMutation, ContentDeleteCategoryMutationVariables>(client, ContentDeleteCategoryDocument, variables, headers)(),
    ...options
  }
    )};

useContentDeleteCategoryMutation.getKey = () => ['ContentDeleteCategory'];


useContentDeleteCategoryMutation.fetcher = (client: GraphQLClient, variables: ContentDeleteCategoryMutationVariables, headers?: RequestInit['headers']) => fetcher<ContentDeleteCategoryMutation, ContentDeleteCategoryMutationVariables>(client, ContentDeleteCategoryDocument, variables, headers);

export const ContentGetAllCategoriesDocument = `
    query ContentGetAllCategories {
  contentServiceAllCategories {
    id
    tenantId
    name
    description
    iconUrl
    parentId
    isEnabled
    isDeleted
    parent {
      id
      name
      description
    }
    children {
      id
      name
      description
      iconUrl
      isEnabled
    }
    createdAt
    updatedAt
  }
}
    `;

export const useContentGetAllCategoriesQuery = <
      TData = ContentGetAllCategoriesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ContentGetAllCategoriesQueryVariables,
      options?: Omit<UseQueryOptions<ContentGetAllCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ContentGetAllCategoriesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<ContentGetAllCategoriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ContentGetAllCategories'] : ['ContentGetAllCategories', variables],
    queryFn: fetcher<ContentGetAllCategoriesQuery, ContentGetAllCategoriesQueryVariables>(client, ContentGetAllCategoriesDocument, variables, headers),
    ...options
  }
    )};

useContentGetAllCategoriesQuery.getKey = (variables?: ContentGetAllCategoriesQueryVariables) => variables === undefined ? ['ContentGetAllCategories'] : ['ContentGetAllCategories', variables];

export const useInfiniteContentGetAllCategoriesQuery = <
      TData = InfiniteData<ContentGetAllCategoriesQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ContentGetAllCategoriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ContentGetAllCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ContentGetAllCategoriesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<ContentGetAllCategoriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ContentGetAllCategories.infinite'] : ['ContentGetAllCategories.infinite', variables],
      queryFn: (metaData) => fetcher<ContentGetAllCategoriesQuery, ContentGetAllCategoriesQueryVariables>(client, ContentGetAllCategoriesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteContentGetAllCategoriesQuery.getKey = (variables?: ContentGetAllCategoriesQueryVariables) => variables === undefined ? ['ContentGetAllCategories.infinite'] : ['ContentGetAllCategories.infinite', variables];


useContentGetAllCategoriesQuery.fetcher = (client: GraphQLClient, variables?: ContentGetAllCategoriesQueryVariables, headers?: RequestInit['headers']) => fetcher<ContentGetAllCategoriesQuery, ContentGetAllCategoriesQueryVariables>(client, ContentGetAllCategoriesDocument, variables, headers);

export const CreateEventsDocument = `
    mutation createEvents($input: EventServiceEventGqlInput!) {
  eventServiceCreateEvent(input: $input)
}
    `;

export const useCreateEventsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateEventsMutation, TError, CreateEventsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateEventsMutation, TError, CreateEventsMutationVariables, TContext>(
      {
    mutationKey: ['createEvents'],
    mutationFn: (variables?: CreateEventsMutationVariables) => fetcher<CreateEventsMutation, CreateEventsMutationVariables>(client, CreateEventsDocument, variables, headers)(),
    ...options
  }
    )};

useCreateEventsMutation.getKey = () => ['createEvents'];


useCreateEventsMutation.fetcher = (client: GraphQLClient, variables: CreateEventsMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateEventsMutation, CreateEventsMutationVariables>(client, CreateEventsDocument, variables, headers);

export const GetAllEventsDocument = `
    query getAllEvents($pagination: PaginationArgs!, $input: EventServiceSearchEventGqlInput!) {
  eventServiceAllEvents(pagination: $pagination, input: $input) {
    id
    name
    status
    content
    startDate
    description
    thumbnailUrl
    startDate
    endDate
    contentId
    categoryIds
    createdAt
    updatedAt
    tenantId
  }
}
    `;

export const useGetAllEventsQuery = <
      TData = GetAllEventsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllEventsQueryVariables,
      options?: Omit<UseQueryOptions<GetAllEventsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllEventsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllEventsQuery, TError, TData>(
      {
    queryKey: ['getAllEvents', variables],
    queryFn: fetcher<GetAllEventsQuery, GetAllEventsQueryVariables>(client, GetAllEventsDocument, variables, headers),
    ...options
  }
    )};

useGetAllEventsQuery.getKey = (variables: GetAllEventsQueryVariables) => ['getAllEvents', variables];

export const useInfiniteGetAllEventsQuery = <
      TData = InfiniteData<GetAllEventsQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllEventsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAllEventsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAllEventsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetAllEventsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAllEvents.infinite', variables],
      queryFn: (metaData) => fetcher<GetAllEventsQuery, GetAllEventsQueryVariables>(client, GetAllEventsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAllEventsQuery.getKey = (variables: GetAllEventsQueryVariables) => ['getAllEvents.infinite', variables];


useGetAllEventsQuery.fetcher = (client: GraphQLClient, variables: GetAllEventsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllEventsQuery, GetAllEventsQueryVariables>(client, GetAllEventsDocument, variables, headers);

export const GetEventDetailDocument = `
    query getEventDetail($eventServiceEventByIdId: String!) {
  eventServiceEventById(id: $eventServiceEventByIdId) {
    id
    name
    status
    content
    startDate
    description
    thumbnailUrl
    startDate
    endDate
    location
    organizerName
    organizerEmail
    bannerUrl
    contentId
    categoryIds
    createdAt
    updatedAt
  }
}
    `;

export const useGetEventDetailQuery = <
      TData = GetEventDetailQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEventDetailQueryVariables,
      options?: Omit<UseQueryOptions<GetEventDetailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetEventDetailQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetEventDetailQuery, TError, TData>(
      {
    queryKey: ['getEventDetail', variables],
    queryFn: fetcher<GetEventDetailQuery, GetEventDetailQueryVariables>(client, GetEventDetailDocument, variables, headers),
    ...options
  }
    )};

useGetEventDetailQuery.getKey = (variables: GetEventDetailQueryVariables) => ['getEventDetail', variables];

export const useInfiniteGetEventDetailQuery = <
      TData = InfiniteData<GetEventDetailQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEventDetailQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetEventDetailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetEventDetailQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetEventDetailQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getEventDetail.infinite', variables],
      queryFn: (metaData) => fetcher<GetEventDetailQuery, GetEventDetailQueryVariables>(client, GetEventDetailDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetEventDetailQuery.getKey = (variables: GetEventDetailQueryVariables) => ['getEventDetail.infinite', variables];


useGetEventDetailQuery.fetcher = (client: GraphQLClient, variables: GetEventDetailQueryVariables, headers?: RequestInit['headers']) => fetcher<GetEventDetailQuery, GetEventDetailQueryVariables>(client, GetEventDetailDocument, variables, headers);

export const UpdateEventsDocument = `
    mutation updateEvents($eventServiceUpdateEventId: String!, $eventServiceUpdateEventInput: EventServiceEventGqlInput!) {
  eventServiceUpdateEvent(
    id: $eventServiceUpdateEventId
    input: $eventServiceUpdateEventInput
  )
}
    `;

export const useUpdateEventsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateEventsMutation, TError, UpdateEventsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateEventsMutation, TError, UpdateEventsMutationVariables, TContext>(
      {
    mutationKey: ['updateEvents'],
    mutationFn: (variables?: UpdateEventsMutationVariables) => fetcher<UpdateEventsMutation, UpdateEventsMutationVariables>(client, UpdateEventsDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateEventsMutation.getKey = () => ['updateEvents'];


useUpdateEventsMutation.fetcher = (client: GraphQLClient, variables: UpdateEventsMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateEventsMutation, UpdateEventsMutationVariables>(client, UpdateEventsDocument, variables, headers);

export const EventServiceDeleteEventsDocument = `
    mutation eventServiceDeleteEvents($ids: [String!]!) {
  eventServiceDeleteEvents(ids: $ids)
}
    `;

export const useEventServiceDeleteEventsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EventServiceDeleteEventsMutation, TError, EventServiceDeleteEventsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<EventServiceDeleteEventsMutation, TError, EventServiceDeleteEventsMutationVariables, TContext>(
      {
    mutationKey: ['eventServiceDeleteEvents'],
    mutationFn: (variables?: EventServiceDeleteEventsMutationVariables) => fetcher<EventServiceDeleteEventsMutation, EventServiceDeleteEventsMutationVariables>(client, EventServiceDeleteEventsDocument, variables, headers)(),
    ...options
  }
    )};

useEventServiceDeleteEventsMutation.getKey = () => ['eventServiceDeleteEvents'];


useEventServiceDeleteEventsMutation.fetcher = (client: GraphQLClient, variables: EventServiceDeleteEventsMutationVariables, headers?: RequestInit['headers']) => fetcher<EventServiceDeleteEventsMutation, EventServiceDeleteEventsMutationVariables>(client, EventServiceDeleteEventsDocument, variables, headers);

export const EventCreateCategoryDocument = `
    mutation EventCreateCategory($input: EventServiceCreateCategoryGqlInput!) {
  eventServiceCreateCategory(input: $input)
}
    `;

export const useEventCreateCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EventCreateCategoryMutation, TError, EventCreateCategoryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<EventCreateCategoryMutation, TError, EventCreateCategoryMutationVariables, TContext>(
      {
    mutationKey: ['EventCreateCategory'],
    mutationFn: (variables?: EventCreateCategoryMutationVariables) => fetcher<EventCreateCategoryMutation, EventCreateCategoryMutationVariables>(client, EventCreateCategoryDocument, variables, headers)(),
    ...options
  }
    )};

useEventCreateCategoryMutation.getKey = () => ['EventCreateCategory'];


useEventCreateCategoryMutation.fetcher = (client: GraphQLClient, variables: EventCreateCategoryMutationVariables, headers?: RequestInit['headers']) => fetcher<EventCreateCategoryMutation, EventCreateCategoryMutationVariables>(client, EventCreateCategoryDocument, variables, headers);

export const EventUpdateCategoryDocument = `
    mutation EventUpdateCategory($id: String!, $input: EventServiceCreateCategoryGqlInput!) {
  eventServiceUpdateCategory(id: $id, input: $input)
}
    `;

export const useEventUpdateCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EventUpdateCategoryMutation, TError, EventUpdateCategoryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<EventUpdateCategoryMutation, TError, EventUpdateCategoryMutationVariables, TContext>(
      {
    mutationKey: ['EventUpdateCategory'],
    mutationFn: (variables?: EventUpdateCategoryMutationVariables) => fetcher<EventUpdateCategoryMutation, EventUpdateCategoryMutationVariables>(client, EventUpdateCategoryDocument, variables, headers)(),
    ...options
  }
    )};

useEventUpdateCategoryMutation.getKey = () => ['EventUpdateCategory'];


useEventUpdateCategoryMutation.fetcher = (client: GraphQLClient, variables: EventUpdateCategoryMutationVariables, headers?: RequestInit['headers']) => fetcher<EventUpdateCategoryMutation, EventUpdateCategoryMutationVariables>(client, EventUpdateCategoryDocument, variables, headers);

export const EventDeleteCategoryDocument = `
    mutation EventDeleteCategory($id: String!) {
  eventServiceDeleteCategory(id: $id)
}
    `;

export const useEventDeleteCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EventDeleteCategoryMutation, TError, EventDeleteCategoryMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<EventDeleteCategoryMutation, TError, EventDeleteCategoryMutationVariables, TContext>(
      {
    mutationKey: ['EventDeleteCategory'],
    mutationFn: (variables?: EventDeleteCategoryMutationVariables) => fetcher<EventDeleteCategoryMutation, EventDeleteCategoryMutationVariables>(client, EventDeleteCategoryDocument, variables, headers)(),
    ...options
  }
    )};

useEventDeleteCategoryMutation.getKey = () => ['EventDeleteCategory'];


useEventDeleteCategoryMutation.fetcher = (client: GraphQLClient, variables: EventDeleteCategoryMutationVariables, headers?: RequestInit['headers']) => fetcher<EventDeleteCategoryMutation, EventDeleteCategoryMutationVariables>(client, EventDeleteCategoryDocument, variables, headers);

export const EventGetAllCategoriesDocument = `
    query EventGetAllCategories {
  eventServiceAllCategories {
    id
    tenantId
    name
    description
    iconUrl
    parentId
    isEnabled
    isDeleted
    parent {
      id
      name
      description
    }
    children {
      id
      name
      description
      iconUrl
      isEnabled
    }
    createdAt
    updatedAt
  }
}
    `;

export const useEventGetAllCategoriesQuery = <
      TData = EventGetAllCategoriesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: EventGetAllCategoriesQueryVariables,
      options?: Omit<UseQueryOptions<EventGetAllCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EventGetAllCategoriesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<EventGetAllCategoriesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['EventGetAllCategories'] : ['EventGetAllCategories', variables],
    queryFn: fetcher<EventGetAllCategoriesQuery, EventGetAllCategoriesQueryVariables>(client, EventGetAllCategoriesDocument, variables, headers),
    ...options
  }
    )};

useEventGetAllCategoriesQuery.getKey = (variables?: EventGetAllCategoriesQueryVariables) => variables === undefined ? ['EventGetAllCategories'] : ['EventGetAllCategories', variables];

export const useInfiniteEventGetAllCategoriesQuery = <
      TData = InfiniteData<EventGetAllCategoriesQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: EventGetAllCategoriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<EventGetAllCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<EventGetAllCategoriesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<EventGetAllCategoriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['EventGetAllCategories.infinite'] : ['EventGetAllCategories.infinite', variables],
      queryFn: (metaData) => fetcher<EventGetAllCategoriesQuery, EventGetAllCategoriesQueryVariables>(client, EventGetAllCategoriesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteEventGetAllCategoriesQuery.getKey = (variables?: EventGetAllCategoriesQueryVariables) => variables === undefined ? ['EventGetAllCategories.infinite'] : ['EventGetAllCategories.infinite', variables];


useEventGetAllCategoriesQuery.fetcher = (client: GraphQLClient, variables?: EventGetAllCategoriesQueryVariables, headers?: RequestInit['headers']) => fetcher<EventGetAllCategoriesQuery, EventGetAllCategoriesQueryVariables>(client, EventGetAllCategoriesDocument, variables, headers);

export const FeatureFlagServiceGetAllFeatureFlagsDocument = `
    query featureFlagServiceGetAllFeatureFlags($input: FeatureFlagServiceGetAllFeatureFlagGqlInput!) {
  featureFlagServiceGetAllFeatureFlags(input: $input) {
    id
    description
    featureCode
    isEnabled
    createdAt
    updatedAt
    tenantId
    type
    rules {
      conditions {
        key
        operator
        values
      }
      priority
    }
  }
}
    `;

export const useFeatureFlagServiceGetAllFeatureFlagsQuery = <
      TData = FeatureFlagServiceGetAllFeatureFlagsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FeatureFlagServiceGetAllFeatureFlagsQueryVariables,
      options?: Omit<UseQueryOptions<FeatureFlagServiceGetAllFeatureFlagsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeatureFlagServiceGetAllFeatureFlagsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<FeatureFlagServiceGetAllFeatureFlagsQuery, TError, TData>(
      {
    queryKey: ['featureFlagServiceGetAllFeatureFlags', variables],
    queryFn: fetcher<FeatureFlagServiceGetAllFeatureFlagsQuery, FeatureFlagServiceGetAllFeatureFlagsQueryVariables>(client, FeatureFlagServiceGetAllFeatureFlagsDocument, variables, headers),
    ...options
  }
    )};

useFeatureFlagServiceGetAllFeatureFlagsQuery.getKey = (variables: FeatureFlagServiceGetAllFeatureFlagsQueryVariables) => ['featureFlagServiceGetAllFeatureFlags', variables];

export const useInfiniteFeatureFlagServiceGetAllFeatureFlagsQuery = <
      TData = InfiniteData<FeatureFlagServiceGetAllFeatureFlagsQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FeatureFlagServiceGetAllFeatureFlagsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FeatureFlagServiceGetAllFeatureFlagsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FeatureFlagServiceGetAllFeatureFlagsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<FeatureFlagServiceGetAllFeatureFlagsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['featureFlagServiceGetAllFeatureFlags.infinite', variables],
      queryFn: (metaData) => fetcher<FeatureFlagServiceGetAllFeatureFlagsQuery, FeatureFlagServiceGetAllFeatureFlagsQueryVariables>(client, FeatureFlagServiceGetAllFeatureFlagsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteFeatureFlagServiceGetAllFeatureFlagsQuery.getKey = (variables: FeatureFlagServiceGetAllFeatureFlagsQueryVariables) => ['featureFlagServiceGetAllFeatureFlags.infinite', variables];


useFeatureFlagServiceGetAllFeatureFlagsQuery.fetcher = (client: GraphQLClient, variables: FeatureFlagServiceGetAllFeatureFlagsQueryVariables, headers?: RequestInit['headers']) => fetcher<FeatureFlagServiceGetAllFeatureFlagsQuery, FeatureFlagServiceGetAllFeatureFlagsQueryVariables>(client, FeatureFlagServiceGetAllFeatureFlagsDocument, variables, headers);

export const FeatureFlagServiceCreateFeatureFlagDocument = `
    mutation featureFlagServiceCreateFeatureFlag($input: FeatureFlagServiceCreateFeatureFlagGqlInput!) {
  featureFlagServiceCreateFeatureFlag(input: $input)
}
    `;

export const useFeatureFlagServiceCreateFeatureFlagMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FeatureFlagServiceCreateFeatureFlagMutation, TError, FeatureFlagServiceCreateFeatureFlagMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FeatureFlagServiceCreateFeatureFlagMutation, TError, FeatureFlagServiceCreateFeatureFlagMutationVariables, TContext>(
      {
    mutationKey: ['featureFlagServiceCreateFeatureFlag'],
    mutationFn: (variables?: FeatureFlagServiceCreateFeatureFlagMutationVariables) => fetcher<FeatureFlagServiceCreateFeatureFlagMutation, FeatureFlagServiceCreateFeatureFlagMutationVariables>(client, FeatureFlagServiceCreateFeatureFlagDocument, variables, headers)(),
    ...options
  }
    )};

useFeatureFlagServiceCreateFeatureFlagMutation.getKey = () => ['featureFlagServiceCreateFeatureFlag'];


useFeatureFlagServiceCreateFeatureFlagMutation.fetcher = (client: GraphQLClient, variables: FeatureFlagServiceCreateFeatureFlagMutationVariables, headers?: RequestInit['headers']) => fetcher<FeatureFlagServiceCreateFeatureFlagMutation, FeatureFlagServiceCreateFeatureFlagMutationVariables>(client, FeatureFlagServiceCreateFeatureFlagDocument, variables, headers);

export const FeatureFlagServiceDeleteFeatureFlagDocument = `
    mutation featureFlagServiceDeleteFeatureFlag($featureFlagId: String!, $type: FeatureFlagTypeEnum!) {
  featureFlagServiceDeleteFeatureFlag(featureFlagId: $featureFlagId, type: $type)
}
    `;

export const useFeatureFlagServiceDeleteFeatureFlagMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FeatureFlagServiceDeleteFeatureFlagMutation, TError, FeatureFlagServiceDeleteFeatureFlagMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FeatureFlagServiceDeleteFeatureFlagMutation, TError, FeatureFlagServiceDeleteFeatureFlagMutationVariables, TContext>(
      {
    mutationKey: ['featureFlagServiceDeleteFeatureFlag'],
    mutationFn: (variables?: FeatureFlagServiceDeleteFeatureFlagMutationVariables) => fetcher<FeatureFlagServiceDeleteFeatureFlagMutation, FeatureFlagServiceDeleteFeatureFlagMutationVariables>(client, FeatureFlagServiceDeleteFeatureFlagDocument, variables, headers)(),
    ...options
  }
    )};

useFeatureFlagServiceDeleteFeatureFlagMutation.getKey = () => ['featureFlagServiceDeleteFeatureFlag'];


useFeatureFlagServiceDeleteFeatureFlagMutation.fetcher = (client: GraphQLClient, variables: FeatureFlagServiceDeleteFeatureFlagMutationVariables, headers?: RequestInit['headers']) => fetcher<FeatureFlagServiceDeleteFeatureFlagMutation, FeatureFlagServiceDeleteFeatureFlagMutationVariables>(client, FeatureFlagServiceDeleteFeatureFlagDocument, variables, headers);

export const FeatureFlagServiceGetFeatureFlagDetailDocument = `
    query featureFlagServiceGetFeatureFlagDetail($input: FeatureFlagServiceGetFeatureFlagDetailGqlInput!) {
  featureFlagServiceGetFeatureFlagDetail(input: $input) {
    id
    featureCode
    description
    isEnabled
    createdAt
    updatedAt
    tenantId
    type
    rules {
      isEnabled
      conditions {
        key
        operator
        values
      }
      priority
    }
  }
}
    `;

export const useFeatureFlagServiceGetFeatureFlagDetailQuery = <
      TData = FeatureFlagServiceGetFeatureFlagDetailQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FeatureFlagServiceGetFeatureFlagDetailQueryVariables,
      options?: Omit<UseQueryOptions<FeatureFlagServiceGetFeatureFlagDetailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeatureFlagServiceGetFeatureFlagDetailQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<FeatureFlagServiceGetFeatureFlagDetailQuery, TError, TData>(
      {
    queryKey: ['featureFlagServiceGetFeatureFlagDetail', variables],
    queryFn: fetcher<FeatureFlagServiceGetFeatureFlagDetailQuery, FeatureFlagServiceGetFeatureFlagDetailQueryVariables>(client, FeatureFlagServiceGetFeatureFlagDetailDocument, variables, headers),
    ...options
  }
    )};

useFeatureFlagServiceGetFeatureFlagDetailQuery.getKey = (variables: FeatureFlagServiceGetFeatureFlagDetailQueryVariables) => ['featureFlagServiceGetFeatureFlagDetail', variables];

export const useInfiniteFeatureFlagServiceGetFeatureFlagDetailQuery = <
      TData = InfiniteData<FeatureFlagServiceGetFeatureFlagDetailQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FeatureFlagServiceGetFeatureFlagDetailQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FeatureFlagServiceGetFeatureFlagDetailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FeatureFlagServiceGetFeatureFlagDetailQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<FeatureFlagServiceGetFeatureFlagDetailQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['featureFlagServiceGetFeatureFlagDetail.infinite', variables],
      queryFn: (metaData) => fetcher<FeatureFlagServiceGetFeatureFlagDetailQuery, FeatureFlagServiceGetFeatureFlagDetailQueryVariables>(client, FeatureFlagServiceGetFeatureFlagDetailDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteFeatureFlagServiceGetFeatureFlagDetailQuery.getKey = (variables: FeatureFlagServiceGetFeatureFlagDetailQueryVariables) => ['featureFlagServiceGetFeatureFlagDetail.infinite', variables];


useFeatureFlagServiceGetFeatureFlagDetailQuery.fetcher = (client: GraphQLClient, variables: FeatureFlagServiceGetFeatureFlagDetailQueryVariables, headers?: RequestInit['headers']) => fetcher<FeatureFlagServiceGetFeatureFlagDetailQuery, FeatureFlagServiceGetFeatureFlagDetailQueryVariables>(client, FeatureFlagServiceGetFeatureFlagDetailDocument, variables, headers);

export const FeatureFlagServiceUpdateFeatureFlagDocument = `
    mutation featureFlagServiceUpdateFeatureFlag($input: FeatureFlagServiceUpdateFeatureFlagGqlInput!, $id: String!) {
  featureFlagServiceUpdateFeatureFlag(input: $input, featureFlagId: $id)
}
    `;

export const useFeatureFlagServiceUpdateFeatureFlagMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FeatureFlagServiceUpdateFeatureFlagMutation, TError, FeatureFlagServiceUpdateFeatureFlagMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FeatureFlagServiceUpdateFeatureFlagMutation, TError, FeatureFlagServiceUpdateFeatureFlagMutationVariables, TContext>(
      {
    mutationKey: ['featureFlagServiceUpdateFeatureFlag'],
    mutationFn: (variables?: FeatureFlagServiceUpdateFeatureFlagMutationVariables) => fetcher<FeatureFlagServiceUpdateFeatureFlagMutation, FeatureFlagServiceUpdateFeatureFlagMutationVariables>(client, FeatureFlagServiceUpdateFeatureFlagDocument, variables, headers)(),
    ...options
  }
    )};

useFeatureFlagServiceUpdateFeatureFlagMutation.getKey = () => ['featureFlagServiceUpdateFeatureFlag'];


useFeatureFlagServiceUpdateFeatureFlagMutation.fetcher = (client: GraphQLClient, variables: FeatureFlagServiceUpdateFeatureFlagMutationVariables, headers?: RequestInit['headers']) => fetcher<FeatureFlagServiceUpdateFeatureFlagMutation, FeatureFlagServiceUpdateFeatureFlagMutationVariables>(client, FeatureFlagServiceUpdateFeatureFlagDocument, variables, headers);

export const FeatureFlagServiceToggleFeatureFlagDocument = `
    mutation featureFlagServiceToggleFeatureFlag($id: String!, $type: FeatureFlagTypeEnum!) {
  featureFlagServiceToggleFeatureFlagById(featureFlagId: $id, type: $type) {
    id
  }
}
    `;

export const useFeatureFlagServiceToggleFeatureFlagMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FeatureFlagServiceToggleFeatureFlagMutation, TError, FeatureFlagServiceToggleFeatureFlagMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FeatureFlagServiceToggleFeatureFlagMutation, TError, FeatureFlagServiceToggleFeatureFlagMutationVariables, TContext>(
      {
    mutationKey: ['featureFlagServiceToggleFeatureFlag'],
    mutationFn: (variables?: FeatureFlagServiceToggleFeatureFlagMutationVariables) => fetcher<FeatureFlagServiceToggleFeatureFlagMutation, FeatureFlagServiceToggleFeatureFlagMutationVariables>(client, FeatureFlagServiceToggleFeatureFlagDocument, variables, headers)(),
    ...options
  }
    )};

useFeatureFlagServiceToggleFeatureFlagMutation.getKey = () => ['featureFlagServiceToggleFeatureFlag'];


useFeatureFlagServiceToggleFeatureFlagMutation.fetcher = (client: GraphQLClient, variables: FeatureFlagServiceToggleFeatureFlagMutationVariables, headers?: RequestInit['headers']) => fetcher<FeatureFlagServiceToggleFeatureFlagMutation, FeatureFlagServiceToggleFeatureFlagMutationVariables>(client, FeatureFlagServiceToggleFeatureFlagDocument, variables, headers);

export const GetEnabledFeatureFlagsDocument = `
    query getEnabledFeatureFlags($input: FeatureFlagServiceGetFeatureFlagGqlInput!) {
  featureFlagServiceGetEnabledFeatureFlags(input: $input) {
    featureCode
  }
}
    `;

export const useGetEnabledFeatureFlagsQuery = <
      TData = GetEnabledFeatureFlagsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEnabledFeatureFlagsQueryVariables,
      options?: Omit<UseQueryOptions<GetEnabledFeatureFlagsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetEnabledFeatureFlagsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetEnabledFeatureFlagsQuery, TError, TData>(
      {
    queryKey: ['getEnabledFeatureFlags', variables],
    queryFn: fetcher<GetEnabledFeatureFlagsQuery, GetEnabledFeatureFlagsQueryVariables>(client, GetEnabledFeatureFlagsDocument, variables, headers),
    ...options
  }
    )};

useGetEnabledFeatureFlagsQuery.getKey = (variables: GetEnabledFeatureFlagsQueryVariables) => ['getEnabledFeatureFlags', variables];

export const useInfiniteGetEnabledFeatureFlagsQuery = <
      TData = InfiniteData<GetEnabledFeatureFlagsQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEnabledFeatureFlagsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetEnabledFeatureFlagsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetEnabledFeatureFlagsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetEnabledFeatureFlagsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getEnabledFeatureFlags.infinite', variables],
      queryFn: (metaData) => fetcher<GetEnabledFeatureFlagsQuery, GetEnabledFeatureFlagsQueryVariables>(client, GetEnabledFeatureFlagsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetEnabledFeatureFlagsQuery.getKey = (variables: GetEnabledFeatureFlagsQueryVariables) => ['getEnabledFeatureFlags.infinite', variables];


useGetEnabledFeatureFlagsQuery.fetcher = (client: GraphQLClient, variables: GetEnabledFeatureFlagsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetEnabledFeatureFlagsQuery, GetEnabledFeatureFlagsQueryVariables>(client, GetEnabledFeatureFlagsDocument, variables, headers);

export const FeatureServiceGetFeatureListDocument = `
    query featureServiceGetFeatureList($input: FeatureServiceGetListGqlInput) {
  featureServiceGetFeatureList(input: $input) {
    data {
      id
      featureCode
      featureName
      isEnabled
      isDeleted
      createdAt
      updatedAt
    }
    total
    page
    limit
    totalPages
  }
}
    `;

export const useFeatureServiceGetFeatureListQuery = <
      TData = FeatureServiceGetFeatureListQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: FeatureServiceGetFeatureListQueryVariables,
      options?: Omit<UseQueryOptions<FeatureServiceGetFeatureListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeatureServiceGetFeatureListQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<FeatureServiceGetFeatureListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['featureServiceGetFeatureList'] : ['featureServiceGetFeatureList', variables],
    queryFn: fetcher<FeatureServiceGetFeatureListQuery, FeatureServiceGetFeatureListQueryVariables>(client, FeatureServiceGetFeatureListDocument, variables, headers),
    ...options
  }
    )};

useFeatureServiceGetFeatureListQuery.getKey = (variables?: FeatureServiceGetFeatureListQueryVariables) => variables === undefined ? ['featureServiceGetFeatureList'] : ['featureServiceGetFeatureList', variables];

export const useInfiniteFeatureServiceGetFeatureListQuery = <
      TData = InfiniteData<FeatureServiceGetFeatureListQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FeatureServiceGetFeatureListQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FeatureServiceGetFeatureListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FeatureServiceGetFeatureListQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<FeatureServiceGetFeatureListQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['featureServiceGetFeatureList.infinite'] : ['featureServiceGetFeatureList.infinite', variables],
      queryFn: (metaData) => fetcher<FeatureServiceGetFeatureListQuery, FeatureServiceGetFeatureListQueryVariables>(client, FeatureServiceGetFeatureListDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteFeatureServiceGetFeatureListQuery.getKey = (variables?: FeatureServiceGetFeatureListQueryVariables) => variables === undefined ? ['featureServiceGetFeatureList.infinite'] : ['featureServiceGetFeatureList.infinite', variables];


useFeatureServiceGetFeatureListQuery.fetcher = (client: GraphQLClient, variables?: FeatureServiceGetFeatureListQueryVariables, headers?: RequestInit['headers']) => fetcher<FeatureServiceGetFeatureListQuery, FeatureServiceGetFeatureListQueryVariables>(client, FeatureServiceGetFeatureListDocument, variables, headers);

export const FeatureServiceCreateFeatureDocument = `
    mutation featureServiceCreateFeature($input: FeatureServiceCreateFeatureGqlInput!) {
  featureServiceCreateFeature(input: $input)
}
    `;

export const useFeatureServiceCreateFeatureMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FeatureServiceCreateFeatureMutation, TError, FeatureServiceCreateFeatureMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FeatureServiceCreateFeatureMutation, TError, FeatureServiceCreateFeatureMutationVariables, TContext>(
      {
    mutationKey: ['featureServiceCreateFeature'],
    mutationFn: (variables?: FeatureServiceCreateFeatureMutationVariables) => fetcher<FeatureServiceCreateFeatureMutation, FeatureServiceCreateFeatureMutationVariables>(client, FeatureServiceCreateFeatureDocument, variables, headers)(),
    ...options
  }
    )};

useFeatureServiceCreateFeatureMutation.getKey = () => ['featureServiceCreateFeature'];


useFeatureServiceCreateFeatureMutation.fetcher = (client: GraphQLClient, variables: FeatureServiceCreateFeatureMutationVariables, headers?: RequestInit['headers']) => fetcher<FeatureServiceCreateFeatureMutation, FeatureServiceCreateFeatureMutationVariables>(client, FeatureServiceCreateFeatureDocument, variables, headers);

export const FeatureServiceCreateFeaturesDocument = `
    mutation featureServiceCreateFeatures($input: FeatureServiceCreateFeaturesGqlInput!) {
  featureServiceCreateFeatures(input: $input)
}
    `;

export const useFeatureServiceCreateFeaturesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FeatureServiceCreateFeaturesMutation, TError, FeatureServiceCreateFeaturesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FeatureServiceCreateFeaturesMutation, TError, FeatureServiceCreateFeaturesMutationVariables, TContext>(
      {
    mutationKey: ['featureServiceCreateFeatures'],
    mutationFn: (variables?: FeatureServiceCreateFeaturesMutationVariables) => fetcher<FeatureServiceCreateFeaturesMutation, FeatureServiceCreateFeaturesMutationVariables>(client, FeatureServiceCreateFeaturesDocument, variables, headers)(),
    ...options
  }
    )};

useFeatureServiceCreateFeaturesMutation.getKey = () => ['featureServiceCreateFeatures'];


useFeatureServiceCreateFeaturesMutation.fetcher = (client: GraphQLClient, variables: FeatureServiceCreateFeaturesMutationVariables, headers?: RequestInit['headers']) => fetcher<FeatureServiceCreateFeaturesMutation, FeatureServiceCreateFeaturesMutationVariables>(client, FeatureServiceCreateFeaturesDocument, variables, headers);

export const FeatureServiceDeleteFeatureDocument = `
    mutation featureServiceDeleteFeature($featureCode: String!) {
  featureServiceDeleteFeature(featureCode: $featureCode)
}
    `;

export const useFeatureServiceDeleteFeatureMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FeatureServiceDeleteFeatureMutation, TError, FeatureServiceDeleteFeatureMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FeatureServiceDeleteFeatureMutation, TError, FeatureServiceDeleteFeatureMutationVariables, TContext>(
      {
    mutationKey: ['featureServiceDeleteFeature'],
    mutationFn: (variables?: FeatureServiceDeleteFeatureMutationVariables) => fetcher<FeatureServiceDeleteFeatureMutation, FeatureServiceDeleteFeatureMutationVariables>(client, FeatureServiceDeleteFeatureDocument, variables, headers)(),
    ...options
  }
    )};

useFeatureServiceDeleteFeatureMutation.getKey = () => ['featureServiceDeleteFeature'];


useFeatureServiceDeleteFeatureMutation.fetcher = (client: GraphQLClient, variables: FeatureServiceDeleteFeatureMutationVariables, headers?: RequestInit['headers']) => fetcher<FeatureServiceDeleteFeatureMutation, FeatureServiceDeleteFeatureMutationVariables>(client, FeatureServiceDeleteFeatureDocument, variables, headers);

export const FeatureServiceToggleFeatureDocument = `
    mutation featureServiceToggleFeature($input: FeatureServiceToggleFeatureGqlInput!) {
  featureServiceToggleFeature(input: $input)
}
    `;

export const useFeatureServiceToggleFeatureMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FeatureServiceToggleFeatureMutation, TError, FeatureServiceToggleFeatureMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FeatureServiceToggleFeatureMutation, TError, FeatureServiceToggleFeatureMutationVariables, TContext>(
      {
    mutationKey: ['featureServiceToggleFeature'],
    mutationFn: (variables?: FeatureServiceToggleFeatureMutationVariables) => fetcher<FeatureServiceToggleFeatureMutation, FeatureServiceToggleFeatureMutationVariables>(client, FeatureServiceToggleFeatureDocument, variables, headers)(),
    ...options
  }
    )};

useFeatureServiceToggleFeatureMutation.getKey = () => ['featureServiceToggleFeature'];


useFeatureServiceToggleFeatureMutation.fetcher = (client: GraphQLClient, variables: FeatureServiceToggleFeatureMutationVariables, headers?: RequestInit['headers']) => fetcher<FeatureServiceToggleFeatureMutation, FeatureServiceToggleFeatureMutationVariables>(client, FeatureServiceToggleFeatureDocument, variables, headers);

export const FeatureServiceUpdateFeatureDocument = `
    mutation featureServiceUpdateFeature($featureCode: String!, $input: FeatureServiceUpdateFeatureGqlInput!) {
  featureServiceUpdateFeature(featureCode: $featureCode, input: $input)
}
    `;

export const useFeatureServiceUpdateFeatureMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FeatureServiceUpdateFeatureMutation, TError, FeatureServiceUpdateFeatureMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FeatureServiceUpdateFeatureMutation, TError, FeatureServiceUpdateFeatureMutationVariables, TContext>(
      {
    mutationKey: ['featureServiceUpdateFeature'],
    mutationFn: (variables?: FeatureServiceUpdateFeatureMutationVariables) => fetcher<FeatureServiceUpdateFeatureMutation, FeatureServiceUpdateFeatureMutationVariables>(client, FeatureServiceUpdateFeatureDocument, variables, headers)(),
    ...options
  }
    )};

useFeatureServiceUpdateFeatureMutation.getKey = () => ['featureServiceUpdateFeature'];


useFeatureServiceUpdateFeatureMutation.fetcher = (client: GraphQLClient, variables: FeatureServiceUpdateFeatureMutationVariables, headers?: RequestInit['headers']) => fetcher<FeatureServiceUpdateFeatureMutation, FeatureServiceUpdateFeatureMutationVariables>(client, FeatureServiceUpdateFeatureDocument, variables, headers);

export const FeatureFlagServiceGetTenantOverridesDocument = `
    query featureFlagServiceGetTenantOverrides {
  featureFlagServiceGetTenantOverrides {
    id
    featureCode
    isEnabled
    reason
    tenantId
    createdAt
    updatedAt
  }
}
    `;

export const useFeatureFlagServiceGetTenantOverridesQuery = <
      TData = FeatureFlagServiceGetTenantOverridesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: FeatureFlagServiceGetTenantOverridesQueryVariables,
      options?: Omit<UseQueryOptions<FeatureFlagServiceGetTenantOverridesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<FeatureFlagServiceGetTenantOverridesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<FeatureFlagServiceGetTenantOverridesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['featureFlagServiceGetTenantOverrides'] : ['featureFlagServiceGetTenantOverrides', variables],
    queryFn: fetcher<FeatureFlagServiceGetTenantOverridesQuery, FeatureFlagServiceGetTenantOverridesQueryVariables>(client, FeatureFlagServiceGetTenantOverridesDocument, variables, headers),
    ...options
  }
    )};

useFeatureFlagServiceGetTenantOverridesQuery.getKey = (variables?: FeatureFlagServiceGetTenantOverridesQueryVariables) => variables === undefined ? ['featureFlagServiceGetTenantOverrides'] : ['featureFlagServiceGetTenantOverrides', variables];

export const useInfiniteFeatureFlagServiceGetTenantOverridesQuery = <
      TData = InfiniteData<FeatureFlagServiceGetTenantOverridesQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: FeatureFlagServiceGetTenantOverridesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<FeatureFlagServiceGetTenantOverridesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<FeatureFlagServiceGetTenantOverridesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<FeatureFlagServiceGetTenantOverridesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['featureFlagServiceGetTenantOverrides.infinite'] : ['featureFlagServiceGetTenantOverrides.infinite', variables],
      queryFn: (metaData) => fetcher<FeatureFlagServiceGetTenantOverridesQuery, FeatureFlagServiceGetTenantOverridesQueryVariables>(client, FeatureFlagServiceGetTenantOverridesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteFeatureFlagServiceGetTenantOverridesQuery.getKey = (variables?: FeatureFlagServiceGetTenantOverridesQueryVariables) => variables === undefined ? ['featureFlagServiceGetTenantOverrides.infinite'] : ['featureFlagServiceGetTenantOverrides.infinite', variables];


useFeatureFlagServiceGetTenantOverridesQuery.fetcher = (client: GraphQLClient, variables?: FeatureFlagServiceGetTenantOverridesQueryVariables, headers?: RequestInit['headers']) => fetcher<FeatureFlagServiceGetTenantOverridesQuery, FeatureFlagServiceGetTenantOverridesQueryVariables>(client, FeatureFlagServiceGetTenantOverridesDocument, variables, headers);

export const FeatureFlagServiceCreateTenantOverrideDocument = `
    mutation featureFlagServiceCreateTenantOverride($input: FeatureFlagServiceCreateTenantOverrideGqlInput!) {
  featureFlagServiceCreateTenantOverride(input: $input) {
    id
    featureCode
    isEnabled
    reason
    tenantId
    createdAt
    updatedAt
  }
}
    `;

export const useFeatureFlagServiceCreateTenantOverrideMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FeatureFlagServiceCreateTenantOverrideMutation, TError, FeatureFlagServiceCreateTenantOverrideMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FeatureFlagServiceCreateTenantOverrideMutation, TError, FeatureFlagServiceCreateTenantOverrideMutationVariables, TContext>(
      {
    mutationKey: ['featureFlagServiceCreateTenantOverride'],
    mutationFn: (variables?: FeatureFlagServiceCreateTenantOverrideMutationVariables) => fetcher<FeatureFlagServiceCreateTenantOverrideMutation, FeatureFlagServiceCreateTenantOverrideMutationVariables>(client, FeatureFlagServiceCreateTenantOverrideDocument, variables, headers)(),
    ...options
  }
    )};

useFeatureFlagServiceCreateTenantOverrideMutation.getKey = () => ['featureFlagServiceCreateTenantOverride'];


useFeatureFlagServiceCreateTenantOverrideMutation.fetcher = (client: GraphQLClient, variables: FeatureFlagServiceCreateTenantOverrideMutationVariables, headers?: RequestInit['headers']) => fetcher<FeatureFlagServiceCreateTenantOverrideMutation, FeatureFlagServiceCreateTenantOverrideMutationVariables>(client, FeatureFlagServiceCreateTenantOverrideDocument, variables, headers);

export const FeatureFlagServiceDeleteTenantOverrideDocument = `
    mutation featureFlagServiceDeleteTenantOverride($input: FeatureFlagServiceDeleteTenantOverrideGqlInput!) {
  featureFlagServiceDeleteTenantOverride(input: $input)
}
    `;

export const useFeatureFlagServiceDeleteTenantOverrideMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<FeatureFlagServiceDeleteTenantOverrideMutation, TError, FeatureFlagServiceDeleteTenantOverrideMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<FeatureFlagServiceDeleteTenantOverrideMutation, TError, FeatureFlagServiceDeleteTenantOverrideMutationVariables, TContext>(
      {
    mutationKey: ['featureFlagServiceDeleteTenantOverride'],
    mutationFn: (variables?: FeatureFlagServiceDeleteTenantOverrideMutationVariables) => fetcher<FeatureFlagServiceDeleteTenantOverrideMutation, FeatureFlagServiceDeleteTenantOverrideMutationVariables>(client, FeatureFlagServiceDeleteTenantOverrideDocument, variables, headers)(),
    ...options
  }
    )};

useFeatureFlagServiceDeleteTenantOverrideMutation.getKey = () => ['featureFlagServiceDeleteTenantOverride'];


useFeatureFlagServiceDeleteTenantOverrideMutation.fetcher = (client: GraphQLClient, variables: FeatureFlagServiceDeleteTenantOverrideMutationVariables, headers?: RequestInit['headers']) => fetcher<FeatureFlagServiceDeleteTenantOverrideMutation, FeatureFlagServiceDeleteTenantOverrideMutationVariables>(client, FeatureFlagServiceDeleteTenantOverrideDocument, variables, headers);

export const GetAllLoyaltyProgramsDocument = `
    query GetAllLoyaltyPrograms($pagination: PaginationArgs!) {
  loyaltyServiceAllLoyaltyPrograms(pagination: $pagination) {
    data {
      id
      tenantId
      name
      description
      startDate
      endDate
      isActive
      isDefault
      pointsConfig {
        earnRules {
          amountSpentRatio
          registrationBonus
          referralBonus
        }
        redemptionRules {
          minimumPoints
          pointValue
        }
      }
      additionalSettings {
        notificationEnabled
        emailTemplateId
        displayInApp
        customTheme {
          primaryColor
          secondaryColor
          logoUrl
        }
        integrations {
          externalSystemId
          apiKeys
        }
      }
      isEnabled
      isDeleted
      createdAt
      updatedAt
    }
    total
  }
}
    `;

export const useGetAllLoyaltyProgramsQuery = <
      TData = GetAllLoyaltyProgramsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllLoyaltyProgramsQueryVariables,
      options?: Omit<UseQueryOptions<GetAllLoyaltyProgramsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllLoyaltyProgramsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllLoyaltyProgramsQuery, TError, TData>(
      {
    queryKey: ['GetAllLoyaltyPrograms', variables],
    queryFn: fetcher<GetAllLoyaltyProgramsQuery, GetAllLoyaltyProgramsQueryVariables>(client, GetAllLoyaltyProgramsDocument, variables, headers),
    ...options
  }
    )};

useGetAllLoyaltyProgramsQuery.getKey = (variables: GetAllLoyaltyProgramsQueryVariables) => ['GetAllLoyaltyPrograms', variables];

export const useInfiniteGetAllLoyaltyProgramsQuery = <
      TData = InfiniteData<GetAllLoyaltyProgramsQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllLoyaltyProgramsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAllLoyaltyProgramsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAllLoyaltyProgramsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetAllLoyaltyProgramsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAllLoyaltyPrograms.infinite', variables],
      queryFn: (metaData) => fetcher<GetAllLoyaltyProgramsQuery, GetAllLoyaltyProgramsQueryVariables>(client, GetAllLoyaltyProgramsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAllLoyaltyProgramsQuery.getKey = (variables: GetAllLoyaltyProgramsQueryVariables) => ['GetAllLoyaltyPrograms.infinite', variables];


useGetAllLoyaltyProgramsQuery.fetcher = (client: GraphQLClient, variables: GetAllLoyaltyProgramsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllLoyaltyProgramsQuery, GetAllLoyaltyProgramsQueryVariables>(client, GetAllLoyaltyProgramsDocument, variables, headers);

export const GetActiveLoyaltyProgramsDocument = `
    query GetActiveLoyaltyPrograms {
  loyaltyServiceActiveLoyaltyPrograms {
    id
    tenantId
    name
    description
    startDate
    endDate
    isActive
    isDefault
    pointsConfig {
      earnRules {
        amountSpentRatio
        registrationBonus
        referralBonus
      }
      redemptionRules {
        minimumPoints
        pointValue
      }
    }
    additionalSettings {
      notificationEnabled
      emailTemplateId
      displayInApp
      customTheme {
        primaryColor
        secondaryColor
        logoUrl
      }
      integrations {
        externalSystemId
        apiKeys
      }
    }
    isEnabled
    isDeleted
    createdAt
    updatedAt
  }
}
    `;

export const useGetActiveLoyaltyProgramsQuery = <
      TData = GetActiveLoyaltyProgramsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetActiveLoyaltyProgramsQueryVariables,
      options?: Omit<UseQueryOptions<GetActiveLoyaltyProgramsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetActiveLoyaltyProgramsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetActiveLoyaltyProgramsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetActiveLoyaltyPrograms'] : ['GetActiveLoyaltyPrograms', variables],
    queryFn: fetcher<GetActiveLoyaltyProgramsQuery, GetActiveLoyaltyProgramsQueryVariables>(client, GetActiveLoyaltyProgramsDocument, variables, headers),
    ...options
  }
    )};

useGetActiveLoyaltyProgramsQuery.getKey = (variables?: GetActiveLoyaltyProgramsQueryVariables) => variables === undefined ? ['GetActiveLoyaltyPrograms'] : ['GetActiveLoyaltyPrograms', variables];

export const useInfiniteGetActiveLoyaltyProgramsQuery = <
      TData = InfiniteData<GetActiveLoyaltyProgramsQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetActiveLoyaltyProgramsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetActiveLoyaltyProgramsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetActiveLoyaltyProgramsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetActiveLoyaltyProgramsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetActiveLoyaltyPrograms.infinite'] : ['GetActiveLoyaltyPrograms.infinite', variables],
      queryFn: (metaData) => fetcher<GetActiveLoyaltyProgramsQuery, GetActiveLoyaltyProgramsQueryVariables>(client, GetActiveLoyaltyProgramsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetActiveLoyaltyProgramsQuery.getKey = (variables?: GetActiveLoyaltyProgramsQueryVariables) => variables === undefined ? ['GetActiveLoyaltyPrograms.infinite'] : ['GetActiveLoyaltyPrograms.infinite', variables];


useGetActiveLoyaltyProgramsQuery.fetcher = (client: GraphQLClient, variables?: GetActiveLoyaltyProgramsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetActiveLoyaltyProgramsQuery, GetActiveLoyaltyProgramsQueryVariables>(client, GetActiveLoyaltyProgramsDocument, variables, headers);

export const GetDefaultLoyaltyProgramDocument = `
    query GetDefaultLoyaltyProgram {
  loyaltyServiceDefaultLoyaltyProgram {
    id
    tenantId
    name
    description
    startDate
    endDate
    isActive
    isDefault
    pointsConfig {
      earnRules {
        amountSpentRatio
        registrationBonus
        referralBonus
      }
      redemptionRules {
        minimumPoints
        pointValue
      }
    }
    additionalSettings {
      notificationEnabled
      emailTemplateId
      displayInApp
      customTheme {
        primaryColor
        secondaryColor
        logoUrl
      }
      integrations {
        externalSystemId
        apiKeys
      }
    }
    isEnabled
    isDeleted
    createdAt
    updatedAt
  }
}
    `;

export const useGetDefaultLoyaltyProgramQuery = <
      TData = GetDefaultLoyaltyProgramQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetDefaultLoyaltyProgramQueryVariables,
      options?: Omit<UseQueryOptions<GetDefaultLoyaltyProgramQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetDefaultLoyaltyProgramQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetDefaultLoyaltyProgramQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetDefaultLoyaltyProgram'] : ['GetDefaultLoyaltyProgram', variables],
    queryFn: fetcher<GetDefaultLoyaltyProgramQuery, GetDefaultLoyaltyProgramQueryVariables>(client, GetDefaultLoyaltyProgramDocument, variables, headers),
    ...options
  }
    )};

useGetDefaultLoyaltyProgramQuery.getKey = (variables?: GetDefaultLoyaltyProgramQueryVariables) => variables === undefined ? ['GetDefaultLoyaltyProgram'] : ['GetDefaultLoyaltyProgram', variables];

export const useInfiniteGetDefaultLoyaltyProgramQuery = <
      TData = InfiniteData<GetDefaultLoyaltyProgramQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDefaultLoyaltyProgramQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetDefaultLoyaltyProgramQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetDefaultLoyaltyProgramQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetDefaultLoyaltyProgramQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetDefaultLoyaltyProgram.infinite'] : ['GetDefaultLoyaltyProgram.infinite', variables],
      queryFn: (metaData) => fetcher<GetDefaultLoyaltyProgramQuery, GetDefaultLoyaltyProgramQueryVariables>(client, GetDefaultLoyaltyProgramDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetDefaultLoyaltyProgramQuery.getKey = (variables?: GetDefaultLoyaltyProgramQueryVariables) => variables === undefined ? ['GetDefaultLoyaltyProgram.infinite'] : ['GetDefaultLoyaltyProgram.infinite', variables];


useGetDefaultLoyaltyProgramQuery.fetcher = (client: GraphQLClient, variables?: GetDefaultLoyaltyProgramQueryVariables, headers?: RequestInit['headers']) => fetcher<GetDefaultLoyaltyProgramQuery, GetDefaultLoyaltyProgramQueryVariables>(client, GetDefaultLoyaltyProgramDocument, variables, headers);

export const GetLoyaltyProgramByIdDocument = `
    query GetLoyaltyProgramById($id: String!) {
  loyaltyServiceLoyaltyProgramById(id: $id) {
    id
    tenantId
    name
    description
    startDate
    endDate
    isActive
    isDefault
    pointsConfig {
      earnRules {
        amountSpentRatio
        registrationBonus
        referralBonus
      }
      redemptionRules {
        minimumPoints
        pointValue
      }
    }
    additionalSettings {
      notificationEnabled
      emailTemplateId
      displayInApp
      customTheme {
        primaryColor
        secondaryColor
        logoUrl
      }
      integrations {
        externalSystemId
        apiKeys
      }
    }
    isEnabled
    isDeleted
    createdAt
    updatedAt
  }
}
    `;

export const useGetLoyaltyProgramByIdQuery = <
      TData = GetLoyaltyProgramByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetLoyaltyProgramByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetLoyaltyProgramByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLoyaltyProgramByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetLoyaltyProgramByIdQuery, TError, TData>(
      {
    queryKey: ['GetLoyaltyProgramById', variables],
    queryFn: fetcher<GetLoyaltyProgramByIdQuery, GetLoyaltyProgramByIdQueryVariables>(client, GetLoyaltyProgramByIdDocument, variables, headers),
    ...options
  }
    )};

useGetLoyaltyProgramByIdQuery.getKey = (variables: GetLoyaltyProgramByIdQueryVariables) => ['GetLoyaltyProgramById', variables];

export const useInfiniteGetLoyaltyProgramByIdQuery = <
      TData = InfiniteData<GetLoyaltyProgramByIdQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetLoyaltyProgramByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetLoyaltyProgramByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetLoyaltyProgramByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetLoyaltyProgramByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetLoyaltyProgramById.infinite', variables],
      queryFn: (metaData) => fetcher<GetLoyaltyProgramByIdQuery, GetLoyaltyProgramByIdQueryVariables>(client, GetLoyaltyProgramByIdDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetLoyaltyProgramByIdQuery.getKey = (variables: GetLoyaltyProgramByIdQueryVariables) => ['GetLoyaltyProgramById.infinite', variables];


useGetLoyaltyProgramByIdQuery.fetcher = (client: GraphQLClient, variables: GetLoyaltyProgramByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetLoyaltyProgramByIdQuery, GetLoyaltyProgramByIdQueryVariables>(client, GetLoyaltyProgramByIdDocument, variables, headers);

export const GetAllLoyaltyTiersDocument = `
    query GetAllLoyaltyTiers($pagination: PaginationArgs!) {
  loyaltyServiceAllLoyaltyTiers(pagination: $pagination) {
    data {
      id
      tenantId
      name
      description
      level
      pointsThreshold
      spendingThreshold
      pointsMultiplier
      spendingPerPoint
      maintenanceThreshold
      validityPeriod
      pointEarnRuleDescription
      benefitDescriptions
      benefit {
        prioritySupport
        exclusiveAccess
        additionalBenefits
        freeServices
        discounts {
          percentage
          minimumPurchase
          maximumDiscount
          scope
          applicableProductIds
          applicableCategoryIds
          applicableServices
        }
      }
      iconUrl
      isEnabled
      isDeleted
      createdAt
      updatedAt
    }
    total
  }
}
    `;

export const useGetAllLoyaltyTiersQuery = <
      TData = GetAllLoyaltyTiersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllLoyaltyTiersQueryVariables,
      options?: Omit<UseQueryOptions<GetAllLoyaltyTiersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllLoyaltyTiersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllLoyaltyTiersQuery, TError, TData>(
      {
    queryKey: ['GetAllLoyaltyTiers', variables],
    queryFn: fetcher<GetAllLoyaltyTiersQuery, GetAllLoyaltyTiersQueryVariables>(client, GetAllLoyaltyTiersDocument, variables, headers),
    ...options
  }
    )};

useGetAllLoyaltyTiersQuery.getKey = (variables: GetAllLoyaltyTiersQueryVariables) => ['GetAllLoyaltyTiers', variables];

export const useInfiniteGetAllLoyaltyTiersQuery = <
      TData = InfiniteData<GetAllLoyaltyTiersQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllLoyaltyTiersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAllLoyaltyTiersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAllLoyaltyTiersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetAllLoyaltyTiersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAllLoyaltyTiers.infinite', variables],
      queryFn: (metaData) => fetcher<GetAllLoyaltyTiersQuery, GetAllLoyaltyTiersQueryVariables>(client, GetAllLoyaltyTiersDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAllLoyaltyTiersQuery.getKey = (variables: GetAllLoyaltyTiersQueryVariables) => ['GetAllLoyaltyTiers.infinite', variables];


useGetAllLoyaltyTiersQuery.fetcher = (client: GraphQLClient, variables: GetAllLoyaltyTiersQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllLoyaltyTiersQuery, GetAllLoyaltyTiersQueryVariables>(client, GetAllLoyaltyTiersDocument, variables, headers);

export const GetEnabledLoyaltyTiersDocument = `
    query GetEnabledLoyaltyTiers($pagination: PaginationArgs!) {
  loyaltyServiceEnabledLoyaltyTiers(pagination: $pagination) {
    id
    tenantId
    name
    description
    level
    pointsThreshold
    spendingThreshold
    pointsMultiplier
    spendingPerPoint
    maintenanceThreshold
    validityPeriod
    pointEarnRuleDescription
    benefitDescriptions
    benefit {
      prioritySupport
      exclusiveAccess
      additionalBenefits
      freeServices
      discounts {
        percentage
        minimumPurchase
        maximumDiscount
        scope
        applicableProductIds
        applicableCategoryIds
        applicableServices
      }
    }
    iconUrl
    isEnabled
    isDeleted
    createdAt
    updatedAt
  }
}
    `;

export const useGetEnabledLoyaltyTiersQuery = <
      TData = GetEnabledLoyaltyTiersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEnabledLoyaltyTiersQueryVariables,
      options?: Omit<UseQueryOptions<GetEnabledLoyaltyTiersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetEnabledLoyaltyTiersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetEnabledLoyaltyTiersQuery, TError, TData>(
      {
    queryKey: ['GetEnabledLoyaltyTiers', variables],
    queryFn: fetcher<GetEnabledLoyaltyTiersQuery, GetEnabledLoyaltyTiersQueryVariables>(client, GetEnabledLoyaltyTiersDocument, variables, headers),
    ...options
  }
    )};

useGetEnabledLoyaltyTiersQuery.getKey = (variables: GetEnabledLoyaltyTiersQueryVariables) => ['GetEnabledLoyaltyTiers', variables];

export const useInfiniteGetEnabledLoyaltyTiersQuery = <
      TData = InfiniteData<GetEnabledLoyaltyTiersQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetEnabledLoyaltyTiersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetEnabledLoyaltyTiersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetEnabledLoyaltyTiersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetEnabledLoyaltyTiersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetEnabledLoyaltyTiers.infinite', variables],
      queryFn: (metaData) => fetcher<GetEnabledLoyaltyTiersQuery, GetEnabledLoyaltyTiersQueryVariables>(client, GetEnabledLoyaltyTiersDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetEnabledLoyaltyTiersQuery.getKey = (variables: GetEnabledLoyaltyTiersQueryVariables) => ['GetEnabledLoyaltyTiers.infinite', variables];


useGetEnabledLoyaltyTiersQuery.fetcher = (client: GraphQLClient, variables: GetEnabledLoyaltyTiersQueryVariables, headers?: RequestInit['headers']) => fetcher<GetEnabledLoyaltyTiersQuery, GetEnabledLoyaltyTiersQueryVariables>(client, GetEnabledLoyaltyTiersDocument, variables, headers);

export const GetLoyaltyTierByIdDocument = `
    query GetLoyaltyTierById($id: String!) {
  loyaltyServiceLoyaltyTierById(id: $id) {
    id
    tenantId
    name
    level
    description
    iconUrl
    spendingThreshold
    pointsThreshold
    pointsMultiplier
    spendingPerPoint
    benefitDescriptions
    pointEarnRuleDescription
    benefit {
      prioritySupport
      exclusiveAccess
      additionalBenefits
      freeServices
      discounts {
        percentage
        minimumPurchase
        maximumDiscount
        scope
        applicableProductIds
        applicableCategoryIds
        applicableServices
      }
    }
    validityPeriod
    maintenanceThreshold
    isEnabled
    isDeleted
    createdAt
    updatedAt
  }
}
    `;

export const useGetLoyaltyTierByIdQuery = <
      TData = GetLoyaltyTierByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetLoyaltyTierByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetLoyaltyTierByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLoyaltyTierByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetLoyaltyTierByIdQuery, TError, TData>(
      {
    queryKey: ['GetLoyaltyTierById', variables],
    queryFn: fetcher<GetLoyaltyTierByIdQuery, GetLoyaltyTierByIdQueryVariables>(client, GetLoyaltyTierByIdDocument, variables, headers),
    ...options
  }
    )};

useGetLoyaltyTierByIdQuery.getKey = (variables: GetLoyaltyTierByIdQueryVariables) => ['GetLoyaltyTierById', variables];

export const useInfiniteGetLoyaltyTierByIdQuery = <
      TData = InfiniteData<GetLoyaltyTierByIdQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetLoyaltyTierByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetLoyaltyTierByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetLoyaltyTierByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetLoyaltyTierByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetLoyaltyTierById.infinite', variables],
      queryFn: (metaData) => fetcher<GetLoyaltyTierByIdQuery, GetLoyaltyTierByIdQueryVariables>(client, GetLoyaltyTierByIdDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetLoyaltyTierByIdQuery.getKey = (variables: GetLoyaltyTierByIdQueryVariables) => ['GetLoyaltyTierById.infinite', variables];


useGetLoyaltyTierByIdQuery.fetcher = (client: GraphQLClient, variables: GetLoyaltyTierByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetLoyaltyTierByIdQuery, GetLoyaltyTierByIdQueryVariables>(client, GetLoyaltyTierByIdDocument, variables, headers);

export const GetOrdersDocument = `
    query GetOrders($input: OrderServiceGetGqlInput!) {
  orderServiceOrganizationGetOrders(input: $input) {
    id
    status
    type
    currency
    productTotalAmount
    productTotalAmountFormatted
    shippingFee
    shippingFeeFormatted
    discountAmount
    discountAmountFormatted
    totalAmount
    totalAmountFormatted
    pointAmount
    pointAmountFormatted
    paymentMethod
    paymentStatus
    shippingMethod
    shippingStatus
    shippingNote
    branchId
    tenantId
    userId
    promotionId
    vouchers
    createdAt
    updatedAt
    shippingAddress {
      name
      phone
      address
      province
      ward
    }
    payment {
      transactionId
      amountPaid
      amountPaidFormatted
      paidAt
      refundId
    }
    products {
      name
      price
      priceFormatted
      quantity
      productId
      currency
      thumbnailUrl
      variant {
        name
        price
        priceFormatted
        sku
        attributeKey
        attributeValue
      }
    }
  }
}
    `;

export const useGetOrdersQuery = <
      TData = GetOrdersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrdersQueryVariables,
      options?: Omit<UseQueryOptions<GetOrdersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOrdersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetOrdersQuery, TError, TData>(
      {
    queryKey: ['GetOrders', variables],
    queryFn: fetcher<GetOrdersQuery, GetOrdersQueryVariables>(client, GetOrdersDocument, variables, headers),
    ...options
  }
    )};

useGetOrdersQuery.getKey = (variables: GetOrdersQueryVariables) => ['GetOrders', variables];

export const useInfiniteGetOrdersQuery = <
      TData = InfiniteData<GetOrdersQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrdersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetOrdersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetOrdersQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetOrdersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetOrders.infinite', variables],
      queryFn: (metaData) => fetcher<GetOrdersQuery, GetOrdersQueryVariables>(client, GetOrdersDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetOrdersQuery.getKey = (variables: GetOrdersQueryVariables) => ['GetOrders.infinite', variables];


useGetOrdersQuery.fetcher = (client: GraphQLClient, variables: GetOrdersQueryVariables, headers?: RequestInit['headers']) => fetcher<GetOrdersQuery, GetOrdersQueryVariables>(client, GetOrdersDocument, variables, headers);

export const GetOrderDocument = `
    query GetOrder($input: OrderServiceDetailGqlInput!) {
  orderServiceGetOrder(input: $input) {
    id
    status
    type
    currency
    productTotalAmount
    productTotalAmountFormatted
    shippingFee
    shippingFeeFormatted
    discountAmount
    discountAmountFormatted
    totalAmount
    totalAmountFormatted
    pointAmount
    pointAmountFormatted
    paymentMethod
    paymentStatus
    shippingMethod
    shippingStatus
    shippingNote
    branchId
    tenantId
    userId
    promotionId
    vouchers
    createdAt
    updatedAt
    shippingAddress {
      name
      phone
      address
      province
      ward
    }
    payment {
      transactionId
      amountPaid
      amountPaidFormatted
      paidAt
      refundId
    }
    products {
      name
      price
      priceFormatted
      quantity
      productId
      currency
      thumbnailUrl
      variant {
        name
        price
        priceFormatted
        sku
        attributeKey
        attributeValue
      }
    }
  }
}
    `;

export const useGetOrderQuery = <
      TData = GetOrderQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrderQueryVariables,
      options?: Omit<UseQueryOptions<GetOrderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOrderQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetOrderQuery, TError, TData>(
      {
    queryKey: ['GetOrder', variables],
    queryFn: fetcher<GetOrderQuery, GetOrderQueryVariables>(client, GetOrderDocument, variables, headers),
    ...options
  }
    )};

useGetOrderQuery.getKey = (variables: GetOrderQueryVariables) => ['GetOrder', variables];

export const useInfiniteGetOrderQuery = <
      TData = InfiniteData<GetOrderQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrderQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetOrderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetOrderQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetOrderQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetOrder.infinite', variables],
      queryFn: (metaData) => fetcher<GetOrderQuery, GetOrderQueryVariables>(client, GetOrderDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetOrderQuery.getKey = (variables: GetOrderQueryVariables) => ['GetOrder.infinite', variables];


useGetOrderQuery.fetcher = (client: GraphQLClient, variables: GetOrderQueryVariables, headers?: RequestInit['headers']) => fetcher<GetOrderQuery, GetOrderQueryVariables>(client, GetOrderDocument, variables, headers);

export const GetOrderHistoriesDocument = `
    query GetOrderHistories($input: OrderServiceGetOrderHistoryGqlInput!) {
  orderServiceGetOrderHistories(input: $input) {
    id
    status
    description
    comment
    updatedBy
    createdAt
  }
}
    `;

export const useGetOrderHistoriesQuery = <
      TData = GetOrderHistoriesQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrderHistoriesQueryVariables,
      options?: Omit<UseQueryOptions<GetOrderHistoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOrderHistoriesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetOrderHistoriesQuery, TError, TData>(
      {
    queryKey: ['GetOrderHistories', variables],
    queryFn: fetcher<GetOrderHistoriesQuery, GetOrderHistoriesQueryVariables>(client, GetOrderHistoriesDocument, variables, headers),
    ...options
  }
    )};

useGetOrderHistoriesQuery.getKey = (variables: GetOrderHistoriesQueryVariables) => ['GetOrderHistories', variables];

export const useInfiniteGetOrderHistoriesQuery = <
      TData = InfiniteData<GetOrderHistoriesQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrderHistoriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetOrderHistoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetOrderHistoriesQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetOrderHistoriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetOrderHistories.infinite', variables],
      queryFn: (metaData) => fetcher<GetOrderHistoriesQuery, GetOrderHistoriesQueryVariables>(client, GetOrderHistoriesDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetOrderHistoriesQuery.getKey = (variables: GetOrderHistoriesQueryVariables) => ['GetOrderHistories.infinite', variables];


useGetOrderHistoriesQuery.fetcher = (client: GraphQLClient, variables: GetOrderHistoriesQueryVariables, headers?: RequestInit['headers']) => fetcher<GetOrderHistoriesQuery, GetOrderHistoriesQueryVariables>(client, GetOrderHistoriesDocument, variables, headers);

export const UpdateOrderStatusDocument = `
    mutation UpdateOrderStatus($input: OrderServiceUpdateStatusGqlInput!) {
  orderServiceUpdateOrderStatus(input: $input)
}
    `;

export const useUpdateOrderStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOrderStatusMutation, TError, UpdateOrderStatusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateOrderStatusMutation, TError, UpdateOrderStatusMutationVariables, TContext>(
      {
    mutationKey: ['UpdateOrderStatus'],
    mutationFn: (variables?: UpdateOrderStatusMutationVariables) => fetcher<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>(client, UpdateOrderStatusDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateOrderStatusMutation.getKey = () => ['UpdateOrderStatus'];


useUpdateOrderStatusMutation.fetcher = (client: GraphQLClient, variables: UpdateOrderStatusMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateOrderStatusMutation, UpdateOrderStatusMutationVariables>(client, UpdateOrderStatusDocument, variables, headers);

export const GetAllOrganizationsDocument = `
    query GetAllOrganizations($input: OrganizationServiceGetOrganizationsGqlInput!) {
  organizationServiceAdminAllOrganizations(input: $input) {
    id
    name
    status
    createdBy
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

export const useGetAllOrganizationsQuery = <
      TData = GetAllOrganizationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllOrganizationsQueryVariables,
      options?: Omit<UseQueryOptions<GetAllOrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllOrganizationsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetAllOrganizationsQuery, TError, TData>(
      {
    queryKey: ['GetAllOrganizations', variables],
    queryFn: fetcher<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>(client, GetAllOrganizationsDocument, variables, headers),
    ...options
  }
    )};

useGetAllOrganizationsQuery.getKey = (variables: GetAllOrganizationsQueryVariables) => ['GetAllOrganizations', variables];

export const useInfiniteGetAllOrganizationsQuery = <
      TData = InfiniteData<GetAllOrganizationsQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllOrganizationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAllOrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAllOrganizationsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetAllOrganizationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAllOrganizations.infinite', variables],
      queryFn: (metaData) => fetcher<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>(client, GetAllOrganizationsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAllOrganizationsQuery.getKey = (variables: GetAllOrganizationsQueryVariables) => ['GetAllOrganizations.infinite', variables];


useGetAllOrganizationsQuery.fetcher = (client: GraphQLClient, variables: GetAllOrganizationsQueryVariables, headers?: RequestInit['headers']) => fetcher<GetAllOrganizationsQuery, GetAllOrganizationsQueryVariables>(client, GetAllOrganizationsDocument, variables, headers);

export const GetOrganizationByIdDocument = `
    query GetOrganizationById($id: String!) {
  organizationServiceAdminOrganizationById(id: $id) {
    id
    name
    status
    createdBy
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

export const useGetOrganizationByIdQuery = <
      TData = GetOrganizationByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrganizationByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetOrganizationByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOrganizationByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetOrganizationByIdQuery, TError, TData>(
      {
    queryKey: ['GetOrganizationById', variables],
    queryFn: fetcher<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>(client, GetOrganizationByIdDocument, variables, headers),
    ...options
  }
    )};

useGetOrganizationByIdQuery.getKey = (variables: GetOrganizationByIdQueryVariables) => ['GetOrganizationById', variables];

export const useInfiniteGetOrganizationByIdQuery = <
      TData = InfiniteData<GetOrganizationByIdQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrganizationByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetOrganizationByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetOrganizationByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetOrganizationByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetOrganizationById.infinite', variables],
      queryFn: (metaData) => fetcher<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>(client, GetOrganizationByIdDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetOrganizationByIdQuery.getKey = (variables: GetOrganizationByIdQueryVariables) => ['GetOrganizationById.infinite', variables];


useGetOrganizationByIdQuery.fetcher = (client: GraphQLClient, variables: GetOrganizationByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>(client, GetOrganizationByIdDocument, variables, headers);

export const CreateOrganizationDocument = `
    mutation CreateOrganization($input: OrganizationServiceCreateOrganizationGqlInput!) {
  organizationServiceAdminCreateOrganization(input: $input) {
    id
    name
    status
    createdBy
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

export const useCreateOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateOrganizationMutation, TError, CreateOrganizationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateOrganizationMutation, TError, CreateOrganizationMutationVariables, TContext>(
      {
    mutationKey: ['CreateOrganization'],
    mutationFn: (variables?: CreateOrganizationMutationVariables) => fetcher<CreateOrganizationMutation, CreateOrganizationMutationVariables>(client, CreateOrganizationDocument, variables, headers)(),
    ...options
  }
    )};

useCreateOrganizationMutation.getKey = () => ['CreateOrganization'];


useCreateOrganizationMutation.fetcher = (client: GraphQLClient, variables: CreateOrganizationMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateOrganizationMutation, CreateOrganizationMutationVariables>(client, CreateOrganizationDocument, variables, headers);

export const UpdateOrganizationDocument = `
    mutation UpdateOrganization($id: String!, $input: OrganizationServiceUpdateOrganizationGqlInput!) {
  organizationServiceAdminUpdateOrganization(id: $id, input: $input) {
    id
    name
    status
    createdBy
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

export const useUpdateOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOrganizationMutation, TError, UpdateOrganizationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateOrganizationMutation, TError, UpdateOrganizationMutationVariables, TContext>(
      {
    mutationKey: ['UpdateOrganization'],
    mutationFn: (variables?: UpdateOrganizationMutationVariables) => fetcher<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(client, UpdateOrganizationDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateOrganizationMutation.getKey = () => ['UpdateOrganization'];


useUpdateOrganizationMutation.fetcher = (client: GraphQLClient, variables: UpdateOrganizationMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(client, UpdateOrganizationDocument, variables, headers);

export const ContentServiceGetPageDocument = `
    query contentServiceGetPage($id: String, $type: PageTypeEnum) {
  contentServiceGetPage(input: {id: $id, type: $type}) {
    id
    name
    type
    description
    tenantId
    components {
      id
      type
      props
    }
    createdAt
    updatedAt
  }
}
    `;

export const useContentServiceGetPageQuery = <
      TData = ContentServiceGetPageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ContentServiceGetPageQueryVariables,
      options?: Omit<UseQueryOptions<ContentServiceGetPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ContentServiceGetPageQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<ContentServiceGetPageQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['contentServiceGetPage'] : ['contentServiceGetPage', variables],
    queryFn: fetcher<ContentServiceGetPageQuery, ContentServiceGetPageQueryVariables>(client, ContentServiceGetPageDocument, variables, headers),
    ...options
  }
    )};

useContentServiceGetPageQuery.getKey = (variables?: ContentServiceGetPageQueryVariables) => variables === undefined ? ['contentServiceGetPage'] : ['contentServiceGetPage', variables];

export const useInfiniteContentServiceGetPageQuery = <
      TData = InfiniteData<ContentServiceGetPageQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ContentServiceGetPageQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ContentServiceGetPageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ContentServiceGetPageQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<ContentServiceGetPageQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['contentServiceGetPage.infinite'] : ['contentServiceGetPage.infinite', variables],
      queryFn: (metaData) => fetcher<ContentServiceGetPageQuery, ContentServiceGetPageQueryVariables>(client, ContentServiceGetPageDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteContentServiceGetPageQuery.getKey = (variables?: ContentServiceGetPageQueryVariables) => variables === undefined ? ['contentServiceGetPage.infinite'] : ['contentServiceGetPage.infinite', variables];


useContentServiceGetPageQuery.fetcher = (client: GraphQLClient, variables?: ContentServiceGetPageQueryVariables, headers?: RequestInit['headers']) => fetcher<ContentServiceGetPageQuery, ContentServiceGetPageQueryVariables>(client, ContentServiceGetPageDocument, variables, headers);

export const ContentServiceCreatePageDocument = `
    mutation contentServiceCreatePage($input: ContentServiceCreatePageGqlInput!) {
  contentServiceCreatePage(input: $input) {
    id
    name
    type
    description
    tenantId
    components {
      id
      type
      props
    }
    createdAt
    updatedAt
  }
}
    `;

export const useContentServiceCreatePageMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ContentServiceCreatePageMutation, TError, ContentServiceCreatePageMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ContentServiceCreatePageMutation, TError, ContentServiceCreatePageMutationVariables, TContext>(
      {
    mutationKey: ['contentServiceCreatePage'],
    mutationFn: (variables?: ContentServiceCreatePageMutationVariables) => fetcher<ContentServiceCreatePageMutation, ContentServiceCreatePageMutationVariables>(client, ContentServiceCreatePageDocument, variables, headers)(),
    ...options
  }
    )};

useContentServiceCreatePageMutation.getKey = () => ['contentServiceCreatePage'];


useContentServiceCreatePageMutation.fetcher = (client: GraphQLClient, variables: ContentServiceCreatePageMutationVariables, headers?: RequestInit['headers']) => fetcher<ContentServiceCreatePageMutation, ContentServiceCreatePageMutationVariables>(client, ContentServiceCreatePageDocument, variables, headers);

export const ContentServiceUpdatePageDocument = `
    mutation contentServiceUpdatePage($id: String!, $input: ContentServiceUpdatePageGqlInput!) {
  contentServiceUpdatePage(id: $id, input: $input) {
    id
    name
    type
    description
    tenantId
    components {
      id
      type
      props
    }
    createdAt
    updatedAt
  }
}
    `;

export const useContentServiceUpdatePageMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ContentServiceUpdatePageMutation, TError, ContentServiceUpdatePageMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<ContentServiceUpdatePageMutation, TError, ContentServiceUpdatePageMutationVariables, TContext>(
      {
    mutationKey: ['contentServiceUpdatePage'],
    mutationFn: (variables?: ContentServiceUpdatePageMutationVariables) => fetcher<ContentServiceUpdatePageMutation, ContentServiceUpdatePageMutationVariables>(client, ContentServiceUpdatePageDocument, variables, headers)(),
    ...options
  }
    )};

useContentServiceUpdatePageMutation.getKey = () => ['contentServiceUpdatePage'];


useContentServiceUpdatePageMutation.fetcher = (client: GraphQLClient, variables: ContentServiceUpdatePageMutationVariables, headers?: RequestInit['headers']) => fetcher<ContentServiceUpdatePageMutation, ContentServiceUpdatePageMutationVariables>(client, ContentServiceUpdatePageDocument, variables, headers);

export const RatingServiceGetRatingsByFilterDocument = `
    query RatingServiceGetRatingsByFilter($input: RatingServiceGetRatingsGqlInput, $pagination: PaginationArgs!) {
  ratingServiceGetRatingsByFilter(input: $input, pagination: $pagination) {
    data {
      id
      rating
      comment
      userId
      referenceType
      referenceId
      createdAt
      updatedAt
    }
    total
  }
}
    `;

export const useRatingServiceGetRatingsByFilterQuery = <
      TData = RatingServiceGetRatingsByFilterQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: RatingServiceGetRatingsByFilterQueryVariables,
      options?: Omit<UseQueryOptions<RatingServiceGetRatingsByFilterQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RatingServiceGetRatingsByFilterQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<RatingServiceGetRatingsByFilterQuery, TError, TData>(
      {
    queryKey: ['RatingServiceGetRatingsByFilter', variables],
    queryFn: fetcher<RatingServiceGetRatingsByFilterQuery, RatingServiceGetRatingsByFilterQueryVariables>(client, RatingServiceGetRatingsByFilterDocument, variables, headers),
    ...options
  }
    )};

useRatingServiceGetRatingsByFilterQuery.getKey = (variables: RatingServiceGetRatingsByFilterQueryVariables) => ['RatingServiceGetRatingsByFilter', variables];

export const useInfiniteRatingServiceGetRatingsByFilterQuery = <
      TData = InfiniteData<RatingServiceGetRatingsByFilterQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: RatingServiceGetRatingsByFilterQueryVariables,
      options: Omit<UseInfiniteQueryOptions<RatingServiceGetRatingsByFilterQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<RatingServiceGetRatingsByFilterQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<RatingServiceGetRatingsByFilterQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['RatingServiceGetRatingsByFilter.infinite', variables],
      queryFn: (metaData) => fetcher<RatingServiceGetRatingsByFilterQuery, RatingServiceGetRatingsByFilterQueryVariables>(client, RatingServiceGetRatingsByFilterDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteRatingServiceGetRatingsByFilterQuery.getKey = (variables: RatingServiceGetRatingsByFilterQueryVariables) => ['RatingServiceGetRatingsByFilter.infinite', variables];


useRatingServiceGetRatingsByFilterQuery.fetcher = (client: GraphQLClient, variables: RatingServiceGetRatingsByFilterQueryVariables, headers?: RequestInit['headers']) => fetcher<RatingServiceGetRatingsByFilterQuery, RatingServiceGetRatingsByFilterQueryVariables>(client, RatingServiceGetRatingsByFilterDocument, variables, headers);

export const RatingServiceDeleteRatingForAdminDocument = `
    mutation RatingServiceDeleteRatingForAdmin($id: String!) {
  ratingServiceDeleteRatingForAdmin(id: $id)
}
    `;

export const useRatingServiceDeleteRatingForAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RatingServiceDeleteRatingForAdminMutation, TError, RatingServiceDeleteRatingForAdminMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<RatingServiceDeleteRatingForAdminMutation, TError, RatingServiceDeleteRatingForAdminMutationVariables, TContext>(
      {
    mutationKey: ['RatingServiceDeleteRatingForAdmin'],
    mutationFn: (variables?: RatingServiceDeleteRatingForAdminMutationVariables) => fetcher<RatingServiceDeleteRatingForAdminMutation, RatingServiceDeleteRatingForAdminMutationVariables>(client, RatingServiceDeleteRatingForAdminDocument, variables, headers)(),
    ...options
  }
    )};

useRatingServiceDeleteRatingForAdminMutation.getKey = () => ['RatingServiceDeleteRatingForAdmin'];


useRatingServiceDeleteRatingForAdminMutation.fetcher = (client: GraphQLClient, variables: RatingServiceDeleteRatingForAdminMutationVariables, headers?: RequestInit['headers']) => fetcher<RatingServiceDeleteRatingForAdminMutation, RatingServiceDeleteRatingForAdminMutationVariables>(client, RatingServiceDeleteRatingForAdminDocument, variables, headers);

export const RatingServiceGetRatingDetailsDocument = `
    query RatingServiceGetRatingDetails($id: String!) {
  ratingServiceGetRatingDetails(id: $id) {
    id
    rating
    comment
    userId
    referenceType
    referenceId
    createdAt
    updatedAt
    metadata
    tenantId
    deletedAt
  }
}
    `;

export const useRatingServiceGetRatingDetailsQuery = <
      TData = RatingServiceGetRatingDetailsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: RatingServiceGetRatingDetailsQueryVariables,
      options?: Omit<UseQueryOptions<RatingServiceGetRatingDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RatingServiceGetRatingDetailsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<RatingServiceGetRatingDetailsQuery, TError, TData>(
      {
    queryKey: ['RatingServiceGetRatingDetails', variables],
    queryFn: fetcher<RatingServiceGetRatingDetailsQuery, RatingServiceGetRatingDetailsQueryVariables>(client, RatingServiceGetRatingDetailsDocument, variables, headers),
    ...options
  }
    )};

useRatingServiceGetRatingDetailsQuery.getKey = (variables: RatingServiceGetRatingDetailsQueryVariables) => ['RatingServiceGetRatingDetails', variables];

export const useInfiniteRatingServiceGetRatingDetailsQuery = <
      TData = InfiniteData<RatingServiceGetRatingDetailsQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: RatingServiceGetRatingDetailsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<RatingServiceGetRatingDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<RatingServiceGetRatingDetailsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<RatingServiceGetRatingDetailsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['RatingServiceGetRatingDetails.infinite', variables],
      queryFn: (metaData) => fetcher<RatingServiceGetRatingDetailsQuery, RatingServiceGetRatingDetailsQueryVariables>(client, RatingServiceGetRatingDetailsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteRatingServiceGetRatingDetailsQuery.getKey = (variables: RatingServiceGetRatingDetailsQueryVariables) => ['RatingServiceGetRatingDetails.infinite', variables];


useRatingServiceGetRatingDetailsQuery.fetcher = (client: GraphQLClient, variables: RatingServiceGetRatingDetailsQueryVariables, headers?: RequestInit['headers']) => fetcher<RatingServiceGetRatingDetailsQuery, RatingServiceGetRatingDetailsQueryVariables>(client, RatingServiceGetRatingDetailsDocument, variables, headers);

export const SduiServiceGetLayoutsDocument = `
    query SduiServiceGetLayouts {
  sduiServiceGetLayouts {
    components {
      banner {
        imageUrl
      }
      bottomNavBar {
        items {
          icon
          label
        }
        selectedIndex
      }
    }
    id
    layoutId
    modules {
      action {
        route
        target
        type
        value
      }
      featureCode
      icon
      isShow
      title
    }
    tenantId
    theme {
      backgroundColor
      buttonStyle
      color
      fontFamily
      fontSize
      primaryColor
      secondaryColor
      themeName
    }
    isEnabled
  }
}
    `;

export const useSduiServiceGetLayoutsQuery = <
      TData = SduiServiceGetLayoutsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: SduiServiceGetLayoutsQueryVariables,
      options?: Omit<UseQueryOptions<SduiServiceGetLayoutsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SduiServiceGetLayoutsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<SduiServiceGetLayoutsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['SduiServiceGetLayouts'] : ['SduiServiceGetLayouts', variables],
    queryFn: fetcher<SduiServiceGetLayoutsQuery, SduiServiceGetLayoutsQueryVariables>(client, SduiServiceGetLayoutsDocument, variables, headers),
    ...options
  }
    )};

useSduiServiceGetLayoutsQuery.getKey = (variables?: SduiServiceGetLayoutsQueryVariables) => variables === undefined ? ['SduiServiceGetLayouts'] : ['SduiServiceGetLayouts', variables];

export const useInfiniteSduiServiceGetLayoutsQuery = <
      TData = InfiniteData<SduiServiceGetLayoutsQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SduiServiceGetLayoutsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SduiServiceGetLayoutsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SduiServiceGetLayoutsQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<SduiServiceGetLayoutsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['SduiServiceGetLayouts.infinite'] : ['SduiServiceGetLayouts.infinite', variables],
      queryFn: (metaData) => fetcher<SduiServiceGetLayoutsQuery, SduiServiceGetLayoutsQueryVariables>(client, SduiServiceGetLayoutsDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteSduiServiceGetLayoutsQuery.getKey = (variables?: SduiServiceGetLayoutsQueryVariables) => variables === undefined ? ['SduiServiceGetLayouts.infinite'] : ['SduiServiceGetLayouts.infinite', variables];


useSduiServiceGetLayoutsQuery.fetcher = (client: GraphQLClient, variables?: SduiServiceGetLayoutsQueryVariables, headers?: RequestInit['headers']) => fetcher<SduiServiceGetLayoutsQuery, SduiServiceGetLayoutsQueryVariables>(client, SduiServiceGetLayoutsDocument, variables, headers);

export const SduiServiceGetLayoutDetailDocument = `
    query SduiServiceGetLayoutDetail($sduiServiceGetLayoutDetailId: String!) {
  sduiServiceGetLayoutDetail(id: $sduiServiceGetLayoutDetailId) {
    components {
      banner {
        imageUrl
      }
      bottomNavBar {
        items {
          icon
          label
        }
        selectedIndex
      }
    }
    id
    layoutId
    modules {
      action {
        route
        target
        type
        value
      }
      featureCode
      icon
      isShow
      title
    }
    tenantId
    theme {
      backgroundColor
      buttonStyle
      color
      fontFamily
      fontSize
      primaryColor
      secondaryColor
      themeName
    }
    isEnabled
    customFields {
      fieldName
      fieldValue
    }
  }
}
    `;

export const useSduiServiceGetLayoutDetailQuery = <
      TData = SduiServiceGetLayoutDetailQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SduiServiceGetLayoutDetailQueryVariables,
      options?: Omit<UseQueryOptions<SduiServiceGetLayoutDetailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SduiServiceGetLayoutDetailQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<SduiServiceGetLayoutDetailQuery, TError, TData>(
      {
    queryKey: ['SduiServiceGetLayoutDetail', variables],
    queryFn: fetcher<SduiServiceGetLayoutDetailQuery, SduiServiceGetLayoutDetailQueryVariables>(client, SduiServiceGetLayoutDetailDocument, variables, headers),
    ...options
  }
    )};

useSduiServiceGetLayoutDetailQuery.getKey = (variables: SduiServiceGetLayoutDetailQueryVariables) => ['SduiServiceGetLayoutDetail', variables];

export const useInfiniteSduiServiceGetLayoutDetailQuery = <
      TData = InfiniteData<SduiServiceGetLayoutDetailQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SduiServiceGetLayoutDetailQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SduiServiceGetLayoutDetailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SduiServiceGetLayoutDetailQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<SduiServiceGetLayoutDetailQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SduiServiceGetLayoutDetail.infinite', variables],
      queryFn: (metaData) => fetcher<SduiServiceGetLayoutDetailQuery, SduiServiceGetLayoutDetailQueryVariables>(client, SduiServiceGetLayoutDetailDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteSduiServiceGetLayoutDetailQuery.getKey = (variables: SduiServiceGetLayoutDetailQueryVariables) => ['SduiServiceGetLayoutDetail.infinite', variables];


useSduiServiceGetLayoutDetailQuery.fetcher = (client: GraphQLClient, variables: SduiServiceGetLayoutDetailQueryVariables, headers?: RequestInit['headers']) => fetcher<SduiServiceGetLayoutDetailQuery, SduiServiceGetLayoutDetailQueryVariables>(client, SduiServiceGetLayoutDetailDocument, variables, headers);

export const SduiServiceGetTenantLayoutDocument = `
    query sduiServiceGetTenantLayout {
  sduiServiceGetLayout {
    id
    components {
      banner {
        imageUrl
      }
    }
    customFields {
      fieldName
      fieldType
      fieldValue
    }
    isEnabled
  }
}
    `;

export const useSduiServiceGetTenantLayoutQuery = <
      TData = SduiServiceGetTenantLayoutQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: SduiServiceGetTenantLayoutQueryVariables,
      options?: Omit<UseQueryOptions<SduiServiceGetTenantLayoutQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SduiServiceGetTenantLayoutQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<SduiServiceGetTenantLayoutQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['sduiServiceGetTenantLayout'] : ['sduiServiceGetTenantLayout', variables],
    queryFn: fetcher<SduiServiceGetTenantLayoutQuery, SduiServiceGetTenantLayoutQueryVariables>(client, SduiServiceGetTenantLayoutDocument, variables, headers),
    ...options
  }
    )};

useSduiServiceGetTenantLayoutQuery.getKey = (variables?: SduiServiceGetTenantLayoutQueryVariables) => variables === undefined ? ['sduiServiceGetTenantLayout'] : ['sduiServiceGetTenantLayout', variables];

export const useInfiniteSduiServiceGetTenantLayoutQuery = <
      TData = InfiniteData<SduiServiceGetTenantLayoutQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SduiServiceGetTenantLayoutQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SduiServiceGetTenantLayoutQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SduiServiceGetTenantLayoutQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<SduiServiceGetTenantLayoutQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['sduiServiceGetTenantLayout.infinite'] : ['sduiServiceGetTenantLayout.infinite', variables],
      queryFn: (metaData) => fetcher<SduiServiceGetTenantLayoutQuery, SduiServiceGetTenantLayoutQueryVariables>(client, SduiServiceGetTenantLayoutDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteSduiServiceGetTenantLayoutQuery.getKey = (variables?: SduiServiceGetTenantLayoutQueryVariables) => variables === undefined ? ['sduiServiceGetTenantLayout.infinite'] : ['sduiServiceGetTenantLayout.infinite', variables];


useSduiServiceGetTenantLayoutQuery.fetcher = (client: GraphQLClient, variables?: SduiServiceGetTenantLayoutQueryVariables, headers?: RequestInit['headers']) => fetcher<SduiServiceGetTenantLayoutQuery, SduiServiceGetTenantLayoutQueryVariables>(client, SduiServiceGetTenantLayoutDocument, variables, headers);

export const UploadServiceRequestUploadDocument = `
    mutation UploadServiceRequestUpload($input: UploadServiceRequestGqlInput!) {
  uploadServiceRequestUpload(input: $input) {
    fileId
    uploadUrl
  }
}
    `;

export const useUploadServiceRequestUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UploadServiceRequestUploadMutation, TError, UploadServiceRequestUploadMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UploadServiceRequestUploadMutation, TError, UploadServiceRequestUploadMutationVariables, TContext>(
      {
    mutationKey: ['UploadServiceRequestUpload'],
    mutationFn: (variables?: UploadServiceRequestUploadMutationVariables) => fetcher<UploadServiceRequestUploadMutation, UploadServiceRequestUploadMutationVariables>(client, UploadServiceRequestUploadDocument, variables, headers)(),
    ...options
  }
    )};

useUploadServiceRequestUploadMutation.getKey = () => ['UploadServiceRequestUpload'];


useUploadServiceRequestUploadMutation.fetcher = (client: GraphQLClient, variables: UploadServiceRequestUploadMutationVariables, headers?: RequestInit['headers']) => fetcher<UploadServiceRequestUploadMutation, UploadServiceRequestUploadMutationVariables>(client, UploadServiceRequestUploadDocument, variables, headers);

export const CompleteUploadDocument = `
    mutation CompleteUpload($input: UploadServiceCompleteGqlInput!) {
  uploadServiceCompleteUpload(input: $input) {
    status
    fileUrl
  }
}
    `;

export const useCompleteUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CompleteUploadMutation, TError, CompleteUploadMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CompleteUploadMutation, TError, CompleteUploadMutationVariables, TContext>(
      {
    mutationKey: ['CompleteUpload'],
    mutationFn: (variables?: CompleteUploadMutationVariables) => fetcher<CompleteUploadMutation, CompleteUploadMutationVariables>(client, CompleteUploadDocument, variables, headers)(),
    ...options
  }
    )};

useCompleteUploadMutation.getKey = () => ['CompleteUpload'];


useCompleteUploadMutation.fetcher = (client: GraphQLClient, variables: CompleteUploadMutationVariables, headers?: RequestInit['headers']) => fetcher<CompleteUploadMutation, CompleteUploadMutationVariables>(client, CompleteUploadDocument, variables, headers);

export const GetSurveysForAdminDocument = `
    query getSurveysForAdmin($pagination: PaginationArgs!) {
  fnsServiceGetSurveysForAdmin(pagination: $pagination) {
    data {
      id
      title
      description
      type
      isActive
      isAnonymous
      tenantId
      createdAt
      updatedAt
      questions {
        id
        text
        type
        uiTemplate
        index
        isRequired
        isActive
        minValue
        maxValue
        options
        actionLabel
        actionUrl
      }
    }
    total
  }
}
    `;

export const useGetSurveysForAdminQuery = <
      TData = GetSurveysForAdminQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetSurveysForAdminQueryVariables,
      options?: Omit<UseQueryOptions<GetSurveysForAdminQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSurveysForAdminQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetSurveysForAdminQuery, TError, TData>(
      {
    queryKey: ['getSurveysForAdmin', variables],
    queryFn: fetcher<GetSurveysForAdminQuery, GetSurveysForAdminQueryVariables>(client, GetSurveysForAdminDocument, variables, headers),
    ...options
  }
    )};

useGetSurveysForAdminQuery.getKey = (variables: GetSurveysForAdminQueryVariables) => ['getSurveysForAdmin', variables];

export const useInfiniteGetSurveysForAdminQuery = <
      TData = InfiniteData<GetSurveysForAdminQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetSurveysForAdminQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSurveysForAdminQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSurveysForAdminQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetSurveysForAdminQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSurveysForAdmin.infinite', variables],
      queryFn: (metaData) => fetcher<GetSurveysForAdminQuery, GetSurveysForAdminQueryVariables>(client, GetSurveysForAdminDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSurveysForAdminQuery.getKey = (variables: GetSurveysForAdminQueryVariables) => ['getSurveysForAdmin.infinite', variables];


useGetSurveysForAdminQuery.fetcher = (client: GraphQLClient, variables: GetSurveysForAdminQueryVariables, headers?: RequestInit['headers']) => fetcher<GetSurveysForAdminQuery, GetSurveysForAdminQueryVariables>(client, GetSurveysForAdminDocument, variables, headers);

export const GetSurveyByIdDocument = `
    query getSurveyById($id: String!) {
  fnsServiceGetSurveyById(id: $id) {
    id
    title
    description
    type
    isActive
    isAnonymous
    tenantId
    createdAt
    updatedAt
    questions {
      id
      text
      type
      uiTemplate
      index
      isRequired
      isActive
      minValue
      maxValue
      options
      actionLabel
      actionUrl
    }
  }
}
    `;

export const useGetSurveyByIdQuery = <
      TData = GetSurveyByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetSurveyByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetSurveyByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSurveyByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetSurveyByIdQuery, TError, TData>(
      {
    queryKey: ['getSurveyById', variables],
    queryFn: fetcher<GetSurveyByIdQuery, GetSurveyByIdQueryVariables>(client, GetSurveyByIdDocument, variables, headers),
    ...options
  }
    )};

useGetSurveyByIdQuery.getKey = (variables: GetSurveyByIdQueryVariables) => ['getSurveyById', variables];

export const useInfiniteGetSurveyByIdQuery = <
      TData = InfiniteData<GetSurveyByIdQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetSurveyByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSurveyByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSurveyByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetSurveyByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSurveyById.infinite', variables],
      queryFn: (metaData) => fetcher<GetSurveyByIdQuery, GetSurveyByIdQueryVariables>(client, GetSurveyByIdDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSurveyByIdQuery.getKey = (variables: GetSurveyByIdQueryVariables) => ['getSurveyById.infinite', variables];


useGetSurveyByIdQuery.fetcher = (client: GraphQLClient, variables: GetSurveyByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetSurveyByIdQuery, GetSurveyByIdQueryVariables>(client, GetSurveyByIdDocument, variables, headers);

export const GetSurveyByTypeDocument = `
    query getSurveyByType($type: SurveyType!) {
  fnsServiceGetSurveyByType(type: $type) {
    id
    title
    description
    type
    isActive
    isAnonymous
    tenantId
    createdAt
    updatedAt
    questions {
      id
      text
      type
      uiTemplate
      index
      isRequired
      isActive
      minValue
      maxValue
      options
      actionLabel
      actionUrl
    }
  }
}
    `;

export const useGetSurveyByTypeQuery = <
      TData = GetSurveyByTypeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetSurveyByTypeQueryVariables,
      options?: Omit<UseQueryOptions<GetSurveyByTypeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSurveyByTypeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetSurveyByTypeQuery, TError, TData>(
      {
    queryKey: ['getSurveyByType', variables],
    queryFn: fetcher<GetSurveyByTypeQuery, GetSurveyByTypeQueryVariables>(client, GetSurveyByTypeDocument, variables, headers),
    ...options
  }
    )};

useGetSurveyByTypeQuery.getKey = (variables: GetSurveyByTypeQueryVariables) => ['getSurveyByType', variables];

export const useInfiniteGetSurveyByTypeQuery = <
      TData = InfiniteData<GetSurveyByTypeQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetSurveyByTypeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSurveyByTypeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSurveyByTypeQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetSurveyByTypeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSurveyByType.infinite', variables],
      queryFn: (metaData) => fetcher<GetSurveyByTypeQuery, GetSurveyByTypeQueryVariables>(client, GetSurveyByTypeDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSurveyByTypeQuery.getKey = (variables: GetSurveyByTypeQueryVariables) => ['getSurveyByType.infinite', variables];


useGetSurveyByTypeQuery.fetcher = (client: GraphQLClient, variables: GetSurveyByTypeQueryVariables, headers?: RequestInit['headers']) => fetcher<GetSurveyByTypeQuery, GetSurveyByTypeQueryVariables>(client, GetSurveyByTypeDocument, variables, headers);

export const CreateSurveyForAdminDocument = `
    mutation createSurveyForAdmin($input: FnsServiceCreateSurveyGqlInput!) {
  fnsServiceCreateSurveyForAdmin(input: $input) {
    id
    title
    description
    type
    isActive
    isAnonymous
    tenantId
    createdAt
    updatedAt
  }
}
    `;

export const useCreateSurveyForAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateSurveyForAdminMutation, TError, CreateSurveyForAdminMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateSurveyForAdminMutation, TError, CreateSurveyForAdminMutationVariables, TContext>(
      {
    mutationKey: ['createSurveyForAdmin'],
    mutationFn: (variables?: CreateSurveyForAdminMutationVariables) => fetcher<CreateSurveyForAdminMutation, CreateSurveyForAdminMutationVariables>(client, CreateSurveyForAdminDocument, variables, headers)(),
    ...options
  }
    )};

useCreateSurveyForAdminMutation.getKey = () => ['createSurveyForAdmin'];


useCreateSurveyForAdminMutation.fetcher = (client: GraphQLClient, variables: CreateSurveyForAdminMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateSurveyForAdminMutation, CreateSurveyForAdminMutationVariables>(client, CreateSurveyForAdminDocument, variables, headers);

export const UpdateSurveyForAdminDocument = `
    mutation updateSurveyForAdmin($id: String!, $input: FnsServiceUpdateSurveyGqlInput!) {
  fnsServiceUpdateSurveyForAdmin(id: $id, input: $input) {
    id
    title
    description
    type
    isActive
    isAnonymous
    tenantId
    createdAt
    updatedAt
  }
}
    `;

export const useUpdateSurveyForAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateSurveyForAdminMutation, TError, UpdateSurveyForAdminMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateSurveyForAdminMutation, TError, UpdateSurveyForAdminMutationVariables, TContext>(
      {
    mutationKey: ['updateSurveyForAdmin'],
    mutationFn: (variables?: UpdateSurveyForAdminMutationVariables) => fetcher<UpdateSurveyForAdminMutation, UpdateSurveyForAdminMutationVariables>(client, UpdateSurveyForAdminDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateSurveyForAdminMutation.getKey = () => ['updateSurveyForAdmin'];


useUpdateSurveyForAdminMutation.fetcher = (client: GraphQLClient, variables: UpdateSurveyForAdminMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateSurveyForAdminMutation, UpdateSurveyForAdminMutationVariables>(client, UpdateSurveyForAdminDocument, variables, headers);

export const GetUserResponsesForAdminDocument = `
    query getUserResponsesForAdmin($pagination: PaginationArgs!, $input: FnsServiceFindUserResponsesToSurveyGqlInput!) {
  fnsServiceGetUserResponsesToSurveyForAdmin(
    pagination: $pagination
    input: $input
  ) {
    data {
      id
      surveyId
      formId
      userId
      tenantId
      ipAddress
      userAgent
      createdAt
      updatedAt
      answers {
        questionId
        answer
      }
    }
    total
  }
}
    `;

export const useGetUserResponsesForAdminQuery = <
      TData = GetUserResponsesForAdminQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserResponsesForAdminQueryVariables,
      options?: Omit<UseQueryOptions<GetUserResponsesForAdminQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserResponsesForAdminQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetUserResponsesForAdminQuery, TError, TData>(
      {
    queryKey: ['getUserResponsesForAdmin', variables],
    queryFn: fetcher<GetUserResponsesForAdminQuery, GetUserResponsesForAdminQueryVariables>(client, GetUserResponsesForAdminDocument, variables, headers),
    ...options
  }
    )};

useGetUserResponsesForAdminQuery.getKey = (variables: GetUserResponsesForAdminQueryVariables) => ['getUserResponsesForAdmin', variables];

export const useInfiniteGetUserResponsesForAdminQuery = <
      TData = InfiniteData<GetUserResponsesForAdminQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserResponsesForAdminQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserResponsesForAdminQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserResponsesForAdminQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetUserResponsesForAdminQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getUserResponsesForAdmin.infinite', variables],
      queryFn: (metaData) => fetcher<GetUserResponsesForAdminQuery, GetUserResponsesForAdminQueryVariables>(client, GetUserResponsesForAdminDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserResponsesForAdminQuery.getKey = (variables: GetUserResponsesForAdminQueryVariables) => ['getUserResponsesForAdmin.infinite', variables];


useGetUserResponsesForAdminQuery.fetcher = (client: GraphQLClient, variables: GetUserResponsesForAdminQueryVariables, headers?: RequestInit['headers']) => fetcher<GetUserResponsesForAdminQuery, GetUserResponsesForAdminQueryVariables>(client, GetUserResponsesForAdminDocument, variables, headers);

export const GetUserResponseByIdForAdminDocument = `
    query getUserResponseByIdForAdmin($id: String!) {
  fnsServiceGetUserResponseByIdForAdmin(id: $id) {
    id
    surveyId
    formId
    userId
    tenantId
    ipAddress
    userAgent
    createdAt
    updatedAt
    answers {
      questionId
      answer
    }
  }
}
    `;

export const useGetUserResponseByIdForAdminQuery = <
      TData = GetUserResponseByIdForAdminQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserResponseByIdForAdminQueryVariables,
      options?: Omit<UseQueryOptions<GetUserResponseByIdForAdminQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserResponseByIdForAdminQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetUserResponseByIdForAdminQuery, TError, TData>(
      {
    queryKey: ['getUserResponseByIdForAdmin', variables],
    queryFn: fetcher<GetUserResponseByIdForAdminQuery, GetUserResponseByIdForAdminQueryVariables>(client, GetUserResponseByIdForAdminDocument, variables, headers),
    ...options
  }
    )};

useGetUserResponseByIdForAdminQuery.getKey = (variables: GetUserResponseByIdForAdminQueryVariables) => ['getUserResponseByIdForAdmin', variables];

export const useInfiniteGetUserResponseByIdForAdminQuery = <
      TData = InfiniteData<GetUserResponseByIdForAdminQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserResponseByIdForAdminQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserResponseByIdForAdminQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserResponseByIdForAdminQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetUserResponseByIdForAdminQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getUserResponseByIdForAdmin.infinite', variables],
      queryFn: (metaData) => fetcher<GetUserResponseByIdForAdminQuery, GetUserResponseByIdForAdminQueryVariables>(client, GetUserResponseByIdForAdminDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserResponseByIdForAdminQuery.getKey = (variables: GetUserResponseByIdForAdminQueryVariables) => ['getUserResponseByIdForAdmin.infinite', variables];


useGetUserResponseByIdForAdminQuery.fetcher = (client: GraphQLClient, variables: GetUserResponseByIdForAdminQueryVariables, headers?: RequestInit['headers']) => fetcher<GetUserResponseByIdForAdminQuery, GetUserResponseByIdForAdminQueryVariables>(client, GetUserResponseByIdForAdminDocument, variables, headers);

export const CreateUserResponseDocument = `
    mutation createUserResponse($input: FnsServiceCreateUserResponseSurveyGqlInput!) {
  fnsServiceCreateUserResponseToSurvey(input: $input) {
    id
    surveyId
    userId
    tenantId
    createdAt
  }
}
    `;

export const useCreateUserResponseMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateUserResponseMutation, TError, CreateUserResponseMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateUserResponseMutation, TError, CreateUserResponseMutationVariables, TContext>(
      {
    mutationKey: ['createUserResponse'],
    mutationFn: (variables?: CreateUserResponseMutationVariables) => fetcher<CreateUserResponseMutation, CreateUserResponseMutationVariables>(client, CreateUserResponseDocument, variables, headers)(),
    ...options
  }
    )};

useCreateUserResponseMutation.getKey = () => ['createUserResponse'];


useCreateUserResponseMutation.fetcher = (client: GraphQLClient, variables: CreateUserResponseMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateUserResponseMutation, CreateUserResponseMutationVariables>(client, CreateUserResponseDocument, variables, headers);

export const CreateResponseForAnonymousDocument = `
    mutation createResponseForAnonymous($input: FnsServiceCreateUserResponseSurveyGqlInput!) {
  fnsServiceCreateUserResponseToSurveyForAnonymous(input: $input) {
    id
    surveyId
    ipAddress
    userAgent
    createdAt
  }
}
    `;

export const useCreateResponseForAnonymousMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateResponseForAnonymousMutation, TError, CreateResponseForAnonymousMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateResponseForAnonymousMutation, TError, CreateResponseForAnonymousMutationVariables, TContext>(
      {
    mutationKey: ['createResponseForAnonymous'],
    mutationFn: (variables?: CreateResponseForAnonymousMutationVariables) => fetcher<CreateResponseForAnonymousMutation, CreateResponseForAnonymousMutationVariables>(client, CreateResponseForAnonymousDocument, variables, headers)(),
    ...options
  }
    )};

useCreateResponseForAnonymousMutation.getKey = () => ['createResponseForAnonymous'];


useCreateResponseForAnonymousMutation.fetcher = (client: GraphQLClient, variables: CreateResponseForAnonymousMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateResponseForAnonymousMutation, CreateResponseForAnonymousMutationVariables>(client, CreateResponseForAnonymousDocument, variables, headers);

export const GetFormsForAdminDocument = `
    query getFormsForAdmin($pagination: PaginationArgs!) {
  fnsServiceGetFormsForAdmin(pagination: $pagination) {
    data {
      id
      title
      description
      isActive
      isAnonymous
      tenantId
      createdAt
      updatedAt
      questions {
        id
        text
        type
        uiTemplate
        index
        isRequired
        isActive
        minValue
        maxValue
        options
        actionLabel
        actionUrl
      }
    }
    total
  }
}
    `;

export const useGetFormsForAdminQuery = <
      TData = GetFormsForAdminQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFormsForAdminQueryVariables,
      options?: Omit<UseQueryOptions<GetFormsForAdminQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFormsForAdminQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetFormsForAdminQuery, TError, TData>(
      {
    queryKey: ['getFormsForAdmin', variables],
    queryFn: fetcher<GetFormsForAdminQuery, GetFormsForAdminQueryVariables>(client, GetFormsForAdminDocument, variables, headers),
    ...options
  }
    )};

useGetFormsForAdminQuery.getKey = (variables: GetFormsForAdminQueryVariables) => ['getFormsForAdmin', variables];

export const useInfiniteGetFormsForAdminQuery = <
      TData = InfiniteData<GetFormsForAdminQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFormsForAdminQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFormsForAdminQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFormsForAdminQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetFormsForAdminQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getFormsForAdmin.infinite', variables],
      queryFn: (metaData) => fetcher<GetFormsForAdminQuery, GetFormsForAdminQueryVariables>(client, GetFormsForAdminDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFormsForAdminQuery.getKey = (variables: GetFormsForAdminQueryVariables) => ['getFormsForAdmin.infinite', variables];


useGetFormsForAdminQuery.fetcher = (client: GraphQLClient, variables: GetFormsForAdminQueryVariables, headers?: RequestInit['headers']) => fetcher<GetFormsForAdminQuery, GetFormsForAdminQueryVariables>(client, GetFormsForAdminDocument, variables, headers);

export const GetFormByIdDocument = `
    query getFormById($id: String!) {
  fnsServiceGetFormById(id: $id) {
    id
    title
    description
    isActive
    isAnonymous
    tenantId
    createdAt
    updatedAt
    questions {
      id
      text
      type
      uiTemplate
      index
      isRequired
      isActive
      minValue
      maxValue
      options
      actionLabel
      actionUrl
    }
  }
}
    `;

export const useGetFormByIdQuery = <
      TData = GetFormByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFormByIdQueryVariables,
      options?: Omit<UseQueryOptions<GetFormByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFormByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<GetFormByIdQuery, TError, TData>(
      {
    queryKey: ['getFormById', variables],
    queryFn: fetcher<GetFormByIdQuery, GetFormByIdQueryVariables>(client, GetFormByIdDocument, variables, headers),
    ...options
  }
    )};

useGetFormByIdQuery.getKey = (variables: GetFormByIdQueryVariables) => ['getFormById', variables];

export const useInfiniteGetFormByIdQuery = <
      TData = InfiniteData<GetFormByIdQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetFormByIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFormByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFormByIdQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<GetFormByIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getFormById.infinite', variables],
      queryFn: (metaData) => fetcher<GetFormByIdQuery, GetFormByIdQueryVariables>(client, GetFormByIdDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFormByIdQuery.getKey = (variables: GetFormByIdQueryVariables) => ['getFormById.infinite', variables];


useGetFormByIdQuery.fetcher = (client: GraphQLClient, variables: GetFormByIdQueryVariables, headers?: RequestInit['headers']) => fetcher<GetFormByIdQuery, GetFormByIdQueryVariables>(client, GetFormByIdDocument, variables, headers);

export const CreateFormForAdminDocument = `
    mutation createFormForAdmin($input: FnsServiceCreateFormGqlInput!) {
  fnsServiceCreateFormForAdmin(input: $input) {
    id
    title
    description
    isActive
    isAnonymous
    tenantId
    createdAt
    updatedAt
  }
}
    `;

export const useCreateFormForAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateFormForAdminMutation, TError, CreateFormForAdminMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateFormForAdminMutation, TError, CreateFormForAdminMutationVariables, TContext>(
      {
    mutationKey: ['createFormForAdmin'],
    mutationFn: (variables?: CreateFormForAdminMutationVariables) => fetcher<CreateFormForAdminMutation, CreateFormForAdminMutationVariables>(client, CreateFormForAdminDocument, variables, headers)(),
    ...options
  }
    )};

useCreateFormForAdminMutation.getKey = () => ['createFormForAdmin'];


useCreateFormForAdminMutation.fetcher = (client: GraphQLClient, variables: CreateFormForAdminMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateFormForAdminMutation, CreateFormForAdminMutationVariables>(client, CreateFormForAdminDocument, variables, headers);

export const UpdateFormForAdminDocument = `
    mutation updateFormForAdmin($id: String!, $input: FnsServiceUpdateFormGqlInput!) {
  fnsServiceUpdateFormForAdmin(id: $id, input: $input) {
    id
    title
    description
    isActive
    isAnonymous
    tenantId
    createdAt
    updatedAt
  }
}
    `;

export const useUpdateFormForAdminMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateFormForAdminMutation, TError, UpdateFormForAdminMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UpdateFormForAdminMutation, TError, UpdateFormForAdminMutationVariables, TContext>(
      {
    mutationKey: ['updateFormForAdmin'],
    mutationFn: (variables?: UpdateFormForAdminMutationVariables) => fetcher<UpdateFormForAdminMutation, UpdateFormForAdminMutationVariables>(client, UpdateFormForAdminDocument, variables, headers)(),
    ...options
  }
    )};

useUpdateFormForAdminMutation.getKey = () => ['updateFormForAdmin'];


useUpdateFormForAdminMutation.fetcher = (client: GraphQLClient, variables: UpdateFormForAdminMutationVariables, headers?: RequestInit['headers']) => fetcher<UpdateFormForAdminMutation, UpdateFormForAdminMutationVariables>(client, UpdateFormForAdminDocument, variables, headers);

export const CreateUserResponseFormDocument = `
    mutation createUserResponseForm($input: FnsServiceCreateUserResponseFormGqlInput!) {
  fnsServiceCreateUserResponseToForm(input: $input) {
    id
    formId
    userId
    tenantId
    createdAt
  }
}
    `;

export const useCreateUserResponseFormMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateUserResponseFormMutation, TError, CreateUserResponseFormMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateUserResponseFormMutation, TError, CreateUserResponseFormMutationVariables, TContext>(
      {
    mutationKey: ['createUserResponseForm'],
    mutationFn: (variables?: CreateUserResponseFormMutationVariables) => fetcher<CreateUserResponseFormMutation, CreateUserResponseFormMutationVariables>(client, CreateUserResponseFormDocument, variables, headers)(),
    ...options
  }
    )};

useCreateUserResponseFormMutation.getKey = () => ['createUserResponseForm'];


useCreateUserResponseFormMutation.fetcher = (client: GraphQLClient, variables: CreateUserResponseFormMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateUserResponseFormMutation, CreateUserResponseFormMutationVariables>(client, CreateUserResponseFormDocument, variables, headers);

export const CreateResponseFormForAnonymousDocument = `
    mutation createResponseFormForAnonymous($input: FnsServiceCreateUserResponseFormGqlInput!) {
  fnsServiceCreateUserResponseToFormForAnonymous(input: $input) {
    id
    formId
    ipAddress
    userAgent
    createdAt
  }
}
    `;

export const useCreateResponseFormForAnonymousMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateResponseFormForAnonymousMutation, TError, CreateResponseFormForAnonymousMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<CreateResponseFormForAnonymousMutation, TError, CreateResponseFormForAnonymousMutationVariables, TContext>(
      {
    mutationKey: ['createResponseFormForAnonymous'],
    mutationFn: (variables?: CreateResponseFormForAnonymousMutationVariables) => fetcher<CreateResponseFormForAnonymousMutation, CreateResponseFormForAnonymousMutationVariables>(client, CreateResponseFormForAnonymousDocument, variables, headers)(),
    ...options
  }
    )};

useCreateResponseFormForAnonymousMutation.getKey = () => ['createResponseFormForAnonymous'];


useCreateResponseFormForAnonymousMutation.fetcher = (client: GraphQLClient, variables: CreateResponseFormForAnonymousMutationVariables, headers?: RequestInit['headers']) => fetcher<CreateResponseFormForAnonymousMutation, CreateResponseFormForAnonymousMutationVariables>(client, CreateResponseFormForAnonymousDocument, variables, headers);

export const UserServiceAllTenantDocument = `
    query userServiceAllTenant($input: UserServiceGetTenantsGqlInput!) {
  userServiceAllTenant(input: $input) {
    id
    name
    status
    organizationId
    zaloAppId
    zaloAppSecret
    miniAppUrl
    title
    description
    banner
    favicon
    createdAt
    updatedAt
    type
  }
}
    `;

export const useUserServiceAllTenantQuery = <
      TData = UserServiceAllTenantQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UserServiceAllTenantQueryVariables,
      options?: Omit<UseQueryOptions<UserServiceAllTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserServiceAllTenantQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<UserServiceAllTenantQuery, TError, TData>(
      {
    queryKey: ['userServiceAllTenant', variables],
    queryFn: fetcher<UserServiceAllTenantQuery, UserServiceAllTenantQueryVariables>(client, UserServiceAllTenantDocument, variables, headers),
    ...options
  }
    )};

useUserServiceAllTenantQuery.getKey = (variables: UserServiceAllTenantQueryVariables) => ['userServiceAllTenant', variables];

export const useInfiniteUserServiceAllTenantQuery = <
      TData = InfiniteData<UserServiceAllTenantQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UserServiceAllTenantQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserServiceAllTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserServiceAllTenantQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<UserServiceAllTenantQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['userServiceAllTenant.infinite', variables],
      queryFn: (metaData) => fetcher<UserServiceAllTenantQuery, UserServiceAllTenantQueryVariables>(client, UserServiceAllTenantDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserServiceAllTenantQuery.getKey = (variables: UserServiceAllTenantQueryVariables) => ['userServiceAllTenant.infinite', variables];


useUserServiceAllTenantQuery.fetcher = (client: GraphQLClient, variables: UserServiceAllTenantQueryVariables, headers?: RequestInit['headers']) => fetcher<UserServiceAllTenantQuery, UserServiceAllTenantQueryVariables>(client, UserServiceAllTenantDocument, variables, headers);

export const UserServiceAllZaloUserOfTenantDocument = `
    query userServiceAllZaloUserOfTenant($input: UserServiceGetZaloUsersGqlInput!) {
  userServiceAllZaloUserOfTenant(input: $input) {
    id
    email
    firstName
    lastName
    phoneNumber
    avatarUrl
    fullName
    status
    type
    tenantId
    organizationId
    zaloId
    createdAt
    updatedAt
  }
}
    `;

export const useUserServiceAllZaloUserOfTenantQuery = <
      TData = UserServiceAllZaloUserOfTenantQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UserServiceAllZaloUserOfTenantQueryVariables,
      options?: Omit<UseQueryOptions<UserServiceAllZaloUserOfTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserServiceAllZaloUserOfTenantQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<UserServiceAllZaloUserOfTenantQuery, TError, TData>(
      {
    queryKey: ['userServiceAllZaloUserOfTenant', variables],
    queryFn: fetcher<UserServiceAllZaloUserOfTenantQuery, UserServiceAllZaloUserOfTenantQueryVariables>(client, UserServiceAllZaloUserOfTenantDocument, variables, headers),
    ...options
  }
    )};

useUserServiceAllZaloUserOfTenantQuery.getKey = (variables: UserServiceAllZaloUserOfTenantQueryVariables) => ['userServiceAllZaloUserOfTenant', variables];

export const useInfiniteUserServiceAllZaloUserOfTenantQuery = <
      TData = InfiniteData<UserServiceAllZaloUserOfTenantQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UserServiceAllZaloUserOfTenantQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserServiceAllZaloUserOfTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserServiceAllZaloUserOfTenantQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<UserServiceAllZaloUserOfTenantQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['userServiceAllZaloUserOfTenant.infinite', variables],
      queryFn: (metaData) => fetcher<UserServiceAllZaloUserOfTenantQuery, UserServiceAllZaloUserOfTenantQueryVariables>(client, UserServiceAllZaloUserOfTenantDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserServiceAllZaloUserOfTenantQuery.getKey = (variables: UserServiceAllZaloUserOfTenantQueryVariables) => ['userServiceAllZaloUserOfTenant.infinite', variables];


useUserServiceAllZaloUserOfTenantQuery.fetcher = (client: GraphQLClient, variables: UserServiceAllZaloUserOfTenantQueryVariables, headers?: RequestInit['headers']) => fetcher<UserServiceAllZaloUserOfTenantQuery, UserServiceAllZaloUserOfTenantQueryVariables>(client, UserServiceAllZaloUserOfTenantDocument, variables, headers);

export const UserServiceCreateTenantDocument = `
    mutation userServiceCreateTenant($input: UserServiceCreateTenantGqlInput!) {
  userServiceCreateTenant(input: $input) {
    id
    name
    status
    organizationId
    zaloAppId
    zaloAppSecret
    miniAppUrl
    title
    description
    banner
    favicon
    createdAt
    updatedAt
  }
}
    `;

export const useUserServiceCreateTenantMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UserServiceCreateTenantMutation, TError, UserServiceCreateTenantMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UserServiceCreateTenantMutation, TError, UserServiceCreateTenantMutationVariables, TContext>(
      {
    mutationKey: ['userServiceCreateTenant'],
    mutationFn: (variables?: UserServiceCreateTenantMutationVariables) => fetcher<UserServiceCreateTenantMutation, UserServiceCreateTenantMutationVariables>(client, UserServiceCreateTenantDocument, variables, headers)(),
    ...options
  }
    )};

useUserServiceCreateTenantMutation.getKey = () => ['userServiceCreateTenant'];


useUserServiceCreateTenantMutation.fetcher = (client: GraphQLClient, variables: UserServiceCreateTenantMutationVariables, headers?: RequestInit['headers']) => fetcher<UserServiceCreateTenantMutation, UserServiceCreateTenantMutationVariables>(client, UserServiceCreateTenantDocument, variables, headers);

export const UserServiceUpdateTenantDocument = `
    mutation userServiceUpdateTenant($input: UserServiceUpdateTenantGqlInput!) {
  userServiceUpdateTenant(input: $input) {
    id
    name
    status
    organizationId
    zaloAppId
    zaloAppSecret
    miniAppUrl
    title
    description
    banner
    favicon
    createdAt
    updatedAt
  }
}
    `;

export const useUserServiceUpdateTenantMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UserServiceUpdateTenantMutation, TError, UserServiceUpdateTenantMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UserServiceUpdateTenantMutation, TError, UserServiceUpdateTenantMutationVariables, TContext>(
      {
    mutationKey: ['userServiceUpdateTenant'],
    mutationFn: (variables?: UserServiceUpdateTenantMutationVariables) => fetcher<UserServiceUpdateTenantMutation, UserServiceUpdateTenantMutationVariables>(client, UserServiceUpdateTenantDocument, variables, headers)(),
    ...options
  }
    )};

useUserServiceUpdateTenantMutation.getKey = () => ['userServiceUpdateTenant'];


useUserServiceUpdateTenantMutation.fetcher = (client: GraphQLClient, variables: UserServiceUpdateTenantMutationVariables, headers?: RequestInit['headers']) => fetcher<UserServiceUpdateTenantMutation, UserServiceUpdateTenantMutationVariables>(client, UserServiceUpdateTenantDocument, variables, headers);

export const UserServiceTenantStatusDocument = `
    mutation userServiceTenantStatus($input: UserServiceTenantStatusGqlInput!) {
  userServiceTenantStatus(input: $input) {
    id
  }
}
    `;

export const useUserServiceTenantStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UserServiceTenantStatusMutation, TError, UserServiceTenantStatusMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) => {
    
    return useMutation<UserServiceTenantStatusMutation, TError, UserServiceTenantStatusMutationVariables, TContext>(
      {
    mutationKey: ['userServiceTenantStatus'],
    mutationFn: (variables?: UserServiceTenantStatusMutationVariables) => fetcher<UserServiceTenantStatusMutation, UserServiceTenantStatusMutationVariables>(client, UserServiceTenantStatusDocument, variables, headers)(),
    ...options
  }
    )};

useUserServiceTenantStatusMutation.getKey = () => ['userServiceTenantStatus'];


useUserServiceTenantStatusMutation.fetcher = (client: GraphQLClient, variables: UserServiceTenantStatusMutationVariables, headers?: RequestInit['headers']) => fetcher<UserServiceTenantStatusMutation, UserServiceTenantStatusMutationVariables>(client, UserServiceTenantStatusDocument, variables, headers);

export const UserServiceAdminAllTenantDocument = `
    query userServiceAdminAllTenant($organizationId: String!, $pagination: PaginationArgs!) {
  userServiceAdminAllTenant(organizationId: $organizationId, input: $pagination) {
    id
    organizationId
    name
    status
    zaloAppId
    zaloAppSecret
    miniAppUrl
    title
    description
    oaId
    domain
    logo
    banner
    favicon
    registerEnabled
    createdAt
    updatedAt
    type
  }
}
    `;

export const useUserServiceAdminAllTenantQuery = <
      TData = UserServiceAdminAllTenantQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UserServiceAdminAllTenantQueryVariables,
      options?: Omit<UseQueryOptions<UserServiceAdminAllTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserServiceAdminAllTenantQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<UserServiceAdminAllTenantQuery, TError, TData>(
      {
    queryKey: ['userServiceAdminAllTenant', variables],
    queryFn: fetcher<UserServiceAdminAllTenantQuery, UserServiceAdminAllTenantQueryVariables>(client, UserServiceAdminAllTenantDocument, variables, headers),
    ...options
  }
    )};

useUserServiceAdminAllTenantQuery.getKey = (variables: UserServiceAdminAllTenantQueryVariables) => ['userServiceAdminAllTenant', variables];

export const useInfiniteUserServiceAdminAllTenantQuery = <
      TData = InfiniteData<UserServiceAdminAllTenantQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UserServiceAdminAllTenantQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserServiceAdminAllTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserServiceAdminAllTenantQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<UserServiceAdminAllTenantQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['userServiceAdminAllTenant.infinite', variables],
      queryFn: (metaData) => fetcher<UserServiceAdminAllTenantQuery, UserServiceAdminAllTenantQueryVariables>(client, UserServiceAdminAllTenantDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserServiceAdminAllTenantQuery.getKey = (variables: UserServiceAdminAllTenantQueryVariables) => ['userServiceAdminAllTenant.infinite', variables];


useUserServiceAdminAllTenantQuery.fetcher = (client: GraphQLClient, variables: UserServiceAdminAllTenantQueryVariables, headers?: RequestInit['headers']) => fetcher<UserServiceAdminAllTenantQuery, UserServiceAdminAllTenantQueryVariables>(client, UserServiceAdminAllTenantDocument, variables, headers);

export const UserServiceGetTenantDocument = `
    query userServiceGetTenant {
  userServiceTenantById {
    type
  }
}
    `;

export const useUserServiceGetTenantQuery = <
      TData = UserServiceGetTenantQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: UserServiceGetTenantQueryVariables,
      options?: Omit<UseQueryOptions<UserServiceGetTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserServiceGetTenantQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<UserServiceGetTenantQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userServiceGetTenant'] : ['userServiceGetTenant', variables],
    queryFn: fetcher<UserServiceGetTenantQuery, UserServiceGetTenantQueryVariables>(client, UserServiceGetTenantDocument, variables, headers),
    ...options
  }
    )};

useUserServiceGetTenantQuery.getKey = (variables?: UserServiceGetTenantQueryVariables) => variables === undefined ? ['userServiceGetTenant'] : ['userServiceGetTenant', variables];

export const useInfiniteUserServiceGetTenantQuery = <
      TData = InfiniteData<UserServiceGetTenantQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UserServiceGetTenantQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserServiceGetTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserServiceGetTenantQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<UserServiceGetTenantQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['userServiceGetTenant.infinite'] : ['userServiceGetTenant.infinite', variables],
      queryFn: (metaData) => fetcher<UserServiceGetTenantQuery, UserServiceGetTenantQueryVariables>(client, UserServiceGetTenantDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserServiceGetTenantQuery.getKey = (variables?: UserServiceGetTenantQueryVariables) => variables === undefined ? ['userServiceGetTenant.infinite'] : ['userServiceGetTenant.infinite', variables];


useUserServiceGetTenantQuery.fetcher = (client: GraphQLClient, variables?: UserServiceGetTenantQueryVariables, headers?: RequestInit['headers']) => fetcher<UserServiceGetTenantQuery, UserServiceGetTenantQueryVariables>(client, UserServiceGetTenantDocument, variables, headers);

export const UserServiceTenantByDomainDocument = `
    query UserServiceTenantByDomain($domain: String!) {
  userServiceTenantByDomain(domain: $domain) {
    banner
    billingStatus
    createdAt
    description
    domain
    favicon
    id
    logo
    miniAppUrl
    name
    oaId
    organizationId
    registerEnabled
    status
    title
    type
    updatedAt
    zaloAppId
    zaloAppSecret
  }
}
    `;

export const useUserServiceTenantByDomainQuery = <
      TData = UserServiceTenantByDomainQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UserServiceTenantByDomainQueryVariables,
      options?: Omit<UseQueryOptions<UserServiceTenantByDomainQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserServiceTenantByDomainQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useQuery<UserServiceTenantByDomainQuery, TError, TData>(
      {
    queryKey: ['UserServiceTenantByDomain', variables],
    queryFn: fetcher<UserServiceTenantByDomainQuery, UserServiceTenantByDomainQueryVariables>(client, UserServiceTenantByDomainDocument, variables, headers),
    ...options
  }
    )};

useUserServiceTenantByDomainQuery.getKey = (variables: UserServiceTenantByDomainQueryVariables) => ['UserServiceTenantByDomain', variables];

export const useInfiniteUserServiceTenantByDomainQuery = <
      TData = InfiniteData<UserServiceTenantByDomainQuery>,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: UserServiceTenantByDomainQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserServiceTenantByDomainQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserServiceTenantByDomainQuery, TError, TData>['queryKey'] },
      headers?: RequestInit['headers']
    ) => {
    
    return useInfiniteQuery<UserServiceTenantByDomainQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['UserServiceTenantByDomain.infinite', variables],
      queryFn: (metaData) => fetcher<UserServiceTenantByDomainQuery, UserServiceTenantByDomainQueryVariables>(client, UserServiceTenantByDomainDocument, {...variables, ...(metaData.pageParam ?? {})}, headers)(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserServiceTenantByDomainQuery.getKey = (variables: UserServiceTenantByDomainQueryVariables) => ['UserServiceTenantByDomain.infinite', variables];


useUserServiceTenantByDomainQuery.fetcher = (client: GraphQLClient, variables: UserServiceTenantByDomainQueryVariables, headers?: RequestInit['headers']) => fetcher<UserServiceTenantByDomainQuery, UserServiceTenantByDomainQueryVariables>(client, UserServiceTenantByDomainDocument, variables, headers);
